
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireab88"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireab88"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5Wgfu", function(module, exports) {
"use strict";

module.exports = (parcelRequire("91Z9E"));

});
parcelRegister("91Z9E", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $6933a5158fb8aa46$export$ffb0004e005737fa; }, function (v) { return $6933a5158fb8aa46$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $6933a5158fb8aa46$export$34b9dba7ce09269b; }, function (v) { return $6933a5158fb8aa46$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $6933a5158fb8aa46$export$25062201e9e25d76; }, function (v) { return $6933a5158fb8aa46$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $6933a5158fb8aa46$export$ffb0004e005737fa;
var $6933a5158fb8aa46$export$34b9dba7ce09269b;
var $6933a5158fb8aa46$export$25062201e9e25d76;
"use strict";

var $aOChP = parcelRequire("aOChP");
var $6933a5158fb8aa46$var$k = Symbol.for("react.element"), $6933a5158fb8aa46$var$l = Symbol.for("react.fragment"), $6933a5158fb8aa46$var$m = Object.prototype.hasOwnProperty, $6933a5158fb8aa46$var$n = $aOChP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $6933a5158fb8aa46$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $6933a5158fb8aa46$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$6933a5158fb8aa46$var$m.call(a, b) && !$6933a5158fb8aa46$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $6933a5158fb8aa46$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $6933a5158fb8aa46$var$n.current
    };
}
$6933a5158fb8aa46$export$ffb0004e005737fa = $6933a5158fb8aa46$var$l;
$6933a5158fb8aa46$export$34b9dba7ce09269b = $6933a5158fb8aa46$var$q;
$6933a5158fb8aa46$export$25062201e9e25d76 = $6933a5158fb8aa46$var$q;

});
parcelRegister("aOChP", function(module, exports) {
"use strict";

module.exports = (parcelRequire("iYrK1"));

});
parcelRegister("iYrK1", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $dd035970bb0a7189$export$dca3b0875bd9a954; }, function (v) { return $dd035970bb0a7189$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $dd035970bb0a7189$export$16fa2f45be04daa8; }, function (v) { return $dd035970bb0a7189$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $dd035970bb0a7189$export$ffb0004e005737fa; }, function (v) { return $dd035970bb0a7189$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $dd035970bb0a7189$export$e2c29f18771995cb; }, function (v) { return $dd035970bb0a7189$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $dd035970bb0a7189$export$221d75b3f55bb0bd; }, function (v) { return $dd035970bb0a7189$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $dd035970bb0a7189$export$5f8d39834fd61797; }, function (v) { return $dd035970bb0a7189$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $dd035970bb0a7189$export$74bf444e3cd11ea5; }, function (v) { return $dd035970bb0a7189$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $dd035970bb0a7189$export$ae55be85d98224ed; }, function (v) { return $dd035970bb0a7189$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "cloneElement", function () { return $dd035970bb0a7189$export$e530037191fcd5d7; }, function (v) { return $dd035970bb0a7189$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $dd035970bb0a7189$export$fd42f52fd3ae1109; }, function (v) { return $dd035970bb0a7189$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $dd035970bb0a7189$export$c8a8987d4410bf2d; }, function (v) { return $dd035970bb0a7189$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $dd035970bb0a7189$export$d38cd72104c1f0e9; }, function (v) { return $dd035970bb0a7189$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $dd035970bb0a7189$export$7d1e3a5e95ceca43; }, function (v) { return $dd035970bb0a7189$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $dd035970bb0a7189$export$257a8862b851cb5b; }, function (v) { return $dd035970bb0a7189$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $dd035970bb0a7189$export$a8257692ac88316c; }, function (v) { return $dd035970bb0a7189$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $dd035970bb0a7189$export$488013bae63b21da; }, function (v) { return $dd035970bb0a7189$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $dd035970bb0a7189$export$7c73462e0d25e514; }, function (v) { return $dd035970bb0a7189$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $dd035970bb0a7189$export$7568632d0d33d16d; }, function (v) { return $dd035970bb0a7189$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $dd035970bb0a7189$export$88948ce120ea2619; }, function (v) { return $dd035970bb0a7189$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $dd035970bb0a7189$export$35808ee640e87ca7; }, function (v) { return $dd035970bb0a7189$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $dd035970bb0a7189$export$fae74005e78b1a27; }, function (v) { return $dd035970bb0a7189$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $dd035970bb0a7189$export$dc8fbce3eb94dc1e; }, function (v) { return $dd035970bb0a7189$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $dd035970bb0a7189$export$6a7bc4e911dc01cf; }, function (v) { return $dd035970bb0a7189$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $dd035970bb0a7189$export$6d9c69b0de29b591; }, function (v) { return $dd035970bb0a7189$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $dd035970bb0a7189$export$f680877a34711e37; }, function (v) { return $dd035970bb0a7189$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $dd035970bb0a7189$export$d5a552a76deda3c2; }, function (v) { return $dd035970bb0a7189$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $dd035970bb0a7189$export$aaabe4eda9ed9969; }, function (v) { return $dd035970bb0a7189$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $dd035970bb0a7189$export$e5c5a5f917a5871c; }, function (v) { return $dd035970bb0a7189$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $dd035970bb0a7189$export$1538c33de8887b59; }, function (v) { return $dd035970bb0a7189$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $dd035970bb0a7189$export$13e3392192263954; }, function (v) { return $dd035970bb0a7189$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $dd035970bb0a7189$export$b8f5890fc79d6aca; }, function (v) { return $dd035970bb0a7189$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $dd035970bb0a7189$export$60241385465d0a34; }, function (v) { return $dd035970bb0a7189$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $dd035970bb0a7189$export$306c0aa65ff9ec16; }, function (v) { return $dd035970bb0a7189$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $dd035970bb0a7189$export$7b286972b8d8ccbf; }, function (v) { return $dd035970bb0a7189$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $dd035970bb0a7189$export$83d89fbfd8236492; }, function (v) { return $dd035970bb0a7189$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dd035970bb0a7189$export$dca3b0875bd9a954;
var $dd035970bb0a7189$export$16fa2f45be04daa8;
var $dd035970bb0a7189$export$ffb0004e005737fa;
var $dd035970bb0a7189$export$e2c29f18771995cb;
var $dd035970bb0a7189$export$221d75b3f55bb0bd;
var $dd035970bb0a7189$export$5f8d39834fd61797;
var $dd035970bb0a7189$export$74bf444e3cd11ea5;
var $dd035970bb0a7189$export$ae55be85d98224ed;
var $dd035970bb0a7189$export$e530037191fcd5d7;
var $dd035970bb0a7189$export$fd42f52fd3ae1109;
var $dd035970bb0a7189$export$c8a8987d4410bf2d;
var $dd035970bb0a7189$export$d38cd72104c1f0e9;
var $dd035970bb0a7189$export$7d1e3a5e95ceca43;
var $dd035970bb0a7189$export$257a8862b851cb5b;
var $dd035970bb0a7189$export$a8257692ac88316c;
var $dd035970bb0a7189$export$488013bae63b21da;
var $dd035970bb0a7189$export$7c73462e0d25e514;
var $dd035970bb0a7189$export$7568632d0d33d16d;
var $dd035970bb0a7189$export$88948ce120ea2619;
var $dd035970bb0a7189$export$35808ee640e87ca7;
var $dd035970bb0a7189$export$fae74005e78b1a27;
var $dd035970bb0a7189$export$dc8fbce3eb94dc1e;
var $dd035970bb0a7189$export$6a7bc4e911dc01cf;
var $dd035970bb0a7189$export$6d9c69b0de29b591;
var $dd035970bb0a7189$export$f680877a34711e37;
var $dd035970bb0a7189$export$d5a552a76deda3c2;
var $dd035970bb0a7189$export$aaabe4eda9ed9969;
var $dd035970bb0a7189$export$e5c5a5f917a5871c;
var $dd035970bb0a7189$export$1538c33de8887b59;
var $dd035970bb0a7189$export$13e3392192263954;
var $dd035970bb0a7189$export$b8f5890fc79d6aca;
var $dd035970bb0a7189$export$60241385465d0a34;
var $dd035970bb0a7189$export$306c0aa65ff9ec16;
var $dd035970bb0a7189$export$7b286972b8d8ccbf;
var $dd035970bb0a7189$export$83d89fbfd8236492;
"use strict";
var $dd035970bb0a7189$var$l = Symbol.for("react.element"), $dd035970bb0a7189$var$n = Symbol.for("react.portal"), $dd035970bb0a7189$var$p = Symbol.for("react.fragment"), $dd035970bb0a7189$var$q = Symbol.for("react.strict_mode"), $dd035970bb0a7189$var$r = Symbol.for("react.profiler"), $dd035970bb0a7189$var$t = Symbol.for("react.provider"), $dd035970bb0a7189$var$u = Symbol.for("react.context"), $dd035970bb0a7189$var$v = Symbol.for("react.forward_ref"), $dd035970bb0a7189$var$w = Symbol.for("react.suspense"), $dd035970bb0a7189$var$x = Symbol.for("react.memo"), $dd035970bb0a7189$var$y = Symbol.for("react.lazy"), $dd035970bb0a7189$var$z = Symbol.iterator;
function $dd035970bb0a7189$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $dd035970bb0a7189$var$z && a[$dd035970bb0a7189$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $dd035970bb0a7189$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $dd035970bb0a7189$var$C = Object.assign, $dd035970bb0a7189$var$D = {};
function $dd035970bb0a7189$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd035970bb0a7189$var$D;
    this.updater = e || $dd035970bb0a7189$var$B;
}
$dd035970bb0a7189$var$E.prototype.isReactComponent = {};
$dd035970bb0a7189$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$dd035970bb0a7189$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $dd035970bb0a7189$var$F() {}
$dd035970bb0a7189$var$F.prototype = $dd035970bb0a7189$var$E.prototype;
function $dd035970bb0a7189$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $dd035970bb0a7189$var$D;
    this.updater = e || $dd035970bb0a7189$var$B;
}
var $dd035970bb0a7189$var$H = $dd035970bb0a7189$var$G.prototype = new $dd035970bb0a7189$var$F;
$dd035970bb0a7189$var$H.constructor = $dd035970bb0a7189$var$G;
$dd035970bb0a7189$var$C($dd035970bb0a7189$var$H, $dd035970bb0a7189$var$E.prototype);
$dd035970bb0a7189$var$H.isPureReactComponent = !0;
var $dd035970bb0a7189$var$I = Array.isArray, $dd035970bb0a7189$var$J = Object.prototype.hasOwnProperty, $dd035970bb0a7189$var$K = {
    current: null
}, $dd035970bb0a7189$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $dd035970bb0a7189$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$dd035970bb0a7189$var$J.call(b, d) && !$dd035970bb0a7189$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $dd035970bb0a7189$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $dd035970bb0a7189$var$K.current
    };
}
function $dd035970bb0a7189$var$N(a, b) {
    return {
        $$typeof: $dd035970bb0a7189$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $dd035970bb0a7189$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $dd035970bb0a7189$var$l;
}
function $dd035970bb0a7189$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $dd035970bb0a7189$var$P = /\/+/g;
function $dd035970bb0a7189$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $dd035970bb0a7189$var$escape("" + a.key) : b.toString(36);
}
function $dd035970bb0a7189$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $dd035970bb0a7189$var$l:
                case $dd035970bb0a7189$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $dd035970bb0a7189$var$Q(h, 0) : d, $dd035970bb0a7189$var$I(c) ? (e = "", null != a && (e = a.replace($dd035970bb0a7189$var$P, "$&/") + "/"), $dd035970bb0a7189$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($dd035970bb0a7189$var$O(c) && (c = $dd035970bb0a7189$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($dd035970bb0a7189$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($dd035970bb0a7189$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $dd035970bb0a7189$var$Q(k, g);
        h += $dd035970bb0a7189$var$R(k, b, e, f, c);
    }
    else if (f = $dd035970bb0a7189$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $dd035970bb0a7189$var$Q(k, g++), h += $dd035970bb0a7189$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $dd035970bb0a7189$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $dd035970bb0a7189$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $dd035970bb0a7189$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $dd035970bb0a7189$var$U = {
    current: null
}, $dd035970bb0a7189$var$V = {
    transition: null
}, $dd035970bb0a7189$var$W = {
    ReactCurrentDispatcher: $dd035970bb0a7189$var$U,
    ReactCurrentBatchConfig: $dd035970bb0a7189$var$V,
    ReactCurrentOwner: $dd035970bb0a7189$var$K
};
$dd035970bb0a7189$export$dca3b0875bd9a954 = {
    map: $dd035970bb0a7189$var$S,
    forEach: function(a, b, e) {
        $dd035970bb0a7189$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $dd035970bb0a7189$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $dd035970bb0a7189$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$dd035970bb0a7189$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$dd035970bb0a7189$export$16fa2f45be04daa8 = $dd035970bb0a7189$var$E;
$dd035970bb0a7189$export$ffb0004e005737fa = $dd035970bb0a7189$var$p;
$dd035970bb0a7189$export$e2c29f18771995cb = $dd035970bb0a7189$var$r;
$dd035970bb0a7189$export$221d75b3f55bb0bd = $dd035970bb0a7189$var$G;
$dd035970bb0a7189$export$5f8d39834fd61797 = $dd035970bb0a7189$var$q;
$dd035970bb0a7189$export$74bf444e3cd11ea5 = $dd035970bb0a7189$var$w;
$dd035970bb0a7189$export$ae55be85d98224ed = $dd035970bb0a7189$var$W;
$dd035970bb0a7189$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $dd035970bb0a7189$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $dd035970bb0a7189$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$dd035970bb0a7189$var$J.call(b, f) && !$dd035970bb0a7189$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $dd035970bb0a7189$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$dd035970bb0a7189$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $dd035970bb0a7189$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $dd035970bb0a7189$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$dd035970bb0a7189$export$c8a8987d4410bf2d = $dd035970bb0a7189$var$M;
$dd035970bb0a7189$export$d38cd72104c1f0e9 = function(a) {
    var b = $dd035970bb0a7189$var$M.bind(null, a);
    b.type = a;
    return b;
};
$dd035970bb0a7189$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$dd035970bb0a7189$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $dd035970bb0a7189$var$v,
        render: a
    };
};
$dd035970bb0a7189$export$a8257692ac88316c = $dd035970bb0a7189$var$O;
$dd035970bb0a7189$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $dd035970bb0a7189$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $dd035970bb0a7189$var$T
    };
};
$dd035970bb0a7189$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $dd035970bb0a7189$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$dd035970bb0a7189$export$7568632d0d33d16d = function(a) {
    var b = $dd035970bb0a7189$var$V.transition;
    $dd035970bb0a7189$var$V.transition = {};
    try {
        a();
    } finally{
        $dd035970bb0a7189$var$V.transition = b;
    }
};
$dd035970bb0a7189$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$dd035970bb0a7189$export$35808ee640e87ca7 = function(a, b) {
    return $dd035970bb0a7189$var$U.current.useCallback(a, b);
};
$dd035970bb0a7189$export$fae74005e78b1a27 = function(a) {
    return $dd035970bb0a7189$var$U.current.useContext(a);
};
$dd035970bb0a7189$export$dc8fbce3eb94dc1e = function() {};
$dd035970bb0a7189$export$6a7bc4e911dc01cf = function(a) {
    return $dd035970bb0a7189$var$U.current.useDeferredValue(a);
};
$dd035970bb0a7189$export$6d9c69b0de29b591 = function(a, b) {
    return $dd035970bb0a7189$var$U.current.useEffect(a, b);
};
$dd035970bb0a7189$export$f680877a34711e37 = function() {
    return $dd035970bb0a7189$var$U.current.useId();
};
$dd035970bb0a7189$export$d5a552a76deda3c2 = function(a, b, e) {
    return $dd035970bb0a7189$var$U.current.useImperativeHandle(a, b, e);
};
$dd035970bb0a7189$export$aaabe4eda9ed9969 = function(a, b) {
    return $dd035970bb0a7189$var$U.current.useInsertionEffect(a, b);
};
$dd035970bb0a7189$export$e5c5a5f917a5871c = function(a, b) {
    return $dd035970bb0a7189$var$U.current.useLayoutEffect(a, b);
};
$dd035970bb0a7189$export$1538c33de8887b59 = function(a, b) {
    return $dd035970bb0a7189$var$U.current.useMemo(a, b);
};
$dd035970bb0a7189$export$13e3392192263954 = function(a, b, e) {
    return $dd035970bb0a7189$var$U.current.useReducer(a, b, e);
};
$dd035970bb0a7189$export$b8f5890fc79d6aca = function(a) {
    return $dd035970bb0a7189$var$U.current.useRef(a);
};
$dd035970bb0a7189$export$60241385465d0a34 = function(a) {
    return $dd035970bb0a7189$var$U.current.useState(a);
};
$dd035970bb0a7189$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $dd035970bb0a7189$var$U.current.useSyncExternalStore(a, b, e);
};
$dd035970bb0a7189$export$7b286972b8d8ccbf = function() {
    return $dd035970bb0a7189$var$U.current.useTransition();
};
$dd035970bb0a7189$export$83d89fbfd8236492 = "18.2.0";

});




parcelRegister("edP6V", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $a5a9ed1d43a3a911$export$ae55be85d98224ed; }, function (v) { return $a5a9ed1d43a3a911$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $a5a9ed1d43a3a911$export$d39a5bbd09211389; }, function (v) { return $a5a9ed1d43a3a911$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $a5a9ed1d43a3a911$export$882461b6382ed46c; }, function (v) { return $a5a9ed1d43a3a911$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $a5a9ed1d43a3a911$export$466bfc07425424d5; }, function (v) { return $a5a9ed1d43a3a911$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $a5a9ed1d43a3a911$export$cd75ccfd720a3cd4; }, function (v) { return $a5a9ed1d43a3a911$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $a5a9ed1d43a3a911$export$fa8d919ba61d84db; }, function (v) { return $a5a9ed1d43a3a911$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $a5a9ed1d43a3a911$export$757ceba2d55c277e; }, function (v) { return $a5a9ed1d43a3a911$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $a5a9ed1d43a3a911$export$b3890eb0ae9dca99; }, function (v) { return $a5a9ed1d43a3a911$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $a5a9ed1d43a3a911$export$502457920280e6be; }, function (v) { return $a5a9ed1d43a3a911$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $a5a9ed1d43a3a911$export$c78a37762a8d58e1; }, function (v) { return $a5a9ed1d43a3a911$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $a5a9ed1d43a3a911$export$dc54d992c10e8a18; }, function (v) { return $a5a9ed1d43a3a911$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $a5a9ed1d43a3a911$export$83d89fbfd8236492; }, function (v) { return $a5a9ed1d43a3a911$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $a5a9ed1d43a3a911$export$ae55be85d98224ed;
var $a5a9ed1d43a3a911$export$d39a5bbd09211389;
var $a5a9ed1d43a3a911$export$882461b6382ed46c;
var $a5a9ed1d43a3a911$export$466bfc07425424d5;
var $a5a9ed1d43a3a911$export$cd75ccfd720a3cd4;
var $a5a9ed1d43a3a911$export$fa8d919ba61d84db;
var $a5a9ed1d43a3a911$export$757ceba2d55c277e;
var $a5a9ed1d43a3a911$export$b3890eb0ae9dca99;
var $a5a9ed1d43a3a911$export$502457920280e6be;
var $a5a9ed1d43a3a911$export$c78a37762a8d58e1;
var $a5a9ed1d43a3a911$export$dc54d992c10e8a18;
var $a5a9ed1d43a3a911$export$83d89fbfd8236492;
"use strict";

var $aOChP = parcelRequire("aOChP");

var $c22GA = parcelRequire("c22GA");
function $a5a9ed1d43a3a911$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $a5a9ed1d43a3a911$var$da = new Set, $a5a9ed1d43a3a911$var$ea = {};
function $a5a9ed1d43a3a911$var$fa(a, b) {
    $a5a9ed1d43a3a911$var$ha(a, b);
    $a5a9ed1d43a3a911$var$ha(a + "Capture", b);
}
function $a5a9ed1d43a3a911$var$ha(a, b) {
    $a5a9ed1d43a3a911$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$a5a9ed1d43a3a911$var$da.add(b[a]);
}
var $a5a9ed1d43a3a911$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a5a9ed1d43a3a911$var$ja = Object.prototype.hasOwnProperty, $a5a9ed1d43a3a911$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $a5a9ed1d43a3a911$var$la = {}, $a5a9ed1d43a3a911$var$ma = {};
function $a5a9ed1d43a3a911$var$oa(a) {
    if ($a5a9ed1d43a3a911$var$ja.call($a5a9ed1d43a3a911$var$ma, a)) return !0;
    if ($a5a9ed1d43a3a911$var$ja.call($a5a9ed1d43a3a911$var$la, a)) return !1;
    if ($a5a9ed1d43a3a911$var$ka.test(a)) return $a5a9ed1d43a3a911$var$ma[a] = !0;
    $a5a9ed1d43a3a911$var$la[a] = !0;
    return !1;
}
function $a5a9ed1d43a3a911$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $a5a9ed1d43a3a911$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $a5a9ed1d43a3a911$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $a5a9ed1d43a3a911$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $a5a9ed1d43a3a911$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $a5a9ed1d43a3a911$var$z[b] = new $a5a9ed1d43a3a911$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $a5a9ed1d43a3a911$var$ra = /[\-:]([a-z])/g;
function $a5a9ed1d43a3a911$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($a5a9ed1d43a3a911$var$ra, $a5a9ed1d43a3a911$var$sa);
    $a5a9ed1d43a3a911$var$z[b] = new $a5a9ed1d43a3a911$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($a5a9ed1d43a3a911$var$ra, $a5a9ed1d43a3a911$var$sa);
    $a5a9ed1d43a3a911$var$z[b] = new $a5a9ed1d43a3a911$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($a5a9ed1d43a3a911$var$ra, $a5a9ed1d43a3a911$var$sa);
    $a5a9ed1d43a3a911$var$z[b] = new $a5a9ed1d43a3a911$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$a5a9ed1d43a3a911$var$z.xlinkHref = new $a5a9ed1d43a3a911$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $a5a9ed1d43a3a911$var$z[a] = new $a5a9ed1d43a3a911$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $a5a9ed1d43a3a911$var$ta(a, b, c, d) {
    var e = $a5a9ed1d43a3a911$var$z.hasOwnProperty(b) ? $a5a9ed1d43a3a911$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $a5a9ed1d43a3a911$var$qa(b, c, e, d) && (c = null), d || null === e ? $a5a9ed1d43a3a911$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $a5a9ed1d43a3a911$var$ua = $aOChP.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $a5a9ed1d43a3a911$var$va = Symbol.for("react.element"), $a5a9ed1d43a3a911$var$wa = Symbol.for("react.portal"), $a5a9ed1d43a3a911$var$ya = Symbol.for("react.fragment"), $a5a9ed1d43a3a911$var$za = Symbol.for("react.strict_mode"), $a5a9ed1d43a3a911$var$Aa = Symbol.for("react.profiler"), $a5a9ed1d43a3a911$var$Ba = Symbol.for("react.provider"), $a5a9ed1d43a3a911$var$Ca = Symbol.for("react.context"), $a5a9ed1d43a3a911$var$Da = Symbol.for("react.forward_ref"), $a5a9ed1d43a3a911$var$Ea = Symbol.for("react.suspense"), $a5a9ed1d43a3a911$var$Fa = Symbol.for("react.suspense_list"), $a5a9ed1d43a3a911$var$Ga = Symbol.for("react.memo"), $a5a9ed1d43a3a911$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $a5a9ed1d43a3a911$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $a5a9ed1d43a3a911$var$Ja = Symbol.iterator;
function $a5a9ed1d43a3a911$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $a5a9ed1d43a3a911$var$Ja && a[$a5a9ed1d43a3a911$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $a5a9ed1d43a3a911$var$A = Object.assign, $a5a9ed1d43a3a911$var$La;
function $a5a9ed1d43a3a911$var$Ma(a) {
    if (void 0 === $a5a9ed1d43a3a911$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $a5a9ed1d43a3a911$var$La = b && b[1] || "";
    }
    return "\n" + $a5a9ed1d43a3a911$var$La + a;
}
var $a5a9ed1d43a3a911$var$Na = !1;
function $a5a9ed1d43a3a911$var$Oa(a, b) {
    if (!a || $a5a9ed1d43a3a911$var$Na) return "";
    $a5a9ed1d43a3a911$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $a5a9ed1d43a3a911$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $a5a9ed1d43a3a911$var$Ma(a) : "";
}
function $a5a9ed1d43a3a911$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $a5a9ed1d43a3a911$var$Ma(a.type);
        case 16:
            return $a5a9ed1d43a3a911$var$Ma("Lazy");
        case 13:
            return $a5a9ed1d43a3a911$var$Ma("Suspense");
        case 19:
            return $a5a9ed1d43a3a911$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $a5a9ed1d43a3a911$var$Oa(a.type, !1), a;
        case 11:
            return a = $a5a9ed1d43a3a911$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $a5a9ed1d43a3a911$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $a5a9ed1d43a3a911$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $a5a9ed1d43a3a911$var$ya:
            return "Fragment";
        case $a5a9ed1d43a3a911$var$wa:
            return "Portal";
        case $a5a9ed1d43a3a911$var$Aa:
            return "Profiler";
        case $a5a9ed1d43a3a911$var$za:
            return "StrictMode";
        case $a5a9ed1d43a3a911$var$Ea:
            return "Suspense";
        case $a5a9ed1d43a3a911$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $a5a9ed1d43a3a911$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $a5a9ed1d43a3a911$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $a5a9ed1d43a3a911$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $a5a9ed1d43a3a911$var$Ga:
            return b = a.displayName || null, null !== b ? b : $a5a9ed1d43a3a911$var$Qa(a.type) || "Memo";
        case $a5a9ed1d43a3a911$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $a5a9ed1d43a3a911$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $a5a9ed1d43a3a911$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $a5a9ed1d43a3a911$var$Qa(b);
        case 8:
            return b === $a5a9ed1d43a3a911$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $a5a9ed1d43a3a911$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $a5a9ed1d43a3a911$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $a5a9ed1d43a3a911$var$Ua(a) {
    var b = $a5a9ed1d43a3a911$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $a5a9ed1d43a3a911$var$Va(a) {
    a._valueTracker || (a._valueTracker = $a5a9ed1d43a3a911$var$Ua(a));
}
function $a5a9ed1d43a3a911$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $a5a9ed1d43a3a911$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $a5a9ed1d43a3a911$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $a5a9ed1d43a3a911$var$Ya(a, b) {
    var c = b.checked;
    return $a5a9ed1d43a3a911$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $a5a9ed1d43a3a911$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $a5a9ed1d43a3a911$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $a5a9ed1d43a3a911$var$ab(a, b) {
    b = b.checked;
    null != b && $a5a9ed1d43a3a911$var$ta(a, "checked", b, !1);
}
function $a5a9ed1d43a3a911$var$bb(a, b) {
    $a5a9ed1d43a3a911$var$ab(a, b);
    var c = $a5a9ed1d43a3a911$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $a5a9ed1d43a3a911$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $a5a9ed1d43a3a911$var$cb(a, b.type, $a5a9ed1d43a3a911$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $a5a9ed1d43a3a911$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $a5a9ed1d43a3a911$var$cb(a, b, c) {
    if ("number" !== b || $a5a9ed1d43a3a911$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $a5a9ed1d43a3a911$var$eb = Array.isArray;
function $a5a9ed1d43a3a911$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $a5a9ed1d43a3a911$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $a5a9ed1d43a3a911$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($a5a9ed1d43a3a911$var$p(91));
    return $a5a9ed1d43a3a911$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $a5a9ed1d43a3a911$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($a5a9ed1d43a3a911$var$p(92));
            if ($a5a9ed1d43a3a911$var$eb(c)) {
                if (1 < c.length) throw Error($a5a9ed1d43a3a911$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $a5a9ed1d43a3a911$var$Sa(c)
    };
}
function $a5a9ed1d43a3a911$var$ib(a, b) {
    var c = $a5a9ed1d43a3a911$var$Sa(b.value), d = $a5a9ed1d43a3a911$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $a5a9ed1d43a3a911$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $a5a9ed1d43a3a911$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $a5a9ed1d43a3a911$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $a5a9ed1d43a3a911$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $a5a9ed1d43a3a911$var$mb, $a5a9ed1d43a3a911$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $a5a9ed1d43a3a911$var$mb = $a5a9ed1d43a3a911$var$mb || document.createElement("div");
        $a5a9ed1d43a3a911$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $a5a9ed1d43a3a911$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $a5a9ed1d43a3a911$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $a5a9ed1d43a3a911$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $a5a9ed1d43a3a911$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($a5a9ed1d43a3a911$var$pb).forEach(function(a) {
    $a5a9ed1d43a3a911$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $a5a9ed1d43a3a911$var$pb[b] = $a5a9ed1d43a3a911$var$pb[a];
    });
});
function $a5a9ed1d43a3a911$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $a5a9ed1d43a3a911$var$pb.hasOwnProperty(a) && $a5a9ed1d43a3a911$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $a5a9ed1d43a3a911$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $a5a9ed1d43a3a911$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $a5a9ed1d43a3a911$var$tb = $a5a9ed1d43a3a911$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $a5a9ed1d43a3a911$var$ub(a, b) {
    if (b) {
        if ($a5a9ed1d43a3a911$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($a5a9ed1d43a3a911$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($a5a9ed1d43a3a911$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($a5a9ed1d43a3a911$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($a5a9ed1d43a3a911$var$p(62));
    }
}
function $a5a9ed1d43a3a911$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a5a9ed1d43a3a911$var$wb = null;
function $a5a9ed1d43a3a911$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $a5a9ed1d43a3a911$var$yb = null, $a5a9ed1d43a3a911$var$zb = null, $a5a9ed1d43a3a911$var$Ab = null;
function $a5a9ed1d43a3a911$var$Bb(a) {
    if (a = $a5a9ed1d43a3a911$var$Cb(a)) {
        if ("function" !== typeof $a5a9ed1d43a3a911$var$yb) throw Error($a5a9ed1d43a3a911$var$p(280));
        var b = a.stateNode;
        b && (b = $a5a9ed1d43a3a911$var$Db(b), $a5a9ed1d43a3a911$var$yb(a.stateNode, a.type, b));
    }
}
function $a5a9ed1d43a3a911$var$Eb(a) {
    $a5a9ed1d43a3a911$var$zb ? $a5a9ed1d43a3a911$var$Ab ? $a5a9ed1d43a3a911$var$Ab.push(a) : $a5a9ed1d43a3a911$var$Ab = [
        a
    ] : $a5a9ed1d43a3a911$var$zb = a;
}
function $a5a9ed1d43a3a911$var$Fb() {
    if ($a5a9ed1d43a3a911$var$zb) {
        var a = $a5a9ed1d43a3a911$var$zb, b = $a5a9ed1d43a3a911$var$Ab;
        $a5a9ed1d43a3a911$var$Ab = $a5a9ed1d43a3a911$var$zb = null;
        $a5a9ed1d43a3a911$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$a5a9ed1d43a3a911$var$Bb(b[a]);
    }
}
function $a5a9ed1d43a3a911$var$Gb(a, b) {
    return a(b);
}
function $a5a9ed1d43a3a911$var$Hb() {}
var $a5a9ed1d43a3a911$var$Ib = !1;
function $a5a9ed1d43a3a911$var$Jb(a, b, c) {
    if ($a5a9ed1d43a3a911$var$Ib) return a(b, c);
    $a5a9ed1d43a3a911$var$Ib = !0;
    try {
        return $a5a9ed1d43a3a911$var$Gb(a, b, c);
    } finally{
        if ($a5a9ed1d43a3a911$var$Ib = !1, null !== $a5a9ed1d43a3a911$var$zb || null !== $a5a9ed1d43a3a911$var$Ab) $a5a9ed1d43a3a911$var$Hb(), $a5a9ed1d43a3a911$var$Fb();
    }
}
function $a5a9ed1d43a3a911$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $a5a9ed1d43a3a911$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($a5a9ed1d43a3a911$var$p(231, b, typeof c));
    return c;
}
var $a5a9ed1d43a3a911$var$Lb = !1;
if ($a5a9ed1d43a3a911$var$ia) try {
    var $a5a9ed1d43a3a911$var$Mb = {};
    Object.defineProperty($a5a9ed1d43a3a911$var$Mb, "passive", {
        get: function() {
            $a5a9ed1d43a3a911$var$Lb = !0;
        }
    });
    window.addEventListener("test", $a5a9ed1d43a3a911$var$Mb, $a5a9ed1d43a3a911$var$Mb);
    window.removeEventListener("test", $a5a9ed1d43a3a911$var$Mb, $a5a9ed1d43a3a911$var$Mb);
} catch (a) {
    $a5a9ed1d43a3a911$var$Lb = !1;
}
function $a5a9ed1d43a3a911$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $a5a9ed1d43a3a911$var$Ob = !1, $a5a9ed1d43a3a911$var$Pb = null, $a5a9ed1d43a3a911$var$Qb = !1, $a5a9ed1d43a3a911$var$Rb = null, $a5a9ed1d43a3a911$var$Sb = {
    onError: function(a) {
        $a5a9ed1d43a3a911$var$Ob = !0;
        $a5a9ed1d43a3a911$var$Pb = a;
    }
};
function $a5a9ed1d43a3a911$var$Tb(a, b, c, d, e, f, g, h, k) {
    $a5a9ed1d43a3a911$var$Ob = !1;
    $a5a9ed1d43a3a911$var$Pb = null;
    $a5a9ed1d43a3a911$var$Nb.apply($a5a9ed1d43a3a911$var$Sb, arguments);
}
function $a5a9ed1d43a3a911$var$Ub(a, b, c, d, e, f, g, h, k) {
    $a5a9ed1d43a3a911$var$Tb.apply(this, arguments);
    if ($a5a9ed1d43a3a911$var$Ob) {
        if ($a5a9ed1d43a3a911$var$Ob) {
            var l = $a5a9ed1d43a3a911$var$Pb;
            $a5a9ed1d43a3a911$var$Ob = !1;
            $a5a9ed1d43a3a911$var$Pb = null;
        } else throw Error($a5a9ed1d43a3a911$var$p(198));
        $a5a9ed1d43a3a911$var$Qb || ($a5a9ed1d43a3a911$var$Qb = !0, $a5a9ed1d43a3a911$var$Rb = l);
    }
}
function $a5a9ed1d43a3a911$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $a5a9ed1d43a3a911$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $a5a9ed1d43a3a911$var$Xb(a) {
    if ($a5a9ed1d43a3a911$var$Vb(a) !== a) throw Error($a5a9ed1d43a3a911$var$p(188));
}
function $a5a9ed1d43a3a911$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $a5a9ed1d43a3a911$var$Vb(a);
        if (null === b) throw Error($a5a9ed1d43a3a911$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $a5a9ed1d43a3a911$var$Xb(e), a;
                if (f === d) return $a5a9ed1d43a3a911$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($a5a9ed1d43a3a911$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($a5a9ed1d43a3a911$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($a5a9ed1d43a3a911$var$p(190));
    }
    if (3 !== c.tag) throw Error($a5a9ed1d43a3a911$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $a5a9ed1d43a3a911$var$Zb(a) {
    a = $a5a9ed1d43a3a911$var$Yb(a);
    return null !== a ? $a5a9ed1d43a3a911$var$$b(a) : null;
}
function $a5a9ed1d43a3a911$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $a5a9ed1d43a3a911$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $a5a9ed1d43a3a911$var$ac = $c22GA.unstable_scheduleCallback, $a5a9ed1d43a3a911$var$bc = $c22GA.unstable_cancelCallback, $a5a9ed1d43a3a911$var$cc = $c22GA.unstable_shouldYield, $a5a9ed1d43a3a911$var$dc = $c22GA.unstable_requestPaint, $a5a9ed1d43a3a911$var$B = $c22GA.unstable_now, $a5a9ed1d43a3a911$var$ec = $c22GA.unstable_getCurrentPriorityLevel, $a5a9ed1d43a3a911$var$fc = $c22GA.unstable_ImmediatePriority, $a5a9ed1d43a3a911$var$gc = $c22GA.unstable_UserBlockingPriority, $a5a9ed1d43a3a911$var$hc = $c22GA.unstable_NormalPriority, $a5a9ed1d43a3a911$var$ic = $c22GA.unstable_LowPriority, $a5a9ed1d43a3a911$var$jc = $c22GA.unstable_IdlePriority, $a5a9ed1d43a3a911$var$kc = null, $a5a9ed1d43a3a911$var$lc = null;
function $a5a9ed1d43a3a911$var$mc(a) {
    if ($a5a9ed1d43a3a911$var$lc && "function" === typeof $a5a9ed1d43a3a911$var$lc.onCommitFiberRoot) try {
        $a5a9ed1d43a3a911$var$lc.onCommitFiberRoot($a5a9ed1d43a3a911$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $a5a9ed1d43a3a911$var$oc = Math.clz32 ? Math.clz32 : $a5a9ed1d43a3a911$var$nc, $a5a9ed1d43a3a911$var$pc = Math.log, $a5a9ed1d43a3a911$var$qc = Math.LN2;
function $a5a9ed1d43a3a911$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($a5a9ed1d43a3a911$var$pc(a) / $a5a9ed1d43a3a911$var$qc | 0) | 0;
}
var $a5a9ed1d43a3a911$var$rc = 64, $a5a9ed1d43a3a911$var$sc = 4194304;
function $a5a9ed1d43a3a911$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $a5a9ed1d43a3a911$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $a5a9ed1d43a3a911$var$tc(h) : (f &= g, 0 !== f && (d = $a5a9ed1d43a3a911$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $a5a9ed1d43a3a911$var$tc(g) : 0 !== f && (d = $a5a9ed1d43a3a911$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $a5a9ed1d43a3a911$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $a5a9ed1d43a3a911$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a5a9ed1d43a3a911$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $a5a9ed1d43a3a911$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $a5a9ed1d43a3a911$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $a5a9ed1d43a3a911$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $a5a9ed1d43a3a911$var$yc() {
    var a = $a5a9ed1d43a3a911$var$rc;
    $a5a9ed1d43a3a911$var$rc <<= 1;
    0 === ($a5a9ed1d43a3a911$var$rc & 4194240) && ($a5a9ed1d43a3a911$var$rc = 64);
    return a;
}
function $a5a9ed1d43a3a911$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $a5a9ed1d43a3a911$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $a5a9ed1d43a3a911$var$oc(b);
    a[b] = c;
}
function $a5a9ed1d43a3a911$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $a5a9ed1d43a3a911$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $a5a9ed1d43a3a911$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $a5a9ed1d43a3a911$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $a5a9ed1d43a3a911$var$C = 0;
function $a5a9ed1d43a3a911$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $a5a9ed1d43a3a911$var$Ec, $a5a9ed1d43a3a911$var$Fc, $a5a9ed1d43a3a911$var$Gc, $a5a9ed1d43a3a911$var$Hc, $a5a9ed1d43a3a911$var$Ic, $a5a9ed1d43a3a911$var$Jc = !1, $a5a9ed1d43a3a911$var$Kc = [], $a5a9ed1d43a3a911$var$Lc = null, $a5a9ed1d43a3a911$var$Mc = null, $a5a9ed1d43a3a911$var$Nc = null, $a5a9ed1d43a3a911$var$Oc = new Map, $a5a9ed1d43a3a911$var$Pc = new Map, $a5a9ed1d43a3a911$var$Qc = [], $a5a9ed1d43a3a911$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $a5a9ed1d43a3a911$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $a5a9ed1d43a3a911$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $a5a9ed1d43a3a911$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $a5a9ed1d43a3a911$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $a5a9ed1d43a3a911$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a5a9ed1d43a3a911$var$Pc.delete(b.pointerId);
    }
}
function $a5a9ed1d43a3a911$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $a5a9ed1d43a3a911$var$Cb(b), null !== b && $a5a9ed1d43a3a911$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $a5a9ed1d43a3a911$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $a5a9ed1d43a3a911$var$Lc = $a5a9ed1d43a3a911$var$Tc($a5a9ed1d43a3a911$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $a5a9ed1d43a3a911$var$Mc = $a5a9ed1d43a3a911$var$Tc($a5a9ed1d43a3a911$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $a5a9ed1d43a3a911$var$Nc = $a5a9ed1d43a3a911$var$Tc($a5a9ed1d43a3a911$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $a5a9ed1d43a3a911$var$Oc.set(f, $a5a9ed1d43a3a911$var$Tc($a5a9ed1d43a3a911$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $a5a9ed1d43a3a911$var$Pc.set(f, $a5a9ed1d43a3a911$var$Tc($a5a9ed1d43a3a911$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $a5a9ed1d43a3a911$var$Vc(a) {
    var b = $a5a9ed1d43a3a911$var$Wc(a.target);
    if (null !== b) {
        var c = $a5a9ed1d43a3a911$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $a5a9ed1d43a3a911$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $a5a9ed1d43a3a911$var$Ic(a.priority, function() {
                        $a5a9ed1d43a3a911$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $a5a9ed1d43a3a911$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $a5a9ed1d43a3a911$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $a5a9ed1d43a3a911$var$wb = d;
            c.target.dispatchEvent(d);
            $a5a9ed1d43a3a911$var$wb = null;
        } else return b = $a5a9ed1d43a3a911$var$Cb(c), null !== b && $a5a9ed1d43a3a911$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $a5a9ed1d43a3a911$var$Zc(a, b, c) {
    $a5a9ed1d43a3a911$var$Xc(a) && c.delete(b);
}
function $a5a9ed1d43a3a911$var$$c() {
    $a5a9ed1d43a3a911$var$Jc = !1;
    null !== $a5a9ed1d43a3a911$var$Lc && $a5a9ed1d43a3a911$var$Xc($a5a9ed1d43a3a911$var$Lc) && ($a5a9ed1d43a3a911$var$Lc = null);
    null !== $a5a9ed1d43a3a911$var$Mc && $a5a9ed1d43a3a911$var$Xc($a5a9ed1d43a3a911$var$Mc) && ($a5a9ed1d43a3a911$var$Mc = null);
    null !== $a5a9ed1d43a3a911$var$Nc && $a5a9ed1d43a3a911$var$Xc($a5a9ed1d43a3a911$var$Nc) && ($a5a9ed1d43a3a911$var$Nc = null);
    $a5a9ed1d43a3a911$var$Oc.forEach($a5a9ed1d43a3a911$var$Zc);
    $a5a9ed1d43a3a911$var$Pc.forEach($a5a9ed1d43a3a911$var$Zc);
}
function $a5a9ed1d43a3a911$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $a5a9ed1d43a3a911$var$Jc || ($a5a9ed1d43a3a911$var$Jc = !0, $c22GA.unstable_scheduleCallback($c22GA.unstable_NormalPriority, $a5a9ed1d43a3a911$var$$c)));
}
function $a5a9ed1d43a3a911$var$bd(a) {
    function b(b) {
        return $a5a9ed1d43a3a911$var$ad(b, a);
    }
    if (0 < $a5a9ed1d43a3a911$var$Kc.length) {
        $a5a9ed1d43a3a911$var$ad($a5a9ed1d43a3a911$var$Kc[0], a);
        for(var c = 1; c < $a5a9ed1d43a3a911$var$Kc.length; c++){
            var d = $a5a9ed1d43a3a911$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $a5a9ed1d43a3a911$var$Lc && $a5a9ed1d43a3a911$var$ad($a5a9ed1d43a3a911$var$Lc, a);
    null !== $a5a9ed1d43a3a911$var$Mc && $a5a9ed1d43a3a911$var$ad($a5a9ed1d43a3a911$var$Mc, a);
    null !== $a5a9ed1d43a3a911$var$Nc && $a5a9ed1d43a3a911$var$ad($a5a9ed1d43a3a911$var$Nc, a);
    $a5a9ed1d43a3a911$var$Oc.forEach(b);
    $a5a9ed1d43a3a911$var$Pc.forEach(b);
    for(c = 0; c < $a5a9ed1d43a3a911$var$Qc.length; c++)d = $a5a9ed1d43a3a911$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $a5a9ed1d43a3a911$var$Qc.length && (c = $a5a9ed1d43a3a911$var$Qc[0], null === c.blockedOn);)$a5a9ed1d43a3a911$var$Vc(c), null === c.blockedOn && $a5a9ed1d43a3a911$var$Qc.shift();
}
var $a5a9ed1d43a3a911$var$cd = $a5a9ed1d43a3a911$var$ua.ReactCurrentBatchConfig, $a5a9ed1d43a3a911$var$dd = !0;
function $a5a9ed1d43a3a911$var$ed(a, b, c, d) {
    var e = $a5a9ed1d43a3a911$var$C, f = $a5a9ed1d43a3a911$var$cd.transition;
    $a5a9ed1d43a3a911$var$cd.transition = null;
    try {
        $a5a9ed1d43a3a911$var$C = 1, $a5a9ed1d43a3a911$var$fd(a, b, c, d);
    } finally{
        $a5a9ed1d43a3a911$var$C = e, $a5a9ed1d43a3a911$var$cd.transition = f;
    }
}
function $a5a9ed1d43a3a911$var$gd(a, b, c, d) {
    var e = $a5a9ed1d43a3a911$var$C, f = $a5a9ed1d43a3a911$var$cd.transition;
    $a5a9ed1d43a3a911$var$cd.transition = null;
    try {
        $a5a9ed1d43a3a911$var$C = 4, $a5a9ed1d43a3a911$var$fd(a, b, c, d);
    } finally{
        $a5a9ed1d43a3a911$var$C = e, $a5a9ed1d43a3a911$var$cd.transition = f;
    }
}
function $a5a9ed1d43a3a911$var$fd(a, b, c, d) {
    if ($a5a9ed1d43a3a911$var$dd) {
        var e = $a5a9ed1d43a3a911$var$Yc(a, b, c, d);
        if (null === e) $a5a9ed1d43a3a911$var$hd(a, b, d, $a5a9ed1d43a3a911$var$id, c), $a5a9ed1d43a3a911$var$Sc(a, d);
        else if ($a5a9ed1d43a3a911$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($a5a9ed1d43a3a911$var$Sc(a, d), b & 4 && -1 < $a5a9ed1d43a3a911$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $a5a9ed1d43a3a911$var$Cb(e);
                null !== f && $a5a9ed1d43a3a911$var$Ec(f);
                f = $a5a9ed1d43a3a911$var$Yc(a, b, c, d);
                null === f && $a5a9ed1d43a3a911$var$hd(a, b, d, $a5a9ed1d43a3a911$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $a5a9ed1d43a3a911$var$hd(a, b, d, null, c);
    }
}
var $a5a9ed1d43a3a911$var$id = null;
function $a5a9ed1d43a3a911$var$Yc(a, b, c, d) {
    $a5a9ed1d43a3a911$var$id = null;
    a = $a5a9ed1d43a3a911$var$xb(d);
    a = $a5a9ed1d43a3a911$var$Wc(a);
    if (null !== a) {
        if (b = $a5a9ed1d43a3a911$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $a5a9ed1d43a3a911$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $a5a9ed1d43a3a911$var$id = a;
    return null;
}
function $a5a9ed1d43a3a911$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($a5a9ed1d43a3a911$var$ec()){
                case $a5a9ed1d43a3a911$var$fc:
                    return 1;
                case $a5a9ed1d43a3a911$var$gc:
                    return 4;
                case $a5a9ed1d43a3a911$var$hc:
                case $a5a9ed1d43a3a911$var$ic:
                    return 16;
                case $a5a9ed1d43a3a911$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $a5a9ed1d43a3a911$var$kd = null, $a5a9ed1d43a3a911$var$ld = null, $a5a9ed1d43a3a911$var$md = null;
function $a5a9ed1d43a3a911$var$nd() {
    if ($a5a9ed1d43a3a911$var$md) return $a5a9ed1d43a3a911$var$md;
    var a, b = $a5a9ed1d43a3a911$var$ld, c = b.length, d, e = "value" in $a5a9ed1d43a3a911$var$kd ? $a5a9ed1d43a3a911$var$kd.value : $a5a9ed1d43a3a911$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $a5a9ed1d43a3a911$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $a5a9ed1d43a3a911$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $a5a9ed1d43a3a911$var$pd() {
    return !0;
}
function $a5a9ed1d43a3a911$var$qd() {
    return !1;
}
function $a5a9ed1d43a3a911$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $a5a9ed1d43a3a911$var$pd : $a5a9ed1d43a3a911$var$qd;
        this.isPropagationStopped = $a5a9ed1d43a3a911$var$qd;
        return this;
    }
    $a5a9ed1d43a3a911$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $a5a9ed1d43a3a911$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $a5a9ed1d43a3a911$var$pd);
        },
        persist: function() {},
        isPersistent: $a5a9ed1d43a3a911$var$pd
    });
    return b;
}
var $a5a9ed1d43a3a911$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a5a9ed1d43a3a911$var$td = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$sd), $a5a9ed1d43a3a911$var$ud = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$sd, {
    view: 0,
    detail: 0
}), $a5a9ed1d43a3a911$var$vd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$ud), $a5a9ed1d43a3a911$var$wd, $a5a9ed1d43a3a911$var$xd, $a5a9ed1d43a3a911$var$yd, $a5a9ed1d43a3a911$var$Ad = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a5a9ed1d43a3a911$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $a5a9ed1d43a3a911$var$yd && ($a5a9ed1d43a3a911$var$yd && "mousemove" === a.type ? ($a5a9ed1d43a3a911$var$wd = a.screenX - $a5a9ed1d43a3a911$var$yd.screenX, $a5a9ed1d43a3a911$var$xd = a.screenY - $a5a9ed1d43a3a911$var$yd.screenY) : $a5a9ed1d43a3a911$var$xd = $a5a9ed1d43a3a911$var$wd = 0, $a5a9ed1d43a3a911$var$yd = a);
        return $a5a9ed1d43a3a911$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $a5a9ed1d43a3a911$var$xd;
    }
}), $a5a9ed1d43a3a911$var$Bd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Ad), $a5a9ed1d43a3a911$var$Cd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$Ad, {
    dataTransfer: 0
}), $a5a9ed1d43a3a911$var$Dd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Cd), $a5a9ed1d43a3a911$var$Ed = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$ud, {
    relatedTarget: 0
}), $a5a9ed1d43a3a911$var$Fd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Ed), $a5a9ed1d43a3a911$var$Gd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a5a9ed1d43a3a911$var$Hd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Gd), $a5a9ed1d43a3a911$var$Id = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $a5a9ed1d43a3a911$var$Jd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Id), $a5a9ed1d43a3a911$var$Kd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$sd, {
    data: 0
}), $a5a9ed1d43a3a911$var$Ld = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Kd), $a5a9ed1d43a3a911$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a5a9ed1d43a3a911$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a5a9ed1d43a3a911$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a5a9ed1d43a3a911$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $a5a9ed1d43a3a911$var$Od[a]) ? !!b[a] : !1;
}
function $a5a9ed1d43a3a911$var$zd() {
    return $a5a9ed1d43a3a911$var$Pd;
}
var $a5a9ed1d43a3a911$var$Qd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $a5a9ed1d43a3a911$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $a5a9ed1d43a3a911$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $a5a9ed1d43a3a911$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a5a9ed1d43a3a911$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $a5a9ed1d43a3a911$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $a5a9ed1d43a3a911$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $a5a9ed1d43a3a911$var$Rd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Qd), $a5a9ed1d43a3a911$var$Sd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a5a9ed1d43a3a911$var$Td = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Sd), $a5a9ed1d43a3a911$var$Ud = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a5a9ed1d43a3a911$var$zd
}), $a5a9ed1d43a3a911$var$Vd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Ud), $a5a9ed1d43a3a911$var$Wd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a5a9ed1d43a3a911$var$Xd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Wd), $a5a9ed1d43a3a911$var$Yd = $a5a9ed1d43a3a911$var$A({}, $a5a9ed1d43a3a911$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a5a9ed1d43a3a911$var$Zd = $a5a9ed1d43a3a911$var$rd($a5a9ed1d43a3a911$var$Yd), $a5a9ed1d43a3a911$var$$d = [
    9,
    13,
    27,
    32
], $a5a9ed1d43a3a911$var$ae = $a5a9ed1d43a3a911$var$ia && "CompositionEvent" in window, $a5a9ed1d43a3a911$var$be = null;
$a5a9ed1d43a3a911$var$ia && "documentMode" in document && ($a5a9ed1d43a3a911$var$be = document.documentMode);
var $a5a9ed1d43a3a911$var$ce = $a5a9ed1d43a3a911$var$ia && "TextEvent" in window && !$a5a9ed1d43a3a911$var$be, $a5a9ed1d43a3a911$var$de = $a5a9ed1d43a3a911$var$ia && (!$a5a9ed1d43a3a911$var$ae || $a5a9ed1d43a3a911$var$be && 8 < $a5a9ed1d43a3a911$var$be && 11 >= $a5a9ed1d43a3a911$var$be), $a5a9ed1d43a3a911$var$ee = String.fromCharCode(32), $a5a9ed1d43a3a911$var$fe = !1;
function $a5a9ed1d43a3a911$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $a5a9ed1d43a3a911$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a5a9ed1d43a3a911$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $a5a9ed1d43a3a911$var$ie = !1;
function $a5a9ed1d43a3a911$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $a5a9ed1d43a3a911$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $a5a9ed1d43a3a911$var$fe = !0;
            return $a5a9ed1d43a3a911$var$ee;
        case "textInput":
            return a = b.data, a === $a5a9ed1d43a3a911$var$ee && $a5a9ed1d43a3a911$var$fe ? null : a;
        default:
            return null;
    }
}
function $a5a9ed1d43a3a911$var$ke(a, b) {
    if ($a5a9ed1d43a3a911$var$ie) return "compositionend" === a || !$a5a9ed1d43a3a911$var$ae && $a5a9ed1d43a3a911$var$ge(a, b) ? (a = $a5a9ed1d43a3a911$var$nd(), $a5a9ed1d43a3a911$var$md = $a5a9ed1d43a3a911$var$ld = $a5a9ed1d43a3a911$var$kd = null, $a5a9ed1d43a3a911$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $a5a9ed1d43a3a911$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $a5a9ed1d43a3a911$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a5a9ed1d43a3a911$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$a5a9ed1d43a3a911$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $a5a9ed1d43a3a911$var$ne(a, b, c, d) {
    $a5a9ed1d43a3a911$var$Eb(d);
    b = $a5a9ed1d43a3a911$var$oe(b, "onChange");
    0 < b.length && (c = new $a5a9ed1d43a3a911$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $a5a9ed1d43a3a911$var$pe = null, $a5a9ed1d43a3a911$var$qe = null;
function $a5a9ed1d43a3a911$var$re(a) {
    $a5a9ed1d43a3a911$var$se(a, 0);
}
function $a5a9ed1d43a3a911$var$te(a) {
    var b = $a5a9ed1d43a3a911$var$ue(a);
    if ($a5a9ed1d43a3a911$var$Wa(b)) return a;
}
function $a5a9ed1d43a3a911$var$ve(a, b) {
    if ("change" === a) return b;
}
var $a5a9ed1d43a3a911$var$we = !1;
if ($a5a9ed1d43a3a911$var$ia) {
    var $a5a9ed1d43a3a911$var$xe;
    if ($a5a9ed1d43a3a911$var$ia) {
        var $a5a9ed1d43a3a911$var$ye = "oninput" in document;
        if (!$a5a9ed1d43a3a911$var$ye) {
            var $a5a9ed1d43a3a911$var$ze = document.createElement("div");
            $a5a9ed1d43a3a911$var$ze.setAttribute("oninput", "return;");
            $a5a9ed1d43a3a911$var$ye = "function" === typeof $a5a9ed1d43a3a911$var$ze.oninput;
        }
        $a5a9ed1d43a3a911$var$xe = $a5a9ed1d43a3a911$var$ye;
    } else $a5a9ed1d43a3a911$var$xe = !1;
    $a5a9ed1d43a3a911$var$we = $a5a9ed1d43a3a911$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $a5a9ed1d43a3a911$var$Ae() {
    $a5a9ed1d43a3a911$var$pe && ($a5a9ed1d43a3a911$var$pe.detachEvent("onpropertychange", $a5a9ed1d43a3a911$var$Be), $a5a9ed1d43a3a911$var$qe = $a5a9ed1d43a3a911$var$pe = null);
}
function $a5a9ed1d43a3a911$var$Be(a) {
    if ("value" === a.propertyName && $a5a9ed1d43a3a911$var$te($a5a9ed1d43a3a911$var$qe)) {
        var b = [];
        $a5a9ed1d43a3a911$var$ne(b, $a5a9ed1d43a3a911$var$qe, a, $a5a9ed1d43a3a911$var$xb(a));
        $a5a9ed1d43a3a911$var$Jb($a5a9ed1d43a3a911$var$re, b);
    }
}
function $a5a9ed1d43a3a911$var$Ce(a, b, c) {
    "focusin" === a ? ($a5a9ed1d43a3a911$var$Ae(), $a5a9ed1d43a3a911$var$pe = b, $a5a9ed1d43a3a911$var$qe = c, $a5a9ed1d43a3a911$var$pe.attachEvent("onpropertychange", $a5a9ed1d43a3a911$var$Be)) : "focusout" === a && $a5a9ed1d43a3a911$var$Ae();
}
function $a5a9ed1d43a3a911$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $a5a9ed1d43a3a911$var$te($a5a9ed1d43a3a911$var$qe);
}
function $a5a9ed1d43a3a911$var$Ee(a, b) {
    if ("click" === a) return $a5a9ed1d43a3a911$var$te(b);
}
function $a5a9ed1d43a3a911$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $a5a9ed1d43a3a911$var$te(b);
}
function $a5a9ed1d43a3a911$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $a5a9ed1d43a3a911$var$He = "function" === typeof Object.is ? Object.is : $a5a9ed1d43a3a911$var$Ge;
function $a5a9ed1d43a3a911$var$Ie(a, b) {
    if ($a5a9ed1d43a3a911$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$a5a9ed1d43a3a911$var$ja.call(b, e) || !$a5a9ed1d43a3a911$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $a5a9ed1d43a3a911$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $a5a9ed1d43a3a911$var$Ke(a, b) {
    var c = $a5a9ed1d43a3a911$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $a5a9ed1d43a3a911$var$Je(c);
    }
}
function $a5a9ed1d43a3a911$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $a5a9ed1d43a3a911$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $a5a9ed1d43a3a911$var$Me() {
    for(var a = window, b = $a5a9ed1d43a3a911$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $a5a9ed1d43a3a911$var$Xa(a.document);
    }
    return b;
}
function $a5a9ed1d43a3a911$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $a5a9ed1d43a3a911$var$Oe(a) {
    var b = $a5a9ed1d43a3a911$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $a5a9ed1d43a3a911$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $a5a9ed1d43a3a911$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $a5a9ed1d43a3a911$var$Ke(c, f);
                var g = $a5a9ed1d43a3a911$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $a5a9ed1d43a3a911$var$Pe = $a5a9ed1d43a3a911$var$ia && "documentMode" in document && 11 >= document.documentMode, $a5a9ed1d43a3a911$var$Qe = null, $a5a9ed1d43a3a911$var$Re = null, $a5a9ed1d43a3a911$var$Se = null, $a5a9ed1d43a3a911$var$Te = !1;
function $a5a9ed1d43a3a911$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $a5a9ed1d43a3a911$var$Te || null == $a5a9ed1d43a3a911$var$Qe || $a5a9ed1d43a3a911$var$Qe !== $a5a9ed1d43a3a911$var$Xa(d) || (d = $a5a9ed1d43a3a911$var$Qe, "selectionStart" in d && $a5a9ed1d43a3a911$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $a5a9ed1d43a3a911$var$Se && $a5a9ed1d43a3a911$var$Ie($a5a9ed1d43a3a911$var$Se, d) || ($a5a9ed1d43a3a911$var$Se = d, d = $a5a9ed1d43a3a911$var$oe($a5a9ed1d43a3a911$var$Re, "onSelect"), 0 < d.length && (b = new $a5a9ed1d43a3a911$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $a5a9ed1d43a3a911$var$Qe)));
}
function $a5a9ed1d43a3a911$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $a5a9ed1d43a3a911$var$We = {
    animationend: $a5a9ed1d43a3a911$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $a5a9ed1d43a3a911$var$Ve("Animation", "AnimationIteration"),
    animationstart: $a5a9ed1d43a3a911$var$Ve("Animation", "AnimationStart"),
    transitionend: $a5a9ed1d43a3a911$var$Ve("Transition", "TransitionEnd")
}, $a5a9ed1d43a3a911$var$Xe = {}, $a5a9ed1d43a3a911$var$Ye = {};
$a5a9ed1d43a3a911$var$ia && ($a5a9ed1d43a3a911$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $a5a9ed1d43a3a911$var$We.animationend.animation, delete $a5a9ed1d43a3a911$var$We.animationiteration.animation, delete $a5a9ed1d43a3a911$var$We.animationstart.animation), "TransitionEvent" in window || delete $a5a9ed1d43a3a911$var$We.transitionend.transition);
function $a5a9ed1d43a3a911$var$Ze(a) {
    if ($a5a9ed1d43a3a911$var$Xe[a]) return $a5a9ed1d43a3a911$var$Xe[a];
    if (!$a5a9ed1d43a3a911$var$We[a]) return a;
    var b = $a5a9ed1d43a3a911$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $a5a9ed1d43a3a911$var$Ye) return $a5a9ed1d43a3a911$var$Xe[a] = b[c];
    return a;
}
var $a5a9ed1d43a3a911$var$$e = $a5a9ed1d43a3a911$var$Ze("animationend"), $a5a9ed1d43a3a911$var$af = $a5a9ed1d43a3a911$var$Ze("animationiteration"), $a5a9ed1d43a3a911$var$bf = $a5a9ed1d43a3a911$var$Ze("animationstart"), $a5a9ed1d43a3a911$var$cf = $a5a9ed1d43a3a911$var$Ze("transitionend"), $a5a9ed1d43a3a911$var$df = new Map, $a5a9ed1d43a3a911$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $a5a9ed1d43a3a911$var$ff(a, b) {
    $a5a9ed1d43a3a911$var$df.set(a, b);
    $a5a9ed1d43a3a911$var$fa(b, [
        a
    ]);
}
for(var $a5a9ed1d43a3a911$var$gf = 0; $a5a9ed1d43a3a911$var$gf < $a5a9ed1d43a3a911$var$ef.length; $a5a9ed1d43a3a911$var$gf++){
    var $a5a9ed1d43a3a911$var$hf = $a5a9ed1d43a3a911$var$ef[$a5a9ed1d43a3a911$var$gf], $a5a9ed1d43a3a911$var$jf = $a5a9ed1d43a3a911$var$hf.toLowerCase(), $a5a9ed1d43a3a911$var$kf = $a5a9ed1d43a3a911$var$hf[0].toUpperCase() + $a5a9ed1d43a3a911$var$hf.slice(1);
    $a5a9ed1d43a3a911$var$ff($a5a9ed1d43a3a911$var$jf, "on" + $a5a9ed1d43a3a911$var$kf);
}
$a5a9ed1d43a3a911$var$ff($a5a9ed1d43a3a911$var$$e, "onAnimationEnd");
$a5a9ed1d43a3a911$var$ff($a5a9ed1d43a3a911$var$af, "onAnimationIteration");
$a5a9ed1d43a3a911$var$ff($a5a9ed1d43a3a911$var$bf, "onAnimationStart");
$a5a9ed1d43a3a911$var$ff("dblclick", "onDoubleClick");
$a5a9ed1d43a3a911$var$ff("focusin", "onFocus");
$a5a9ed1d43a3a911$var$ff("focusout", "onBlur");
$a5a9ed1d43a3a911$var$ff($a5a9ed1d43a3a911$var$cf, "onTransitionEnd");
$a5a9ed1d43a3a911$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a5a9ed1d43a3a911$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a5a9ed1d43a3a911$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a5a9ed1d43a3a911$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a5a9ed1d43a3a911$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a5a9ed1d43a3a911$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a5a9ed1d43a3a911$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a5a9ed1d43a3a911$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a5a9ed1d43a3a911$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a5a9ed1d43a3a911$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a5a9ed1d43a3a911$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a5a9ed1d43a3a911$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($a5a9ed1d43a3a911$var$lf));
function $a5a9ed1d43a3a911$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $a5a9ed1d43a3a911$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $a5a9ed1d43a3a911$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a5a9ed1d43a3a911$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $a5a9ed1d43a3a911$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($a5a9ed1d43a3a911$var$Qb) throw a = $a5a9ed1d43a3a911$var$Rb, $a5a9ed1d43a3a911$var$Qb = !1, $a5a9ed1d43a3a911$var$Rb = null, a;
}
function $a5a9ed1d43a3a911$var$D(a, b) {
    var c = b[$a5a9ed1d43a3a911$var$of];
    void 0 === c && (c = b[$a5a9ed1d43a3a911$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($a5a9ed1d43a3a911$var$pf(b, a, 2, !1), c.add(d));
}
function $a5a9ed1d43a3a911$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $a5a9ed1d43a3a911$var$pf(c, a, d, b);
}
var $a5a9ed1d43a3a911$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $a5a9ed1d43a3a911$var$sf(a) {
    if (!a[$a5a9ed1d43a3a911$var$rf]) {
        a[$a5a9ed1d43a3a911$var$rf] = !0;
        $a5a9ed1d43a3a911$var$da.forEach(function(b) {
            "selectionchange" !== b && ($a5a9ed1d43a3a911$var$mf.has(b) || $a5a9ed1d43a3a911$var$qf(b, !1, a), $a5a9ed1d43a3a911$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$a5a9ed1d43a3a911$var$rf] || (b[$a5a9ed1d43a3a911$var$rf] = !0, $a5a9ed1d43a3a911$var$qf("selectionchange", !1, b));
    }
}
function $a5a9ed1d43a3a911$var$pf(a, b, c, d) {
    switch($a5a9ed1d43a3a911$var$jd(b)){
        case 1:
            var e = $a5a9ed1d43a3a911$var$ed;
            break;
        case 4:
            e = $a5a9ed1d43a3a911$var$gd;
            break;
        default:
            e = $a5a9ed1d43a3a911$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$a5a9ed1d43a3a911$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $a5a9ed1d43a3a911$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $a5a9ed1d43a3a911$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $a5a9ed1d43a3a911$var$Jb(function() {
        var d = f, e = $a5a9ed1d43a3a911$var$xb(c), g = [];
        a: {
            var h = $a5a9ed1d43a3a911$var$df.get(a);
            if (void 0 !== h) {
                var k = $a5a9ed1d43a3a911$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $a5a9ed1d43a3a911$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $a5a9ed1d43a3a911$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $a5a9ed1d43a3a911$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $a5a9ed1d43a3a911$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $a5a9ed1d43a3a911$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $a5a9ed1d43a3a911$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $a5a9ed1d43a3a911$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $a5a9ed1d43a3a911$var$Vd;
                        break;
                    case $a5a9ed1d43a3a911$var$$e:
                    case $a5a9ed1d43a3a911$var$af:
                    case $a5a9ed1d43a3a911$var$bf:
                        k = $a5a9ed1d43a3a911$var$Hd;
                        break;
                    case $a5a9ed1d43a3a911$var$cf:
                        k = $a5a9ed1d43a3a911$var$Xd;
                        break;
                    case "scroll":
                        k = $a5a9ed1d43a3a911$var$vd;
                        break;
                    case "wheel":
                        k = $a5a9ed1d43a3a911$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $a5a9ed1d43a3a911$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $a5a9ed1d43a3a911$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $a5a9ed1d43a3a911$var$Kb(w, x), null != F && t.push($a5a9ed1d43a3a911$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $a5a9ed1d43a3a911$var$wb && (n = c.relatedTarget || c.fromElement) && ($a5a9ed1d43a3a911$var$Wc(n) || n[$a5a9ed1d43a3a911$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $a5a9ed1d43a3a911$var$Wc(n) : null, null !== n && (J = $a5a9ed1d43a3a911$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $a5a9ed1d43a3a911$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $a5a9ed1d43a3a911$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $a5a9ed1d43a3a911$var$ue(k);
                        u = null == n ? h : $a5a9ed1d43a3a911$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $a5a9ed1d43a3a911$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $a5a9ed1d43a3a911$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $a5a9ed1d43a3a911$var$vf(F))u++;
                            for(; 0 < w - u;)t = $a5a9ed1d43a3a911$var$vf(t), w--;
                            for(; 0 < u - w;)x = $a5a9ed1d43a3a911$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $a5a9ed1d43a3a911$var$vf(t);
                                x = $a5a9ed1d43a3a911$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $a5a9ed1d43a3a911$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $a5a9ed1d43a3a911$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $a5a9ed1d43a3a911$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $a5a9ed1d43a3a911$var$ve;
                else if ($a5a9ed1d43a3a911$var$me(h)) {
                    if ($a5a9ed1d43a3a911$var$we) na = $a5a9ed1d43a3a911$var$Fe;
                    else {
                        na = $a5a9ed1d43a3a911$var$De;
                        var xa = $a5a9ed1d43a3a911$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $a5a9ed1d43a3a911$var$Ee);
                if (na && (na = na(a, d))) {
                    $a5a9ed1d43a3a911$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $a5a9ed1d43a3a911$var$cb(h, "number", h.value);
            }
            xa = d ? $a5a9ed1d43a3a911$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($a5a9ed1d43a3a911$var$me(xa) || "true" === xa.contentEditable) $a5a9ed1d43a3a911$var$Qe = xa, $a5a9ed1d43a3a911$var$Re = d, $a5a9ed1d43a3a911$var$Se = null;
                    break;
                case "focusout":
                    $a5a9ed1d43a3a911$var$Se = $a5a9ed1d43a3a911$var$Re = $a5a9ed1d43a3a911$var$Qe = null;
                    break;
                case "mousedown":
                    $a5a9ed1d43a3a911$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a5a9ed1d43a3a911$var$Te = !1;
                    $a5a9ed1d43a3a911$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($a5a9ed1d43a3a911$var$Pe) break;
                case "keydown":
                case "keyup":
                    $a5a9ed1d43a3a911$var$Ue(g, c, e);
            }
            var $a;
            if ($a5a9ed1d43a3a911$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $a5a9ed1d43a3a911$var$ie ? $a5a9ed1d43a3a911$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($a5a9ed1d43a3a911$var$de && "ko" !== c.locale && ($a5a9ed1d43a3a911$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $a5a9ed1d43a3a911$var$ie && ($a = $a5a9ed1d43a3a911$var$nd()) : ($a5a9ed1d43a3a911$var$kd = e, $a5a9ed1d43a3a911$var$ld = "value" in $a5a9ed1d43a3a911$var$kd ? $a5a9ed1d43a3a911$var$kd.value : $a5a9ed1d43a3a911$var$kd.textContent, $a5a9ed1d43a3a911$var$ie = !0)), xa = $a5a9ed1d43a3a911$var$oe(d, ba), 0 < xa.length && (ba = new $a5a9ed1d43a3a911$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $a5a9ed1d43a3a911$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $a5a9ed1d43a3a911$var$ce ? $a5a9ed1d43a3a911$var$je(a, c) : $a5a9ed1d43a3a911$var$ke(a, c)) d = $a5a9ed1d43a3a911$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $a5a9ed1d43a3a911$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $a5a9ed1d43a3a911$var$se(g, b);
    });
}
function $a5a9ed1d43a3a911$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $a5a9ed1d43a3a911$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $a5a9ed1d43a3a911$var$Kb(a, c), null != f && d.unshift($a5a9ed1d43a3a911$var$tf(a, f, e)), f = $a5a9ed1d43a3a911$var$Kb(a, b), null != f && d.push($a5a9ed1d43a3a911$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $a5a9ed1d43a3a911$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $a5a9ed1d43a3a911$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $a5a9ed1d43a3a911$var$Kb(c, f), null != k && g.unshift($a5a9ed1d43a3a911$var$tf(c, k, h))) : e || (k = $a5a9ed1d43a3a911$var$Kb(c, f), null != k && g.push($a5a9ed1d43a3a911$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $a5a9ed1d43a3a911$var$xf = /\r\n?/g, $a5a9ed1d43a3a911$var$yf = /\u0000|\uFFFD/g;
function $a5a9ed1d43a3a911$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($a5a9ed1d43a3a911$var$xf, "\n").replace($a5a9ed1d43a3a911$var$yf, "");
}
function $a5a9ed1d43a3a911$var$Af(a, b, c) {
    b = $a5a9ed1d43a3a911$var$zf(b);
    if ($a5a9ed1d43a3a911$var$zf(a) !== b && c) throw Error($a5a9ed1d43a3a911$var$p(425));
}
function $a5a9ed1d43a3a911$var$Bf() {}
var $a5a9ed1d43a3a911$var$Cf = null, $a5a9ed1d43a3a911$var$Df = null;
function $a5a9ed1d43a3a911$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $a5a9ed1d43a3a911$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $a5a9ed1d43a3a911$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $a5a9ed1d43a3a911$var$Hf = "function" === typeof Promise ? Promise : void 0, $a5a9ed1d43a3a911$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a5a9ed1d43a3a911$var$Hf ? function(a) {
    return $a5a9ed1d43a3a911$var$Hf.resolve(null).then(a).catch($a5a9ed1d43a3a911$var$If);
} : $a5a9ed1d43a3a911$var$Ff;
function $a5a9ed1d43a3a911$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $a5a9ed1d43a3a911$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $a5a9ed1d43a3a911$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $a5a9ed1d43a3a911$var$bd(b);
}
function $a5a9ed1d43a3a911$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $a5a9ed1d43a3a911$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $a5a9ed1d43a3a911$var$Nf = Math.random().toString(36).slice(2), $a5a9ed1d43a3a911$var$Of = "__reactFiber$" + $a5a9ed1d43a3a911$var$Nf, $a5a9ed1d43a3a911$var$Pf = "__reactProps$" + $a5a9ed1d43a3a911$var$Nf, $a5a9ed1d43a3a911$var$uf = "__reactContainer$" + $a5a9ed1d43a3a911$var$Nf, $a5a9ed1d43a3a911$var$of = "__reactEvents$" + $a5a9ed1d43a3a911$var$Nf, $a5a9ed1d43a3a911$var$Qf = "__reactListeners$" + $a5a9ed1d43a3a911$var$Nf, $a5a9ed1d43a3a911$var$Rf = "__reactHandles$" + $a5a9ed1d43a3a911$var$Nf;
function $a5a9ed1d43a3a911$var$Wc(a) {
    var b = a[$a5a9ed1d43a3a911$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$a5a9ed1d43a3a911$var$uf] || c[$a5a9ed1d43a3a911$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $a5a9ed1d43a3a911$var$Mf(a); null !== a;){
                if (c = a[$a5a9ed1d43a3a911$var$Of]) return c;
                a = $a5a9ed1d43a3a911$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $a5a9ed1d43a3a911$var$Cb(a) {
    a = a[$a5a9ed1d43a3a911$var$Of] || a[$a5a9ed1d43a3a911$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $a5a9ed1d43a3a911$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($a5a9ed1d43a3a911$var$p(33));
}
function $a5a9ed1d43a3a911$var$Db(a) {
    return a[$a5a9ed1d43a3a911$var$Pf] || null;
}
var $a5a9ed1d43a3a911$var$Sf = [], $a5a9ed1d43a3a911$var$Tf = -1;
function $a5a9ed1d43a3a911$var$Uf(a) {
    return {
        current: a
    };
}
function $a5a9ed1d43a3a911$var$E(a) {
    0 > $a5a9ed1d43a3a911$var$Tf || (a.current = $a5a9ed1d43a3a911$var$Sf[$a5a9ed1d43a3a911$var$Tf], $a5a9ed1d43a3a911$var$Sf[$a5a9ed1d43a3a911$var$Tf] = null, $a5a9ed1d43a3a911$var$Tf--);
}
function $a5a9ed1d43a3a911$var$G(a, b) {
    $a5a9ed1d43a3a911$var$Tf++;
    $a5a9ed1d43a3a911$var$Sf[$a5a9ed1d43a3a911$var$Tf] = a.current;
    a.current = b;
}
var $a5a9ed1d43a3a911$var$Vf = {}, $a5a9ed1d43a3a911$var$H = $a5a9ed1d43a3a911$var$Uf($a5a9ed1d43a3a911$var$Vf), $a5a9ed1d43a3a911$var$Wf = $a5a9ed1d43a3a911$var$Uf(!1), $a5a9ed1d43a3a911$var$Xf = $a5a9ed1d43a3a911$var$Vf;
function $a5a9ed1d43a3a911$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $a5a9ed1d43a3a911$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $a5a9ed1d43a3a911$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $a5a9ed1d43a3a911$var$$f() {
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf);
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$H);
}
function $a5a9ed1d43a3a911$var$ag(a, b, c) {
    if ($a5a9ed1d43a3a911$var$H.current !== $a5a9ed1d43a3a911$var$Vf) throw Error($a5a9ed1d43a3a911$var$p(168));
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$H, b);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Wf, c);
}
function $a5a9ed1d43a3a911$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($a5a9ed1d43a3a911$var$p(108, $a5a9ed1d43a3a911$var$Ra(a) || "Unknown", e));
    return $a5a9ed1d43a3a911$var$A({}, c, d);
}
function $a5a9ed1d43a3a911$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $a5a9ed1d43a3a911$var$Vf;
    $a5a9ed1d43a3a911$var$Xf = $a5a9ed1d43a3a911$var$H.current;
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$H, a);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Wf, $a5a9ed1d43a3a911$var$Wf.current);
    return !0;
}
function $a5a9ed1d43a3a911$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($a5a9ed1d43a3a911$var$p(169));
    c ? (a = $a5a9ed1d43a3a911$var$bg(a, b, $a5a9ed1d43a3a911$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf), $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$H), $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$H, a)) : $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Wf, c);
}
var $a5a9ed1d43a3a911$var$eg = null, $a5a9ed1d43a3a911$var$fg = !1, $a5a9ed1d43a3a911$var$gg = !1;
function $a5a9ed1d43a3a911$var$hg(a) {
    null === $a5a9ed1d43a3a911$var$eg ? $a5a9ed1d43a3a911$var$eg = [
        a
    ] : $a5a9ed1d43a3a911$var$eg.push(a);
}
function $a5a9ed1d43a3a911$var$ig(a) {
    $a5a9ed1d43a3a911$var$fg = !0;
    $a5a9ed1d43a3a911$var$hg(a);
}
function $a5a9ed1d43a3a911$var$jg() {
    if (!$a5a9ed1d43a3a911$var$gg && null !== $a5a9ed1d43a3a911$var$eg) {
        $a5a9ed1d43a3a911$var$gg = !0;
        var a = 0, b = $a5a9ed1d43a3a911$var$C;
        try {
            var c = $a5a9ed1d43a3a911$var$eg;
            for($a5a9ed1d43a3a911$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $a5a9ed1d43a3a911$var$eg = null;
            $a5a9ed1d43a3a911$var$fg = !1;
        } catch (e) {
            throw null !== $a5a9ed1d43a3a911$var$eg && ($a5a9ed1d43a3a911$var$eg = $a5a9ed1d43a3a911$var$eg.slice(a + 1)), $a5a9ed1d43a3a911$var$ac($a5a9ed1d43a3a911$var$fc, $a5a9ed1d43a3a911$var$jg), e;
        } finally{
            $a5a9ed1d43a3a911$var$C = b, $a5a9ed1d43a3a911$var$gg = !1;
        }
    }
    return null;
}
var $a5a9ed1d43a3a911$var$kg = [], $a5a9ed1d43a3a911$var$lg = 0, $a5a9ed1d43a3a911$var$mg = null, $a5a9ed1d43a3a911$var$ng = 0, $a5a9ed1d43a3a911$var$og = [], $a5a9ed1d43a3a911$var$pg = 0, $a5a9ed1d43a3a911$var$qg = null, $a5a9ed1d43a3a911$var$rg = 1, $a5a9ed1d43a3a911$var$sg = "";
function $a5a9ed1d43a3a911$var$tg(a, b) {
    $a5a9ed1d43a3a911$var$kg[$a5a9ed1d43a3a911$var$lg++] = $a5a9ed1d43a3a911$var$ng;
    $a5a9ed1d43a3a911$var$kg[$a5a9ed1d43a3a911$var$lg++] = $a5a9ed1d43a3a911$var$mg;
    $a5a9ed1d43a3a911$var$mg = a;
    $a5a9ed1d43a3a911$var$ng = b;
}
function $a5a9ed1d43a3a911$var$ug(a, b, c) {
    $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$rg;
    $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$sg;
    $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$qg;
    $a5a9ed1d43a3a911$var$qg = a;
    var d = $a5a9ed1d43a3a911$var$rg;
    a = $a5a9ed1d43a3a911$var$sg;
    var e = 32 - $a5a9ed1d43a3a911$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $a5a9ed1d43a3a911$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $a5a9ed1d43a3a911$var$rg = 1 << 32 - $a5a9ed1d43a3a911$var$oc(b) + e | c << e | d;
        $a5a9ed1d43a3a911$var$sg = f + a;
    } else $a5a9ed1d43a3a911$var$rg = 1 << f | c << e | d, $a5a9ed1d43a3a911$var$sg = a;
}
function $a5a9ed1d43a3a911$var$vg(a) {
    null !== a.return && ($a5a9ed1d43a3a911$var$tg(a, 1), $a5a9ed1d43a3a911$var$ug(a, 1, 0));
}
function $a5a9ed1d43a3a911$var$wg(a) {
    for(; a === $a5a9ed1d43a3a911$var$mg;)$a5a9ed1d43a3a911$var$mg = $a5a9ed1d43a3a911$var$kg[--$a5a9ed1d43a3a911$var$lg], $a5a9ed1d43a3a911$var$kg[$a5a9ed1d43a3a911$var$lg] = null, $a5a9ed1d43a3a911$var$ng = $a5a9ed1d43a3a911$var$kg[--$a5a9ed1d43a3a911$var$lg], $a5a9ed1d43a3a911$var$kg[$a5a9ed1d43a3a911$var$lg] = null;
    for(; a === $a5a9ed1d43a3a911$var$qg;)$a5a9ed1d43a3a911$var$qg = $a5a9ed1d43a3a911$var$og[--$a5a9ed1d43a3a911$var$pg], $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg] = null, $a5a9ed1d43a3a911$var$sg = $a5a9ed1d43a3a911$var$og[--$a5a9ed1d43a3a911$var$pg], $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg] = null, $a5a9ed1d43a3a911$var$rg = $a5a9ed1d43a3a911$var$og[--$a5a9ed1d43a3a911$var$pg], $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg] = null;
}
var $a5a9ed1d43a3a911$var$xg = null, $a5a9ed1d43a3a911$var$yg = null, $a5a9ed1d43a3a911$var$I = !1, $a5a9ed1d43a3a911$var$zg = null;
function $a5a9ed1d43a3a911$var$Ag(a, b) {
    var c = $a5a9ed1d43a3a911$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $a5a9ed1d43a3a911$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $a5a9ed1d43a3a911$var$xg = a, $a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $a5a9ed1d43a3a911$var$xg = a, $a5a9ed1d43a3a911$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $a5a9ed1d43a3a911$var$qg ? {
                id: $a5a9ed1d43a3a911$var$rg,
                overflow: $a5a9ed1d43a3a911$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $a5a9ed1d43a3a911$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $a5a9ed1d43a3a911$var$xg = a, $a5a9ed1d43a3a911$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $a5a9ed1d43a3a911$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $a5a9ed1d43a3a911$var$Eg(a) {
    if ($a5a9ed1d43a3a911$var$I) {
        var b = $a5a9ed1d43a3a911$var$yg;
        if (b) {
            var c = b;
            if (!$a5a9ed1d43a3a911$var$Cg(a, b)) {
                if ($a5a9ed1d43a3a911$var$Dg(a)) throw Error($a5a9ed1d43a3a911$var$p(418));
                b = $a5a9ed1d43a3a911$var$Lf(c.nextSibling);
                var d = $a5a9ed1d43a3a911$var$xg;
                b && $a5a9ed1d43a3a911$var$Cg(a, b) ? $a5a9ed1d43a3a911$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $a5a9ed1d43a3a911$var$I = !1, $a5a9ed1d43a3a911$var$xg = a);
            }
        } else {
            if ($a5a9ed1d43a3a911$var$Dg(a)) throw Error($a5a9ed1d43a3a911$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $a5a9ed1d43a3a911$var$I = !1;
            $a5a9ed1d43a3a911$var$xg = a;
        }
    }
}
function $a5a9ed1d43a3a911$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $a5a9ed1d43a3a911$var$xg = a;
}
function $a5a9ed1d43a3a911$var$Gg(a) {
    if (a !== $a5a9ed1d43a3a911$var$xg) return !1;
    if (!$a5a9ed1d43a3a911$var$I) return $a5a9ed1d43a3a911$var$Fg(a), $a5a9ed1d43a3a911$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$a5a9ed1d43a3a911$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $a5a9ed1d43a3a911$var$yg)) {
        if ($a5a9ed1d43a3a911$var$Dg(a)) throw $a5a9ed1d43a3a911$var$Hg(), Error($a5a9ed1d43a3a911$var$p(418));
        for(; b;)$a5a9ed1d43a3a911$var$Ag(a, b), b = $a5a9ed1d43a3a911$var$Lf(b.nextSibling);
    }
    $a5a9ed1d43a3a911$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($a5a9ed1d43a3a911$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $a5a9ed1d43a3a911$var$yg = null;
        }
    } else $a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$xg ? $a5a9ed1d43a3a911$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $a5a9ed1d43a3a911$var$Hg() {
    for(var a = $a5a9ed1d43a3a911$var$yg; a;)a = $a5a9ed1d43a3a911$var$Lf(a.nextSibling);
}
function $a5a9ed1d43a3a911$var$Ig() {
    $a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$xg = null;
    $a5a9ed1d43a3a911$var$I = !1;
}
function $a5a9ed1d43a3a911$var$Jg(a) {
    null === $a5a9ed1d43a3a911$var$zg ? $a5a9ed1d43a3a911$var$zg = [
        a
    ] : $a5a9ed1d43a3a911$var$zg.push(a);
}
var $a5a9ed1d43a3a911$var$Kg = $a5a9ed1d43a3a911$var$ua.ReactCurrentBatchConfig;
function $a5a9ed1d43a3a911$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $a5a9ed1d43a3a911$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $a5a9ed1d43a3a911$var$Mg = $a5a9ed1d43a3a911$var$Uf(null), $a5a9ed1d43a3a911$var$Ng = null, $a5a9ed1d43a3a911$var$Og = null, $a5a9ed1d43a3a911$var$Pg = null;
function $a5a9ed1d43a3a911$var$Qg() {
    $a5a9ed1d43a3a911$var$Pg = $a5a9ed1d43a3a911$var$Og = $a5a9ed1d43a3a911$var$Ng = null;
}
function $a5a9ed1d43a3a911$var$Rg(a) {
    var b = $a5a9ed1d43a3a911$var$Mg.current;
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Mg);
    a._currentValue = b;
}
function $a5a9ed1d43a3a911$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $a5a9ed1d43a3a911$var$Tg(a, b) {
    $a5a9ed1d43a3a911$var$Ng = a;
    $a5a9ed1d43a3a911$var$Pg = $a5a9ed1d43a3a911$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($a5a9ed1d43a3a911$var$Ug = !0), a.firstContext = null);
}
function $a5a9ed1d43a3a911$var$Vg(a) {
    var b = a._currentValue;
    if ($a5a9ed1d43a3a911$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $a5a9ed1d43a3a911$var$Og) {
            if (null === $a5a9ed1d43a3a911$var$Ng) throw Error($a5a9ed1d43a3a911$var$p(308));
            $a5a9ed1d43a3a911$var$Og = a;
            $a5a9ed1d43a3a911$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $a5a9ed1d43a3a911$var$Og = $a5a9ed1d43a3a911$var$Og.next = a;
    }
    return b;
}
var $a5a9ed1d43a3a911$var$Wg = null;
function $a5a9ed1d43a3a911$var$Xg(a) {
    null === $a5a9ed1d43a3a911$var$Wg ? $a5a9ed1d43a3a911$var$Wg = [
        a
    ] : $a5a9ed1d43a3a911$var$Wg.push(a);
}
function $a5a9ed1d43a3a911$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $a5a9ed1d43a3a911$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $a5a9ed1d43a3a911$var$Zg(a, d);
}
function $a5a9ed1d43a3a911$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $a5a9ed1d43a3a911$var$$g = !1;
function $a5a9ed1d43a3a911$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $a5a9ed1d43a3a911$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $a5a9ed1d43a3a911$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a5a9ed1d43a3a911$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($a5a9ed1d43a3a911$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $a5a9ed1d43a3a911$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $a5a9ed1d43a3a911$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $a5a9ed1d43a3a911$var$Zg(a, c);
}
function $a5a9ed1d43a3a911$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a5a9ed1d43a3a911$var$Cc(a, c);
    }
}
function $a5a9ed1d43a3a911$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $a5a9ed1d43a3a911$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $a5a9ed1d43a3a911$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $a5a9ed1d43a3a911$var$A({}, q, r);
                            break a;
                        case 2:
                            $a5a9ed1d43a3a911$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $a5a9ed1d43a3a911$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $a5a9ed1d43a3a911$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($a5a9ed1d43a3a911$var$p(191, e));
            e.call(d);
        }
    }
}
var $a5a9ed1d43a3a911$var$jh = (new $aOChP.Component).refs;
function $a5a9ed1d43a3a911$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $a5a9ed1d43a3a911$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $a5a9ed1d43a3a911$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $a5a9ed1d43a3a911$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a5a9ed1d43a3a911$var$L(), e = $a5a9ed1d43a3a911$var$lh(a), f = $a5a9ed1d43a3a911$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a5a9ed1d43a3a911$var$dh(a, f, e);
        null !== b && ($a5a9ed1d43a3a911$var$mh(b, a, e, d), $a5a9ed1d43a3a911$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $a5a9ed1d43a3a911$var$L(), e = $a5a9ed1d43a3a911$var$lh(a), f = $a5a9ed1d43a3a911$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $a5a9ed1d43a3a911$var$dh(a, f, e);
        null !== b && ($a5a9ed1d43a3a911$var$mh(b, a, e, d), $a5a9ed1d43a3a911$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $a5a9ed1d43a3a911$var$L(), d = $a5a9ed1d43a3a911$var$lh(a), e = $a5a9ed1d43a3a911$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $a5a9ed1d43a3a911$var$dh(a, e, d);
        null !== b && ($a5a9ed1d43a3a911$var$mh(b, a, d, c), $a5a9ed1d43a3a911$var$eh(b, a, d));
    }
};
function $a5a9ed1d43a3a911$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$a5a9ed1d43a3a911$var$Ie(c, d) || !$a5a9ed1d43a3a911$var$Ie(e, f) : !0;
}
function $a5a9ed1d43a3a911$var$ph(a, b, c) {
    var d = !1, e = $a5a9ed1d43a3a911$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $a5a9ed1d43a3a911$var$Vg(f) : (e = $a5a9ed1d43a3a911$var$Zf(b) ? $a5a9ed1d43a3a911$var$Xf : $a5a9ed1d43a3a911$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $a5a9ed1d43a3a911$var$Yf(a, e) : $a5a9ed1d43a3a911$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $a5a9ed1d43a3a911$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $a5a9ed1d43a3a911$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $a5a9ed1d43a3a911$var$nh.enqueueReplaceState(b, b.state, null);
}
function $a5a9ed1d43a3a911$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $a5a9ed1d43a3a911$var$jh;
    $a5a9ed1d43a3a911$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $a5a9ed1d43a3a911$var$Vg(f) : (f = $a5a9ed1d43a3a911$var$Zf(b) ? $a5a9ed1d43a3a911$var$Xf : $a5a9ed1d43a3a911$var$H.current, e.context = $a5a9ed1d43a3a911$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($a5a9ed1d43a3a911$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $a5a9ed1d43a3a911$var$nh.enqueueReplaceState(e, e.state, null), $a5a9ed1d43a3a911$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $a5a9ed1d43a3a911$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($a5a9ed1d43a3a911$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($a5a9ed1d43a3a911$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $a5a9ed1d43a3a911$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($a5a9ed1d43a3a911$var$p(284));
        if (!c._owner) throw Error($a5a9ed1d43a3a911$var$p(290, a));
    }
    return a;
}
function $a5a9ed1d43a3a911$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($a5a9ed1d43a3a911$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $a5a9ed1d43a3a911$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $a5a9ed1d43a3a911$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $a5a9ed1d43a3a911$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $a5a9ed1d43a3a911$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $a5a9ed1d43a3a911$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $a5a9ed1d43a3a911$var$Ha && $a5a9ed1d43a3a911$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $a5a9ed1d43a3a911$var$sh(a, b, c), d.return = a, d;
        d = $a5a9ed1d43a3a911$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $a5a9ed1d43a3a911$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $a5a9ed1d43a3a911$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $a5a9ed1d43a3a911$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $a5a9ed1d43a3a911$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $a5a9ed1d43a3a911$var$va:
                    return c = $a5a9ed1d43a3a911$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $a5a9ed1d43a3a911$var$sh(a, null, b), c.return = a, c;
                case $a5a9ed1d43a3a911$var$wa:
                    return b = $a5a9ed1d43a3a911$var$zh(b, a.mode, c), b.return = a, b;
                case $a5a9ed1d43a3a911$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($a5a9ed1d43a3a911$var$eb(b) || $a5a9ed1d43a3a911$var$Ka(b)) return b = $a5a9ed1d43a3a911$var$Ah(b, a.mode, c, null), b.return = a, b;
            $a5a9ed1d43a3a911$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $a5a9ed1d43a3a911$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $a5a9ed1d43a3a911$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $a5a9ed1d43a3a911$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($a5a9ed1d43a3a911$var$eb(c) || $a5a9ed1d43a3a911$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $a5a9ed1d43a3a911$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $a5a9ed1d43a3a911$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $a5a9ed1d43a3a911$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $a5a9ed1d43a3a911$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($a5a9ed1d43a3a911$var$eb(d) || $a5a9ed1d43a3a911$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $a5a9ed1d43a3a911$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $a5a9ed1d43a3a911$var$Ka(h);
        if ("function" !== typeof l) throw Error($a5a9ed1d43a3a911$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($a5a9ed1d43a3a911$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $a5a9ed1d43a3a911$var$I && $a5a9ed1d43a3a911$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $a5a9ed1d43a3a911$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $a5a9ed1d43a3a911$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $a5a9ed1d43a3a911$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $a5a9ed1d43a3a911$var$Ha && $a5a9ed1d43a3a911$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $a5a9ed1d43a3a911$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $a5a9ed1d43a3a911$var$ya ? (d = $a5a9ed1d43a3a911$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $a5a9ed1d43a3a911$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $a5a9ed1d43a3a911$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $a5a9ed1d43a3a911$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $a5a9ed1d43a3a911$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $a5a9ed1d43a3a911$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($a5a9ed1d43a3a911$var$eb(f)) return n(a, d, f, h);
            if ($a5a9ed1d43a3a911$var$Ka(f)) return t(a, d, f, h);
            $a5a9ed1d43a3a911$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $a5a9ed1d43a3a911$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $a5a9ed1d43a3a911$var$Bh = $a5a9ed1d43a3a911$var$vh(!0), $a5a9ed1d43a3a911$var$Ch = $a5a9ed1d43a3a911$var$vh(!1), $a5a9ed1d43a3a911$var$Dh = {}, $a5a9ed1d43a3a911$var$Eh = $a5a9ed1d43a3a911$var$Uf($a5a9ed1d43a3a911$var$Dh), $a5a9ed1d43a3a911$var$Fh = $a5a9ed1d43a3a911$var$Uf($a5a9ed1d43a3a911$var$Dh), $a5a9ed1d43a3a911$var$Gh = $a5a9ed1d43a3a911$var$Uf($a5a9ed1d43a3a911$var$Dh);
function $a5a9ed1d43a3a911$var$Hh(a) {
    if (a === $a5a9ed1d43a3a911$var$Dh) throw Error($a5a9ed1d43a3a911$var$p(174));
    return a;
}
function $a5a9ed1d43a3a911$var$Ih(a, b) {
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Gh, b);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Fh, a);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Eh, $a5a9ed1d43a3a911$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $a5a9ed1d43a3a911$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $a5a9ed1d43a3a911$var$lb(b, a);
    }
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Eh);
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Eh, b);
}
function $a5a9ed1d43a3a911$var$Jh() {
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Eh);
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Fh);
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Gh);
}
function $a5a9ed1d43a3a911$var$Kh(a) {
    $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Gh.current);
    var b = $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Eh.current);
    var c = $a5a9ed1d43a3a911$var$lb(b, a.type);
    b !== c && ($a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Fh, a), $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Eh, c));
}
function $a5a9ed1d43a3a911$var$Lh(a) {
    $a5a9ed1d43a3a911$var$Fh.current === a && ($a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Eh), $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Fh));
}
var $a5a9ed1d43a3a911$var$M = $a5a9ed1d43a3a911$var$Uf(0);
function $a5a9ed1d43a3a911$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $a5a9ed1d43a3a911$var$Nh = [];
function $a5a9ed1d43a3a911$var$Oh() {
    for(var a = 0; a < $a5a9ed1d43a3a911$var$Nh.length; a++)$a5a9ed1d43a3a911$var$Nh[a]._workInProgressVersionPrimary = null;
    $a5a9ed1d43a3a911$var$Nh.length = 0;
}
var $a5a9ed1d43a3a911$var$Ph = $a5a9ed1d43a3a911$var$ua.ReactCurrentDispatcher, $a5a9ed1d43a3a911$var$Qh = $a5a9ed1d43a3a911$var$ua.ReactCurrentBatchConfig, $a5a9ed1d43a3a911$var$Rh = 0, $a5a9ed1d43a3a911$var$N = null, $a5a9ed1d43a3a911$var$O = null, $a5a9ed1d43a3a911$var$P = null, $a5a9ed1d43a3a911$var$Sh = !1, $a5a9ed1d43a3a911$var$Th = !1, $a5a9ed1d43a3a911$var$Uh = 0, $a5a9ed1d43a3a911$var$Vh = 0;
function $a5a9ed1d43a3a911$var$Q() {
    throw Error($a5a9ed1d43a3a911$var$p(321));
}
function $a5a9ed1d43a3a911$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$a5a9ed1d43a3a911$var$He(a[c], b[c])) return !1;
    return !0;
}
function $a5a9ed1d43a3a911$var$Xh(a, b, c, d, e, f) {
    $a5a9ed1d43a3a911$var$Rh = f;
    $a5a9ed1d43a3a911$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $a5a9ed1d43a3a911$var$Ph.current = null === a || null === a.memoizedState ? $a5a9ed1d43a3a911$var$Yh : $a5a9ed1d43a3a911$var$Zh;
    a = c(d, e);
    if ($a5a9ed1d43a3a911$var$Th) {
        f = 0;
        do {
            $a5a9ed1d43a3a911$var$Th = !1;
            $a5a9ed1d43a3a911$var$Uh = 0;
            if (25 <= f) throw Error($a5a9ed1d43a3a911$var$p(301));
            f += 1;
            $a5a9ed1d43a3a911$var$P = $a5a9ed1d43a3a911$var$O = null;
            b.updateQueue = null;
            $a5a9ed1d43a3a911$var$Ph.current = $a5a9ed1d43a3a911$var$$h;
            a = c(d, e);
        }while ($a5a9ed1d43a3a911$var$Th);
    }
    $a5a9ed1d43a3a911$var$Ph.current = $a5a9ed1d43a3a911$var$ai;
    b = null !== $a5a9ed1d43a3a911$var$O && null !== $a5a9ed1d43a3a911$var$O.next;
    $a5a9ed1d43a3a911$var$Rh = 0;
    $a5a9ed1d43a3a911$var$P = $a5a9ed1d43a3a911$var$O = $a5a9ed1d43a3a911$var$N = null;
    $a5a9ed1d43a3a911$var$Sh = !1;
    if (b) throw Error($a5a9ed1d43a3a911$var$p(300));
    return a;
}
function $a5a9ed1d43a3a911$var$bi() {
    var a = 0 !== $a5a9ed1d43a3a911$var$Uh;
    $a5a9ed1d43a3a911$var$Uh = 0;
    return a;
}
function $a5a9ed1d43a3a911$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a5a9ed1d43a3a911$var$P ? $a5a9ed1d43a3a911$var$N.memoizedState = $a5a9ed1d43a3a911$var$P = a : $a5a9ed1d43a3a911$var$P = $a5a9ed1d43a3a911$var$P.next = a;
    return $a5a9ed1d43a3a911$var$P;
}
function $a5a9ed1d43a3a911$var$di() {
    if (null === $a5a9ed1d43a3a911$var$O) {
        var a = $a5a9ed1d43a3a911$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $a5a9ed1d43a3a911$var$O.next;
    var b = null === $a5a9ed1d43a3a911$var$P ? $a5a9ed1d43a3a911$var$N.memoizedState : $a5a9ed1d43a3a911$var$P.next;
    if (null !== b) $a5a9ed1d43a3a911$var$P = b, $a5a9ed1d43a3a911$var$O = a;
    else {
        if (null === a) throw Error($a5a9ed1d43a3a911$var$p(310));
        $a5a9ed1d43a3a911$var$O = a;
        a = {
            memoizedState: $a5a9ed1d43a3a911$var$O.memoizedState,
            baseState: $a5a9ed1d43a3a911$var$O.baseState,
            baseQueue: $a5a9ed1d43a3a911$var$O.baseQueue,
            queue: $a5a9ed1d43a3a911$var$O.queue,
            next: null
        };
        null === $a5a9ed1d43a3a911$var$P ? $a5a9ed1d43a3a911$var$N.memoizedState = $a5a9ed1d43a3a911$var$P = a : $a5a9ed1d43a3a911$var$P = $a5a9ed1d43a3a911$var$P.next = a;
    }
    return $a5a9ed1d43a3a911$var$P;
}
function $a5a9ed1d43a3a911$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $a5a9ed1d43a3a911$var$fi(a) {
    var b = $a5a9ed1d43a3a911$var$di(), c = b.queue;
    if (null === c) throw Error($a5a9ed1d43a3a911$var$p(311));
    c.lastRenderedReducer = a;
    var d = $a5a9ed1d43a3a911$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($a5a9ed1d43a3a911$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $a5a9ed1d43a3a911$var$N.lanes |= m;
                $a5a9ed1d43a3a911$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $a5a9ed1d43a3a911$var$He(d, b.memoizedState) || ($a5a9ed1d43a3a911$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $a5a9ed1d43a3a911$var$N.lanes |= f, $a5a9ed1d43a3a911$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $a5a9ed1d43a3a911$var$gi(a) {
    var b = $a5a9ed1d43a3a911$var$di(), c = b.queue;
    if (null === c) throw Error($a5a9ed1d43a3a911$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $a5a9ed1d43a3a911$var$He(f, b.memoizedState) || ($a5a9ed1d43a3a911$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $a5a9ed1d43a3a911$var$hi() {}
function $a5a9ed1d43a3a911$var$ii(a, b) {
    var c = $a5a9ed1d43a3a911$var$N, d = $a5a9ed1d43a3a911$var$di(), e = b(), f = !$a5a9ed1d43a3a911$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $a5a9ed1d43a3a911$var$Ug = !0);
    d = d.queue;
    $a5a9ed1d43a3a911$var$ji($a5a9ed1d43a3a911$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $a5a9ed1d43a3a911$var$P && $a5a9ed1d43a3a911$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $a5a9ed1d43a3a911$var$li(9, $a5a9ed1d43a3a911$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $a5a9ed1d43a3a911$var$R) throw Error($a5a9ed1d43a3a911$var$p(349));
        0 !== ($a5a9ed1d43a3a911$var$Rh & 30) || $a5a9ed1d43a3a911$var$ni(c, b, e);
    }
    return e;
}
function $a5a9ed1d43a3a911$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $a5a9ed1d43a3a911$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a5a9ed1d43a3a911$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $a5a9ed1d43a3a911$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $a5a9ed1d43a3a911$var$oi(b) && $a5a9ed1d43a3a911$var$pi(a);
}
function $a5a9ed1d43a3a911$var$ki(a, b, c) {
    return c(function() {
        $a5a9ed1d43a3a911$var$oi(b) && $a5a9ed1d43a3a911$var$pi(a);
    });
}
function $a5a9ed1d43a3a911$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$a5a9ed1d43a3a911$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $a5a9ed1d43a3a911$var$pi(a) {
    var b = $a5a9ed1d43a3a911$var$Zg(a, 1);
    null !== b && $a5a9ed1d43a3a911$var$mh(b, a, 1, -1);
}
function $a5a9ed1d43a3a911$var$qi(a) {
    var b = $a5a9ed1d43a3a911$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a5a9ed1d43a3a911$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $a5a9ed1d43a3a911$var$ri.bind(null, $a5a9ed1d43a3a911$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $a5a9ed1d43a3a911$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $a5a9ed1d43a3a911$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $a5a9ed1d43a3a911$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $a5a9ed1d43a3a911$var$si() {
    return $a5a9ed1d43a3a911$var$di().memoizedState;
}
function $a5a9ed1d43a3a911$var$ti(a, b, c, d) {
    var e = $a5a9ed1d43a3a911$var$ci();
    $a5a9ed1d43a3a911$var$N.flags |= a;
    e.memoizedState = $a5a9ed1d43a3a911$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $a5a9ed1d43a3a911$var$ui(a, b, c, d) {
    var e = $a5a9ed1d43a3a911$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $a5a9ed1d43a3a911$var$O) {
        var g = $a5a9ed1d43a3a911$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $a5a9ed1d43a3a911$var$Wh(d, g.deps)) {
            e.memoizedState = $a5a9ed1d43a3a911$var$li(b, c, f, d);
            return;
        }
    }
    $a5a9ed1d43a3a911$var$N.flags |= a;
    e.memoizedState = $a5a9ed1d43a3a911$var$li(1 | b, c, f, d);
}
function $a5a9ed1d43a3a911$var$vi(a, b) {
    return $a5a9ed1d43a3a911$var$ti(8390656, 8, a, b);
}
function $a5a9ed1d43a3a911$var$ji(a, b) {
    return $a5a9ed1d43a3a911$var$ui(2048, 8, a, b);
}
function $a5a9ed1d43a3a911$var$wi(a, b) {
    return $a5a9ed1d43a3a911$var$ui(4, 2, a, b);
}
function $a5a9ed1d43a3a911$var$xi(a, b) {
    return $a5a9ed1d43a3a911$var$ui(4, 4, a, b);
}
function $a5a9ed1d43a3a911$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $a5a9ed1d43a3a911$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $a5a9ed1d43a3a911$var$ui(4, 4, $a5a9ed1d43a3a911$var$yi.bind(null, b, a), c);
}
function $a5a9ed1d43a3a911$var$Ai() {}
function $a5a9ed1d43a3a911$var$Bi(a, b) {
    var c = $a5a9ed1d43a3a911$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a5a9ed1d43a3a911$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a5a9ed1d43a3a911$var$Ci(a, b) {
    var c = $a5a9ed1d43a3a911$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $a5a9ed1d43a3a911$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $a5a9ed1d43a3a911$var$Di(a, b, c) {
    if (0 === ($a5a9ed1d43a3a911$var$Rh & 21)) return a.baseState && (a.baseState = !1, $a5a9ed1d43a3a911$var$Ug = !0), a.memoizedState = c;
    $a5a9ed1d43a3a911$var$He(c, b) || (c = $a5a9ed1d43a3a911$var$yc(), $a5a9ed1d43a3a911$var$N.lanes |= c, $a5a9ed1d43a3a911$var$hh |= c, a.baseState = !0);
    return b;
}
function $a5a9ed1d43a3a911$var$Ei(a, b) {
    var c = $a5a9ed1d43a3a911$var$C;
    $a5a9ed1d43a3a911$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $a5a9ed1d43a3a911$var$Qh.transition;
    $a5a9ed1d43a3a911$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $a5a9ed1d43a3a911$var$C = c, $a5a9ed1d43a3a911$var$Qh.transition = d;
    }
}
function $a5a9ed1d43a3a911$var$Fi() {
    return $a5a9ed1d43a3a911$var$di().memoizedState;
}
function $a5a9ed1d43a3a911$var$Gi(a, b, c) {
    var d = $a5a9ed1d43a3a911$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a5a9ed1d43a3a911$var$Hi(a)) $a5a9ed1d43a3a911$var$Ii(b, c);
    else if (c = $a5a9ed1d43a3a911$var$Yg(a, b, c, d), null !== c) {
        var e = $a5a9ed1d43a3a911$var$L();
        $a5a9ed1d43a3a911$var$mh(c, a, d, e);
        $a5a9ed1d43a3a911$var$Ji(c, b, d);
    }
}
function $a5a9ed1d43a3a911$var$ri(a, b, c) {
    var d = $a5a9ed1d43a3a911$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a5a9ed1d43a3a911$var$Hi(a)) $a5a9ed1d43a3a911$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($a5a9ed1d43a3a911$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $a5a9ed1d43a3a911$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $a5a9ed1d43a3a911$var$Yg(a, b, e, d);
        null !== c && (e = $a5a9ed1d43a3a911$var$L(), $a5a9ed1d43a3a911$var$mh(c, a, d, e), $a5a9ed1d43a3a911$var$Ji(c, b, d));
    }
}
function $a5a9ed1d43a3a911$var$Hi(a) {
    var b = a.alternate;
    return a === $a5a9ed1d43a3a911$var$N || null !== b && b === $a5a9ed1d43a3a911$var$N;
}
function $a5a9ed1d43a3a911$var$Ii(a, b) {
    $a5a9ed1d43a3a911$var$Th = $a5a9ed1d43a3a911$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $a5a9ed1d43a3a911$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $a5a9ed1d43a3a911$var$Cc(a, c);
    }
}
var $a5a9ed1d43a3a911$var$ai = {
    readContext: $a5a9ed1d43a3a911$var$Vg,
    useCallback: $a5a9ed1d43a3a911$var$Q,
    useContext: $a5a9ed1d43a3a911$var$Q,
    useEffect: $a5a9ed1d43a3a911$var$Q,
    useImperativeHandle: $a5a9ed1d43a3a911$var$Q,
    useInsertionEffect: $a5a9ed1d43a3a911$var$Q,
    useLayoutEffect: $a5a9ed1d43a3a911$var$Q,
    useMemo: $a5a9ed1d43a3a911$var$Q,
    useReducer: $a5a9ed1d43a3a911$var$Q,
    useRef: $a5a9ed1d43a3a911$var$Q,
    useState: $a5a9ed1d43a3a911$var$Q,
    useDebugValue: $a5a9ed1d43a3a911$var$Q,
    useDeferredValue: $a5a9ed1d43a3a911$var$Q,
    useTransition: $a5a9ed1d43a3a911$var$Q,
    useMutableSource: $a5a9ed1d43a3a911$var$Q,
    useSyncExternalStore: $a5a9ed1d43a3a911$var$Q,
    useId: $a5a9ed1d43a3a911$var$Q,
    unstable_isNewReconciler: !1
}, $a5a9ed1d43a3a911$var$Yh = {
    readContext: $a5a9ed1d43a3a911$var$Vg,
    useCallback: function(a, b) {
        $a5a9ed1d43a3a911$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $a5a9ed1d43a3a911$var$Vg,
    useEffect: $a5a9ed1d43a3a911$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $a5a9ed1d43a3a911$var$ti(4194308, 4, $a5a9ed1d43a3a911$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $a5a9ed1d43a3a911$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $a5a9ed1d43a3a911$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $a5a9ed1d43a3a911$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $a5a9ed1d43a3a911$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $a5a9ed1d43a3a911$var$Gi.bind(null, $a5a9ed1d43a3a911$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $a5a9ed1d43a3a911$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $a5a9ed1d43a3a911$var$qi,
    useDebugValue: $a5a9ed1d43a3a911$var$Ai,
    useDeferredValue: function(a) {
        return $a5a9ed1d43a3a911$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $a5a9ed1d43a3a911$var$qi(!1), b = a[0];
        a = $a5a9ed1d43a3a911$var$Ei.bind(null, a[1]);
        $a5a9ed1d43a3a911$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $a5a9ed1d43a3a911$var$N, e = $a5a9ed1d43a3a911$var$ci();
        if ($a5a9ed1d43a3a911$var$I) {
            if (void 0 === c) throw Error($a5a9ed1d43a3a911$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $a5a9ed1d43a3a911$var$R) throw Error($a5a9ed1d43a3a911$var$p(349));
            0 !== ($a5a9ed1d43a3a911$var$Rh & 30) || $a5a9ed1d43a3a911$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $a5a9ed1d43a3a911$var$vi($a5a9ed1d43a3a911$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $a5a9ed1d43a3a911$var$li(9, $a5a9ed1d43a3a911$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $a5a9ed1d43a3a911$var$ci(), b = $a5a9ed1d43a3a911$var$R.identifierPrefix;
        if ($a5a9ed1d43a3a911$var$I) {
            var c = $a5a9ed1d43a3a911$var$sg;
            var d = $a5a9ed1d43a3a911$var$rg;
            c = (d & ~(1 << 32 - $a5a9ed1d43a3a911$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $a5a9ed1d43a3a911$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $a5a9ed1d43a3a911$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $a5a9ed1d43a3a911$var$Zh = {
    readContext: $a5a9ed1d43a3a911$var$Vg,
    useCallback: $a5a9ed1d43a3a911$var$Bi,
    useContext: $a5a9ed1d43a3a911$var$Vg,
    useEffect: $a5a9ed1d43a3a911$var$ji,
    useImperativeHandle: $a5a9ed1d43a3a911$var$zi,
    useInsertionEffect: $a5a9ed1d43a3a911$var$wi,
    useLayoutEffect: $a5a9ed1d43a3a911$var$xi,
    useMemo: $a5a9ed1d43a3a911$var$Ci,
    useReducer: $a5a9ed1d43a3a911$var$fi,
    useRef: $a5a9ed1d43a3a911$var$si,
    useState: function() {
        return $a5a9ed1d43a3a911$var$fi($a5a9ed1d43a3a911$var$ei);
    },
    useDebugValue: $a5a9ed1d43a3a911$var$Ai,
    useDeferredValue: function(a) {
        var b = $a5a9ed1d43a3a911$var$di();
        return $a5a9ed1d43a3a911$var$Di(b, $a5a9ed1d43a3a911$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $a5a9ed1d43a3a911$var$fi($a5a9ed1d43a3a911$var$ei)[0], b = $a5a9ed1d43a3a911$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a5a9ed1d43a3a911$var$hi,
    useSyncExternalStore: $a5a9ed1d43a3a911$var$ii,
    useId: $a5a9ed1d43a3a911$var$Fi,
    unstable_isNewReconciler: !1
}, $a5a9ed1d43a3a911$var$$h = {
    readContext: $a5a9ed1d43a3a911$var$Vg,
    useCallback: $a5a9ed1d43a3a911$var$Bi,
    useContext: $a5a9ed1d43a3a911$var$Vg,
    useEffect: $a5a9ed1d43a3a911$var$ji,
    useImperativeHandle: $a5a9ed1d43a3a911$var$zi,
    useInsertionEffect: $a5a9ed1d43a3a911$var$wi,
    useLayoutEffect: $a5a9ed1d43a3a911$var$xi,
    useMemo: $a5a9ed1d43a3a911$var$Ci,
    useReducer: $a5a9ed1d43a3a911$var$gi,
    useRef: $a5a9ed1d43a3a911$var$si,
    useState: function() {
        return $a5a9ed1d43a3a911$var$gi($a5a9ed1d43a3a911$var$ei);
    },
    useDebugValue: $a5a9ed1d43a3a911$var$Ai,
    useDeferredValue: function(a) {
        var b = $a5a9ed1d43a3a911$var$di();
        return null === $a5a9ed1d43a3a911$var$O ? b.memoizedState = a : $a5a9ed1d43a3a911$var$Di(b, $a5a9ed1d43a3a911$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $a5a9ed1d43a3a911$var$gi($a5a9ed1d43a3a911$var$ei)[0], b = $a5a9ed1d43a3a911$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $a5a9ed1d43a3a911$var$hi,
    useSyncExternalStore: $a5a9ed1d43a3a911$var$ii,
    useId: $a5a9ed1d43a3a911$var$Fi,
    unstable_isNewReconciler: !1
};
function $a5a9ed1d43a3a911$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $a5a9ed1d43a3a911$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $a5a9ed1d43a3a911$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $a5a9ed1d43a3a911$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $a5a9ed1d43a3a911$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $a5a9ed1d43a3a911$var$Oi(a, b, c) {
    c = $a5a9ed1d43a3a911$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $a5a9ed1d43a3a911$var$Pi || ($a5a9ed1d43a3a911$var$Pi = !0, $a5a9ed1d43a3a911$var$Qi = d);
        $a5a9ed1d43a3a911$var$Mi(a, b);
    };
    return c;
}
function $a5a9ed1d43a3a911$var$Ri(a, b, c) {
    c = $a5a9ed1d43a3a911$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $a5a9ed1d43a3a911$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $a5a9ed1d43a3a911$var$Mi(a, b);
        "function" !== typeof d && (null === $a5a9ed1d43a3a911$var$Si ? $a5a9ed1d43a3a911$var$Si = new Set([
            this
        ]) : $a5a9ed1d43a3a911$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $a5a9ed1d43a3a911$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $a5a9ed1d43a3a911$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $a5a9ed1d43a3a911$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $a5a9ed1d43a3a911$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $a5a9ed1d43a3a911$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $a5a9ed1d43a3a911$var$ch(-1, 1), b.tag = 2, $a5a9ed1d43a3a911$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $a5a9ed1d43a3a911$var$Xi = $a5a9ed1d43a3a911$var$ua.ReactCurrentOwner, $a5a9ed1d43a3a911$var$Ug = !1;
function $a5a9ed1d43a3a911$var$Yi(a, b, c, d) {
    b.child = null === a ? $a5a9ed1d43a3a911$var$Ch(b, null, c, d) : $a5a9ed1d43a3a911$var$Bh(b, a.child, c, d);
}
function $a5a9ed1d43a3a911$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $a5a9ed1d43a3a911$var$Tg(b, e);
    d = $a5a9ed1d43a3a911$var$Xh(a, b, c, d, f, e);
    c = $a5a9ed1d43a3a911$var$bi();
    if (null !== a && !$a5a9ed1d43a3a911$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a5a9ed1d43a3a911$var$$i(a, b, e);
    $a5a9ed1d43a3a911$var$I && c && $a5a9ed1d43a3a911$var$vg(b);
    b.flags |= 1;
    $a5a9ed1d43a3a911$var$Yi(a, b, d, e);
    return b.child;
}
function $a5a9ed1d43a3a911$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$a5a9ed1d43a3a911$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $a5a9ed1d43a3a911$var$cj(a, b, f, d, e);
        a = $a5a9ed1d43a3a911$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $a5a9ed1d43a3a911$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $a5a9ed1d43a3a911$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $a5a9ed1d43a3a911$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $a5a9ed1d43a3a911$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($a5a9ed1d43a3a911$var$Ie(f, d) && a.ref === b.ref) {
            if ($a5a9ed1d43a3a911$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($a5a9ed1d43a3a911$var$Ug = !0);
            else return b.lanes = a.lanes, $a5a9ed1d43a3a911$var$$i(a, b, e);
        }
    }
    return $a5a9ed1d43a3a911$var$dj(a, b, c, d, e);
}
function $a5a9ed1d43a3a911$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$fj, $a5a9ed1d43a3a911$var$gj), $a5a9ed1d43a3a911$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$fj, $a5a9ed1d43a3a911$var$gj), $a5a9ed1d43a3a911$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$fj, $a5a9ed1d43a3a911$var$gj);
            $a5a9ed1d43a3a911$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$fj, $a5a9ed1d43a3a911$var$gj), $a5a9ed1d43a3a911$var$gj |= d;
    $a5a9ed1d43a3a911$var$Yi(a, b, e, c);
    return b.child;
}
function $a5a9ed1d43a3a911$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $a5a9ed1d43a3a911$var$dj(a, b, c, d, e) {
    var f = $a5a9ed1d43a3a911$var$Zf(c) ? $a5a9ed1d43a3a911$var$Xf : $a5a9ed1d43a3a911$var$H.current;
    f = $a5a9ed1d43a3a911$var$Yf(b, f);
    $a5a9ed1d43a3a911$var$Tg(b, e);
    c = $a5a9ed1d43a3a911$var$Xh(a, b, c, d, f, e);
    d = $a5a9ed1d43a3a911$var$bi();
    if (null !== a && !$a5a9ed1d43a3a911$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $a5a9ed1d43a3a911$var$$i(a, b, e);
    $a5a9ed1d43a3a911$var$I && d && $a5a9ed1d43a3a911$var$vg(b);
    b.flags |= 1;
    $a5a9ed1d43a3a911$var$Yi(a, b, c, e);
    return b.child;
}
function $a5a9ed1d43a3a911$var$ij(a, b, c, d, e) {
    if ($a5a9ed1d43a3a911$var$Zf(c)) {
        var f = !0;
        $a5a9ed1d43a3a911$var$cg(b);
    } else f = !1;
    $a5a9ed1d43a3a911$var$Tg(b, e);
    if (null === b.stateNode) $a5a9ed1d43a3a911$var$jj(a, b), $a5a9ed1d43a3a911$var$ph(b, c, d), $a5a9ed1d43a3a911$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $a5a9ed1d43a3a911$var$Vg(l) : (l = $a5a9ed1d43a3a911$var$Zf(c) ? $a5a9ed1d43a3a911$var$Xf : $a5a9ed1d43a3a911$var$H.current, l = $a5a9ed1d43a3a911$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $a5a9ed1d43a3a911$var$qh(b, g, d, l);
        $a5a9ed1d43a3a911$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $a5a9ed1d43a3a911$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $a5a9ed1d43a3a911$var$Wf.current || $a5a9ed1d43a3a911$var$$g ? ("function" === typeof m && ($a5a9ed1d43a3a911$var$kh(b, c, m, d), k = b.memoizedState), (h = $a5a9ed1d43a3a911$var$$g || $a5a9ed1d43a3a911$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $a5a9ed1d43a3a911$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $a5a9ed1d43a3a911$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $a5a9ed1d43a3a911$var$Vg(k) : (k = $a5a9ed1d43a3a911$var$Zf(c) ? $a5a9ed1d43a3a911$var$Xf : $a5a9ed1d43a3a911$var$H.current, k = $a5a9ed1d43a3a911$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $a5a9ed1d43a3a911$var$qh(b, g, d, k);
        $a5a9ed1d43a3a911$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $a5a9ed1d43a3a911$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $a5a9ed1d43a3a911$var$Wf.current || $a5a9ed1d43a3a911$var$$g ? ("function" === typeof y && ($a5a9ed1d43a3a911$var$kh(b, c, y, d), n = b.memoizedState), (l = $a5a9ed1d43a3a911$var$$g || $a5a9ed1d43a3a911$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $a5a9ed1d43a3a911$var$kj(a, b, c, d, f, e);
}
function $a5a9ed1d43a3a911$var$kj(a, b, c, d, e, f) {
    $a5a9ed1d43a3a911$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $a5a9ed1d43a3a911$var$dg(b, c, !1), $a5a9ed1d43a3a911$var$$i(a, b, f);
    d = b.stateNode;
    $a5a9ed1d43a3a911$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $a5a9ed1d43a3a911$var$Bh(b, a.child, null, f), b.child = $a5a9ed1d43a3a911$var$Bh(b, null, h, f)) : $a5a9ed1d43a3a911$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $a5a9ed1d43a3a911$var$dg(b, c, !0);
    return b.child;
}
function $a5a9ed1d43a3a911$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $a5a9ed1d43a3a911$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $a5a9ed1d43a3a911$var$ag(a, b.context, !1);
    $a5a9ed1d43a3a911$var$Ih(a, b.containerInfo);
}
function $a5a9ed1d43a3a911$var$mj(a, b, c, d, e) {
    $a5a9ed1d43a3a911$var$Ig();
    $a5a9ed1d43a3a911$var$Jg(e);
    b.flags |= 256;
    $a5a9ed1d43a3a911$var$Yi(a, b, c, d);
    return b.child;
}
var $a5a9ed1d43a3a911$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $a5a9ed1d43a3a911$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $a5a9ed1d43a3a911$var$pj(a, b, c) {
    var d = b.pendingProps, e = $a5a9ed1d43a3a911$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, e & 1);
    if (null === a) {
        $a5a9ed1d43a3a911$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $a5a9ed1d43a3a911$var$qj(g, d, 0, null), a = $a5a9ed1d43a3a911$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $a5a9ed1d43a3a911$var$oj(c), b.memoizedState = $a5a9ed1d43a3a911$var$nj, a) : $a5a9ed1d43a3a911$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $a5a9ed1d43a3a911$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $a5a9ed1d43a3a911$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $a5a9ed1d43a3a911$var$wh(h, f) : (f = $a5a9ed1d43a3a911$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $a5a9ed1d43a3a911$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $a5a9ed1d43a3a911$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $a5a9ed1d43a3a911$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $a5a9ed1d43a3a911$var$rj(a, b) {
    b = $a5a9ed1d43a3a911$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $a5a9ed1d43a3a911$var$tj(a, b, c, d) {
    null !== d && $a5a9ed1d43a3a911$var$Jg(d);
    $a5a9ed1d43a3a911$var$Bh(b, a.child, null, c);
    a = $a5a9ed1d43a3a911$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $a5a9ed1d43a3a911$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $a5a9ed1d43a3a911$var$Li(Error($a5a9ed1d43a3a911$var$p(422))), $a5a9ed1d43a3a911$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $a5a9ed1d43a3a911$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $a5a9ed1d43a3a911$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $a5a9ed1d43a3a911$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $a5a9ed1d43a3a911$var$oj(g);
        b.memoizedState = $a5a9ed1d43a3a911$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $a5a9ed1d43a3a911$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($a5a9ed1d43a3a911$var$p(419));
        d = $a5a9ed1d43a3a911$var$Li(f, d, void 0);
        return $a5a9ed1d43a3a911$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($a5a9ed1d43a3a911$var$Ug || h) {
        d = $a5a9ed1d43a3a911$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $a5a9ed1d43a3a911$var$Zg(a, e), $a5a9ed1d43a3a911$var$mh(d, a, e, -1));
        }
        $a5a9ed1d43a3a911$var$uj();
        d = $a5a9ed1d43a3a911$var$Li(Error($a5a9ed1d43a3a911$var$p(421)));
        return $a5a9ed1d43a3a911$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $a5a9ed1d43a3a911$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$Lf(e.nextSibling);
    $a5a9ed1d43a3a911$var$xg = b;
    $a5a9ed1d43a3a911$var$I = !0;
    $a5a9ed1d43a3a911$var$zg = null;
    null !== a && ($a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$rg, $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$sg, $a5a9ed1d43a3a911$var$og[$a5a9ed1d43a3a911$var$pg++] = $a5a9ed1d43a3a911$var$qg, $a5a9ed1d43a3a911$var$rg = a.id, $a5a9ed1d43a3a911$var$sg = a.overflow, $a5a9ed1d43a3a911$var$qg = b);
    b = $a5a9ed1d43a3a911$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $a5a9ed1d43a3a911$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $a5a9ed1d43a3a911$var$Sg(a.return, b, c);
}
function $a5a9ed1d43a3a911$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $a5a9ed1d43a3a911$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $a5a9ed1d43a3a911$var$Yi(a, b, d.children, c);
    d = $a5a9ed1d43a3a911$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $a5a9ed1d43a3a911$var$wj(a, c, b);
            else if (19 === a.tag) $a5a9ed1d43a3a911$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $a5a9ed1d43a3a911$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $a5a9ed1d43a3a911$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $a5a9ed1d43a3a911$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $a5a9ed1d43a3a911$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $a5a9ed1d43a3a911$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $a5a9ed1d43a3a911$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $a5a9ed1d43a3a911$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $a5a9ed1d43a3a911$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($a5a9ed1d43a3a911$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $a5a9ed1d43a3a911$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $a5a9ed1d43a3a911$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $a5a9ed1d43a3a911$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $a5a9ed1d43a3a911$var$lj(b);
            $a5a9ed1d43a3a911$var$Ig();
            break;
        case 5:
            $a5a9ed1d43a3a911$var$Kh(b);
            break;
        case 1:
            $a5a9ed1d43a3a911$var$Zf(b.type) && $a5a9ed1d43a3a911$var$cg(b);
            break;
        case 4:
            $a5a9ed1d43a3a911$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, $a5a9ed1d43a3a911$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $a5a9ed1d43a3a911$var$pj(a, b, c);
                $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, $a5a9ed1d43a3a911$var$M.current & 1);
                a = $a5a9ed1d43a3a911$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, $a5a9ed1d43a3a911$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $a5a9ed1d43a3a911$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, $a5a9ed1d43a3a911$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $a5a9ed1d43a3a911$var$ej(a, b, c);
    }
    return $a5a9ed1d43a3a911$var$$i(a, b, c);
}
var $a5a9ed1d43a3a911$var$Aj, $a5a9ed1d43a3a911$var$Bj, $a5a9ed1d43a3a911$var$Cj, $a5a9ed1d43a3a911$var$Dj;
$a5a9ed1d43a3a911$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$a5a9ed1d43a3a911$var$Bj = function() {};
$a5a9ed1d43a3a911$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $a5a9ed1d43a3a911$var$Ya(a, e);
                d = $a5a9ed1d43a3a911$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $a5a9ed1d43a3a911$var$A({}, e, {
                    value: void 0
                });
                d = $a5a9ed1d43a3a911$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $a5a9ed1d43a3a911$var$gb(a, e);
                d = $a5a9ed1d43a3a911$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $a5a9ed1d43a3a911$var$Bf);
        }
        $a5a9ed1d43a3a911$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($a5a9ed1d43a3a911$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($a5a9ed1d43a3a911$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $a5a9ed1d43a3a911$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$a5a9ed1d43a3a911$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $a5a9ed1d43a3a911$var$Ej(a, b) {
    if (!$a5a9ed1d43a3a911$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $a5a9ed1d43a3a911$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $a5a9ed1d43a3a911$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $a5a9ed1d43a3a911$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a5a9ed1d43a3a911$var$S(b), null;
        case 1:
            return $a5a9ed1d43a3a911$var$Zf(b.type) && $a5a9ed1d43a3a911$var$$f(), $a5a9ed1d43a3a911$var$S(b), null;
        case 3:
            d = b.stateNode;
            $a5a9ed1d43a3a911$var$Jh();
            $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf);
            $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$H);
            $a5a9ed1d43a3a911$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $a5a9ed1d43a3a911$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $a5a9ed1d43a3a911$var$zg && ($a5a9ed1d43a3a911$var$Gj($a5a9ed1d43a3a911$var$zg), $a5a9ed1d43a3a911$var$zg = null));
            $a5a9ed1d43a3a911$var$Bj(a, b);
            $a5a9ed1d43a3a911$var$S(b);
            return null;
        case 5:
            $a5a9ed1d43a3a911$var$Lh(b);
            var e = $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $a5a9ed1d43a3a911$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($a5a9ed1d43a3a911$var$p(166));
                    $a5a9ed1d43a3a911$var$S(b);
                    return null;
                }
                a = $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Eh.current);
                if ($a5a9ed1d43a3a911$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$a5a9ed1d43a3a911$var$Of] = b;
                    d[$a5a9ed1d43a3a911$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $a5a9ed1d43a3a911$var$D("cancel", d);
                            $a5a9ed1d43a3a911$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $a5a9ed1d43a3a911$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $a5a9ed1d43a3a911$var$lf.length; e++)$a5a9ed1d43a3a911$var$D($a5a9ed1d43a3a911$var$lf[e], d);
                            break;
                        case "source":
                            $a5a9ed1d43a3a911$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $a5a9ed1d43a3a911$var$D("error", d);
                            $a5a9ed1d43a3a911$var$D("load", d);
                            break;
                        case "details":
                            $a5a9ed1d43a3a911$var$D("toggle", d);
                            break;
                        case "input":
                            $a5a9ed1d43a3a911$var$Za(d, f);
                            $a5a9ed1d43a3a911$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $a5a9ed1d43a3a911$var$D("invalid", d);
                            break;
                        case "textarea":
                            $a5a9ed1d43a3a911$var$hb(d, f), $a5a9ed1d43a3a911$var$D("invalid", d);
                    }
                    $a5a9ed1d43a3a911$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $a5a9ed1d43a3a911$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $a5a9ed1d43a3a911$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $a5a9ed1d43a3a911$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $a5a9ed1d43a3a911$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $a5a9ed1d43a3a911$var$Va(d);
                            $a5a9ed1d43a3a911$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $a5a9ed1d43a3a911$var$Va(d);
                            $a5a9ed1d43a3a911$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $a5a9ed1d43a3a911$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $a5a9ed1d43a3a911$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$a5a9ed1d43a3a911$var$Of] = b;
                    a[$a5a9ed1d43a3a911$var$Pf] = d;
                    $a5a9ed1d43a3a911$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $a5a9ed1d43a3a911$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $a5a9ed1d43a3a911$var$D("cancel", a);
                                $a5a9ed1d43a3a911$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $a5a9ed1d43a3a911$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $a5a9ed1d43a3a911$var$lf.length; e++)$a5a9ed1d43a3a911$var$D($a5a9ed1d43a3a911$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $a5a9ed1d43a3a911$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $a5a9ed1d43a3a911$var$D("error", a);
                                $a5a9ed1d43a3a911$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $a5a9ed1d43a3a911$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $a5a9ed1d43a3a911$var$Za(a, d);
                                e = $a5a9ed1d43a3a911$var$Ya(a, d);
                                $a5a9ed1d43a3a911$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $a5a9ed1d43a3a911$var$A({}, d, {
                                    value: void 0
                                });
                                $a5a9ed1d43a3a911$var$D("invalid", a);
                                break;
                            case "textarea":
                                $a5a9ed1d43a3a911$var$hb(a, d);
                                e = $a5a9ed1d43a3a911$var$gb(a, d);
                                $a5a9ed1d43a3a911$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $a5a9ed1d43a3a911$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $a5a9ed1d43a3a911$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $a5a9ed1d43a3a911$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $a5a9ed1d43a3a911$var$ob(a, k) : "number" === typeof k && $a5a9ed1d43a3a911$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($a5a9ed1d43a3a911$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $a5a9ed1d43a3a911$var$D("scroll", a) : null != k && $a5a9ed1d43a3a911$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $a5a9ed1d43a3a911$var$Va(a);
                                $a5a9ed1d43a3a911$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $a5a9ed1d43a3a911$var$Va(a);
                                $a5a9ed1d43a3a911$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $a5a9ed1d43a3a911$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $a5a9ed1d43a3a911$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $a5a9ed1d43a3a911$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $a5a9ed1d43a3a911$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $a5a9ed1d43a3a911$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $a5a9ed1d43a3a911$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($a5a9ed1d43a3a911$var$p(166));
                c = $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Gh.current);
                $a5a9ed1d43a3a911$var$Hh($a5a9ed1d43a3a911$var$Eh.current);
                if ($a5a9ed1d43a3a911$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$a5a9ed1d43a3a911$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $a5a9ed1d43a3a911$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $a5a9ed1d43a3a911$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $a5a9ed1d43a3a911$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$a5a9ed1d43a3a911$var$Of] = b, b.stateNode = d;
            }
            $a5a9ed1d43a3a911$var$S(b);
            return null;
        case 13:
            $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($a5a9ed1d43a3a911$var$I && null !== $a5a9ed1d43a3a911$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $a5a9ed1d43a3a911$var$Hg(), $a5a9ed1d43a3a911$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $a5a9ed1d43a3a911$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($a5a9ed1d43a3a911$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($a5a9ed1d43a3a911$var$p(317));
                        f[$a5a9ed1d43a3a911$var$Of] = b;
                    } else $a5a9ed1d43a3a911$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $a5a9ed1d43a3a911$var$S(b);
                    f = !1;
                } else null !== $a5a9ed1d43a3a911$var$zg && ($a5a9ed1d43a3a911$var$Gj($a5a9ed1d43a3a911$var$zg), $a5a9ed1d43a3a911$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($a5a9ed1d43a3a911$var$M.current & 1) ? 0 === $a5a9ed1d43a3a911$var$T && ($a5a9ed1d43a3a911$var$T = 3) : $a5a9ed1d43a3a911$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $a5a9ed1d43a3a911$var$S(b);
            return null;
        case 4:
            return $a5a9ed1d43a3a911$var$Jh(), $a5a9ed1d43a3a911$var$Bj(a, b), null === a && $a5a9ed1d43a3a911$var$sf(b.stateNode.containerInfo), $a5a9ed1d43a3a911$var$S(b), null;
        case 10:
            return $a5a9ed1d43a3a911$var$Rg(b.type._context), $a5a9ed1d43a3a911$var$S(b), null;
        case 17:
            return $a5a9ed1d43a3a911$var$Zf(b.type) && $a5a9ed1d43a3a911$var$$f(), $a5a9ed1d43a3a911$var$S(b), null;
        case 19:
            $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M);
            f = b.memoizedState;
            if (null === f) return $a5a9ed1d43a3a911$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $a5a9ed1d43a3a911$var$Ej(f, !1);
                else {
                    if (0 !== $a5a9ed1d43a3a911$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $a5a9ed1d43a3a911$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $a5a9ed1d43a3a911$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, $a5a9ed1d43a3a911$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $a5a9ed1d43a3a911$var$B() > $a5a9ed1d43a3a911$var$Hj && (b.flags |= 128, d = !0, $a5a9ed1d43a3a911$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $a5a9ed1d43a3a911$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $a5a9ed1d43a3a911$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$a5a9ed1d43a3a911$var$I) return $a5a9ed1d43a3a911$var$S(b), null;
                    } else 2 * $a5a9ed1d43a3a911$var$B() - f.renderingStartTime > $a5a9ed1d43a3a911$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $a5a9ed1d43a3a911$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $a5a9ed1d43a3a911$var$B(), b.sibling = null, c = $a5a9ed1d43a3a911$var$M.current, $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$M, d ? c & 1 | 2 : c & 1), b;
            $a5a9ed1d43a3a911$var$S(b);
            return null;
        case 22:
        case 23:
            return $a5a9ed1d43a3a911$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($a5a9ed1d43a3a911$var$gj & 1073741824) && ($a5a9ed1d43a3a911$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $a5a9ed1d43a3a911$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($a5a9ed1d43a3a911$var$p(156, b.tag));
}
function $a5a9ed1d43a3a911$var$Jj(a, b) {
    $a5a9ed1d43a3a911$var$wg(b);
    switch(b.tag){
        case 1:
            return $a5a9ed1d43a3a911$var$Zf(b.type) && $a5a9ed1d43a3a911$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $a5a9ed1d43a3a911$var$Jh(), $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf), $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$H), $a5a9ed1d43a3a911$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $a5a9ed1d43a3a911$var$Lh(b), null;
        case 13:
            $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($a5a9ed1d43a3a911$var$p(340));
                $a5a9ed1d43a3a911$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M), null;
        case 4:
            return $a5a9ed1d43a3a911$var$Jh(), null;
        case 10:
            return $a5a9ed1d43a3a911$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $a5a9ed1d43a3a911$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $a5a9ed1d43a3a911$var$Kj = !1, $a5a9ed1d43a3a911$var$U = !1, $a5a9ed1d43a3a911$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $a5a9ed1d43a3a911$var$V = null;
function $a5a9ed1d43a3a911$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $a5a9ed1d43a3a911$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $a5a9ed1d43a3a911$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $a5a9ed1d43a3a911$var$W(a, b, d);
    }
}
var $a5a9ed1d43a3a911$var$Oj = !1;
function $a5a9ed1d43a3a911$var$Pj(a, b) {
    $a5a9ed1d43a3a911$var$Cf = $a5a9ed1d43a3a911$var$dd;
    a = $a5a9ed1d43a3a911$var$Me();
    if ($a5a9ed1d43a3a911$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $a5a9ed1d43a3a911$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $a5a9ed1d43a3a911$var$dd = !1;
    for($a5a9ed1d43a3a911$var$V = b; null !== $a5a9ed1d43a3a911$var$V;)if (b = $a5a9ed1d43a3a911$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $a5a9ed1d43a3a911$var$V = a;
    else for(; null !== $a5a9ed1d43a3a911$var$V;){
        b = $a5a9ed1d43a3a911$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $a5a9ed1d43a3a911$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($a5a9ed1d43a3a911$var$p(163));
            }
        } catch (F) {
            $a5a9ed1d43a3a911$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $a5a9ed1d43a3a911$var$V = a;
            break;
        }
        $a5a9ed1d43a3a911$var$V = b.return;
    }
    n = $a5a9ed1d43a3a911$var$Oj;
    $a5a9ed1d43a3a911$var$Oj = !1;
    return n;
}
function $a5a9ed1d43a3a911$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $a5a9ed1d43a3a911$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $a5a9ed1d43a3a911$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $a5a9ed1d43a3a911$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $a5a9ed1d43a3a911$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $a5a9ed1d43a3a911$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$a5a9ed1d43a3a911$var$Of], delete b[$a5a9ed1d43a3a911$var$Pf], delete b[$a5a9ed1d43a3a911$var$of], delete b[$a5a9ed1d43a3a911$var$Qf], delete b[$a5a9ed1d43a3a911$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $a5a9ed1d43a3a911$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $a5a9ed1d43a3a911$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $a5a9ed1d43a3a911$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $a5a9ed1d43a3a911$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $a5a9ed1d43a3a911$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($a5a9ed1d43a3a911$var$Wj(a, b, c), a = a.sibling; null !== a;)$a5a9ed1d43a3a911$var$Wj(a, b, c), a = a.sibling;
}
function $a5a9ed1d43a3a911$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($a5a9ed1d43a3a911$var$Xj(a, b, c), a = a.sibling; null !== a;)$a5a9ed1d43a3a911$var$Xj(a, b, c), a = a.sibling;
}
var $a5a9ed1d43a3a911$var$X = null, $a5a9ed1d43a3a911$var$Yj = !1;
function $a5a9ed1d43a3a911$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$a5a9ed1d43a3a911$var$ak(a, b, c), c = c.sibling;
}
function $a5a9ed1d43a3a911$var$ak(a, b, c) {
    if ($a5a9ed1d43a3a911$var$lc && "function" === typeof $a5a9ed1d43a3a911$var$lc.onCommitFiberUnmount) try {
        $a5a9ed1d43a3a911$var$lc.onCommitFiberUnmount($a5a9ed1d43a3a911$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $a5a9ed1d43a3a911$var$U || $a5a9ed1d43a3a911$var$Mj(c, b);
        case 6:
            var d = $a5a9ed1d43a3a911$var$X, e = $a5a9ed1d43a3a911$var$Yj;
            $a5a9ed1d43a3a911$var$X = null;
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
            $a5a9ed1d43a3a911$var$X = d;
            $a5a9ed1d43a3a911$var$Yj = e;
            null !== $a5a9ed1d43a3a911$var$X && ($a5a9ed1d43a3a911$var$Yj ? (a = $a5a9ed1d43a3a911$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $a5a9ed1d43a3a911$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $a5a9ed1d43a3a911$var$X && ($a5a9ed1d43a3a911$var$Yj ? (a = $a5a9ed1d43a3a911$var$X, c = c.stateNode, 8 === a.nodeType ? $a5a9ed1d43a3a911$var$Kf(a.parentNode, c) : 1 === a.nodeType && $a5a9ed1d43a3a911$var$Kf(a, c), $a5a9ed1d43a3a911$var$bd(a)) : $a5a9ed1d43a3a911$var$Kf($a5a9ed1d43a3a911$var$X, c.stateNode));
            break;
        case 4:
            d = $a5a9ed1d43a3a911$var$X;
            e = $a5a9ed1d43a3a911$var$Yj;
            $a5a9ed1d43a3a911$var$X = c.stateNode.containerInfo;
            $a5a9ed1d43a3a911$var$Yj = !0;
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
            $a5a9ed1d43a3a911$var$X = d;
            $a5a9ed1d43a3a911$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$a5a9ed1d43a3a911$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $a5a9ed1d43a3a911$var$Nj(c, b, g) : 0 !== (f & 4) && $a5a9ed1d43a3a911$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
            break;
        case 1:
            if (!$a5a9ed1d43a3a911$var$U && ($a5a9ed1d43a3a911$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $a5a9ed1d43a3a911$var$W(c, b, h);
            }
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
            break;
        case 21:
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($a5a9ed1d43a3a911$var$U = (d = $a5a9ed1d43a3a911$var$U) || null !== c.memoizedState, $a5a9ed1d43a3a911$var$Zj(a, b, c), $a5a9ed1d43a3a911$var$U = d) : $a5a9ed1d43a3a911$var$Zj(a, b, c);
            break;
        default:
            $a5a9ed1d43a3a911$var$Zj(a, b, c);
    }
}
function $a5a9ed1d43a3a911$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $a5a9ed1d43a3a911$var$Lj);
        b.forEach(function(b) {
            var d = $a5a9ed1d43a3a911$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $a5a9ed1d43a3a911$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $a5a9ed1d43a3a911$var$X = h.stateNode;
                        $a5a9ed1d43a3a911$var$Yj = !1;
                        break a;
                    case 3:
                        $a5a9ed1d43a3a911$var$X = h.stateNode.containerInfo;
                        $a5a9ed1d43a3a911$var$Yj = !0;
                        break a;
                    case 4:
                        $a5a9ed1d43a3a911$var$X = h.stateNode.containerInfo;
                        $a5a9ed1d43a3a911$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $a5a9ed1d43a3a911$var$X) throw Error($a5a9ed1d43a3a911$var$p(160));
            $a5a9ed1d43a3a911$var$ak(f, g, e);
            $a5a9ed1d43a3a911$var$X = null;
            $a5a9ed1d43a3a911$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $a5a9ed1d43a3a911$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$a5a9ed1d43a3a911$var$ek(b, a), b = b.sibling;
}
function $a5a9ed1d43a3a911$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            if (d & 4) {
                try {
                    $a5a9ed1d43a3a911$var$Qj(3, a, a.return), $a5a9ed1d43a3a911$var$Rj(3, a);
                } catch (t) {
                    $a5a9ed1d43a3a911$var$W(a, a.return, t);
                }
                try {
                    $a5a9ed1d43a3a911$var$Qj(5, a, a.return);
                } catch (t) {
                    $a5a9ed1d43a3a911$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            d & 512 && null !== c && $a5a9ed1d43a3a911$var$Mj(c, c.return);
            break;
        case 5:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            d & 512 && null !== c && $a5a9ed1d43a3a911$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $a5a9ed1d43a3a911$var$ob(e, "");
                } catch (t) {
                    $a5a9ed1d43a3a911$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $a5a9ed1d43a3a911$var$ab(e, f);
                    $a5a9ed1d43a3a911$var$vb(h, g);
                    var l = $a5a9ed1d43a3a911$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $a5a9ed1d43a3a911$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $a5a9ed1d43a3a911$var$nb(e, q) : "children" === m ? $a5a9ed1d43a3a911$var$ob(e, q) : $a5a9ed1d43a3a911$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $a5a9ed1d43a3a911$var$bb(e, f);
                            break;
                        case "textarea":
                            $a5a9ed1d43a3a911$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $a5a9ed1d43a3a911$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $a5a9ed1d43a3a911$var$fb(e, !!f.multiple, f.defaultValue, !0) : $a5a9ed1d43a3a911$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$a5a9ed1d43a3a911$var$Pf] = f;
                } catch (t) {
                    $a5a9ed1d43a3a911$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($a5a9ed1d43a3a911$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $a5a9ed1d43a3a911$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $a5a9ed1d43a3a911$var$bd(b.containerInfo);
            } catch (t) {
                $a5a9ed1d43a3a911$var$W(a, a.return, t);
            }
            break;
        case 4:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            break;
        case 13:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($a5a9ed1d43a3a911$var$gk = $a5a9ed1d43a3a911$var$B()));
            d & 4 && $a5a9ed1d43a3a911$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($a5a9ed1d43a3a911$var$U = (l = $a5a9ed1d43a3a911$var$U) || m, $a5a9ed1d43a3a911$var$dk(b, a), $a5a9ed1d43a3a911$var$U = l) : $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($a5a9ed1d43a3a911$var$V = a, m = a.child; null !== m;){
                    for(q = $a5a9ed1d43a3a911$var$V = m; null !== $a5a9ed1d43a3a911$var$V;){
                        r = $a5a9ed1d43a3a911$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $a5a9ed1d43a3a911$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $a5a9ed1d43a3a911$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $a5a9ed1d43a3a911$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $a5a9ed1d43a3a911$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $a5a9ed1d43a3a911$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $a5a9ed1d43a3a911$var$V = y) : $a5a9ed1d43a3a911$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $a5a9ed1d43a3a911$var$rb("display", g));
                            } catch (t) {
                                $a5a9ed1d43a3a911$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $a5a9ed1d43a3a911$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $a5a9ed1d43a3a911$var$dk(b, a);
            $a5a9ed1d43a3a911$var$fk(a);
            d & 4 && $a5a9ed1d43a3a911$var$bk(a);
            break;
        case 21:
            break;
        default:
            $a5a9ed1d43a3a911$var$dk(b, a), $a5a9ed1d43a3a911$var$fk(a);
    }
}
function $a5a9ed1d43a3a911$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($a5a9ed1d43a3a911$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($a5a9ed1d43a3a911$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($a5a9ed1d43a3a911$var$ob(e, ""), d.flags &= -33);
                    var f = $a5a9ed1d43a3a911$var$Vj(a);
                    $a5a9ed1d43a3a911$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $a5a9ed1d43a3a911$var$Vj(a);
                    $a5a9ed1d43a3a911$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($a5a9ed1d43a3a911$var$p(161));
            }
        } catch (k) {
            $a5a9ed1d43a3a911$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $a5a9ed1d43a3a911$var$ik(a, b, c) {
    $a5a9ed1d43a3a911$var$V = a;
    $a5a9ed1d43a3a911$var$jk(a, b, c);
}
function $a5a9ed1d43a3a911$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $a5a9ed1d43a3a911$var$V;){
        var e = $a5a9ed1d43a3a911$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $a5a9ed1d43a3a911$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $a5a9ed1d43a3a911$var$U;
                h = $a5a9ed1d43a3a911$var$Kj;
                var l = $a5a9ed1d43a3a911$var$U;
                $a5a9ed1d43a3a911$var$Kj = g;
                if (($a5a9ed1d43a3a911$var$U = k) && !l) for($a5a9ed1d43a3a911$var$V = e; null !== $a5a9ed1d43a3a911$var$V;)g = $a5a9ed1d43a3a911$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $a5a9ed1d43a3a911$var$kk(e) : null !== k ? (k.return = g, $a5a9ed1d43a3a911$var$V = k) : $a5a9ed1d43a3a911$var$kk(e);
                for(; null !== f;)$a5a9ed1d43a3a911$var$V = f, $a5a9ed1d43a3a911$var$jk(f, b, c), f = f.sibling;
                $a5a9ed1d43a3a911$var$V = e;
                $a5a9ed1d43a3a911$var$Kj = h;
                $a5a9ed1d43a3a911$var$U = l;
            }
            $a5a9ed1d43a3a911$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $a5a9ed1d43a3a911$var$V = f) : $a5a9ed1d43a3a911$var$lk(a, b, c);
    }
}
function $a5a9ed1d43a3a911$var$lk(a) {
    for(; null !== $a5a9ed1d43a3a911$var$V;){
        var b = $a5a9ed1d43a3a911$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $a5a9ed1d43a3a911$var$U || $a5a9ed1d43a3a911$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$a5a9ed1d43a3a911$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $a5a9ed1d43a3a911$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $a5a9ed1d43a3a911$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $a5a9ed1d43a3a911$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $a5a9ed1d43a3a911$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($a5a9ed1d43a3a911$var$p(163));
                }
                $a5a9ed1d43a3a911$var$U || b.flags & 512 && $a5a9ed1d43a3a911$var$Sj(b);
            } catch (r) {
                $a5a9ed1d43a3a911$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $a5a9ed1d43a3a911$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a5a9ed1d43a3a911$var$V = c;
            break;
        }
        $a5a9ed1d43a3a911$var$V = b.return;
    }
}
function $a5a9ed1d43a3a911$var$hk(a) {
    for(; null !== $a5a9ed1d43a3a911$var$V;){
        var b = $a5a9ed1d43a3a911$var$V;
        if (b === a) {
            $a5a9ed1d43a3a911$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $a5a9ed1d43a3a911$var$V = c;
            break;
        }
        $a5a9ed1d43a3a911$var$V = b.return;
    }
}
function $a5a9ed1d43a3a911$var$kk(a) {
    for(; null !== $a5a9ed1d43a3a911$var$V;){
        var b = $a5a9ed1d43a3a911$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $a5a9ed1d43a3a911$var$Rj(4, b);
                    } catch (k) {
                        $a5a9ed1d43a3a911$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $a5a9ed1d43a3a911$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $a5a9ed1d43a3a911$var$Sj(b);
                    } catch (k) {
                        $a5a9ed1d43a3a911$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $a5a9ed1d43a3a911$var$Sj(b);
                    } catch (k) {
                        $a5a9ed1d43a3a911$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $a5a9ed1d43a3a911$var$W(b, b.return, k);
        }
        if (b === a) {
            $a5a9ed1d43a3a911$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $a5a9ed1d43a3a911$var$V = h;
            break;
        }
        $a5a9ed1d43a3a911$var$V = b.return;
    }
}
var $a5a9ed1d43a3a911$var$mk = Math.ceil, $a5a9ed1d43a3a911$var$nk = $a5a9ed1d43a3a911$var$ua.ReactCurrentDispatcher, $a5a9ed1d43a3a911$var$ok = $a5a9ed1d43a3a911$var$ua.ReactCurrentOwner, $a5a9ed1d43a3a911$var$pk = $a5a9ed1d43a3a911$var$ua.ReactCurrentBatchConfig, $a5a9ed1d43a3a911$var$K = 0, $a5a9ed1d43a3a911$var$R = null, $a5a9ed1d43a3a911$var$Y = null, $a5a9ed1d43a3a911$var$Z = 0, $a5a9ed1d43a3a911$var$gj = 0, $a5a9ed1d43a3a911$var$fj = $a5a9ed1d43a3a911$var$Uf(0), $a5a9ed1d43a3a911$var$T = 0, $a5a9ed1d43a3a911$var$qk = null, $a5a9ed1d43a3a911$var$hh = 0, $a5a9ed1d43a3a911$var$rk = 0, $a5a9ed1d43a3a911$var$sk = 0, $a5a9ed1d43a3a911$var$tk = null, $a5a9ed1d43a3a911$var$uk = null, $a5a9ed1d43a3a911$var$gk = 0, $a5a9ed1d43a3a911$var$Hj = Infinity, $a5a9ed1d43a3a911$var$vk = null, $a5a9ed1d43a3a911$var$Pi = !1, $a5a9ed1d43a3a911$var$Qi = null, $a5a9ed1d43a3a911$var$Si = null, $a5a9ed1d43a3a911$var$wk = !1, $a5a9ed1d43a3a911$var$xk = null, $a5a9ed1d43a3a911$var$yk = 0, $a5a9ed1d43a3a911$var$zk = 0, $a5a9ed1d43a3a911$var$Ak = null, $a5a9ed1d43a3a911$var$Bk = -1, $a5a9ed1d43a3a911$var$Ck = 0;
function $a5a9ed1d43a3a911$var$L() {
    return 0 !== ($a5a9ed1d43a3a911$var$K & 6) ? $a5a9ed1d43a3a911$var$B() : -1 !== $a5a9ed1d43a3a911$var$Bk ? $a5a9ed1d43a3a911$var$Bk : $a5a9ed1d43a3a911$var$Bk = $a5a9ed1d43a3a911$var$B();
}
function $a5a9ed1d43a3a911$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($a5a9ed1d43a3a911$var$K & 2) && 0 !== $a5a9ed1d43a3a911$var$Z) return $a5a9ed1d43a3a911$var$Z & -$a5a9ed1d43a3a911$var$Z;
    if (null !== $a5a9ed1d43a3a911$var$Kg.transition) return 0 === $a5a9ed1d43a3a911$var$Ck && ($a5a9ed1d43a3a911$var$Ck = $a5a9ed1d43a3a911$var$yc()), $a5a9ed1d43a3a911$var$Ck;
    a = $a5a9ed1d43a3a911$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $a5a9ed1d43a3a911$var$jd(a.type);
    return a;
}
function $a5a9ed1d43a3a911$var$mh(a, b, c, d) {
    if (50 < $a5a9ed1d43a3a911$var$zk) throw $a5a9ed1d43a3a911$var$zk = 0, $a5a9ed1d43a3a911$var$Ak = null, Error($a5a9ed1d43a3a911$var$p(185));
    $a5a9ed1d43a3a911$var$Ac(a, c, d);
    if (0 === ($a5a9ed1d43a3a911$var$K & 2) || a !== $a5a9ed1d43a3a911$var$R) a === $a5a9ed1d43a3a911$var$R && (0 === ($a5a9ed1d43a3a911$var$K & 2) && ($a5a9ed1d43a3a911$var$rk |= c), 4 === $a5a9ed1d43a3a911$var$T && $a5a9ed1d43a3a911$var$Dk(a, $a5a9ed1d43a3a911$var$Z)), $a5a9ed1d43a3a911$var$Ek(a, d), 1 === c && 0 === $a5a9ed1d43a3a911$var$K && 0 === (b.mode & 1) && ($a5a9ed1d43a3a911$var$Hj = $a5a9ed1d43a3a911$var$B() + 500, $a5a9ed1d43a3a911$var$fg && $a5a9ed1d43a3a911$var$jg());
}
function $a5a9ed1d43a3a911$var$Ek(a, b) {
    var c = a.callbackNode;
    $a5a9ed1d43a3a911$var$wc(a, b);
    var d = $a5a9ed1d43a3a911$var$uc(a, a === $a5a9ed1d43a3a911$var$R ? $a5a9ed1d43a3a911$var$Z : 0);
    if (0 === d) null !== c && $a5a9ed1d43a3a911$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $a5a9ed1d43a3a911$var$bc(c);
        if (1 === b) 0 === a.tag ? $a5a9ed1d43a3a911$var$ig($a5a9ed1d43a3a911$var$Fk.bind(null, a)) : $a5a9ed1d43a3a911$var$hg($a5a9ed1d43a3a911$var$Fk.bind(null, a)), $a5a9ed1d43a3a911$var$Jf(function() {
            0 === ($a5a9ed1d43a3a911$var$K & 6) && $a5a9ed1d43a3a911$var$jg();
        }), c = null;
        else {
            switch($a5a9ed1d43a3a911$var$Dc(d)){
                case 1:
                    c = $a5a9ed1d43a3a911$var$fc;
                    break;
                case 4:
                    c = $a5a9ed1d43a3a911$var$gc;
                    break;
                case 16:
                    c = $a5a9ed1d43a3a911$var$hc;
                    break;
                case 536870912:
                    c = $a5a9ed1d43a3a911$var$jc;
                    break;
                default:
                    c = $a5a9ed1d43a3a911$var$hc;
            }
            c = $a5a9ed1d43a3a911$var$Gk(c, $a5a9ed1d43a3a911$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $a5a9ed1d43a3a911$var$Hk(a, b) {
    $a5a9ed1d43a3a911$var$Bk = -1;
    $a5a9ed1d43a3a911$var$Ck = 0;
    if (0 !== ($a5a9ed1d43a3a911$var$K & 6)) throw Error($a5a9ed1d43a3a911$var$p(327));
    var c = a.callbackNode;
    if ($a5a9ed1d43a3a911$var$Ik() && a.callbackNode !== c) return null;
    var d = $a5a9ed1d43a3a911$var$uc(a, a === $a5a9ed1d43a3a911$var$R ? $a5a9ed1d43a3a911$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $a5a9ed1d43a3a911$var$Jk(a, d);
    else {
        b = d;
        var e = $a5a9ed1d43a3a911$var$K;
        $a5a9ed1d43a3a911$var$K |= 2;
        var f = $a5a9ed1d43a3a911$var$Kk();
        if ($a5a9ed1d43a3a911$var$R !== a || $a5a9ed1d43a3a911$var$Z !== b) $a5a9ed1d43a3a911$var$vk = null, $a5a9ed1d43a3a911$var$Hj = $a5a9ed1d43a3a911$var$B() + 500, $a5a9ed1d43a3a911$var$Lk(a, b);
        for(;;)try {
            $a5a9ed1d43a3a911$var$Mk();
            break;
        } catch (h) {
            $a5a9ed1d43a3a911$var$Nk(a, h);
        }
        $a5a9ed1d43a3a911$var$Qg();
        $a5a9ed1d43a3a911$var$nk.current = f;
        $a5a9ed1d43a3a911$var$K = e;
        null !== $a5a9ed1d43a3a911$var$Y ? b = 0 : ($a5a9ed1d43a3a911$var$R = null, $a5a9ed1d43a3a911$var$Z = 0, b = $a5a9ed1d43a3a911$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $a5a9ed1d43a3a911$var$xc(a), 0 !== e && (d = e, b = $a5a9ed1d43a3a911$var$Ok(a, e)));
        if (1 === b) throw c = $a5a9ed1d43a3a911$var$qk, $a5a9ed1d43a3a911$var$Lk(a, 0), $a5a9ed1d43a3a911$var$Dk(a, d), $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B()), c;
        if (6 === b) $a5a9ed1d43a3a911$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$a5a9ed1d43a3a911$var$Pk(e) && (b = $a5a9ed1d43a3a911$var$Jk(a, d), 2 === b && (f = $a5a9ed1d43a3a911$var$xc(a), 0 !== f && (d = f, b = $a5a9ed1d43a3a911$var$Ok(a, f))), 1 === b)) throw c = $a5a9ed1d43a3a911$var$qk, $a5a9ed1d43a3a911$var$Lk(a, 0), $a5a9ed1d43a3a911$var$Dk(a, d), $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($a5a9ed1d43a3a911$var$p(345));
                case 2:
                    $a5a9ed1d43a3a911$var$Qk(a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk);
                    break;
                case 3:
                    $a5a9ed1d43a3a911$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $a5a9ed1d43a3a911$var$gk + 500 - $a5a9ed1d43a3a911$var$B(), 10 < b)) {
                        if (0 !== $a5a9ed1d43a3a911$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $a5a9ed1d43a3a911$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $a5a9ed1d43a3a911$var$Ff($a5a9ed1d43a3a911$var$Qk.bind(null, a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk), b);
                        break;
                    }
                    $a5a9ed1d43a3a911$var$Qk(a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk);
                    break;
                case 4:
                    $a5a9ed1d43a3a911$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $a5a9ed1d43a3a911$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $a5a9ed1d43a3a911$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $a5a9ed1d43a3a911$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $a5a9ed1d43a3a911$var$Ff($a5a9ed1d43a3a911$var$Qk.bind(null, a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk), d);
                        break;
                    }
                    $a5a9ed1d43a3a911$var$Qk(a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk);
                    break;
                case 5:
                    $a5a9ed1d43a3a911$var$Qk(a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk);
                    break;
                default:
                    throw Error($a5a9ed1d43a3a911$var$p(329));
            }
        }
    }
    $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B());
    return a.callbackNode === c ? $a5a9ed1d43a3a911$var$Hk.bind(null, a) : null;
}
function $a5a9ed1d43a3a911$var$Ok(a, b) {
    var c = $a5a9ed1d43a3a911$var$tk;
    a.current.memoizedState.isDehydrated && ($a5a9ed1d43a3a911$var$Lk(a, b).flags |= 256);
    a = $a5a9ed1d43a3a911$var$Jk(a, b);
    2 !== a && (b = $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$uk = c, null !== b && $a5a9ed1d43a3a911$var$Gj(b));
    return a;
}
function $a5a9ed1d43a3a911$var$Gj(a) {
    null === $a5a9ed1d43a3a911$var$uk ? $a5a9ed1d43a3a911$var$uk = a : $a5a9ed1d43a3a911$var$uk.push.apply($a5a9ed1d43a3a911$var$uk, a);
}
function $a5a9ed1d43a3a911$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$a5a9ed1d43a3a911$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $a5a9ed1d43a3a911$var$Dk(a, b) {
    b &= ~$a5a9ed1d43a3a911$var$sk;
    b &= ~$a5a9ed1d43a3a911$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $a5a9ed1d43a3a911$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $a5a9ed1d43a3a911$var$Fk(a) {
    if (0 !== ($a5a9ed1d43a3a911$var$K & 6)) throw Error($a5a9ed1d43a3a911$var$p(327));
    $a5a9ed1d43a3a911$var$Ik();
    var b = $a5a9ed1d43a3a911$var$uc(a, 0);
    if (0 === (b & 1)) return $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B()), null;
    var c = $a5a9ed1d43a3a911$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $a5a9ed1d43a3a911$var$xc(a);
        0 !== d && (b = d, c = $a5a9ed1d43a3a911$var$Ok(a, d));
    }
    if (1 === c) throw c = $a5a9ed1d43a3a911$var$qk, $a5a9ed1d43a3a911$var$Lk(a, 0), $a5a9ed1d43a3a911$var$Dk(a, b), $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B()), c;
    if (6 === c) throw Error($a5a9ed1d43a3a911$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $a5a9ed1d43a3a911$var$Qk(a, $a5a9ed1d43a3a911$var$uk, $a5a9ed1d43a3a911$var$vk);
    $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B());
    return null;
}
function $a5a9ed1d43a3a911$var$Rk(a, b) {
    var c = $a5a9ed1d43a3a911$var$K;
    $a5a9ed1d43a3a911$var$K |= 1;
    try {
        return a(b);
    } finally{
        $a5a9ed1d43a3a911$var$K = c, 0 === $a5a9ed1d43a3a911$var$K && ($a5a9ed1d43a3a911$var$Hj = $a5a9ed1d43a3a911$var$B() + 500, $a5a9ed1d43a3a911$var$fg && $a5a9ed1d43a3a911$var$jg());
    }
}
function $a5a9ed1d43a3a911$var$Sk(a) {
    null !== $a5a9ed1d43a3a911$var$xk && 0 === $a5a9ed1d43a3a911$var$xk.tag && 0 === ($a5a9ed1d43a3a911$var$K & 6) && $a5a9ed1d43a3a911$var$Ik();
    var b = $a5a9ed1d43a3a911$var$K;
    $a5a9ed1d43a3a911$var$K |= 1;
    var c = $a5a9ed1d43a3a911$var$pk.transition, d = $a5a9ed1d43a3a911$var$C;
    try {
        if ($a5a9ed1d43a3a911$var$pk.transition = null, $a5a9ed1d43a3a911$var$C = 1, a) return a();
    } finally{
        $a5a9ed1d43a3a911$var$C = d, $a5a9ed1d43a3a911$var$pk.transition = c, $a5a9ed1d43a3a911$var$K = b, 0 === ($a5a9ed1d43a3a911$var$K & 6) && $a5a9ed1d43a3a911$var$jg();
    }
}
function $a5a9ed1d43a3a911$var$Ij() {
    $a5a9ed1d43a3a911$var$gj = $a5a9ed1d43a3a911$var$fj.current;
    $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$fj);
}
function $a5a9ed1d43a3a911$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $a5a9ed1d43a3a911$var$Gf(c));
    if (null !== $a5a9ed1d43a3a911$var$Y) for(c = $a5a9ed1d43a3a911$var$Y.return; null !== c;){
        var d = c;
        $a5a9ed1d43a3a911$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $a5a9ed1d43a3a911$var$$f();
                break;
            case 3:
                $a5a9ed1d43a3a911$var$Jh();
                $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$Wf);
                $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$H);
                $a5a9ed1d43a3a911$var$Oh();
                break;
            case 5:
                $a5a9ed1d43a3a911$var$Lh(d);
                break;
            case 4:
                $a5a9ed1d43a3a911$var$Jh();
                break;
            case 13:
                $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M);
                break;
            case 19:
                $a5a9ed1d43a3a911$var$E($a5a9ed1d43a3a911$var$M);
                break;
            case 10:
                $a5a9ed1d43a3a911$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $a5a9ed1d43a3a911$var$Ij();
        }
        c = c.return;
    }
    $a5a9ed1d43a3a911$var$R = a;
    $a5a9ed1d43a3a911$var$Y = a = $a5a9ed1d43a3a911$var$wh(a.current, null);
    $a5a9ed1d43a3a911$var$Z = $a5a9ed1d43a3a911$var$gj = b;
    $a5a9ed1d43a3a911$var$T = 0;
    $a5a9ed1d43a3a911$var$qk = null;
    $a5a9ed1d43a3a911$var$sk = $a5a9ed1d43a3a911$var$rk = $a5a9ed1d43a3a911$var$hh = 0;
    $a5a9ed1d43a3a911$var$uk = $a5a9ed1d43a3a911$var$tk = null;
    if (null !== $a5a9ed1d43a3a911$var$Wg) {
        for(b = 0; b < $a5a9ed1d43a3a911$var$Wg.length; b++)if (c = $a5a9ed1d43a3a911$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $a5a9ed1d43a3a911$var$Wg = null;
    }
    return a;
}
function $a5a9ed1d43a3a911$var$Nk(a, b) {
    do {
        var c = $a5a9ed1d43a3a911$var$Y;
        try {
            $a5a9ed1d43a3a911$var$Qg();
            $a5a9ed1d43a3a911$var$Ph.current = $a5a9ed1d43a3a911$var$ai;
            if ($a5a9ed1d43a3a911$var$Sh) {
                for(var d = $a5a9ed1d43a3a911$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $a5a9ed1d43a3a911$var$Sh = !1;
            }
            $a5a9ed1d43a3a911$var$Rh = 0;
            $a5a9ed1d43a3a911$var$P = $a5a9ed1d43a3a911$var$O = $a5a9ed1d43a3a911$var$N = null;
            $a5a9ed1d43a3a911$var$Th = !1;
            $a5a9ed1d43a3a911$var$Uh = 0;
            $a5a9ed1d43a3a911$var$ok.current = null;
            if (null === c || null === c.return) {
                $a5a9ed1d43a3a911$var$T = 1;
                $a5a9ed1d43a3a911$var$qk = b;
                $a5a9ed1d43a3a911$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $a5a9ed1d43a3a911$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $a5a9ed1d43a3a911$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $a5a9ed1d43a3a911$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $a5a9ed1d43a3a911$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $a5a9ed1d43a3a911$var$Ti(f, l, b);
                            $a5a9ed1d43a3a911$var$uj();
                            break a;
                        }
                        k = Error($a5a9ed1d43a3a911$var$p(426));
                    }
                } else if ($a5a9ed1d43a3a911$var$I && h.mode & 1) {
                    var J = $a5a9ed1d43a3a911$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $a5a9ed1d43a3a911$var$Wi(J, g, h, f, b);
                        $a5a9ed1d43a3a911$var$Jg($a5a9ed1d43a3a911$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $a5a9ed1d43a3a911$var$Ki(k, h);
                4 !== $a5a9ed1d43a3a911$var$T && ($a5a9ed1d43a3a911$var$T = 2);
                null === $a5a9ed1d43a3a911$var$tk ? $a5a9ed1d43a3a911$var$tk = [
                    f
                ] : $a5a9ed1d43a3a911$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $a5a9ed1d43a3a911$var$Oi(f, k, b);
                            $a5a9ed1d43a3a911$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $a5a9ed1d43a3a911$var$Si || !$a5a9ed1d43a3a911$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $a5a9ed1d43a3a911$var$Ri(f, h, b);
                                $a5a9ed1d43a3a911$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $a5a9ed1d43a3a911$var$Tk(c);
        } catch (na) {
            b = na;
            $a5a9ed1d43a3a911$var$Y === c && null !== c && ($a5a9ed1d43a3a911$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $a5a9ed1d43a3a911$var$Kk() {
    var a = $a5a9ed1d43a3a911$var$nk.current;
    $a5a9ed1d43a3a911$var$nk.current = $a5a9ed1d43a3a911$var$ai;
    return null === a ? $a5a9ed1d43a3a911$var$ai : a;
}
function $a5a9ed1d43a3a911$var$uj() {
    if (0 === $a5a9ed1d43a3a911$var$T || 3 === $a5a9ed1d43a3a911$var$T || 2 === $a5a9ed1d43a3a911$var$T) $a5a9ed1d43a3a911$var$T = 4;
    null === $a5a9ed1d43a3a911$var$R || 0 === ($a5a9ed1d43a3a911$var$hh & 268435455) && 0 === ($a5a9ed1d43a3a911$var$rk & 268435455) || $a5a9ed1d43a3a911$var$Dk($a5a9ed1d43a3a911$var$R, $a5a9ed1d43a3a911$var$Z);
}
function $a5a9ed1d43a3a911$var$Jk(a, b) {
    var c = $a5a9ed1d43a3a911$var$K;
    $a5a9ed1d43a3a911$var$K |= 2;
    var d = $a5a9ed1d43a3a911$var$Kk();
    if ($a5a9ed1d43a3a911$var$R !== a || $a5a9ed1d43a3a911$var$Z !== b) $a5a9ed1d43a3a911$var$vk = null, $a5a9ed1d43a3a911$var$Lk(a, b);
    for(;;)try {
        $a5a9ed1d43a3a911$var$Uk();
        break;
    } catch (e) {
        $a5a9ed1d43a3a911$var$Nk(a, e);
    }
    $a5a9ed1d43a3a911$var$Qg();
    $a5a9ed1d43a3a911$var$K = c;
    $a5a9ed1d43a3a911$var$nk.current = d;
    if (null !== $a5a9ed1d43a3a911$var$Y) throw Error($a5a9ed1d43a3a911$var$p(261));
    $a5a9ed1d43a3a911$var$R = null;
    $a5a9ed1d43a3a911$var$Z = 0;
    return $a5a9ed1d43a3a911$var$T;
}
function $a5a9ed1d43a3a911$var$Uk() {
    for(; null !== $a5a9ed1d43a3a911$var$Y;)$a5a9ed1d43a3a911$var$Vk($a5a9ed1d43a3a911$var$Y);
}
function $a5a9ed1d43a3a911$var$Mk() {
    for(; null !== $a5a9ed1d43a3a911$var$Y && !$a5a9ed1d43a3a911$var$cc();)$a5a9ed1d43a3a911$var$Vk($a5a9ed1d43a3a911$var$Y);
}
function $a5a9ed1d43a3a911$var$Vk(a) {
    var b = $a5a9ed1d43a3a911$var$Wk(a.alternate, a, $a5a9ed1d43a3a911$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $a5a9ed1d43a3a911$var$Tk(a) : $a5a9ed1d43a3a911$var$Y = b;
    $a5a9ed1d43a3a911$var$ok.current = null;
}
function $a5a9ed1d43a3a911$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $a5a9ed1d43a3a911$var$Fj(c, b, $a5a9ed1d43a3a911$var$gj), null !== c) {
                $a5a9ed1d43a3a911$var$Y = c;
                return;
            }
        } else {
            c = $a5a9ed1d43a3a911$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $a5a9ed1d43a3a911$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $a5a9ed1d43a3a911$var$T = 6;
                $a5a9ed1d43a3a911$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $a5a9ed1d43a3a911$var$Y = b;
            return;
        }
        $a5a9ed1d43a3a911$var$Y = b = a;
    }while (null !== b);
    0 === $a5a9ed1d43a3a911$var$T && ($a5a9ed1d43a3a911$var$T = 5);
}
function $a5a9ed1d43a3a911$var$Qk(a, b, c) {
    var d = $a5a9ed1d43a3a911$var$C, e = $a5a9ed1d43a3a911$var$pk.transition;
    try {
        $a5a9ed1d43a3a911$var$pk.transition = null, $a5a9ed1d43a3a911$var$C = 1, $a5a9ed1d43a3a911$var$Xk(a, b, c, d);
    } finally{
        $a5a9ed1d43a3a911$var$pk.transition = e, $a5a9ed1d43a3a911$var$C = d;
    }
    return null;
}
function $a5a9ed1d43a3a911$var$Xk(a, b, c, d) {
    do $a5a9ed1d43a3a911$var$Ik();
    while (null !== $a5a9ed1d43a3a911$var$xk);
    if (0 !== ($a5a9ed1d43a3a911$var$K & 6)) throw Error($a5a9ed1d43a3a911$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($a5a9ed1d43a3a911$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $a5a9ed1d43a3a911$var$Bc(a, f);
    a === $a5a9ed1d43a3a911$var$R && ($a5a9ed1d43a3a911$var$Y = $a5a9ed1d43a3a911$var$R = null, $a5a9ed1d43a3a911$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $a5a9ed1d43a3a911$var$wk || ($a5a9ed1d43a3a911$var$wk = !0, $a5a9ed1d43a3a911$var$Gk($a5a9ed1d43a3a911$var$hc, function() {
        $a5a9ed1d43a3a911$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $a5a9ed1d43a3a911$var$pk.transition;
        $a5a9ed1d43a3a911$var$pk.transition = null;
        var g = $a5a9ed1d43a3a911$var$C;
        $a5a9ed1d43a3a911$var$C = 1;
        var h = $a5a9ed1d43a3a911$var$K;
        $a5a9ed1d43a3a911$var$K |= 4;
        $a5a9ed1d43a3a911$var$ok.current = null;
        $a5a9ed1d43a3a911$var$Pj(a, c);
        $a5a9ed1d43a3a911$var$ek(c, a);
        $a5a9ed1d43a3a911$var$Oe($a5a9ed1d43a3a911$var$Df);
        $a5a9ed1d43a3a911$var$dd = !!$a5a9ed1d43a3a911$var$Cf;
        $a5a9ed1d43a3a911$var$Df = $a5a9ed1d43a3a911$var$Cf = null;
        a.current = c;
        $a5a9ed1d43a3a911$var$ik(c, a, e);
        $a5a9ed1d43a3a911$var$dc();
        $a5a9ed1d43a3a911$var$K = h;
        $a5a9ed1d43a3a911$var$C = g;
        $a5a9ed1d43a3a911$var$pk.transition = f;
    } else a.current = c;
    $a5a9ed1d43a3a911$var$wk && ($a5a9ed1d43a3a911$var$wk = !1, $a5a9ed1d43a3a911$var$xk = a, $a5a9ed1d43a3a911$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($a5a9ed1d43a3a911$var$Si = null);
    $a5a9ed1d43a3a911$var$mc(c.stateNode, d);
    $a5a9ed1d43a3a911$var$Ek(a, $a5a9ed1d43a3a911$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($a5a9ed1d43a3a911$var$Pi) throw $a5a9ed1d43a3a911$var$Pi = !1, a = $a5a9ed1d43a3a911$var$Qi, $a5a9ed1d43a3a911$var$Qi = null, a;
    0 !== ($a5a9ed1d43a3a911$var$yk & 1) && 0 !== a.tag && $a5a9ed1d43a3a911$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $a5a9ed1d43a3a911$var$Ak ? $a5a9ed1d43a3a911$var$zk++ : ($a5a9ed1d43a3a911$var$zk = 0, $a5a9ed1d43a3a911$var$Ak = a) : $a5a9ed1d43a3a911$var$zk = 0;
    $a5a9ed1d43a3a911$var$jg();
    return null;
}
function $a5a9ed1d43a3a911$var$Ik() {
    if (null !== $a5a9ed1d43a3a911$var$xk) {
        var a = $a5a9ed1d43a3a911$var$Dc($a5a9ed1d43a3a911$var$yk), b = $a5a9ed1d43a3a911$var$pk.transition, c = $a5a9ed1d43a3a911$var$C;
        try {
            $a5a9ed1d43a3a911$var$pk.transition = null;
            $a5a9ed1d43a3a911$var$C = 16 > a ? 16 : a;
            if (null === $a5a9ed1d43a3a911$var$xk) var d = !1;
            else {
                a = $a5a9ed1d43a3a911$var$xk;
                $a5a9ed1d43a3a911$var$xk = null;
                $a5a9ed1d43a3a911$var$yk = 0;
                if (0 !== ($a5a9ed1d43a3a911$var$K & 6)) throw Error($a5a9ed1d43a3a911$var$p(331));
                var e = $a5a9ed1d43a3a911$var$K;
                $a5a9ed1d43a3a911$var$K |= 4;
                for($a5a9ed1d43a3a911$var$V = a.current; null !== $a5a9ed1d43a3a911$var$V;){
                    var f = $a5a9ed1d43a3a911$var$V, g = f.child;
                    if (0 !== ($a5a9ed1d43a3a911$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($a5a9ed1d43a3a911$var$V = l; null !== $a5a9ed1d43a3a911$var$V;){
                                    var m = $a5a9ed1d43a3a911$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $a5a9ed1d43a3a911$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $a5a9ed1d43a3a911$var$V = q;
                                    else for(; null !== $a5a9ed1d43a3a911$var$V;){
                                        m = $a5a9ed1d43a3a911$var$V;
                                        var r = m.sibling, y = m.return;
                                        $a5a9ed1d43a3a911$var$Tj(m);
                                        if (m === l) {
                                            $a5a9ed1d43a3a911$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $a5a9ed1d43a3a911$var$V = r;
                                            break;
                                        }
                                        $a5a9ed1d43a3a911$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $a5a9ed1d43a3a911$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $a5a9ed1d43a3a911$var$V = g;
                    else b: for(; null !== $a5a9ed1d43a3a911$var$V;){
                        f = $a5a9ed1d43a3a911$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $a5a9ed1d43a3a911$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $a5a9ed1d43a3a911$var$V = x;
                            break b;
                        }
                        $a5a9ed1d43a3a911$var$V = f.return;
                    }
                }
                var w = a.current;
                for($a5a9ed1d43a3a911$var$V = w; null !== $a5a9ed1d43a3a911$var$V;){
                    g = $a5a9ed1d43a3a911$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $a5a9ed1d43a3a911$var$V = u;
                    else b: for(g = w; null !== $a5a9ed1d43a3a911$var$V;){
                        h = $a5a9ed1d43a3a911$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $a5a9ed1d43a3a911$var$Rj(9, h);
                            }
                        } catch (na) {
                            $a5a9ed1d43a3a911$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $a5a9ed1d43a3a911$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $a5a9ed1d43a3a911$var$V = F;
                            break b;
                        }
                        $a5a9ed1d43a3a911$var$V = h.return;
                    }
                }
                $a5a9ed1d43a3a911$var$K = e;
                $a5a9ed1d43a3a911$var$jg();
                if ($a5a9ed1d43a3a911$var$lc && "function" === typeof $a5a9ed1d43a3a911$var$lc.onPostCommitFiberRoot) try {
                    $a5a9ed1d43a3a911$var$lc.onPostCommitFiberRoot($a5a9ed1d43a3a911$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $a5a9ed1d43a3a911$var$C = c, $a5a9ed1d43a3a911$var$pk.transition = b;
        }
    }
    return !1;
}
function $a5a9ed1d43a3a911$var$Yk(a, b, c) {
    b = $a5a9ed1d43a3a911$var$Ki(c, b);
    b = $a5a9ed1d43a3a911$var$Oi(a, b, 1);
    a = $a5a9ed1d43a3a911$var$dh(a, b, 1);
    b = $a5a9ed1d43a3a911$var$L();
    null !== a && ($a5a9ed1d43a3a911$var$Ac(a, 1, b), $a5a9ed1d43a3a911$var$Ek(a, b));
}
function $a5a9ed1d43a3a911$var$W(a, b, c) {
    if (3 === a.tag) $a5a9ed1d43a3a911$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $a5a9ed1d43a3a911$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $a5a9ed1d43a3a911$var$Si || !$a5a9ed1d43a3a911$var$Si.has(d))) {
                a = $a5a9ed1d43a3a911$var$Ki(c, a);
                a = $a5a9ed1d43a3a911$var$Ri(b, a, 1);
                b = $a5a9ed1d43a3a911$var$dh(b, a, 1);
                a = $a5a9ed1d43a3a911$var$L();
                null !== b && ($a5a9ed1d43a3a911$var$Ac(b, 1, a), $a5a9ed1d43a3a911$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $a5a9ed1d43a3a911$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $a5a9ed1d43a3a911$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $a5a9ed1d43a3a911$var$R === a && ($a5a9ed1d43a3a911$var$Z & c) === c && (4 === $a5a9ed1d43a3a911$var$T || 3 === $a5a9ed1d43a3a911$var$T && ($a5a9ed1d43a3a911$var$Z & 130023424) === $a5a9ed1d43a3a911$var$Z && 500 > $a5a9ed1d43a3a911$var$B() - $a5a9ed1d43a3a911$var$gk ? $a5a9ed1d43a3a911$var$Lk(a, 0) : $a5a9ed1d43a3a911$var$sk |= c);
    $a5a9ed1d43a3a911$var$Ek(a, b);
}
function $a5a9ed1d43a3a911$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $a5a9ed1d43a3a911$var$sc, $a5a9ed1d43a3a911$var$sc <<= 1, 0 === ($a5a9ed1d43a3a911$var$sc & 130023424) && ($a5a9ed1d43a3a911$var$sc = 4194304)));
    var c = $a5a9ed1d43a3a911$var$L();
    a = $a5a9ed1d43a3a911$var$Zg(a, b);
    null !== a && ($a5a9ed1d43a3a911$var$Ac(a, b, c), $a5a9ed1d43a3a911$var$Ek(a, c));
}
function $a5a9ed1d43a3a911$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $a5a9ed1d43a3a911$var$Zk(a, c);
}
function $a5a9ed1d43a3a911$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($a5a9ed1d43a3a911$var$p(314));
    }
    null !== d && d.delete(b);
    $a5a9ed1d43a3a911$var$Zk(a, c);
}
var $a5a9ed1d43a3a911$var$Wk;
$a5a9ed1d43a3a911$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $a5a9ed1d43a3a911$var$Wf.current) $a5a9ed1d43a3a911$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $a5a9ed1d43a3a911$var$Ug = !1, $a5a9ed1d43a3a911$var$zj(a, b, c);
            $a5a9ed1d43a3a911$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $a5a9ed1d43a3a911$var$Ug = !1, $a5a9ed1d43a3a911$var$I && 0 !== (b.flags & 1048576) && $a5a9ed1d43a3a911$var$ug(b, $a5a9ed1d43a3a911$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $a5a9ed1d43a3a911$var$jj(a, b);
            a = b.pendingProps;
            var e = $a5a9ed1d43a3a911$var$Yf(b, $a5a9ed1d43a3a911$var$H.current);
            $a5a9ed1d43a3a911$var$Tg(b, c);
            e = $a5a9ed1d43a3a911$var$Xh(null, b, d, a, e, c);
            var f = $a5a9ed1d43a3a911$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $a5a9ed1d43a3a911$var$Zf(d) ? (f = !0, $a5a9ed1d43a3a911$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $a5a9ed1d43a3a911$var$ah(b), e.updater = $a5a9ed1d43a3a911$var$nh, b.stateNode = e, e._reactInternals = b, $a5a9ed1d43a3a911$var$rh(b, d, a, c), b = $a5a9ed1d43a3a911$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $a5a9ed1d43a3a911$var$I && f && $a5a9ed1d43a3a911$var$vg(b), $a5a9ed1d43a3a911$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $a5a9ed1d43a3a911$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $a5a9ed1d43a3a911$var$$k(d);
                a = $a5a9ed1d43a3a911$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $a5a9ed1d43a3a911$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $a5a9ed1d43a3a911$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $a5a9ed1d43a3a911$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $a5a9ed1d43a3a911$var$aj(null, b, d, $a5a9ed1d43a3a911$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($a5a9ed1d43a3a911$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5a9ed1d43a3a911$var$Lg(d, e), $a5a9ed1d43a3a911$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5a9ed1d43a3a911$var$Lg(d, e), $a5a9ed1d43a3a911$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $a5a9ed1d43a3a911$var$lj(b);
                if (null === a) throw Error($a5a9ed1d43a3a911$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $a5a9ed1d43a3a911$var$bh(a, b);
                $a5a9ed1d43a3a911$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $a5a9ed1d43a3a911$var$Ki(Error($a5a9ed1d43a3a911$var$p(423)), b);
                        b = $a5a9ed1d43a3a911$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $a5a9ed1d43a3a911$var$Ki(Error($a5a9ed1d43a3a911$var$p(424)), b);
                        b = $a5a9ed1d43a3a911$var$mj(a, b, d, c, e);
                        break a;
                    } else for($a5a9ed1d43a3a911$var$yg = $a5a9ed1d43a3a911$var$Lf(b.stateNode.containerInfo.firstChild), $a5a9ed1d43a3a911$var$xg = b, $a5a9ed1d43a3a911$var$I = !0, $a5a9ed1d43a3a911$var$zg = null, c = $a5a9ed1d43a3a911$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $a5a9ed1d43a3a911$var$Ig();
                    if (d === e) {
                        b = $a5a9ed1d43a3a911$var$$i(a, b, c);
                        break a;
                    }
                    $a5a9ed1d43a3a911$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $a5a9ed1d43a3a911$var$Kh(b), null === a && $a5a9ed1d43a3a911$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $a5a9ed1d43a3a911$var$Ef(d, e) ? g = null : null !== f && $a5a9ed1d43a3a911$var$Ef(d, f) && (b.flags |= 32), $a5a9ed1d43a3a911$var$hj(a, b), $a5a9ed1d43a3a911$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $a5a9ed1d43a3a911$var$Eg(b), null;
        case 13:
            return $a5a9ed1d43a3a911$var$pj(a, b, c);
        case 4:
            return $a5a9ed1d43a3a911$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $a5a9ed1d43a3a911$var$Bh(b, null, d, c) : $a5a9ed1d43a3a911$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5a9ed1d43a3a911$var$Lg(d, e), $a5a9ed1d43a3a911$var$Zi(a, b, d, e, c);
        case 7:
            return $a5a9ed1d43a3a911$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $a5a9ed1d43a3a911$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $a5a9ed1d43a3a911$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $a5a9ed1d43a3a911$var$G($a5a9ed1d43a3a911$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($a5a9ed1d43a3a911$var$He(f.value, g)) {
                        if (f.children === e.children && !$a5a9ed1d43a3a911$var$Wf.current) {
                            b = $a5a9ed1d43a3a911$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $a5a9ed1d43a3a911$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $a5a9ed1d43a3a911$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($a5a9ed1d43a3a911$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $a5a9ed1d43a3a911$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $a5a9ed1d43a3a911$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $a5a9ed1d43a3a911$var$Tg(b, c), e = $a5a9ed1d43a3a911$var$Vg(e), d = d(e), b.flags |= 1, $a5a9ed1d43a3a911$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $a5a9ed1d43a3a911$var$Lg(d, b.pendingProps), e = $a5a9ed1d43a3a911$var$Lg(d.type, e), $a5a9ed1d43a3a911$var$aj(a, b, d, e, c);
        case 15:
            return $a5a9ed1d43a3a911$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $a5a9ed1d43a3a911$var$Lg(d, e), $a5a9ed1d43a3a911$var$jj(a, b), b.tag = 1, $a5a9ed1d43a3a911$var$Zf(d) ? (a = !0, $a5a9ed1d43a3a911$var$cg(b)) : a = !1, $a5a9ed1d43a3a911$var$Tg(b, c), $a5a9ed1d43a3a911$var$ph(b, d, e), $a5a9ed1d43a3a911$var$rh(b, d, e, c), $a5a9ed1d43a3a911$var$kj(null, b, d, !0, a, c);
        case 19:
            return $a5a9ed1d43a3a911$var$yj(a, b, c);
        case 22:
            return $a5a9ed1d43a3a911$var$ej(a, b, c);
    }
    throw Error($a5a9ed1d43a3a911$var$p(156, b.tag));
};
function $a5a9ed1d43a3a911$var$Gk(a, b) {
    return $a5a9ed1d43a3a911$var$ac(a, b);
}
function $a5a9ed1d43a3a911$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a5a9ed1d43a3a911$var$Bg(a, b, c, d) {
    return new $a5a9ed1d43a3a911$var$al(a, b, c, d);
}
function $a5a9ed1d43a3a911$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $a5a9ed1d43a3a911$var$$k(a) {
    if ("function" === typeof a) return $a5a9ed1d43a3a911$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $a5a9ed1d43a3a911$var$Da) return 11;
        if (a === $a5a9ed1d43a3a911$var$Ga) return 14;
    }
    return 2;
}
function $a5a9ed1d43a3a911$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $a5a9ed1d43a3a911$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $a5a9ed1d43a3a911$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $a5a9ed1d43a3a911$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $a5a9ed1d43a3a911$var$ya:
            return $a5a9ed1d43a3a911$var$Ah(c.children, e, f, b);
        case $a5a9ed1d43a3a911$var$za:
            g = 8;
            e |= 8;
            break;
        case $a5a9ed1d43a3a911$var$Aa:
            return a = $a5a9ed1d43a3a911$var$Bg(12, c, b, e | 2), a.elementType = $a5a9ed1d43a3a911$var$Aa, a.lanes = f, a;
        case $a5a9ed1d43a3a911$var$Ea:
            return a = $a5a9ed1d43a3a911$var$Bg(13, c, b, e), a.elementType = $a5a9ed1d43a3a911$var$Ea, a.lanes = f, a;
        case $a5a9ed1d43a3a911$var$Fa:
            return a = $a5a9ed1d43a3a911$var$Bg(19, c, b, e), a.elementType = $a5a9ed1d43a3a911$var$Fa, a.lanes = f, a;
        case $a5a9ed1d43a3a911$var$Ia:
            return $a5a9ed1d43a3a911$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $a5a9ed1d43a3a911$var$Ba:
                    g = 10;
                    break a;
                case $a5a9ed1d43a3a911$var$Ca:
                    g = 9;
                    break a;
                case $a5a9ed1d43a3a911$var$Da:
                    g = 11;
                    break a;
                case $a5a9ed1d43a3a911$var$Ga:
                    g = 14;
                    break a;
                case $a5a9ed1d43a3a911$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($a5a9ed1d43a3a911$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $a5a9ed1d43a3a911$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $a5a9ed1d43a3a911$var$Ah(a, b, c, d) {
    a = $a5a9ed1d43a3a911$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $a5a9ed1d43a3a911$var$qj(a, b, c, d) {
    a = $a5a9ed1d43a3a911$var$Bg(22, a, d, b);
    a.elementType = $a5a9ed1d43a3a911$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $a5a9ed1d43a3a911$var$xh(a, b, c) {
    a = $a5a9ed1d43a3a911$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $a5a9ed1d43a3a911$var$zh(a, b, c) {
    b = $a5a9ed1d43a3a911$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $a5a9ed1d43a3a911$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $a5a9ed1d43a3a911$var$zc(0);
    this.expirationTimes = $a5a9ed1d43a3a911$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a5a9ed1d43a3a911$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $a5a9ed1d43a3a911$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $a5a9ed1d43a3a911$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $a5a9ed1d43a3a911$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $a5a9ed1d43a3a911$var$ah(f);
    return a;
}
function $a5a9ed1d43a3a911$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $a5a9ed1d43a3a911$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $a5a9ed1d43a3a911$var$el(a) {
    if (!a) return $a5a9ed1d43a3a911$var$Vf;
    a = a._reactInternals;
    a: {
        if ($a5a9ed1d43a3a911$var$Vb(a) !== a || 1 !== a.tag) throw Error($a5a9ed1d43a3a911$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($a5a9ed1d43a3a911$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($a5a9ed1d43a3a911$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($a5a9ed1d43a3a911$var$Zf(c)) return $a5a9ed1d43a3a911$var$bg(a, c, b);
    }
    return b;
}
function $a5a9ed1d43a3a911$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $a5a9ed1d43a3a911$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $a5a9ed1d43a3a911$var$el(null);
    c = a.current;
    d = $a5a9ed1d43a3a911$var$L();
    e = $a5a9ed1d43a3a911$var$lh(c);
    f = $a5a9ed1d43a3a911$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $a5a9ed1d43a3a911$var$dh(c, f, e);
    a.current.lanes = e;
    $a5a9ed1d43a3a911$var$Ac(a, e, d);
    $a5a9ed1d43a3a911$var$Ek(a, d);
    return a;
}
function $a5a9ed1d43a3a911$var$gl(a, b, c, d) {
    var e = b.current, f = $a5a9ed1d43a3a911$var$L(), g = $a5a9ed1d43a3a911$var$lh(e);
    c = $a5a9ed1d43a3a911$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $a5a9ed1d43a3a911$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $a5a9ed1d43a3a911$var$dh(e, b, g);
    null !== a && ($a5a9ed1d43a3a911$var$mh(a, e, g, f), $a5a9ed1d43a3a911$var$eh(a, e, g));
    return g;
}
function $a5a9ed1d43a3a911$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $a5a9ed1d43a3a911$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $a5a9ed1d43a3a911$var$jl(a, b) {
    $a5a9ed1d43a3a911$var$il(a, b);
    (a = a.alternate) && $a5a9ed1d43a3a911$var$il(a, b);
}
function $a5a9ed1d43a3a911$var$kl() {
    return null;
}
var $a5a9ed1d43a3a911$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $a5a9ed1d43a3a911$var$ml(a) {
    this._internalRoot = a;
}
$a5a9ed1d43a3a911$var$nl.prototype.render = $a5a9ed1d43a3a911$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($a5a9ed1d43a3a911$var$p(409));
    $a5a9ed1d43a3a911$var$gl(a, b, null, null);
};
$a5a9ed1d43a3a911$var$nl.prototype.unmount = $a5a9ed1d43a3a911$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $a5a9ed1d43a3a911$var$Sk(function() {
            $a5a9ed1d43a3a911$var$gl(null, a, null, null);
        });
        b[$a5a9ed1d43a3a911$var$uf] = null;
    }
};
function $a5a9ed1d43a3a911$var$nl(a) {
    this._internalRoot = a;
}
$a5a9ed1d43a3a911$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $a5a9ed1d43a3a911$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $a5a9ed1d43a3a911$var$Qc.length && 0 !== b && b < $a5a9ed1d43a3a911$var$Qc[c].priority; c++);
        $a5a9ed1d43a3a911$var$Qc.splice(c, 0, a);
        0 === c && $a5a9ed1d43a3a911$var$Vc(a);
    }
};
function $a5a9ed1d43a3a911$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $a5a9ed1d43a3a911$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $a5a9ed1d43a3a911$var$ql() {}
function $a5a9ed1d43a3a911$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $a5a9ed1d43a3a911$var$hl(g);
                f.call(a);
            };
        }
        var g = $a5a9ed1d43a3a911$var$fl(b, d, a, 0, null, !1, !1, "", $a5a9ed1d43a3a911$var$ql);
        a._reactRootContainer = g;
        a[$a5a9ed1d43a3a911$var$uf] = g.current;
        $a5a9ed1d43a3a911$var$sf(8 === a.nodeType ? a.parentNode : a);
        $a5a9ed1d43a3a911$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $a5a9ed1d43a3a911$var$hl(k);
            h.call(a);
        };
    }
    var k = $a5a9ed1d43a3a911$var$cl(a, 0, !1, null, null, !1, !1, "", $a5a9ed1d43a3a911$var$ql);
    a._reactRootContainer = k;
    a[$a5a9ed1d43a3a911$var$uf] = k.current;
    $a5a9ed1d43a3a911$var$sf(8 === a.nodeType ? a.parentNode : a);
    $a5a9ed1d43a3a911$var$Sk(function() {
        $a5a9ed1d43a3a911$var$gl(b, k, c, d);
    });
    return k;
}
function $a5a9ed1d43a3a911$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $a5a9ed1d43a3a911$var$hl(g);
                h.call(a);
            };
        }
        $a5a9ed1d43a3a911$var$gl(b, g, a, e);
    } else g = $a5a9ed1d43a3a911$var$rl(c, b, a, e, d);
    return $a5a9ed1d43a3a911$var$hl(g);
}
$a5a9ed1d43a3a911$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $a5a9ed1d43a3a911$var$tc(b.pendingLanes);
                0 !== c && ($a5a9ed1d43a3a911$var$Cc(b, c | 1), $a5a9ed1d43a3a911$var$Ek(b, $a5a9ed1d43a3a911$var$B()), 0 === ($a5a9ed1d43a3a911$var$K & 6) && ($a5a9ed1d43a3a911$var$Hj = $a5a9ed1d43a3a911$var$B() + 500, $a5a9ed1d43a3a911$var$jg()));
            }
            break;
        case 13:
            $a5a9ed1d43a3a911$var$Sk(function() {
                var b = $a5a9ed1d43a3a911$var$Zg(a, 1);
                if (null !== b) {
                    var c = $a5a9ed1d43a3a911$var$L();
                    $a5a9ed1d43a3a911$var$mh(b, a, 1, c);
                }
            }), $a5a9ed1d43a3a911$var$jl(a, 1);
    }
};
$a5a9ed1d43a3a911$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $a5a9ed1d43a3a911$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $a5a9ed1d43a3a911$var$L();
            $a5a9ed1d43a3a911$var$mh(b, a, 134217728, c);
        }
        $a5a9ed1d43a3a911$var$jl(a, 134217728);
    }
};
$a5a9ed1d43a3a911$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $a5a9ed1d43a3a911$var$lh(a), c = $a5a9ed1d43a3a911$var$Zg(a, b);
        if (null !== c) {
            var d = $a5a9ed1d43a3a911$var$L();
            $a5a9ed1d43a3a911$var$mh(c, a, b, d);
        }
        $a5a9ed1d43a3a911$var$jl(a, b);
    }
};
$a5a9ed1d43a3a911$var$Hc = function() {
    return $a5a9ed1d43a3a911$var$C;
};
$a5a9ed1d43a3a911$var$Ic = function(a, b) {
    var c = $a5a9ed1d43a3a911$var$C;
    try {
        return $a5a9ed1d43a3a911$var$C = a, b();
    } finally{
        $a5a9ed1d43a3a911$var$C = c;
    }
};
$a5a9ed1d43a3a911$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $a5a9ed1d43a3a911$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $a5a9ed1d43a3a911$var$Db(d);
                        if (!e) throw Error($a5a9ed1d43a3a911$var$p(90));
                        $a5a9ed1d43a3a911$var$Wa(d);
                        $a5a9ed1d43a3a911$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $a5a9ed1d43a3a911$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $a5a9ed1d43a3a911$var$fb(a, !!c.multiple, b, !1);
    }
};
$a5a9ed1d43a3a911$var$Gb = $a5a9ed1d43a3a911$var$Rk;
$a5a9ed1d43a3a911$var$Hb = $a5a9ed1d43a3a911$var$Sk;
var $a5a9ed1d43a3a911$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $a5a9ed1d43a3a911$var$Cb,
        $a5a9ed1d43a3a911$var$ue,
        $a5a9ed1d43a3a911$var$Db,
        $a5a9ed1d43a3a911$var$Eb,
        $a5a9ed1d43a3a911$var$Fb,
        $a5a9ed1d43a3a911$var$Rk
    ]
}, $a5a9ed1d43a3a911$var$ul = {
    findFiberByHostInstance: $a5a9ed1d43a3a911$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $a5a9ed1d43a3a911$var$vl = {
    bundleType: $a5a9ed1d43a3a911$var$ul.bundleType,
    version: $a5a9ed1d43a3a911$var$ul.version,
    rendererPackageName: $a5a9ed1d43a3a911$var$ul.rendererPackageName,
    rendererConfig: $a5a9ed1d43a3a911$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $a5a9ed1d43a3a911$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $a5a9ed1d43a3a911$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $a5a9ed1d43a3a911$var$ul.findFiberByHostInstance || $a5a9ed1d43a3a911$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a5a9ed1d43a3a911$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a5a9ed1d43a3a911$var$wl.isDisabled && $a5a9ed1d43a3a911$var$wl.supportsFiber) try {
        $a5a9ed1d43a3a911$var$kc = $a5a9ed1d43a3a911$var$wl.inject($a5a9ed1d43a3a911$var$vl), $a5a9ed1d43a3a911$var$lc = $a5a9ed1d43a3a911$var$wl;
    } catch (a) {}
}
$a5a9ed1d43a3a911$export$ae55be85d98224ed = $a5a9ed1d43a3a911$var$tl;
$a5a9ed1d43a3a911$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$a5a9ed1d43a3a911$var$ol(b)) throw Error($a5a9ed1d43a3a911$var$p(200));
    return $a5a9ed1d43a3a911$var$dl(a, b, null, c);
};
$a5a9ed1d43a3a911$export$882461b6382ed46c = function(a, b) {
    if (!$a5a9ed1d43a3a911$var$ol(a)) throw Error($a5a9ed1d43a3a911$var$p(299));
    var c = !1, d = "", e = $a5a9ed1d43a3a911$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $a5a9ed1d43a3a911$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$a5a9ed1d43a3a911$var$uf] = b.current;
    $a5a9ed1d43a3a911$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $a5a9ed1d43a3a911$var$ml(b);
};
$a5a9ed1d43a3a911$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($a5a9ed1d43a3a911$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($a5a9ed1d43a3a911$var$p(268, a));
    }
    a = $a5a9ed1d43a3a911$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$a5a9ed1d43a3a911$export$cd75ccfd720a3cd4 = function(a) {
    return $a5a9ed1d43a3a911$var$Sk(a);
};
$a5a9ed1d43a3a911$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$a5a9ed1d43a3a911$var$pl(b)) throw Error($a5a9ed1d43a3a911$var$p(200));
    return $a5a9ed1d43a3a911$var$sl(null, a, b, !0, c);
};
$a5a9ed1d43a3a911$export$757ceba2d55c277e = function(a, b, c) {
    if (!$a5a9ed1d43a3a911$var$ol(a)) throw Error($a5a9ed1d43a3a911$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $a5a9ed1d43a3a911$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $a5a9ed1d43a3a911$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$a5a9ed1d43a3a911$var$uf] = b.current;
    $a5a9ed1d43a3a911$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $a5a9ed1d43a3a911$var$nl(b);
};
$a5a9ed1d43a3a911$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$a5a9ed1d43a3a911$var$pl(b)) throw Error($a5a9ed1d43a3a911$var$p(200));
    return $a5a9ed1d43a3a911$var$sl(null, a, b, !1, c);
};
$a5a9ed1d43a3a911$export$502457920280e6be = function(a) {
    if (!$a5a9ed1d43a3a911$var$pl(a)) throw Error($a5a9ed1d43a3a911$var$p(40));
    return a._reactRootContainer ? ($a5a9ed1d43a3a911$var$Sk(function() {
        $a5a9ed1d43a3a911$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$a5a9ed1d43a3a911$var$uf] = null;
        });
    }), !0) : !1;
};
$a5a9ed1d43a3a911$export$c78a37762a8d58e1 = $a5a9ed1d43a3a911$var$Rk;
$a5a9ed1d43a3a911$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$a5a9ed1d43a3a911$var$pl(c)) throw Error($a5a9ed1d43a3a911$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($a5a9ed1d43a3a911$var$p(38));
    return $a5a9ed1d43a3a911$var$sl(a, b, c, !1, d);
};
$a5a9ed1d43a3a911$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("c22GA", function(module, exports) {
"use strict";

module.exports = (parcelRequire("jpqPB"));

});
parcelRegister("jpqPB", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $e2152a3e5622f9e8$export$c4744153514ff05d; }, function (v) { return $e2152a3e5622f9e8$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $e2152a3e5622f9e8$export$3e506c1ccc9cc1a7; }, function (v) { return $e2152a3e5622f9e8$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $e2152a3e5622f9e8$export$e26fe2ed2fa76875; }, function (v) { return $e2152a3e5622f9e8$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $e2152a3e5622f9e8$export$502329bbf4b505b1; }, function (v) { return $e2152a3e5622f9e8$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $e2152a3e5622f9e8$export$6e3807111c4874c4; }, function (v) { return $e2152a3e5622f9e8$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $e2152a3e5622f9e8$export$c27134553091fb3a; }, function (v) { return $e2152a3e5622f9e8$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $e2152a3e5622f9e8$export$33ee1acdc04fd2a2; }, function (v) { return $e2152a3e5622f9e8$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $e2152a3e5622f9e8$export$b00a404bbd5edef2; }, function (v) { return $e2152a3e5622f9e8$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $e2152a3e5622f9e8$export$8352ce38b91d0c62; }, function (v) { return $e2152a3e5622f9e8$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $e2152a3e5622f9e8$export$d66a1c1c77bd778b; }, function (v) { return $e2152a3e5622f9e8$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $e2152a3e5622f9e8$export$d3dfb8e4810cb555; }, function (v) { return $e2152a3e5622f9e8$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $e2152a3e5622f9e8$export$839f9183b0465a69; }, function (v) { return $e2152a3e5622f9e8$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $e2152a3e5622f9e8$export$72fdf0e06517287b; }, function (v) { return $e2152a3e5622f9e8$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $e2152a3e5622f9e8$export$4b844e58a3e414b4; }, function (v) { return $e2152a3e5622f9e8$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $e2152a3e5622f9e8$export$816d2913ae6b83b1; }, function (v) { return $e2152a3e5622f9e8$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $e2152a3e5622f9e8$export$61bcfe829111a1d0; }, function (v) { return $e2152a3e5622f9e8$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $e2152a3e5622f9e8$export$7ee8c9beb337bc3f; }, function (v) { return $e2152a3e5622f9e8$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $e2152a3e5622f9e8$export$b5836b71941fa3ed; }, function (v) { return $e2152a3e5622f9e8$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $e2152a3e5622f9e8$export$cf845f2c119da08a; }, function (v) { return $e2152a3e5622f9e8$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $e2152a3e5622f9e8$export$c4744153514ff05d;
var $e2152a3e5622f9e8$export$3e506c1ccc9cc1a7;
var $e2152a3e5622f9e8$export$e26fe2ed2fa76875;
var $e2152a3e5622f9e8$export$502329bbf4b505b1;
var $e2152a3e5622f9e8$export$6e3807111c4874c4;
var $e2152a3e5622f9e8$export$c27134553091fb3a;
var $e2152a3e5622f9e8$export$33ee1acdc04fd2a2;
var $e2152a3e5622f9e8$export$b00a404bbd5edef2;
var $e2152a3e5622f9e8$export$8352ce38b91d0c62;
var $e2152a3e5622f9e8$export$d66a1c1c77bd778b;
var $e2152a3e5622f9e8$export$d3dfb8e4810cb555;
var $e2152a3e5622f9e8$export$839f9183b0465a69;
var $e2152a3e5622f9e8$export$72fdf0e06517287b;
var $e2152a3e5622f9e8$export$4b844e58a3e414b4;
var $e2152a3e5622f9e8$export$816d2913ae6b83b1;
var $e2152a3e5622f9e8$export$61bcfe829111a1d0;
var $e2152a3e5622f9e8$export$7ee8c9beb337bc3f;
var $e2152a3e5622f9e8$export$b5836b71941fa3ed;
var $e2152a3e5622f9e8$export$cf845f2c119da08a;
"use strict";
function $e2152a3e5622f9e8$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $e2152a3e5622f9e8$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $e2152a3e5622f9e8$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $e2152a3e5622f9e8$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $e2152a3e5622f9e8$var$g(C, c)) n < e && 0 > $e2152a3e5622f9e8$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $e2152a3e5622f9e8$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $e2152a3e5622f9e8$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $e2152a3e5622f9e8$var$l = performance;
    $e2152a3e5622f9e8$export$c4744153514ff05d = function() {
        return $e2152a3e5622f9e8$var$l.now();
    };
} else {
    var $e2152a3e5622f9e8$var$p = Date, $e2152a3e5622f9e8$var$q = $e2152a3e5622f9e8$var$p.now();
    $e2152a3e5622f9e8$export$c4744153514ff05d = function() {
        return $e2152a3e5622f9e8$var$p.now() - $e2152a3e5622f9e8$var$q;
    };
}
var $e2152a3e5622f9e8$var$r = [], $e2152a3e5622f9e8$var$t = [], $e2152a3e5622f9e8$var$u = 1, $e2152a3e5622f9e8$var$v = null, $e2152a3e5622f9e8$var$y = 3, $e2152a3e5622f9e8$var$z = !1, $e2152a3e5622f9e8$var$A = !1, $e2152a3e5622f9e8$var$B = !1, $e2152a3e5622f9e8$var$D = "function" === typeof setTimeout ? setTimeout : null, $e2152a3e5622f9e8$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $e2152a3e5622f9e8$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $e2152a3e5622f9e8$var$G(a) {
    for(var b = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$t); null !== b;){
        if (null === b.callback) $e2152a3e5622f9e8$var$k($e2152a3e5622f9e8$var$t);
        else if (b.startTime <= a) $e2152a3e5622f9e8$var$k($e2152a3e5622f9e8$var$t), b.sortIndex = b.expirationTime, $e2152a3e5622f9e8$var$f($e2152a3e5622f9e8$var$r, b);
        else break;
        b = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$t);
    }
}
function $e2152a3e5622f9e8$var$H(a) {
    $e2152a3e5622f9e8$var$B = !1;
    $e2152a3e5622f9e8$var$G(a);
    if (!$e2152a3e5622f9e8$var$A) {
        if (null !== $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r)) $e2152a3e5622f9e8$var$A = !0, $e2152a3e5622f9e8$var$I($e2152a3e5622f9e8$var$J);
        else {
            var b = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$t);
            null !== b && $e2152a3e5622f9e8$var$K($e2152a3e5622f9e8$var$H, b.startTime - a);
        }
    }
}
function $e2152a3e5622f9e8$var$J(a, b) {
    $e2152a3e5622f9e8$var$A = !1;
    $e2152a3e5622f9e8$var$B && ($e2152a3e5622f9e8$var$B = !1, $e2152a3e5622f9e8$var$E($e2152a3e5622f9e8$var$L), $e2152a3e5622f9e8$var$L = -1);
    $e2152a3e5622f9e8$var$z = !0;
    var c = $e2152a3e5622f9e8$var$y;
    try {
        $e2152a3e5622f9e8$var$G(b);
        for($e2152a3e5622f9e8$var$v = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r); null !== $e2152a3e5622f9e8$var$v && (!($e2152a3e5622f9e8$var$v.expirationTime > b) || a && !$e2152a3e5622f9e8$var$M());){
            var d = $e2152a3e5622f9e8$var$v.callback;
            if ("function" === typeof d) {
                $e2152a3e5622f9e8$var$v.callback = null;
                $e2152a3e5622f9e8$var$y = $e2152a3e5622f9e8$var$v.priorityLevel;
                var e = d($e2152a3e5622f9e8$var$v.expirationTime <= b);
                b = $e2152a3e5622f9e8$export$c4744153514ff05d();
                "function" === typeof e ? $e2152a3e5622f9e8$var$v.callback = e : $e2152a3e5622f9e8$var$v === $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r) && $e2152a3e5622f9e8$var$k($e2152a3e5622f9e8$var$r);
                $e2152a3e5622f9e8$var$G(b);
            } else $e2152a3e5622f9e8$var$k($e2152a3e5622f9e8$var$r);
            $e2152a3e5622f9e8$var$v = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r);
        }
        if (null !== $e2152a3e5622f9e8$var$v) var w = !0;
        else {
            var m = $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$t);
            null !== m && $e2152a3e5622f9e8$var$K($e2152a3e5622f9e8$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $e2152a3e5622f9e8$var$v = null, $e2152a3e5622f9e8$var$y = c, $e2152a3e5622f9e8$var$z = !1;
    }
}
var $e2152a3e5622f9e8$var$N = !1, $e2152a3e5622f9e8$var$O = null, $e2152a3e5622f9e8$var$L = -1, $e2152a3e5622f9e8$var$P = 5, $e2152a3e5622f9e8$var$Q = -1;
function $e2152a3e5622f9e8$var$M() {
    return $e2152a3e5622f9e8$export$c4744153514ff05d() - $e2152a3e5622f9e8$var$Q < $e2152a3e5622f9e8$var$P ? !1 : !0;
}
function $e2152a3e5622f9e8$var$R() {
    if (null !== $e2152a3e5622f9e8$var$O) {
        var a = $e2152a3e5622f9e8$export$c4744153514ff05d();
        $e2152a3e5622f9e8$var$Q = a;
        var b = !0;
        try {
            b = $e2152a3e5622f9e8$var$O(!0, a);
        } finally{
            b ? $e2152a3e5622f9e8$var$S() : ($e2152a3e5622f9e8$var$N = !1, $e2152a3e5622f9e8$var$O = null);
        }
    } else $e2152a3e5622f9e8$var$N = !1;
}
var $e2152a3e5622f9e8$var$S;
if ("function" === typeof $e2152a3e5622f9e8$var$F) $e2152a3e5622f9e8$var$S = function() {
    $e2152a3e5622f9e8$var$F($e2152a3e5622f9e8$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $e2152a3e5622f9e8$var$T = new MessageChannel, $e2152a3e5622f9e8$var$U = $e2152a3e5622f9e8$var$T.port2;
    $e2152a3e5622f9e8$var$T.port1.onmessage = $e2152a3e5622f9e8$var$R;
    $e2152a3e5622f9e8$var$S = function() {
        $e2152a3e5622f9e8$var$U.postMessage(null);
    };
} else $e2152a3e5622f9e8$var$S = function() {
    $e2152a3e5622f9e8$var$D($e2152a3e5622f9e8$var$R, 0);
};
function $e2152a3e5622f9e8$var$I(a) {
    $e2152a3e5622f9e8$var$O = a;
    $e2152a3e5622f9e8$var$N || ($e2152a3e5622f9e8$var$N = !0, $e2152a3e5622f9e8$var$S());
}
function $e2152a3e5622f9e8$var$K(a, b) {
    $e2152a3e5622f9e8$var$L = $e2152a3e5622f9e8$var$D(function() {
        a($e2152a3e5622f9e8$export$c4744153514ff05d());
    }, b);
}
$e2152a3e5622f9e8$export$3e506c1ccc9cc1a7 = 5;
$e2152a3e5622f9e8$export$e26fe2ed2fa76875 = 1;
$e2152a3e5622f9e8$export$502329bbf4b505b1 = 4;
$e2152a3e5622f9e8$export$6e3807111c4874c4 = 3;
$e2152a3e5622f9e8$export$c27134553091fb3a = null;
$e2152a3e5622f9e8$export$33ee1acdc04fd2a2 = 2;
$e2152a3e5622f9e8$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$e2152a3e5622f9e8$export$8352ce38b91d0c62 = function() {
    $e2152a3e5622f9e8$var$A || $e2152a3e5622f9e8$var$z || ($e2152a3e5622f9e8$var$A = !0, $e2152a3e5622f9e8$var$I($e2152a3e5622f9e8$var$J));
};
$e2152a3e5622f9e8$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $e2152a3e5622f9e8$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$e2152a3e5622f9e8$export$d3dfb8e4810cb555 = function() {
    return $e2152a3e5622f9e8$var$y;
};
$e2152a3e5622f9e8$export$839f9183b0465a69 = function() {
    return $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r);
};
$e2152a3e5622f9e8$export$72fdf0e06517287b = function(a) {
    switch($e2152a3e5622f9e8$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $e2152a3e5622f9e8$var$y;
    }
    var c = $e2152a3e5622f9e8$var$y;
    $e2152a3e5622f9e8$var$y = b;
    try {
        return a();
    } finally{
        $e2152a3e5622f9e8$var$y = c;
    }
};
$e2152a3e5622f9e8$export$4b844e58a3e414b4 = function() {};
$e2152a3e5622f9e8$export$816d2913ae6b83b1 = function() {};
$e2152a3e5622f9e8$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $e2152a3e5622f9e8$var$y;
    $e2152a3e5622f9e8$var$y = a;
    try {
        return b();
    } finally{
        $e2152a3e5622f9e8$var$y = c;
    }
};
$e2152a3e5622f9e8$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $e2152a3e5622f9e8$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $e2152a3e5622f9e8$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $e2152a3e5622f9e8$var$f($e2152a3e5622f9e8$var$t, a), null === $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$r) && a === $e2152a3e5622f9e8$var$h($e2152a3e5622f9e8$var$t) && ($e2152a3e5622f9e8$var$B ? ($e2152a3e5622f9e8$var$E($e2152a3e5622f9e8$var$L), $e2152a3e5622f9e8$var$L = -1) : $e2152a3e5622f9e8$var$B = !0, $e2152a3e5622f9e8$var$K($e2152a3e5622f9e8$var$H, c - d))) : (a.sortIndex = e, $e2152a3e5622f9e8$var$f($e2152a3e5622f9e8$var$r, a), $e2152a3e5622f9e8$var$A || $e2152a3e5622f9e8$var$z || ($e2152a3e5622f9e8$var$A = !0, $e2152a3e5622f9e8$var$I($e2152a3e5622f9e8$var$J)));
    return a;
};
$e2152a3e5622f9e8$export$b5836b71941fa3ed = $e2152a3e5622f9e8$var$M;
$e2152a3e5622f9e8$export$cf845f2c119da08a = function(a) {
    var b = $e2152a3e5622f9e8$var$y;
    return function() {
        var c = $e2152a3e5622f9e8$var$y;
        $e2152a3e5622f9e8$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $e2152a3e5622f9e8$var$y = c;
        }
    };
};

});



parcelRegister("97ZOK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6a54b82a6a0361a6$export$2e2bcd8739ae039; });

var $aOChP = parcelRequire("aOChP");
const $6a54b82a6a0361a6$var$UserContext = /*#__PURE__*/ (0, $aOChP.createContext)({
    loggedInUser: "Default User"
});
var $6a54b82a6a0361a6$export$2e2bcd8739ae039 = $6a54b82a6a0361a6$var$UserContext;

});

parcelRegister("1pyfK", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", function () { return $1072b227e5a629a3$export$bf730a2d8bf68b42; }, function (v) { return $1072b227e5a629a3$export$bf730a2d8bf68b42 = v; });
/**
 * @license React
 * use-sync-external-store-with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1072b227e5a629a3$export$bf730a2d8bf68b42;
"use strict";

var $aOChP = parcelRequire("aOChP");
function $1072b227e5a629a3$var$n(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $1072b227e5a629a3$var$p = "function" === typeof Object.is ? Object.is : $1072b227e5a629a3$var$n, $1072b227e5a629a3$var$q = $aOChP.useSyncExternalStore, $1072b227e5a629a3$var$r = $aOChP.useRef, $1072b227e5a629a3$var$t = $aOChP.useEffect, $1072b227e5a629a3$var$u = $aOChP.useMemo, $1072b227e5a629a3$var$v = $aOChP.useDebugValue;
$1072b227e5a629a3$export$bf730a2d8bf68b42 = function(a, b, e, l, h) {
    var c = $1072b227e5a629a3$var$r(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $1072b227e5a629a3$var$u(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== h && f.hasValue) {
                    var b = f.value;
                    if (h(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($1072b227e5a629a3$var$p(d, a)) return b;
            var e = l(a);
            if (void 0 !== h && h(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        h
    ]);
    var d = $1072b227e5a629a3$var$q(a, c[0], c[1]);
    $1072b227e5a629a3$var$t(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $1072b227e5a629a3$var$v(d);
    return d;
};

});

parcelRegister("179KA", function(module, exports) {

var $6oe5e = parcelRequire("6oe5e");
module.exports = $6oe5e("fG59c").then(()=>parcelRequire("5iYCl"));

});
parcelRegister("6oe5e", function(module, exports) {
"use strict";

function $4a6fe8a2d42bb37b$var$load(id) {
    // eslint-disable-next-line no-undef
    return import((parcelRequire("9wJdH")).resolve(id));
}
module.exports = $4a6fe8a2d42bb37b$var$load;

});


parcelRegister("jJdUP", function(module, exports) {

var $6oe5e = parcelRequire("6oe5e");
module.exports = $6oe5e("4R2og").then(()=>parcelRequire("5rUzI"));

});


var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");
var $3ffba8a88cb861dc$exports = {};

$parcel$export($3ffba8a88cb861dc$exports, "createRoot", function () { return $3ffba8a88cb861dc$export$882461b6382ed46c; }, function (v) { return $3ffba8a88cb861dc$export$882461b6382ed46c = v; });
$parcel$export($3ffba8a88cb861dc$exports, "hydrateRoot", function () { return $3ffba8a88cb861dc$export$757ceba2d55c277e; }, function (v) { return $3ffba8a88cb861dc$export$757ceba2d55c277e = v; });
var $3ffba8a88cb861dc$export$882461b6382ed46c;
var $3ffba8a88cb861dc$export$757ceba2d55c277e;
"use strict";
var $a4960af4154d3849$exports = {};
"use strict";
function $a4960af4154d3849$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($a4960af4154d3849$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$a4960af4154d3849$var$checkDCE();

$a4960af4154d3849$exports = (parcelRequire("edP6V"));


var $3ffba8a88cb861dc$var$i;
$3ffba8a88cb861dc$export$882461b6382ed46c = $a4960af4154d3849$exports.createRoot;
$3ffba8a88cb861dc$export$757ceba2d55c277e = $a4960af4154d3849$exports.hydrateRoot;



var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");
var $5340b145e6475b90$exports = {};
$5340b145e6475b90$exports = new URL("FEAST_FLEET.2fbdbd07.svg", import.meta.url).toString();


/**
 * React Router DOM v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aOChP = parcelRequire("aOChP");

/**
 * @remix-run/router v1.15.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $2167cc54b87f9d14$var$_extends() {
    $2167cc54b87f9d14$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $2167cc54b87f9d14$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $2167cc54b87f9d14$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($2167cc54b87f9d14$export$e19cd5f9376f8cee || ($2167cc54b87f9d14$export$e19cd5f9376f8cee = {}));
const $2167cc54b87f9d14$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $2167cc54b87f9d14$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $2167cc54b87f9d14$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $2167cc54b87f9d14$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $2167cc54b87f9d14$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $2167cc54b87f9d14$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $2167cc54b87f9d14$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $2167cc54b87f9d14$export$fe53371bee54353d(to);
    }
    return $2167cc54b87f9d14$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $2167cc54b87f9d14$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $2167cc54b87f9d14$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $2167cc54b87f9d14$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $2167cc54b87f9d14$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $2167cc54b87f9d14$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $2167cc54b87f9d14$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $2167cc54b87f9d14$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $2167cc54b87f9d14$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $2167cc54b87f9d14$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $2167cc54b87f9d14$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $2167cc54b87f9d14$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $2167cc54b87f9d14$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $2167cc54b87f9d14$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $2167cc54b87f9d14$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $2167cc54b87f9d14$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $2167cc54b87f9d14$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($2167cc54b87f9d14$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push;
        let location = $2167cc54b87f9d14$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $2167cc54b87f9d14$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace;
        let location = $2167cc54b87f9d14$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $2167cc54b87f9d14$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $2167cc54b87f9d14$export$fe53371bee54353d(to);
        $2167cc54b87f9d14$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($2167cc54b87f9d14$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($2167cc54b87f9d14$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $2167cc54b87f9d14$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($2167cc54b87f9d14$var$ResultType || ($2167cc54b87f9d14$var$ResultType = {}));
const $2167cc54b87f9d14$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $2167cc54b87f9d14$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $2167cc54b87f9d14$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $2167cc54b87f9d14$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $2167cc54b87f9d14$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($2167cc54b87f9d14$var$isIndexRoute(route)) {
            let indexRoute = $2167cc54b87f9d14$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $2167cc54b87f9d14$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $2167cc54b87f9d14$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $2167cc54b87f9d14$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $2167cc54b87f9d14$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $2167cc54b87f9d14$var$flattenRoutes(routes);
    $2167cc54b87f9d14$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $2167cc54b87f9d14$var$matchRouteBranch(branches[i], // Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    $2167cc54b87f9d14$var$safelyDecodeURI(pathname));
    return matches;
}
function $2167cc54b87f9d14$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $2167cc54b87f9d14$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $2167cc54b87f9d14$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $2167cc54b87f9d14$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $2167cc54b87f9d14$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $2167cc54b87f9d14$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $2167cc54b87f9d14$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $2167cc54b87f9d14$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $2167cc54b87f9d14$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $2167cc54b87f9d14$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $2167cc54b87f9d14$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $2167cc54b87f9d14$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $2167cc54b87f9d14$var$paramRe = /^:[\w-]+$/;
const $2167cc54b87f9d14$var$dynamicSegmentValue = 3;
const $2167cc54b87f9d14$var$indexRouteValue = 2;
const $2167cc54b87f9d14$var$emptySegmentValue = 1;
const $2167cc54b87f9d14$var$staticSegmentValue = 10;
const $2167cc54b87f9d14$var$splatPenalty = -2;
const $2167cc54b87f9d14$var$isSplat = (s)=>s === "*";
function $2167cc54b87f9d14$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($2167cc54b87f9d14$var$isSplat)) initialScore += $2167cc54b87f9d14$var$splatPenalty;
    if (index) initialScore += $2167cc54b87f9d14$var$indexRouteValue;
    return segments.filter((s)=>!$2167cc54b87f9d14$var$isSplat(s)).reduce((score, segment)=>score + ($2167cc54b87f9d14$var$paramRe.test(segment) ? $2167cc54b87f9d14$var$dynamicSegmentValue : segment === "" ? $2167cc54b87f9d14$var$emptySegmentValue : $2167cc54b87f9d14$var$staticSegmentValue), initialScore);
}
function $2167cc54b87f9d14$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $2167cc54b87f9d14$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $2167cc54b87f9d14$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $2167cc54b87f9d14$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $2167cc54b87f9d14$export$a5c6d149b50c1d86($2167cc54b87f9d14$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $2167cc54b87f9d14$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $2167cc54b87f9d14$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $2167cc54b87f9d14$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $2167cc54b87f9d14$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $2167cc54b87f9d14$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $2167cc54b87f9d14$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = $2167cc54b87f9d14$var$safelyDecodeURIComponent(value || "", paramName);
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $2167cc54b87f9d14$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $2167cc54b87f9d14$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $2167cc54b87f9d14$var$safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        $2167cc54b87f9d14$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function $2167cc54b87f9d14$var$safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        $2167cc54b87f9d14$export$c0e02632e14916fd(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $2167cc54b87f9d14$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $2167cc54b87f9d14$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $2167cc54b87f9d14$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $2167cc54b87f9d14$var$normalizeSearch(search),
        hash: $2167cc54b87f9d14$var$normalizeHash(hash)
    };
}
function $2167cc54b87f9d14$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $2167cc54b87f9d14$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $2167cc54b87f9d14$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $2167cc54b87f9d14$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $2167cc54b87f9d14$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $2167cc54b87f9d14$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $2167cc54b87f9d14$export$8ccf933b0513f8d0(toArg);
    else {
        to = $2167cc54b87f9d14$var$_extends({}, toArg);
        $2167cc54b87f9d14$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $2167cc54b87f9d14$var$getInvalidPathError("?", "pathname", "search", to));
        $2167cc54b87f9d14$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $2167cc54b87f9d14$var$getInvalidPathError("#", "pathname", "hash", to));
        $2167cc54b87f9d14$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $2167cc54b87f9d14$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $2167cc54b87f9d14$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $2167cc54b87f9d14$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $2167cc54b87f9d14$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $2167cc54b87f9d14$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $2167cc54b87f9d14$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $2167cc54b87f9d14$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $2167cc54b87f9d14$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $2167cc54b87f9d14$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $2167cc54b87f9d14$export$42a99a7a4bc0e76a extends Error {
}
class $2167cc54b87f9d14$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $2167cc54b87f9d14$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $2167cc54b87f9d14$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $2167cc54b87f9d14$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $2167cc54b87f9d14$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $2167cc54b87f9d14$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $2167cc54b87f9d14$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $2167cc54b87f9d14$var$unwrapTrackedPromise(value) {
    if (!$2167cc54b87f9d14$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $2167cc54b87f9d14$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $2167cc54b87f9d14$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $2167cc54b87f9d14$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $2167cc54b87f9d14$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $2167cc54b87f9d14$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $2167cc54b87f9d14$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $2167cc54b87f9d14$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $2167cc54b87f9d14$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $2167cc54b87f9d14$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $2167cc54b87f9d14$var$validMutationMethods = new Set($2167cc54b87f9d14$var$validMutationMethodsArr);
const $2167cc54b87f9d14$var$validRequestMethodsArr = [
    "get",
    ...$2167cc54b87f9d14$var$validMutationMethodsArr
];
const $2167cc54b87f9d14$var$validRequestMethods = new Set($2167cc54b87f9d14$var$validRequestMethodsArr);
const $2167cc54b87f9d14$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $2167cc54b87f9d14$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $2167cc54b87f9d14$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $2167cc54b87f9d14$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $2167cc54b87f9d14$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $2167cc54b87f9d14$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $2167cc54b87f9d14$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $2167cc54b87f9d14$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $2167cc54b87f9d14$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $2167cc54b87f9d14$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $2167cc54b87f9d14$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $2167cc54b87f9d14$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $2167cc54b87f9d14$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $2167cc54b87f9d14$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $2167cc54b87f9d14$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $2167cc54b87f9d14$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        initialized = initialMatches.every((m)=>m.route.loader && m.route.loader.hydrate !== true && (loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $2167cc54b87f9d14$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $2167cc54b87f9d14$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $2167cc54b87f9d14$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $2167cc54b87f9d14$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$2167cc54b87f9d14$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $2167cc54b87f9d14$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $2167cc54b87f9d14$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $2167cc54b87f9d14$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $2167cc54b87f9d14$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $2167cc54b87f9d14$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($2167cc54b87f9d14$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $2167cc54b87f9d14$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $2167cc54b87f9d14$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $2167cc54b87f9d14$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $2167cc54b87f9d14$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $2167cc54b87f9d14$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $2167cc54b87f9d14$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $2167cc54b87f9d14$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $2167cc54b87f9d14$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $2167cc54b87f9d14$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $2167cc54b87f9d14$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $2167cc54b87f9d14$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $2167cc54b87f9d14$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$2167cc54b87f9d14$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $2167cc54b87f9d14$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $2167cc54b87f9d14$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $2167cc54b87f9d14$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $2167cc54b87f9d14$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $2167cc54b87f9d14$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $2167cc54b87f9d14$var$ResultType.error,
            error: $2167cc54b87f9d14$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $2167cc54b87f9d14$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($2167cc54b87f9d14$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($2167cc54b87f9d14$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $2167cc54b87f9d14$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($2167cc54b87f9d14$var$isDeferredResult(result)) throw $2167cc54b87f9d14$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $2167cc54b87f9d14$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $2167cc54b87f9d14$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $2167cc54b87f9d14$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $2167cc54b87f9d14$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since iot's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $2167cc54b87f9d14$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($2167cc54b87f9d14$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $2167cc54b87f9d14$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $2167cc54b87f9d14$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $2167cc54b87f9d14$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $2167cc54b87f9d14$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $2167cc54b87f9d14$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $2167cc54b87f9d14$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $2167cc54b87f9d14$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $2167cc54b87f9d14$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $2167cc54b87f9d14$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $2167cc54b87f9d14$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $2167cc54b87f9d14$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $2167cc54b87f9d14$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($2167cc54b87f9d14$var$isRedirectResult(actionResult) || $2167cc54b87f9d14$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $2167cc54b87f9d14$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($2167cc54b87f9d14$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $2167cc54b87f9d14$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $2167cc54b87f9d14$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($2167cc54b87f9d14$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($2167cc54b87f9d14$var$isDeferredResult(actionResult)) throw $2167cc54b87f9d14$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $2167cc54b87f9d14$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $2167cc54b87f9d14$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $2167cc54b87f9d14$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $2167cc54b87f9d14$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $2167cc54b87f9d14$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $2167cc54b87f9d14$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $2167cc54b87f9d14$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $2167cc54b87f9d14$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $2167cc54b87f9d14$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $2167cc54b87f9d14$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $2167cc54b87f9d14$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $2167cc54b87f9d14$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $2167cc54b87f9d14$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $2167cc54b87f9d14$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($2167cc54b87f9d14$var$isDeferredResult(result)) result = await $2167cc54b87f9d14$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $2167cc54b87f9d14$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($2167cc54b87f9d14$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $2167cc54b87f9d14$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($2167cc54b87f9d14$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $2167cc54b87f9d14$export$3e9cee6b33872309(!$2167cc54b87f9d14$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $2167cc54b87f9d14$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $2167cc54b87f9d14$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $2167cc54b87f9d14$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($2167cc54b87f9d14$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $2167cc54b87f9d14$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $2167cc54b87f9d14$export$e19cd5f9376f8cee.Replace : $2167cc54b87f9d14$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $2167cc54b87f9d14$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($2167cc54b87f9d14$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $2167cc54b87f9d14$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $2167cc54b87f9d14$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $2167cc54b87f9d14$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$2167cc54b87f9d14$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $2167cc54b87f9d14$var$callLoaderOrAction("loader", $2167cc54b87f9d14$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $2167cc54b87f9d14$var$ResultType.error,
                        error: $2167cc54b87f9d14$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $2167cc54b87f9d14$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $2167cc54b87f9d14$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $2167cc54b87f9d14$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $2167cc54b87f9d14$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $2167cc54b87f9d14$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $2167cc54b87f9d14$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $2167cc54b87f9d14$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $2167cc54b87f9d14$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $2167cc54b87f9d14$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $2167cc54b87f9d14$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $2167cc54b87f9d14$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $2167cc54b87f9d14$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $2167cc54b87f9d14$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$2167cc54b87f9d14$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $2167cc54b87f9d14$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $2167cc54b87f9d14$export$4d0306f8f6a4585b = Symbol("deferred");
function $2167cc54b87f9d14$export$3336b097a6fbc59a(routes, opts) {
    $2167cc54b87f9d14$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $2167cc54b87f9d14$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $2167cc54b87f9d14$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $2167cc54b87f9d14$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $2167cc54b87f9d14$var$createLocation("", $2167cc54b87f9d14$export$fe53371bee54353d(url), null, "default");
        let matches = $2167cc54b87f9d14$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$2167cc54b87f9d14$var$isValidMethod(method) && method !== "HEAD") {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $2167cc54b87f9d14$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $2167cc54b87f9d14$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($2167cc54b87f9d14$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $2167cc54b87f9d14$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $2167cc54b87f9d14$var$createLocation("", $2167cc54b87f9d14$export$fe53371bee54353d(url), null, "default");
        let matches = $2167cc54b87f9d14$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$2167cc54b87f9d14$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $2167cc54b87f9d14$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $2167cc54b87f9d14$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $2167cc54b87f9d14$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $2167cc54b87f9d14$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $2167cc54b87f9d14$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($2167cc54b87f9d14$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$2167cc54b87f9d14$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $2167cc54b87f9d14$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($2167cc54b87f9d14$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $2167cc54b87f9d14$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $2167cc54b87f9d14$var$isResponse(result) ? result : $2167cc54b87f9d14$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($2167cc54b87f9d14$var$isQueryRouteResponse(e)) {
                if (e.type === $2167cc54b87f9d14$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($2167cc54b87f9d14$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $2167cc54b87f9d14$var$ResultType.error,
                error: error
            };
        } else {
            result = await $2167cc54b87f9d14$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $2167cc54b87f9d14$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($2167cc54b87f9d14$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($2167cc54b87f9d14$var$isDeferredResult(result)) {
            let error = $2167cc54b87f9d14$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $2167cc54b87f9d14$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($2167cc54b87f9d14$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($2167cc54b87f9d14$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $2167cc54b87f9d14$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $2167cc54b87f9d14$var$_extends({}, context, {
                statusCode: $2167cc54b87f9d14$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $2167cc54b87f9d14$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $2167cc54b87f9d14$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $2167cc54b87f9d14$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $2167cc54b87f9d14$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $2167cc54b87f9d14$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$2167cc54b87f9d14$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $2167cc54b87f9d14$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $2167cc54b87f9d14$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $2167cc54b87f9d14$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $2167cc54b87f9d14$export$fec11da027c70692(routes, context, error) {
    let newContext = $2167cc54b87f9d14$var$_extends({}, context, {
        statusCode: $2167cc54b87f9d14$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $2167cc54b87f9d14$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $2167cc54b87f9d14$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $2167cc54b87f9d14$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $2167cc54b87f9d14$export$cae722b0cc860f13(to ? to : ".", $2167cc54b87f9d14$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $2167cc54b87f9d14$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$2167cc54b87f9d14$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $2167cc54b87f9d14$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $2167cc54b87f9d14$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $2167cc54b87f9d14$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$2167cc54b87f9d14$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$2167cc54b87f9d14$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $2167cc54b87f9d14$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $2167cc54b87f9d14$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $2167cc54b87f9d14$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$2167cc54b87f9d14$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$2167cc54b87f9d14$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $2167cc54b87f9d14$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $2167cc54b87f9d14$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $2167cc54b87f9d14$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $2167cc54b87f9d14$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $2167cc54b87f9d14$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($2167cc54b87f9d14$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $2167cc54b87f9d14$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $2167cc54b87f9d14$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $2167cc54b87f9d14$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $2167cc54b87f9d14$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $2167cc54b87f9d14$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $2167cc54b87f9d14$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($2167cc54b87f9d14$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $2167cc54b87f9d14$var$shouldRevalidateLoader(match, $2167cc54b87f9d14$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $2167cc54b87f9d14$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $2167cc54b87f9d14$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $2167cc54b87f9d14$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $2167cc54b87f9d14$var$shouldRevalidateLoader(fetcherMatch, $2167cc54b87f9d14$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $2167cc54b87f9d14$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $2167cc54b87f9d14$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $2167cc54b87f9d14$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $2167cc54b87f9d14$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $2167cc54b87f9d14$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $2167cc54b87f9d14$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$2167cc54b87f9d14$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $2167cc54b87f9d14$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $2167cc54b87f9d14$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $2167cc54b87f9d14$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $2167cc54b87f9d14$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $2167cc54b87f9d14$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $2167cc54b87f9d14$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $2167cc54b87f9d14$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $2167cc54b87f9d14$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $2167cc54b87f9d14$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($2167cc54b87f9d14$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($2167cc54b87f9d14$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $2167cc54b87f9d14$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$2167cc54b87f9d14$var$ABSOLUTE_URL_REGEX.test(location)) location = $2167cc54b87f9d14$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $2167cc54b87f9d14$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $2167cc54b87f9d14$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $2167cc54b87f9d14$var$ResultType.error ? $2167cc54b87f9d14$var$ResultType.error : $2167cc54b87f9d14$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $2167cc54b87f9d14$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $2167cc54b87f9d14$var$ResultType.error) return {
            type: resultType,
            error: new $2167cc54b87f9d14$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $2167cc54b87f9d14$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $2167cc54b87f9d14$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($2167cc54b87f9d14$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $2167cc54b87f9d14$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $2167cc54b87f9d14$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $2167cc54b87f9d14$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($2167cc54b87f9d14$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $2167cc54b87f9d14$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $2167cc54b87f9d14$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $2167cc54b87f9d14$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $2167cc54b87f9d14$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $2167cc54b87f9d14$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $2167cc54b87f9d14$export$3e9cee6b33872309(!$2167cc54b87f9d14$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($2167cc54b87f9d14$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $2167cc54b87f9d14$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $2167cc54b87f9d14$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($2167cc54b87f9d14$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $2167cc54b87f9d14$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $2167cc54b87f9d14$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $2167cc54b87f9d14$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($2167cc54b87f9d14$var$isErrorResult(result)) {
            let boundaryMatch = $2167cc54b87f9d14$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $2167cc54b87f9d14$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($2167cc54b87f9d14$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $2167cc54b87f9d14$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($2167cc54b87f9d14$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $2167cc54b87f9d14$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $2167cc54b87f9d14$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $2167cc54b87f9d14$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $2167cc54b87f9d14$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $2167cc54b87f9d14$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $2167cc54b87f9d14$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $2167cc54b87f9d14$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $2167cc54b87f9d14$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $2167cc54b87f9d14$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($2167cc54b87f9d14$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $2167cc54b87f9d14$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(path) : path;
    return $2167cc54b87f9d14$export$fe53371bee54353d($2167cc54b87f9d14$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $2167cc54b87f9d14$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $2167cc54b87f9d14$var$isDeferredResult(result) {
    return result.type === $2167cc54b87f9d14$var$ResultType.deferred;
}
function $2167cc54b87f9d14$var$isErrorResult(result) {
    return result.type === $2167cc54b87f9d14$var$ResultType.error;
}
function $2167cc54b87f9d14$var$isRedirectResult(result) {
    return (result && result.type) === $2167cc54b87f9d14$var$ResultType.redirect;
}
function $2167cc54b87f9d14$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $2167cc54b87f9d14$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $2167cc54b87f9d14$var$isRedirectResponse(result) {
    if (!$2167cc54b87f9d14$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $2167cc54b87f9d14$var$isQueryRouteResponse(obj) {
    return obj && $2167cc54b87f9d14$var$isResponse(obj.response) && (obj.type === $2167cc54b87f9d14$var$ResultType.data || obj.type === $2167cc54b87f9d14$var$ResultType.error);
}
function $2167cc54b87f9d14$var$isValidMethod(method) {
    return $2167cc54b87f9d14$var$validRequestMethods.has(method.toLowerCase());
}
function $2167cc54b87f9d14$var$isMutationMethod(method) {
    return $2167cc54b87f9d14$var$validMutationMethods.has(method.toLowerCase());
}
async function $2167cc54b87f9d14$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$2167cc54b87f9d14$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($2167cc54b87f9d14$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $2167cc54b87f9d14$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $2167cc54b87f9d14$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $2167cc54b87f9d14$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $2167cc54b87f9d14$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $2167cc54b87f9d14$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $2167cc54b87f9d14$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $2167cc54b87f9d14$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $2167cc54b87f9d14$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $2167cc54b87f9d14$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $2167cc54b87f9d14$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $2167cc54b87f9d14$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $2167cc54b87f9d14$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $2167cc54b87f9d14$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $2167cc54b87f9d14$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $2167cc54b87f9d14$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $2167cc54b87f9d14$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $2167cc54b87f9d14$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $2167cc54b87f9d14$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($2167cc54b87f9d14$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $2167cc54b87f9d14$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($2167cc54b87f9d14$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $2167cc54b87f9d14$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aOChP = parcelRequire("aOChP");

function $7d4ddebaad7c3ba2$var$_extends() {
    $7d4ddebaad7c3ba2$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7d4ddebaad7c3ba2$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7d4ddebaad7c3ba2$export$3add0d5dce533e2e = /*#__PURE__*/ $aOChP.createContext(null);
const $7d4ddebaad7c3ba2$export$145dfa71566a64dc = /*#__PURE__*/ $aOChP.createContext(null);
const $7d4ddebaad7c3ba2$var$AwaitContext = /*#__PURE__*/ $aOChP.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7d4ddebaad7c3ba2$export$26749e8557646306 = /*#__PURE__*/ $aOChP.createContext(null);
const $7d4ddebaad7c3ba2$export$c7914228fb69b0f5 = /*#__PURE__*/ $aOChP.createContext(null);
const $7d4ddebaad7c3ba2$export$9072aa6dd1f93057 = /*#__PURE__*/ $aOChP.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7d4ddebaad7c3ba2$var$RouteErrorContext = /*#__PURE__*/ $aOChP.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7d4ddebaad7c3ba2$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $aOChP.useContext($7d4ddebaad7c3ba2$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7d4ddebaad7c3ba2$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $2167cc54b87f9d14$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() {
    return $aOChP.useContext($7d4ddebaad7c3ba2$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7d4ddebaad7c3ba2$export$45d76561a5302f2b() {
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    return $aOChP.useContext($7d4ddebaad7c3ba2$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7d4ddebaad7c3ba2$export$1b3f31771c5d07c() {
    return $aOChP.useContext($7d4ddebaad7c3ba2$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7d4ddebaad7c3ba2$export$6c330e8992e8a295(pattern) {
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7d4ddebaad7c3ba2$export$45d76561a5302f2b();
    return $aOChP.useMemo(()=>(0, $2167cc54b87f9d14$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7d4ddebaad7c3ba2$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7d4ddebaad7c3ba2$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $aOChP.useContext($7d4ddebaad7c3ba2$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $aOChP.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7d4ddebaad7c3ba2$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7d4ddebaad7c3ba2$var$useNavigateStable() : $7d4ddebaad7c3ba2$var$useNavigateUnstable();
}
function $7d4ddebaad7c3ba2$var$useNavigateUnstable() {
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    let dataRouterContext = $aOChP.useContext($7d4ddebaad7c3ba2$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $aOChP.useContext($7d4ddebaad7c3ba2$export$26749e8557646306);
    let { matches: matches } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7d4ddebaad7c3ba2$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2167cc54b87f9d14$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $aOChP.useRef(false);
    $7d4ddebaad7c3ba2$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aOChP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $2167cc54b87f9d14$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2167cc54b87f9d14$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7d4ddebaad7c3ba2$var$OutletContext = /*#__PURE__*/ $aOChP.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7d4ddebaad7c3ba2$export$4138103a3ae699cc() {
    return $aOChP.useContext($7d4ddebaad7c3ba2$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7d4ddebaad7c3ba2$export$a3be3530d8e40d0b(context) {
    let outlet = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7d4ddebaad7c3ba2$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7d4ddebaad7c3ba2$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $aOChP.useContext($7d4ddebaad7c3ba2$export$26749e8557646306);
    let { matches: matches } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7d4ddebaad7c3ba2$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $2167cc54b87f9d14$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $aOChP.useMemo(()=>(0, $2167cc54b87f9d14$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7d4ddebaad7c3ba2$export$5d3fca4a98652595(routes, locationArg) {
    return $7d4ddebaad7c3ba2$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7d4ddebaad7c3ba2$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $aOChP.useContext($7d4ddebaad7c3ba2$export$26749e8557646306);
    let { matches: parentMatches } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7d4ddebaad7c3ba2$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $2167cc54b87f9d14$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    let matches = (0, $2167cc54b87f9d14$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7d4ddebaad7c3ba2$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $2167cc54b87f9d14$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $2167cc54b87f9d14$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7d4ddebaad7c3ba2$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $2167cc54b87f9d14$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7d4ddebaad7c3ba2$var$DefaultErrorComponent() {
    let error = $7d4ddebaad7c3ba2$export$ed527bf60f6e05f2();
    let message = (0, $2167cc54b87f9d14$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $aOChP.createElement($aOChP.Fragment, null, /*#__PURE__*/ $aOChP.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $aOChP.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $aOChP.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7d4ddebaad7c3ba2$var$defaultErrorElement = /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$DefaultErrorComponent, null);
class $7d4ddebaad7c3ba2$var$RenderErrorBoundary extends $aOChP.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7d4ddebaad7c3ba2$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $aOChP.useContext($7d4ddebaad7c3ba2$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7d4ddebaad7c3ba2$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7d4ddebaad7c3ba2$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7d4ddebaad7c3ba2$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $aOChP.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7d4ddebaad7c3ba2$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7d4ddebaad7c3ba2$var$DataRouterHook || {});
var $7d4ddebaad7c3ba2$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7d4ddebaad7c3ba2$var$DataRouterStateHook || {});
function $7d4ddebaad7c3ba2$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7d4ddebaad7c3ba2$var$useDataRouterContext(hookName) {
    let ctx = $aOChP.useContext($7d4ddebaad7c3ba2$export$3add0d5dce533e2e);
    !ctx && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7d4ddebaad7c3ba2$var$useDataRouterState(hookName) {
    let state = $aOChP.useContext($7d4ddebaad7c3ba2$export$145dfa71566a64dc);
    !state && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    return state;
}
function $7d4ddebaad7c3ba2$var$useRouteContext(hookName) {
    let route = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    !route && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7d4ddebaad7c3ba2$var$useCurrentRouteId(hookName) {
    let route = $7d4ddebaad7c3ba2$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7d4ddebaad7c3ba2$export$5fc8298006ad9e58() {
    return $7d4ddebaad7c3ba2$var$useCurrentRouteId($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7d4ddebaad7c3ba2$export$d0fd4b7106de2769() {
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7d4ddebaad7c3ba2$export$600dc272ed516c15() {
    let dataRouterContext = $7d4ddebaad7c3ba2$var$useDataRouterContext($7d4ddebaad7c3ba2$var$DataRouterHook.UseRevalidator);
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseRevalidator);
    return $aOChP.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7d4ddebaad7c3ba2$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseMatches);
    return $aOChP.useMemo(()=>matches.map((m)=>(0, $2167cc54b87f9d14$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7d4ddebaad7c3ba2$export$1448a5050d252c4d() {
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7d4ddebaad7c3ba2$var$useCurrentRouteId($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7d4ddebaad7c3ba2$export$fd5d37484eab868d(routeId) {
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7d4ddebaad7c3ba2$export$fdc00f3f26066d5e() {
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseActionData);
    let routeId = $7d4ddebaad7c3ba2$var$useCurrentRouteId($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7d4ddebaad7c3ba2$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $aOChP.useContext($7d4ddebaad7c3ba2$var$RouteErrorContext);
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseRouteError);
    let routeId = $7d4ddebaad7c3ba2$var$useCurrentRouteId($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7d4ddebaad7c3ba2$export$78a72ddb39bdd145() {
    let value = $aOChP.useContext($7d4ddebaad7c3ba2$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7d4ddebaad7c3ba2$export$17f53340677d5831() {
    let value = $aOChP.useContext($7d4ddebaad7c3ba2$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7d4ddebaad7c3ba2$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7d4ddebaad7c3ba2$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7d4ddebaad7c3ba2$var$useDataRouterContext($7d4ddebaad7c3ba2$var$DataRouterHook.UseBlocker);
    let state = $7d4ddebaad7c3ba2$var$useDataRouterState($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $aOChP.useState("");
    let blockerFunction = $aOChP.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7d4ddebaad7c3ba2$var$_extends({}, currentLocation, {
                pathname: (0, $2167cc54b87f9d14$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7d4ddebaad7c3ba2$var$_extends({}, nextLocation, {
                pathname: (0, $2167cc54b87f9d14$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $aOChP.useEffect(()=>{
        let key = String(++$7d4ddebaad7c3ba2$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $aOChP.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $2167cc54b87f9d14$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7d4ddebaad7c3ba2$var$useNavigateStable() {
    let { router: router } = $7d4ddebaad7c3ba2$var$useDataRouterContext($7d4ddebaad7c3ba2$var$DataRouterHook.UseNavigateStable);
    let id = $7d4ddebaad7c3ba2$var$useCurrentRouteId($7d4ddebaad7c3ba2$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $aOChP.useRef(false);
    $7d4ddebaad7c3ba2$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $aOChP.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7d4ddebaad7c3ba2$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7d4ddebaad7c3ba2$var$alreadyWarned = {};
function $7d4ddebaad7c3ba2$var$warningOnce(key, cond, message) {
    if (!cond && !$7d4ddebaad7c3ba2$var$alreadyWarned[key]) $7d4ddebaad7c3ba2$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7d4ddebaad7c3ba2$var$START_TRANSITION = "startTransition";
const $7d4ddebaad7c3ba2$var$startTransitionImpl = $aOChP[$7d4ddebaad7c3ba2$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7d4ddebaad7c3ba2$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $aOChP.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOChP.useCallback((newState)=>{
        if (v7_startTransition && $7d4ddebaad7c3ba2$var$startTransitionImpl) $7d4ddebaad7c3ba2$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $aOChP.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $aOChP.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $aOChP.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aOChP.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $aOChP.createElement($aOChP.Fragment, null, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7d4ddebaad7c3ba2$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7d4ddebaad7c3ba2$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7d4ddebaad7c3ba2$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $aOChP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2167cc54b87f9d14$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aOChP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOChP.useCallback((newState)=>{
        v7_startTransition && $7d4ddebaad7c3ba2$var$startTransitionImpl ? $7d4ddebaad7c3ba2$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOChP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7d4ddebaad7c3ba2$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $aOChP.useContext($7d4ddebaad7c3ba2$export$26749e8557646306);
    let { matches: matches } = $aOChP.useContext($7d4ddebaad7c3ba2$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7d4ddebaad7c3ba2$export$45d76561a5302f2b();
    let navigate = $7d4ddebaad7c3ba2$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $2167cc54b87f9d14$export$cae722b0cc860f13)(to, (0, $2167cc54b87f9d14$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $aOChP.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7d4ddebaad7c3ba2$export$910ae8079b2c2852(props) {
    return $7d4ddebaad7c3ba2$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7d4ddebaad7c3ba2$export$e7b0ac011bb776c6(_props) {
    (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7d4ddebaad7c3ba2$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $2167cc54b87f9d14$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7d4ddebaad7c3ba2$export$9c954a9d03d32f4a() && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $aOChP.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7d4ddebaad7c3ba2$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $2167cc54b87f9d14$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $aOChP.useMemo(()=>{
        let trailingPathname = (0, $2167cc54b87f9d14$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7d4ddebaad7c3ba2$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7d4ddebaad7c3ba2$export$5d3fca4a98652595($7d4ddebaad7c3ba2$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7d4ddebaad7c3ba2$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$ResolveAwait, null, children));
}
var $7d4ddebaad7c3ba2$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7d4ddebaad7c3ba2$var$AwaitRenderStatus || {});
const $7d4ddebaad7c3ba2$var$neverSettledPromise = new Promise(()=>{});
class $7d4ddebaad7c3ba2$var$AwaitErrorBoundary extends $aOChP.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7d4ddebaad7c3ba2$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7d4ddebaad7c3ba2$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7d4ddebaad7c3ba2$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7d4ddebaad7c3ba2$var$AwaitRenderStatus.error : promise._data !== undefined ? $7d4ddebaad7c3ba2$var$AwaitRenderStatus.success : $7d4ddebaad7c3ba2$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7d4ddebaad7c3ba2$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7d4ddebaad7c3ba2$var$AwaitRenderStatus.error && promise._error instanceof (0, $2167cc54b87f9d14$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7d4ddebaad7c3ba2$var$neverSettledPromise;
        if (status === $7d4ddebaad7c3ba2$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7d4ddebaad7c3ba2$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7d4ddebaad7c3ba2$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $aOChP.createElement($7d4ddebaad7c3ba2$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7d4ddebaad7c3ba2$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7d4ddebaad7c3ba2$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $aOChP.createElement($aOChP.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7d4ddebaad7c3ba2$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $aOChP.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $aOChP.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $aOChP.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7d4ddebaad7c3ba2$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7d4ddebaad7c3ba2$export$e7b0ac011bb776c6) && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7d4ddebaad7c3ba2$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7d4ddebaad7c3ba2$export$daf73786167a7f72(matches) {
    return $7d4ddebaad7c3ba2$var$_renderMatches(matches);
}
function $7d4ddebaad7c3ba2$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $aOChP.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $aOChP.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $aOChP.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7d4ddebaad7c3ba2$export$f30f7e456d254e83(routes, opts) {
    return (0, $2167cc54b87f9d14$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7d4ddebaad7c3ba2$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2167cc54b87f9d14$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7d4ddebaad7c3ba2$export$52b333d321859367
    }).initialize();
}



function $5016641478f75324$var$_extends() {
    $5016641478f75324$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $5016641478f75324$var$_extends.apply(this, arguments);
}
function $5016641478f75324$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $5016641478f75324$var$defaultMethod = "get";
const $5016641478f75324$var$defaultEncType = "application/x-www-form-urlencoded";
function $5016641478f75324$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $5016641478f75324$var$isButtonElement(object) {
    return $5016641478f75324$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $5016641478f75324$var$isFormElement(object) {
    return $5016641478f75324$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $5016641478f75324$var$isInputElement(object) {
    return $5016641478f75324$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $5016641478f75324$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $5016641478f75324$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$5016641478f75324$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $5016641478f75324$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $5016641478f75324$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $5016641478f75324$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $5016641478f75324$var$_formDataSupportsSubmitter = null;
function $5016641478f75324$var$isFormDataSubmitterSupported() {
    if ($5016641478f75324$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $5016641478f75324$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $5016641478f75324$var$_formDataSupportsSubmitter = true;
    }
    return $5016641478f75324$var$_formDataSupportsSubmitter;
}
const $5016641478f75324$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $5016641478f75324$var$getFormEncType(encType) {
    if (encType != null && !$5016641478f75324$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $5016641478f75324$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($5016641478f75324$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $2167cc54b87f9d14$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $5016641478f75324$var$defaultMethod;
        encType = $5016641478f75324$var$getFormEncType(target.getAttribute("enctype")) || $5016641478f75324$var$defaultEncType;
        formData = new FormData(target);
    } else if ($5016641478f75324$var$isButtonElement(target) || $5016641478f75324$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $2167cc54b87f9d14$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $5016641478f75324$var$defaultMethod;
        encType = $5016641478f75324$var$getFormEncType(target.getAttribute("formenctype")) || $5016641478f75324$var$getFormEncType(form.getAttribute("enctype")) || $5016641478f75324$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$5016641478f75324$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($5016641478f75324$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $5016641478f75324$var$defaultMethod;
        action = null;
        encType = $5016641478f75324$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $5016641478f75324$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $5016641478f75324$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $5016641478f75324$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $5016641478f75324$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $5016641478f75324$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $5016641478f75324$export$1f3f55432a00e06d(routes, opts) {
    return (0, $2167cc54b87f9d14$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5016641478f75324$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2167cc54b87f9d14$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $5016641478f75324$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7d4ddebaad7c3ba2$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $5016641478f75324$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $2167cc54b87f9d14$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $5016641478f75324$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $2167cc54b87f9d14$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $5016641478f75324$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7d4ddebaad7c3ba2$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $5016641478f75324$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $5016641478f75324$var$_extends({}, state, {
        errors: $5016641478f75324$var$deserializeErrors(state.errors)
    });
    return state;
}
function $5016641478f75324$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $2167cc54b87f9d14$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $5016641478f75324$export$7ad602f0e94e62d1 = /*#__PURE__*/ $aOChP.createContext({
    isTransitioning: false
});
const $5016641478f75324$export$148fd98d095596d4 = /*#__PURE__*/ $aOChP.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $5016641478f75324$var$START_TRANSITION = "startTransition";
const $5016641478f75324$var$startTransitionImpl = $aOChP[$5016641478f75324$var$START_TRANSITION];
const $5016641478f75324$var$FLUSH_SYNC = "flushSync";
const $5016641478f75324$var$flushSyncImpl = $a4960af4154d3849$exports[$5016641478f75324$var$FLUSH_SYNC];
const $5016641478f75324$var$USE_ID = "useId";
const $5016641478f75324$var$useIdImpl = $aOChP[$5016641478f75324$var$USE_ID];
function $5016641478f75324$var$startTransitionSafe(cb) {
    if ($5016641478f75324$var$startTransitionImpl) $5016641478f75324$var$startTransitionImpl(cb);
    else cb();
}
function $5016641478f75324$var$flushSyncSafe(cb) {
    if ($5016641478f75324$var$flushSyncImpl) $5016641478f75324$var$flushSyncImpl(cb);
    else cb();
}
class $5016641478f75324$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $5016641478f75324$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $aOChP.useState(router.state);
    let [pendingState, setPendingState] = $aOChP.useState();
    let [vtContext, setVtContext] = $aOChP.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $aOChP.useState();
    let [transition, setTransition] = $aOChP.useState();
    let [interruption, setInterruption] = $aOChP.useState();
    let fetcherData = $aOChP.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $aOChP.useCallback((cb)=>{
        if (v7_startTransition) $5016641478f75324$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $aOChP.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $5016641478f75324$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $5016641478f75324$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $5016641478f75324$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $5016641478f75324$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $5016641478f75324$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $aOChP.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $aOChP.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $5016641478f75324$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $aOChP.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $aOChP.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $aOChP.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $aOChP.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $aOChP.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aOChP.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $aOChP.createElement($aOChP.Fragment, null, /*#__PURE__*/ $aOChP.createElement((0, $7d4ddebaad7c3ba2$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $aOChP.createElement((0, $7d4ddebaad7c3ba2$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $aOChP.createElement($5016641478f75324$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $aOChP.createElement($5016641478f75324$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $aOChP.createElement((0, $7d4ddebaad7c3ba2$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $aOChP.createElement($5016641478f75324$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $5016641478f75324$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7d4ddebaad7c3ba2$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $5016641478f75324$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $aOChP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2167cc54b87f9d14$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aOChP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOChP.useCallback((newState)=>{
        v7_startTransition && $5016641478f75324$var$startTransitionImpl ? $5016641478f75324$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOChP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOChP.createElement((0, $7d4ddebaad7c3ba2$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $5016641478f75324$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $aOChP.useRef();
    if (historyRef.current == null) historyRef.current = (0, $2167cc54b87f9d14$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aOChP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOChP.useCallback((newState)=>{
        v7_startTransition && $5016641478f75324$var$startTransitionImpl ? $5016641478f75324$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOChP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOChP.createElement((0, $7d4ddebaad7c3ba2$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $5016641478f75324$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $aOChP.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $aOChP.useCallback((newState)=>{
        v7_startTransition && $5016641478f75324$var$startTransitionImpl ? $5016641478f75324$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $aOChP.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $aOChP.createElement((0, $7d4ddebaad7c3ba2$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $5016641478f75324$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $5016641478f75324$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $5016641478f75324$export$a6c7ac8248d6e38a = /*#__PURE__*/ $aOChP.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $5016641478f75324$var$_objectWithoutPropertiesLoose(_ref7, $5016641478f75324$var$_excluded);
    let { basename: basename } = $aOChP.useContext((0, $7d4ddebaad7c3ba2$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $5016641478f75324$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($5016641478f75324$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $2167cc54b87f9d14$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7d4ddebaad7c3ba2$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $5016641478f75324$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $aOChP.createElement("a", $5016641478f75324$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $5016641478f75324$export$b0d92dbee9b5b60d = /*#__PURE__*/ $aOChP.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $5016641478f75324$var$_objectWithoutPropertiesLoose(_ref8, $5016641478f75324$var$_excluded2);
    let path = (0, $7d4ddebaad7c3ba2$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7d4ddebaad7c3ba2$export$45d76561a5302f2b)();
    let routerState = $aOChP.useContext((0, $7d4ddebaad7c3ba2$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $aOChP.useContext((0, $7d4ddebaad7c3ba2$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $5016641478f75324$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $2167cc54b87f9d14$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $aOChP.createElement($5016641478f75324$export$a6c7ac8248d6e38a, $5016641478f75324$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $5016641478f75324$export$a7fed597f4b8afd8 = /*#__PURE__*/ $aOChP.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $5016641478f75324$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $5016641478f75324$var$_objectWithoutPropertiesLoose(_ref9, $5016641478f75324$var$_excluded3);
    let submit = $5016641478f75324$export$47c85c6e3a081d3();
    let formAction = $5016641478f75324$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $aOChP.createElement("form", $5016641478f75324$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $5016641478f75324$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $5016641478f75324$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $5016641478f75324$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($5016641478f75324$var$DataRouterHook || ($5016641478f75324$var$DataRouterHook = {}));
var $5016641478f75324$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($5016641478f75324$var$DataRouterStateHook || ($5016641478f75324$var$DataRouterStateHook = {}));
// Internal hooks
function $5016641478f75324$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $5016641478f75324$var$useDataRouterContext(hookName) {
    let ctx = $aOChP.useContext((0, $7d4ddebaad7c3ba2$export$3add0d5dce533e2e));
    !ctx && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    return ctx;
}
function $5016641478f75324$var$useDataRouterState(hookName) {
    let state = $aOChP.useContext((0, $7d4ddebaad7c3ba2$export$145dfa71566a64dc));
    !state && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $5016641478f75324$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7d4ddebaad7c3ba2$export$9770f232ac06a008)();
    let location = (0, $7d4ddebaad7c3ba2$export$45d76561a5302f2b)();
    let path = (0, $7d4ddebaad7c3ba2$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $aOChP.useCallback((event)=>{
        if ($5016641478f75324$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $2167cc54b87f9d14$export$fe53371bee54353d)(location) === (0, $2167cc54b87f9d14$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $5016641478f75324$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $aOChP.useRef($5016641478f75324$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $aOChP.useRef(false);
    let location = (0, $7d4ddebaad7c3ba2$export$45d76561a5302f2b)();
    let searchParams = $aOChP.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $5016641478f75324$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7d4ddebaad7c3ba2$export$9770f232ac06a008)();
    let setSearchParams = $aOChP.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $5016641478f75324$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $5016641478f75324$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $5016641478f75324$var$fetcherId = 0;
let $5016641478f75324$var$getUniqueFetcherId = ()=>"__" + String(++$5016641478f75324$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $5016641478f75324$export$47c85c6e3a081d3() {
    let { router: router } = $5016641478f75324$var$useDataRouterContext($5016641478f75324$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $aOChP.useContext((0, $7d4ddebaad7c3ba2$export$26749e8557646306));
    let currentRouteId = (0, $7d4ddebaad7c3ba2$export$5fc8298006ad9e58)();
    return $aOChP.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $5016641478f75324$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $5016641478f75324$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $5016641478f75324$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $5016641478f75324$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $aOChP.useContext((0, $7d4ddebaad7c3ba2$export$26749e8557646306));
    let routeContext = $aOChP.useContext((0, $7d4ddebaad7c3ba2$export$9072aa6dd1f93057));
    !routeContext && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $5016641478f75324$var$_extends({}, (0, $7d4ddebaad7c3ba2$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7d4ddebaad7c3ba2$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $2167cc54b87f9d14$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $2167cc54b87f9d14$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $5016641478f75324$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $5016641478f75324$var$useDataRouterContext($5016641478f75324$var$DataRouterHook.UseFetcher);
    let state = $5016641478f75324$var$useDataRouterState($5016641478f75324$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $aOChP.useContext($5016641478f75324$export$148fd98d095596d4);
    let route = $aOChP.useContext((0, $7d4ddebaad7c3ba2$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    !route && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $5016641478f75324$var$useIdImpl ? $5016641478f75324$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $aOChP.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($5016641478f75324$var$getUniqueFetcherId());
    // Registration/cleanup
    $aOChP.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $aOChP.useCallback((href, opts)=>{
        !routeId && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $5016641478f75324$export$47c85c6e3a081d3();
    let submit = $aOChP.useCallback((target, opts)=>{
        submitImpl(target, $5016641478f75324$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $aOChP.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $aOChP.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $aOChP.createElement($5016641478f75324$export$a7fed597f4b8afd8, $5016641478f75324$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $2167cc54b87f9d14$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $aOChP.useMemo(()=>$5016641478f75324$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $5016641478f75324$export$fa996778a3a31087() {
    let state = $5016641478f75324$var$useDataRouterState($5016641478f75324$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $5016641478f75324$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $5016641478f75324$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $5016641478f75324$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $5016641478f75324$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $5016641478f75324$var$useDataRouterContext($5016641478f75324$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $5016641478f75324$var$useDataRouterState($5016641478f75324$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $aOChP.useContext((0, $7d4ddebaad7c3ba2$export$26749e8557646306));
    let location = (0, $7d4ddebaad7c3ba2$export$45d76561a5302f2b)();
    let matches = (0, $7d4ddebaad7c3ba2$export$2378eb7f5ff86053)();
    let navigation = (0, $7d4ddebaad7c3ba2$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $aOChP.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $5016641478f75324$var$usePageHide($aOChP.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $5016641478f75324$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $5016641478f75324$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($5016641478f75324$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aOChP.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $5016641478f75324$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $5016641478f75324$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aOChP.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($5016641478f75324$var$_extends({}, location, {
                    pathname: (0, $2167cc54b87f9d14$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($5016641478f75324$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $aOChP.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $5016641478f75324$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $aOChP.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $5016641478f75324$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $aOChP.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $5016641478f75324$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7d4ddebaad7c3ba2$export$b273b3273281a049)(when);
    $aOChP.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $aOChP.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $5016641478f75324$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $aOChP.useContext($5016641478f75324$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $2167cc54b87f9d14$export$3e9cee6b33872309)(false);
    let { basename: basename } = $5016641478f75324$var$useDataRouterContext($5016641478f75324$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7d4ddebaad7c3ba2$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $2167cc54b87f9d14$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $2167cc54b87f9d14$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $2167cc54b87f9d14$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $2167cc54b87f9d14$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



var $aOChP = parcelRequire("aOChP");
const $73f176afd2e77c2f$var$useOnlineStatus = ()=>{
    const [onlineStatus, setOnlineStatus] = (0, $aOChP.useState)(true);
    window.addEventListener("online", ()=>{
        setOnlineStatus(true);
    });
    window.addEventListener("offline", ()=>{
        setOnlineStatus(false);
    });
    return onlineStatus;
};
var $73f176afd2e77c2f$export$2e2bcd8739ae039 = $73f176afd2e77c2f$var$useOnlineStatus;



var $97ZOK = parcelRequire("97ZOK");

var $aOChP = parcelRequire("aOChP");
var $0ff5c5e94bad875e$exports = {};
"use strict";

$0ff5c5e94bad875e$exports = (parcelRequire("1pyfK"));


var $1c7032cc59fc9fd2$var$__defProp = Object.defineProperty;
var $1c7032cc59fc9fd2$var$__defProps = Object.defineProperties;
var $1c7032cc59fc9fd2$var$__getOwnPropDescs = Object.getOwnPropertyDescriptors;
var $1c7032cc59fc9fd2$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $1c7032cc59fc9fd2$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $1c7032cc59fc9fd2$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $1c7032cc59fc9fd2$var$__defNormalProp = (obj, key, value)=>key in obj ? $1c7032cc59fc9fd2$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $1c7032cc59fc9fd2$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($1c7032cc59fc9fd2$var$__hasOwnProp.call(b, prop)) $1c7032cc59fc9fd2$var$__defNormalProp(a, prop, b[prop]);
    if ($1c7032cc59fc9fd2$var$__getOwnPropSymbols) {
        for (var prop of $1c7032cc59fc9fd2$var$__getOwnPropSymbols(b))if ($1c7032cc59fc9fd2$var$__propIsEnum.call(b, prop)) $1c7032cc59fc9fd2$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $1c7032cc59fc9fd2$var$__spreadProps = (a, b)=>$1c7032cc59fc9fd2$var$__defProps(a, $1c7032cc59fc9fd2$var$__getOwnPropDescs(b));
var $1c7032cc59fc9fd2$var$__objRest = (source, exclude)=>{
    var target = {};
    for(var prop in source)if ($1c7032cc59fc9fd2$var$__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
    if (source != null && $1c7032cc59fc9fd2$var$__getOwnPropSymbols) {
        for (var prop of $1c7032cc59fc9fd2$var$__getOwnPropSymbols(source))if (exclude.indexOf(prop) < 0 && $1c7032cc59fc9fd2$var$__propIsEnum.call(source, prop)) target[prop] = source[prop];
    }
    return target;
};
var $1c7032cc59fc9fd2$var$React = // prettier-ignore
// @ts-ignore
"default" in $aOChP ? $aOChP["default"] : $aOChP;
// src/components/Context.ts
var $1c7032cc59fc9fd2$var$ContextKey = Symbol.for(`react-redux-context`);
var $1c7032cc59fc9fd2$var$gT = typeof globalThis !== "undefined" ? globalThis : /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */ {};
function $1c7032cc59fc9fd2$var$getContext() {
    var _a;
    if (!$1c7032cc59fc9fd2$var$React.createContext) return {};
    const contextMap = (_a = $1c7032cc59fc9fd2$var$gT[$1c7032cc59fc9fd2$var$ContextKey]) != null ? _a : $1c7032cc59fc9fd2$var$gT[$1c7032cc59fc9fd2$var$ContextKey] = /* @__PURE__ */ new Map();
    let realContext = contextMap.get($1c7032cc59fc9fd2$var$React.createContext);
    if (!realContext) {
        realContext = $1c7032cc59fc9fd2$var$React.createContext(null);
        contextMap.set($1c7032cc59fc9fd2$var$React.createContext, realContext);
    }
    return realContext;
}
var $1c7032cc59fc9fd2$export$cc80c08dc91f1c00 = /* @__PURE__ */ $1c7032cc59fc9fd2$var$getContext();
// src/utils/useSyncExternalStore.ts
var $1c7032cc59fc9fd2$var$notInitialized = ()=>{
    throw new Error("uSES not initialized!");
};
// src/hooks/useReduxContext.ts
function $1c7032cc59fc9fd2$var$createReduxContextHook(context = $1c7032cc59fc9fd2$export$cc80c08dc91f1c00) {
    return function useReduxContext2() {
        const contextValue = $1c7032cc59fc9fd2$var$React.useContext(context);
        return contextValue;
    };
}
var $1c7032cc59fc9fd2$var$useReduxContext = /* @__PURE__ */ $1c7032cc59fc9fd2$var$createReduxContextHook();
// src/hooks/useSelector.ts
var $1c7032cc59fc9fd2$var$useSyncExternalStoreWithSelector = $1c7032cc59fc9fd2$var$notInitialized;
var $1c7032cc59fc9fd2$var$initializeUseSelector = (fn)=>{
    $1c7032cc59fc9fd2$var$useSyncExternalStoreWithSelector = fn;
};
var $1c7032cc59fc9fd2$var$refEquality = (a, b)=>a === b;
function $1c7032cc59fc9fd2$export$2b53f90d2bd1cbfb(context = $1c7032cc59fc9fd2$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $1c7032cc59fc9fd2$export$cc80c08dc91f1c00 ? $1c7032cc59fc9fd2$var$useReduxContext : $1c7032cc59fc9fd2$var$createReduxContextHook(context);
    const useSelector2 = (selector, equalityFnOrOptions = {})=>{
        const { equalityFn: equalityFn = $1c7032cc59fc9fd2$var$refEquality, devModeChecks: devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {
            equalityFn: equalityFnOrOptions
        } : equalityFnOrOptions;
        const { store: store, subscription: subscription, getServerState: getServerState, stabilityCheck: stabilityCheck, identityFunctionCheck: identityFunctionCheck } = useReduxContext2();
        const firstRun = $1c7032cc59fc9fd2$var$React.useRef(true);
        const wrappedSelector = $1c7032cc59fc9fd2$var$React.useCallback({
            [selector.name] (state) {
                const selected = selector(state);
                var e, e1;
                return selected;
            }
        }[selector.name], [
            selector,
            stabilityCheck,
            devModeChecks.stabilityCheck
        ]);
        const selectedState = $1c7032cc59fc9fd2$var$useSyncExternalStoreWithSelector(subscription.addNestedSub, store.getState, getServerState || store.getState, wrappedSelector, equalityFn);
        $1c7032cc59fc9fd2$var$React.useDebugValue(selectedState);
        return selectedState;
    };
    Object.assign(useSelector2, {
        withTypes: ()=>useSelector2
    });
    return useSelector2;
}
var $1c7032cc59fc9fd2$export$2105062e25df4afe = /* @__PURE__ */ $1c7032cc59fc9fd2$export$2b53f90d2bd1cbfb();
// src/utils/react-is.ts
var $1c7032cc59fc9fd2$var$REACT_ELEMENT_TYPE = Symbol.for("react.element");
var $1c7032cc59fc9fd2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
var $1c7032cc59fc9fd2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
var $1c7032cc59fc9fd2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
var $1c7032cc59fc9fd2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler");
var $1c7032cc59fc9fd2$var$REACT_PROVIDER_TYPE = Symbol.for("react.provider");
var $1c7032cc59fc9fd2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context");
var $1c7032cc59fc9fd2$var$REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
var $1c7032cc59fc9fd2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
var $1c7032cc59fc9fd2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
var $1c7032cc59fc9fd2$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
var $1c7032cc59fc9fd2$var$REACT_MEMO_TYPE = Symbol.for("react.memo");
var $1c7032cc59fc9fd2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
var $1c7032cc59fc9fd2$var$REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
var $1c7032cc59fc9fd2$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
var $1c7032cc59fc9fd2$var$ForwardRef = $1c7032cc59fc9fd2$var$REACT_FORWARD_REF_TYPE;
var $1c7032cc59fc9fd2$var$Memo = $1c7032cc59fc9fd2$var$REACT_MEMO_TYPE;
function $1c7032cc59fc9fd2$var$isValidElementType(type) {
    if (typeof type === "string" || typeof type === "function") return true;
    if (type === $1c7032cc59fc9fd2$var$REACT_FRAGMENT_TYPE || type === $1c7032cc59fc9fd2$var$REACT_PROFILER_TYPE || type === $1c7032cc59fc9fd2$var$REACT_STRICT_MODE_TYPE || type === $1c7032cc59fc9fd2$var$REACT_SUSPENSE_TYPE || type === $1c7032cc59fc9fd2$var$REACT_SUSPENSE_LIST_TYPE || type === $1c7032cc59fc9fd2$var$REACT_OFFSCREEN_TYPE) return true;
    if (typeof type === "object" && type !== null) {
        if (type.$$typeof === $1c7032cc59fc9fd2$var$REACT_LAZY_TYPE || type.$$typeof === $1c7032cc59fc9fd2$var$REACT_MEMO_TYPE || type.$$typeof === $1c7032cc59fc9fd2$var$REACT_PROVIDER_TYPE || type.$$typeof === $1c7032cc59fc9fd2$var$REACT_CONTEXT_TYPE || type.$$typeof === $1c7032cc59fc9fd2$var$REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
        // types supported by any Flight configuration anywhere since
        // we don't know which Flight build this will end up being used
        // with.
        type.$$typeof === $1c7032cc59fc9fd2$var$REACT_CLIENT_REFERENCE || type.getModuleId !== void 0) return true;
    }
    return false;
}
function $1c7032cc59fc9fd2$var$typeOf(object) {
    if (typeof object === "object" && object !== null) {
        const $$typeof = object.$$typeof;
        switch($$typeof){
            case $1c7032cc59fc9fd2$var$REACT_ELEMENT_TYPE:
                {
                    const type = object.type;
                    switch(type){
                        case $1c7032cc59fc9fd2$var$REACT_FRAGMENT_TYPE:
                        case $1c7032cc59fc9fd2$var$REACT_PROFILER_TYPE:
                        case $1c7032cc59fc9fd2$var$REACT_STRICT_MODE_TYPE:
                        case $1c7032cc59fc9fd2$var$REACT_SUSPENSE_TYPE:
                        case $1c7032cc59fc9fd2$var$REACT_SUSPENSE_LIST_TYPE:
                            return type;
                        default:
                            {
                                const $$typeofType = type && type.$$typeof;
                                switch($$typeofType){
                                    case $1c7032cc59fc9fd2$var$REACT_SERVER_CONTEXT_TYPE:
                                    case $1c7032cc59fc9fd2$var$REACT_CONTEXT_TYPE:
                                    case $1c7032cc59fc9fd2$var$REACT_FORWARD_REF_TYPE:
                                    case $1c7032cc59fc9fd2$var$REACT_LAZY_TYPE:
                                    case $1c7032cc59fc9fd2$var$REACT_MEMO_TYPE:
                                    case $1c7032cc59fc9fd2$var$REACT_PROVIDER_TYPE:
                                        return $$typeofType;
                                    default:
                                        return $$typeof;
                                }
                            }
                    }
                }
            case $1c7032cc59fc9fd2$var$REACT_PORTAL_TYPE:
                return $$typeof;
        }
    }
    return void 0;
}
function $1c7032cc59fc9fd2$var$isContextConsumer(object) {
    return $1c7032cc59fc9fd2$var$typeOf(object) === $1c7032cc59fc9fd2$var$REACT_CONTEXT_TYPE;
}
function $1c7032cc59fc9fd2$var$isMemo(object) {
    return $1c7032cc59fc9fd2$var$typeOf(object) === $1c7032cc59fc9fd2$var$REACT_MEMO_TYPE;
}
// src/utils/warning.ts
function $1c7032cc59fc9fd2$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/connect/verifySubselectors.ts
function $1c7032cc59fc9fd2$var$verify(selector, methodName) {
    if (!selector) throw new Error(`Unexpected value for ${methodName} in connect.`);
    else if (methodName === "mapStateToProps" || methodName === "mapDispatchToProps") {
        if (!Object.prototype.hasOwnProperty.call(selector, "dependsOnOwnProps")) $1c7032cc59fc9fd2$var$warning(`The selector for ${methodName} of connect did not specify a value for dependsOnOwnProps.`);
    }
}
function $1c7032cc59fc9fd2$var$verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps) {
    $1c7032cc59fc9fd2$var$verify(mapStateToProps, "mapStateToProps");
    $1c7032cc59fc9fd2$var$verify(mapDispatchToProps, "mapDispatchToProps");
    $1c7032cc59fc9fd2$var$verify(mergeProps, "mergeProps");
}
// src/connect/selectorFactory.ts
function $1c7032cc59fc9fd2$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, { areStatesEqual: areStatesEqual, areOwnPropsEqual: areOwnPropsEqual, areStatePropsEqual: areStatePropsEqual }) {
    let hasRunAtLeastOnce = false;
    let state;
    let ownProps;
    let stateProps;
    let dispatchProps;
    let mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        const nextStateProps = mapStateToProps(state, ownProps);
        const statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        const propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        const stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
}
function $1c7032cc59fc9fd2$var$finalPropsSelectorFactory(dispatch, _a) {
    var _b = _a, { initMapStateToProps: initMapStateToProps, initMapDispatchToProps: initMapDispatchToProps, initMergeProps: initMergeProps } = _b, options = $1c7032cc59fc9fd2$var$__objRest(_b, [
        "initMapStateToProps",
        "initMapDispatchToProps",
        "initMergeProps"
    ]);
    const mapStateToProps = initMapStateToProps(dispatch, options);
    const mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    const mergeProps = initMergeProps(dispatch, options);
    return $1c7032cc59fc9fd2$var$pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// src/utils/bindActionCreators.ts
function $1c7032cc59fc9fd2$var$bindActionCreators(actionCreators, dispatch) {
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = (...args)=>dispatch(actionCreator(...args));
    }
    return boundActionCreators;
}
// src/utils/isPlainObject.ts
function $1c7032cc59fc9fd2$var$isPlainObject(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    const proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    let baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}
// src/utils/verifyPlainObject.ts
function $1c7032cc59fc9fd2$var$verifyPlainObject(value, displayName, methodName) {
    if (!$1c7032cc59fc9fd2$var$isPlainObject(value)) $1c7032cc59fc9fd2$var$warning(`${methodName}() in ${displayName} must return a plain object. Instead received ${value}.`);
}
// src/connect/wrapMapToProps.ts
function $1c7032cc59fc9fd2$var$wrapMapToPropsConstant(getConstant) {
    return function initConstantSelector(dispatch) {
        const constant = getConstant(dispatch);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
}
function $1c7032cc59fc9fd2$var$getDependsOnOwnProps(mapToProps) {
    return mapToProps.dependsOnOwnProps ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}
function $1c7032cc59fc9fd2$var$wrapMapToPropsFunc(mapToProps, methodName) {
    return function initProxySelector(dispatch, { displayName: displayName }) {
        const proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch, void 0);
        };
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $1c7032cc59fc9fd2$var$getDependsOnOwnProps(mapToProps);
            let props = proxy(stateOrDispatch, ownProps);
            if (typeof props === "function") {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $1c7032cc59fc9fd2$var$getDependsOnOwnProps(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}
// src/connect/invalidArgFactory.ts
function $1c7032cc59fc9fd2$var$createInvalidArgFactory(arg, name) {
    return (dispatch, options)=>{
        throw new Error(`Invalid value of type ${typeof arg} for ${name} argument when connecting component ${options.wrappedComponentName}.`);
    };
}
// src/connect/mapDispatchToProps.ts
function $1c7032cc59fc9fd2$var$mapDispatchToPropsFactory(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === "object" ? $1c7032cc59fc9fd2$var$wrapMapToPropsConstant((dispatch)=>// @ts-ignore
        $1c7032cc59fc9fd2$var$bindActionCreators(mapDispatchToProps, dispatch)) : !mapDispatchToProps ? $1c7032cc59fc9fd2$var$wrapMapToPropsConstant((dispatch)=>({
            dispatch: dispatch
        })) : typeof mapDispatchToProps === "function" ? // @ts-ignore
    $1c7032cc59fc9fd2$var$wrapMapToPropsFunc(mapDispatchToProps, "mapDispatchToProps") : $1c7032cc59fc9fd2$var$createInvalidArgFactory(mapDispatchToProps, "mapDispatchToProps");
}
// src/connect/mapStateToProps.ts
function $1c7032cc59fc9fd2$var$mapStateToPropsFactory(mapStateToProps) {
    return !mapStateToProps ? $1c7032cc59fc9fd2$var$wrapMapToPropsConstant(()=>({})) : typeof mapStateToProps === "function" ? // @ts-ignore
    $1c7032cc59fc9fd2$var$wrapMapToPropsFunc(mapStateToProps, "mapStateToProps") : $1c7032cc59fc9fd2$var$createInvalidArgFactory(mapStateToProps, "mapStateToProps");
}
// src/connect/mergeProps.ts
function $1c7032cc59fc9fd2$var$defaultMergeProps(stateProps, dispatchProps, ownProps) {
    return $1c7032cc59fc9fd2$var$__spreadValues($1c7032cc59fc9fd2$var$__spreadValues($1c7032cc59fc9fd2$var$__spreadValues({}, ownProps), stateProps), dispatchProps);
}
function $1c7032cc59fc9fd2$var$wrapMergePropsFunc(mergeProps) {
    return function initMergePropsProxy(dispatch, { displayName: displayName, areMergedPropsEqual: areMergedPropsEqual }) {
        let hasRunOnce = false;
        let mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            const nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $1c7032cc59fc9fd2$var$mergePropsFactory(mergeProps) {
    return !mergeProps ? ()=>$1c7032cc59fc9fd2$var$defaultMergeProps : typeof mergeProps === "function" ? $1c7032cc59fc9fd2$var$wrapMergePropsFunc(mergeProps) : $1c7032cc59fc9fd2$var$createInvalidArgFactory(mergeProps, "mergeProps");
}
// src/utils/batch.ts
function $1c7032cc59fc9fd2$var$defaultNoopBatch(callback) {
    callback();
}
// src/utils/Subscription.ts
function $1c7032cc59fc9fd2$var$createListenerCollection() {
    let first = null;
    let last = null;
    return {
        clear () {
            first = null;
            last = null;
        },
        notify () {
            $1c7032cc59fc9fd2$var$defaultNoopBatch(()=>{
                let listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get () {
            const listeners = [];
            let listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe (callback) {
            let isSubscribed = true;
            const listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $1c7032cc59fc9fd2$var$nullListeners = {
    notify () {},
    get: ()=>[]
};
function $1c7032cc59fc9fd2$var$createSubscription(store, parentSub) {
    let unsubscribe;
    let listeners = $1c7032cc59fc9fd2$var$nullListeners;
    let subscriptionsAmount = 0;
    let selfSubscribed = false;
    function addNestedSub(listener) {
        trySubscribe();
        const cleanupListener = listeners.subscribe(listener);
        let removed = false;
        return ()=>{
            if (!removed) {
                removed = true;
                cleanupListener();
                tryUnsubscribe();
            }
        };
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return selfSubscribed;
    }
    function trySubscribe() {
        subscriptionsAmount++;
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $1c7032cc59fc9fd2$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        subscriptionsAmount--;
        if (unsubscribe && subscriptionsAmount === 0) {
            unsubscribe();
            unsubscribe = void 0;
            listeners.clear();
            listeners = $1c7032cc59fc9fd2$var$nullListeners;
        }
    }
    function trySubscribeSelf() {
        if (!selfSubscribed) {
            selfSubscribed = true;
            trySubscribe();
        }
    }
    function tryUnsubscribeSelf() {
        if (selfSubscribed) {
            selfSubscribed = false;
            tryUnsubscribe();
        }
    }
    const subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribeSelf,
        tryUnsubscribe: tryUnsubscribeSelf,
        getListeners: ()=>listeners
    };
    return subscription;
}
// src/utils/useIsomorphicLayoutEffect.ts
var $1c7032cc59fc9fd2$var$canUseDOM = !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var $1c7032cc59fc9fd2$var$useIsomorphicLayoutEffect = $1c7032cc59fc9fd2$var$canUseDOM ? $1c7032cc59fc9fd2$var$React.useLayoutEffect : $1c7032cc59fc9fd2$var$React.useEffect;
// src/utils/shallowEqual.ts
function $1c7032cc59fc9fd2$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $1c7032cc59fc9fd2$export$d36bdfa510afb180(objA, objB) {
    if ($1c7032cc59fc9fd2$var$is(objA, objB)) return true;
    if (typeof objA !== "object" || objA === null || typeof objB !== "object" || objB === null) return false;
    const keysA = Object.keys(objA);
    const keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(let i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$1c7032cc59fc9fd2$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}
// src/utils/hoistStatics.ts
var $1c7032cc59fc9fd2$var$REACT_STATICS = {
    childContextTypes: true,
    contextType: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromError: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};
var $1c7032cc59fc9fd2$var$KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};
var $1c7032cc59fc9fd2$var$FORWARD_REF_STATICS = {
    $$typeof: true,
    render: true,
    defaultProps: true,
    displayName: true,
    propTypes: true
};
var $1c7032cc59fc9fd2$var$MEMO_STATICS = {
    $$typeof: true,
    compare: true,
    defaultProps: true,
    displayName: true,
    propTypes: true,
    type: true
};
var $1c7032cc59fc9fd2$var$TYPE_STATICS = {
    [$1c7032cc59fc9fd2$var$ForwardRef]: $1c7032cc59fc9fd2$var$FORWARD_REF_STATICS,
    [$1c7032cc59fc9fd2$var$Memo]: $1c7032cc59fc9fd2$var$MEMO_STATICS
};
function $1c7032cc59fc9fd2$var$getStatics(component) {
    if ($1c7032cc59fc9fd2$var$isMemo(component)) return $1c7032cc59fc9fd2$var$MEMO_STATICS;
    return $1c7032cc59fc9fd2$var$TYPE_STATICS[component["$$typeof"]] || $1c7032cc59fc9fd2$var$REACT_STATICS;
}
var $1c7032cc59fc9fd2$var$defineProperty = Object.defineProperty;
var $1c7032cc59fc9fd2$var$getOwnPropertyNames = Object.getOwnPropertyNames;
var $1c7032cc59fc9fd2$var$getOwnPropertySymbols = Object.getOwnPropertySymbols;
var $1c7032cc59fc9fd2$var$getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var $1c7032cc59fc9fd2$var$getPrototypeOf = Object.getPrototypeOf;
var $1c7032cc59fc9fd2$var$objectPrototype = Object.prototype;
function $1c7032cc59fc9fd2$var$hoistNonReactStatics(targetComponent, sourceComponent) {
    if (typeof sourceComponent !== "string") {
        if ($1c7032cc59fc9fd2$var$objectPrototype) {
            const inheritedComponent = $1c7032cc59fc9fd2$var$getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== $1c7032cc59fc9fd2$var$objectPrototype) $1c7032cc59fc9fd2$var$hoistNonReactStatics(targetComponent, inheritedComponent);
        }
        let keys = $1c7032cc59fc9fd2$var$getOwnPropertyNames(sourceComponent);
        if ($1c7032cc59fc9fd2$var$getOwnPropertySymbols) keys = keys.concat($1c7032cc59fc9fd2$var$getOwnPropertySymbols(sourceComponent));
        const targetStatics = $1c7032cc59fc9fd2$var$getStatics(targetComponent);
        const sourceStatics = $1c7032cc59fc9fd2$var$getStatics(sourceComponent);
        for(let i = 0; i < keys.length; ++i){
            const key = keys[i];
            if (!$1c7032cc59fc9fd2$var$KNOWN_STATICS[key] && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
                const descriptor = $1c7032cc59fc9fd2$var$getOwnPropertyDescriptor(sourceComponent, key);
                try {
                    $1c7032cc59fc9fd2$var$defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }
    }
    return targetComponent;
}
// src/components/connect.tsx
var $1c7032cc59fc9fd2$var$useSyncExternalStore = $1c7032cc59fc9fd2$var$notInitialized;
var $1c7032cc59fc9fd2$var$initializeConnect = (fn)=>{
    $1c7032cc59fc9fd2$var$useSyncExternalStore = fn;
};
var $1c7032cc59fc9fd2$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $1c7032cc59fc9fd2$var$stringifyComponent = (Comp)=>{
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $1c7032cc59fc9fd2$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    $1c7032cc59fc9fd2$var$useIsomorphicLayoutEffect(()=>effectFunc(...effectArgs), dependencies);
}
function $1c7032cc59fc9fd2$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    lastWrapperProps.current = wrapperProps;
    renderIsScheduled.current = false;
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $1c7032cc59fc9fd2$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, additionalSubscribeListener) {
    if (!shouldHandleStateChanges) return ()=>{};
    let didUnsubscribe = false;
    let lastThrownError = null;
    const checkForUpdates = ()=>{
        if (didUnsubscribe || !isMounted.current) return;
        const latestStoreState = store.getState();
        let newChildProps, error;
        try {
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true;
            additionalSubscribeListener();
        }
    };
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    const unsubscribeWrapper = ()=>{
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) throw lastThrownError;
    };
    return unsubscribeWrapper;
}
function $1c7032cc59fc9fd2$var$strictEqual(a, b) {
    return a === b;
}
var $1c7032cc59fc9fd2$var$hasWarnedAboutDeprecatedPureOption = false;
function $1c7032cc59fc9fd2$var$connect(mapStateToProps, mapDispatchToProps, mergeProps, { pure: // The `pure` option has been removed, so TS doesn't like us destructuring this to check its existence.
// @ts-ignore
pure, areStatesEqual: areStatesEqual = $1c7032cc59fc9fd2$var$strictEqual, areOwnPropsEqual: areOwnPropsEqual = $1c7032cc59fc9fd2$export$d36bdfa510afb180, areStatePropsEqual: areStatePropsEqual = $1c7032cc59fc9fd2$export$d36bdfa510afb180, areMergedPropsEqual: areMergedPropsEqual = $1c7032cc59fc9fd2$export$d36bdfa510afb180, forwardRef: // use React's forwardRef to expose a ref of the wrapped component
forwardRef = false, context: // the context consumer to use
context = $1c7032cc59fc9fd2$export$cc80c08dc91f1c00 } = {}) {
    const Context = context;
    const initMapStateToProps = $1c7032cc59fc9fd2$var$mapStateToPropsFactory(mapStateToProps);
    const initMapDispatchToProps = $1c7032cc59fc9fd2$var$mapDispatchToPropsFactory(mapDispatchToProps);
    const initMergeProps = $1c7032cc59fc9fd2$var$mergePropsFactory(mergeProps);
    const shouldHandleStateChanges = Boolean(mapStateToProps);
    const wrapWithConnect = (WrappedComponent)=>{
        const wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || "Component";
        const displayName = `Connect(${wrappedComponentName})`;
        const selectorFactoryOptions = {
            shouldHandleStateChanges: shouldHandleStateChanges,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent,
            initMapStateToProps: // @ts-ignore
            initMapStateToProps,
            initMapDispatchToProps: // @ts-ignore
            initMapDispatchToProps,
            initMergeProps: initMergeProps,
            areStatesEqual: areStatesEqual,
            areStatePropsEqual: areStatePropsEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        };
        function ConnectFunction(props) {
            const [propsContext, reactReduxForwardedRef, wrapperProps] = $1c7032cc59fc9fd2$var$React.useMemo(()=>{
                const _a = props, { reactReduxForwardedRef: reactReduxForwardedRef2 } = _a, wrapperProps2 = $1c7032cc59fc9fd2$var$__objRest(_a, [
                    "reactReduxForwardedRef"
                ]);
                return [
                    props.context,
                    reactReduxForwardedRef2,
                    wrapperProps2
                ];
            }, [
                props
            ]);
            const ContextToUse = $1c7032cc59fc9fd2$var$React.useMemo(()=>{
                let ResultContext = Context;
                propsContext == null || propsContext.Consumer;
                return ResultContext;
            }, [
                propsContext,
                Context
            ]);
            const contextValue = $1c7032cc59fc9fd2$var$React.useContext(ContextToUse);
            const didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            const didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            const store = didStoreComeFromProps ? props.store : contextValue.store;
            const getServerState = didStoreComeFromContext ? contextValue.getServerState : store.getState;
            const childPropsSelector = $1c7032cc59fc9fd2$var$React.useMemo(()=>{
                return $1c7032cc59fc9fd2$var$finalPropsSelectorFactory(store.dispatch, selectorFactoryOptions);
            }, [
                store
            ]);
            const [subscription, notifyNestedSubs] = $1c7032cc59fc9fd2$var$React.useMemo(()=>{
                if (!shouldHandleStateChanges) return $1c7032cc59fc9fd2$var$NO_SUBSCRIPTION_ARRAY;
                const subscription2 = $1c7032cc59fc9fd2$var$createSubscription(store, didStoreComeFromProps ? void 0 : contextValue.subscription);
                const notifyNestedSubs2 = subscription2.notifyNestedSubs.bind(subscription2);
                return [
                    subscription2,
                    notifyNestedSubs2
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]);
            const overriddenContextValue = $1c7032cc59fc9fd2$var$React.useMemo(()=>{
                if (didStoreComeFromProps) return contextValue;
                return $1c7032cc59fc9fd2$var$__spreadProps($1c7032cc59fc9fd2$var$__spreadValues({}, contextValue), {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]);
            const lastChildProps = $1c7032cc59fc9fd2$var$React.useRef();
            const lastWrapperProps = $1c7032cc59fc9fd2$var$React.useRef(wrapperProps);
            const childPropsFromStoreUpdate = $1c7032cc59fc9fd2$var$React.useRef();
            const renderIsScheduled = $1c7032cc59fc9fd2$var$React.useRef(false);
            const isProcessingDispatch = $1c7032cc59fc9fd2$var$React.useRef(false);
            const isMounted = $1c7032cc59fc9fd2$var$React.useRef(false);
            const latestSubscriptionCallbackError = $1c7032cc59fc9fd2$var$React.useRef();
            $1c7032cc59fc9fd2$var$useIsomorphicLayoutEffect(()=>{
                isMounted.current = true;
                return ()=>{
                    isMounted.current = false;
                };
            }, []);
            const actualChildPropsSelector = $1c7032cc59fc9fd2$var$React.useMemo(()=>{
                const selector = ()=>{
                    if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                    return childPropsSelector(store.getState(), wrapperProps);
                };
                return selector;
            }, [
                store,
                wrapperProps
            ]);
            const subscribeForReact = $1c7032cc59fc9fd2$var$React.useMemo(()=>{
                const subscribe = (reactListener)=>{
                    if (!subscription) return ()=>{};
                    return $1c7032cc59fc9fd2$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, // @ts-ignore
                    childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, isMounted, childPropsFromStoreUpdate, notifyNestedSubs, reactListener);
                };
                return subscribe;
            }, [
                subscription
            ]);
            $1c7032cc59fc9fd2$var$useIsomorphicLayoutEffectWithArgs($1c7032cc59fc9fd2$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]);
            let actualChildProps;
            try {
                actualChildProps = $1c7032cc59fc9fd2$var$useSyncExternalStore(// TODO We're passing through a big wrapper that does a bunch of extra side effects besides subscribing
                subscribeForReact, // TODO This is incredibly hacky. We've already processed the store update and calculated new child props,
                // TODO and we're just passing that through so it triggers a re-render for us rather than relying on `uSES`.
                actualChildPropsSelector, getServerState ? ()=>childPropsSelector(getServerState(), wrapperProps) : actualChildPropsSelector);
            } catch (err) {
                if (latestSubscriptionCallbackError.current) err.message += `
The error may be correlated with this previous error:
${latestSubscriptionCallbackError.current.stack}

`;
                throw err;
            }
            $1c7032cc59fc9fd2$var$useIsomorphicLayoutEffect(()=>{
                latestSubscriptionCallbackError.current = void 0;
                childPropsFromStoreUpdate.current = void 0;
                lastChildProps.current = actualChildProps;
            });
            const renderedWrappedComponent = $1c7032cc59fc9fd2$var$React.useMemo(()=>{
                return(// @ts-ignore
                /* @__PURE__ */ $1c7032cc59fc9fd2$var$React.createElement(WrappedComponent, $1c7032cc59fc9fd2$var$__spreadProps($1c7032cc59fc9fd2$var$__spreadValues({}, actualChildProps), {
                    ref: reactReduxForwardedRef
                })));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]);
            const renderedChild = $1c7032cc59fc9fd2$var$React.useMemo(()=>{
                if (shouldHandleStateChanges) return /* @__PURE__ */ $1c7032cc59fc9fd2$var$React.createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        }
        const _Connect = $1c7032cc59fc9fd2$var$React.memo(ConnectFunction);
        const Connect = _Connect;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            const _forwarded = $1c7032cc59fc9fd2$var$React.forwardRef(function forwardConnectRef(props, ref) {
                return /* @__PURE__ */ $1c7032cc59fc9fd2$var$React.createElement(Connect, $1c7032cc59fc9fd2$var$__spreadProps($1c7032cc59fc9fd2$var$__spreadValues({}, props), {
                    reactReduxForwardedRef: ref
                }));
            });
            const forwarded = _forwarded;
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return /* @__PURE__ */ $1c7032cc59fc9fd2$var$hoistNonReactStatics(forwarded, WrappedComponent);
        }
        return /* @__PURE__ */ $1c7032cc59fc9fd2$var$hoistNonReactStatics(Connect, WrappedComponent);
    };
    return wrapWithConnect;
}
var $1c7032cc59fc9fd2$export$64605811ab45167f = $1c7032cc59fc9fd2$var$connect;
// src/components/Provider.tsx
function $1c7032cc59fc9fd2$var$Provider({ store: store, context: context, children: children, serverState: serverState, stabilityCheck: stabilityCheck = "once", identityFunctionCheck: identityFunctionCheck = "once" }) {
    const contextValue = $1c7032cc59fc9fd2$var$React.useMemo(()=>{
        const subscription = $1c7032cc59fc9fd2$var$createSubscription(store);
        return {
            store: store,
            subscription: subscription,
            getServerState: serverState ? ()=>serverState : void 0,
            stabilityCheck: stabilityCheck,
            identityFunctionCheck: identityFunctionCheck
        };
    }, [
        store,
        serverState,
        stabilityCheck,
        identityFunctionCheck
    ]);
    const previousState = $1c7032cc59fc9fd2$var$React.useMemo(()=>store.getState(), [
        store
    ]);
    $1c7032cc59fc9fd2$var$useIsomorphicLayoutEffect(()=>{
        const { subscription: subscription } = contextValue;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return ()=>{
            subscription.tryUnsubscribe();
            subscription.onStateChange = void 0;
        };
    }, [
        contextValue,
        previousState
    ]);
    const Context = context || $1c7032cc59fc9fd2$export$cc80c08dc91f1c00;
    return /* @__PURE__ */ $1c7032cc59fc9fd2$var$React.createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $1c7032cc59fc9fd2$export$2881499e37b75b9a = $1c7032cc59fc9fd2$var$Provider;
// src/hooks/useStore.ts
function $1c7032cc59fc9fd2$export$671dba69185d0304(context = $1c7032cc59fc9fd2$export$cc80c08dc91f1c00) {
    const useReduxContext2 = context === $1c7032cc59fc9fd2$export$cc80c08dc91f1c00 ? $1c7032cc59fc9fd2$var$useReduxContext : // @ts-ignore
    $1c7032cc59fc9fd2$var$createReduxContextHook(context);
    const useStore2 = ()=>{
        const { store: store } = useReduxContext2();
        return store;
    };
    Object.assign(useStore2, {
        withTypes: ()=>useStore2
    });
    return useStore2;
}
var $1c7032cc59fc9fd2$export$6ccbb43953eebf8 = /* @__PURE__ */ $1c7032cc59fc9fd2$export$671dba69185d0304();
// src/hooks/useDispatch.ts
function $1c7032cc59fc9fd2$export$bc9b55530897c558(context = $1c7032cc59fc9fd2$export$cc80c08dc91f1c00) {
    const useStore2 = context === $1c7032cc59fc9fd2$export$cc80c08dc91f1c00 ? $1c7032cc59fc9fd2$export$6ccbb43953eebf8 : $1c7032cc59fc9fd2$export$671dba69185d0304(context);
    const useDispatch2 = ()=>{
        const store = useStore2();
        return store.dispatch;
    };
    Object.assign(useDispatch2, {
        withTypes: ()=>useDispatch2
    });
    return useDispatch2;
}
var $1c7032cc59fc9fd2$export$8ad76b76a4c905f8 = /* @__PURE__ */ $1c7032cc59fc9fd2$export$bc9b55530897c558();
// src/exports.ts
var $1c7032cc59fc9fd2$export$712ea50be43a7858 = $1c7032cc59fc9fd2$var$defaultNoopBatch;
// src/index.ts
$1c7032cc59fc9fd2$var$initializeUseSelector((0, $0ff5c5e94bad875e$exports.useSyncExternalStoreWithSelector));
$1c7032cc59fc9fd2$var$initializeConnect($aOChP.useSyncExternalStore);


const $7d1003a005902228$var$Header = ()=>{
    const { loggedInUser: loggedInUser } = (0, $aOChP.useContext)((0, $97ZOK.default));
    //Subscribing to the store using a Selector, subscribing only to cart not theme, not user, only cart and that to not entire cart only items in cart
    const cartItems = (0, $1c7032cc59fc9fd2$export$2105062e25df4afe)((store)=>store.cart.items);
    // let btnName = "Login"
    const [btnName, setbtnName] = (0, $aOChP.useState)("Login");
    const onlineStatus = (0, $73f176afd2e77c2f$export$2e2bcd8739ae039)();
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        className: "header top-0 sticky z-30 px-20 py-2 flex justify-between items-center shadow-lg text-lg font-poppins bg-white",
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "logo-container",
                children: /*#__PURE__*/ (0, $5Wgfu.jsx)("a", {
                    href: "/",
                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                        width: "96",
                        height: "96",
                        src: (0, (/*@__PURE__*/$parcel$interopDefault($5340b145e6475b90$exports))),
                        // During Testing
                        // src="https://img.icons8.com/fluency/96/pizza-delivery.png" 
                        alt: "logo"
                    })
                })
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "nav-items",
                children: /*#__PURE__*/ (0, $5Wgfu.jsxs)("ul", {
                    className: "flex items-center gap-2",
                    children: [
                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                            className: "m-1 p-1",
                            children: onlineStatus ? "\u2705 Online" : "\u274C Disconnected"
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsxs)("li", {
                            className: "m-1 p-1",
                            children: [
                                /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5016641478f75324$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: " Home "
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                            className: "m-1 p-1",
                            children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5016641478f75324$export$a6c7ac8248d6e38a), {
                                to: "/about",
                                children: "About Us"
                            })
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                            className: "m-1 p-1",
                            children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5016641478f75324$export$a6c7ac8248d6e38a), {
                                to: "/contact",
                                children: "Contact Us"
                            })
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                            className: "m-1 p-1",
                            children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5016641478f75324$export$a6c7ac8248d6e38a), {
                                to: "/grocery",
                                children: "Grocery"
                            })
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsxs)("li", {
                            className: "m-1 p-1 font-bold",
                            children: [
                                /*#__PURE__*/ (0, $5Wgfu.jsxs)((0, $5016641478f75324$export$a6c7ac8248d6e38a), {
                                    to: "/cart",
                                    children: [
                                        "Cart (",
                                        cartItems.length,
                                        ")"
                                    ]
                                }),
                                " "
                            ]
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsx)("button", {
                            className: "login-btn",
                            onClick: ()=>{
                                btnName === "Login" ? setbtnName("Logout") : setbtnName("Login");
                            },
                            children: btnName
                        }),
                        /*#__PURE__*/ (0, $5Wgfu.jsx)("li", {
                            className: "m-1 p-1 font-semibold",
                            children: loggedInUser
                        })
                    ]
                })
            })
        ]
    });
};
var $7d1003a005902228$export$2e2bcd8739ae039 = $7d1003a005902228$var$Header;



var $5Wgfu = parcelRequire("5Wgfu");

var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");
const $ded4f04298f3b61e$export$31adfacaf07ffe63 = "https://media-assets.swiggy.com/swiggy/image/upload/fl_lossy,f_auto,q_auto,w_660/";
const $ded4f04298f3b61e$export$1f59aa9c7691335c = "https://thingproxy.freeboard.io/fetch/" + encodeURIComponent("https://www.swiggy.com/dapi/restaurants/list/v5?lat=12.9328638&lng=77.6139346&is-seo-homepage-enabled=true&page_type=DESKTOP_WEB_LISTING");
const $ded4f04298f3b61e$export$944d0eca8e7f4cb3 = "https://thingproxy.freeboard.io/fetch/" + encodeURIComponent("https://www.swiggy.com/dapi/restaurants/list/update");
const $ded4f04298f3b61e$export$b77c1aa4fb57bd1c = "https://thingproxy.freeboard.io/fetch/" + encodeURIComponent("https://www.swiggy.com/dapi/menu/pl?page-type=REGULAR_MENU&complete-menu=true&lat=12.9328638&lng=77.6139346&restaurantId=") //  const LOGO_URL = "../../icons/logo.png";
 // export {CDN_URL}
;



var $97ZOK = parcelRequire("97ZOK");
const $d8376de71c59ab12$var$ResCard = ({ resData: resData })=>{
    // console.log(resData);
    const { loggedInUser: loggedInUser } = (0, $aOChP.useContext)((0, $97ZOK.default));
    const { cloudinaryImageId: cloudinaryImageId, name: name, cuisines: cuisines, avgRating: avgRating, sla: { slaString: slaString }, costForTwo: costForTwo } = resData?.info;
    // console.log(resData);
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        className: "res-card w-64 pb-2   hover:shadow-xl rounded-xl",
        "data-testid": "resCard",
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                className: "res-logo rounded-lg h-44 w-full",
                src: (0, $ded4f04298f3b61e$export$31adfacaf07ffe63) + cloudinaryImageId,
                alt: "res-img"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                className: "textDetails m-2",
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("h3", {
                        className: "font-medium text-xl truncate",
                        children: name
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("h4", {
                        className: "truncate",
                        children: cuisines.join(", ")
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("h5", {
                        className: "font-medium",
                        children: [
                            avgRating,
                            " \u2B50",
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("span", {
                                className: "flex gap-2",
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                        className: "w-5",
                                        src: (0, $ded4f04298f3b61e$export$31adfacaf07ffe63) + "v1648635511/Delivery_fee_new_cjxumu"
                                    }),
                                    slaString
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                        children: costForTwo
                    })
                ]
            })
        ]
    });
};
const $d8376de71c59ab12$export$70ba389ae48934f4 = (ResCard)=>{
    //component returning
    return (props)=>{
        const { header: header, subHeader: subHeader } = props?.resData?.info?.aggregatedDiscountInfoV3;
        // console.log(props.resData.info.aggregatedDiscountInfoV3);
        return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
            className: "relative ",
            children: [
                /*#__PURE__*/ (0, $5Wgfu.jsx)(ResCard, {
                    ...props
                }),
                /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                    className: "bg-red  absolute top-[150px] w-full bg-gradient-to-b from-transparent to-gray-900 rounded-lg",
                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)("label", {
                        className: " text-white ml-2 text-xl font-bold",
                        children: header + " " + subHeader
                    })
                })
            ]
        });
    };
};
var $d8376de71c59ab12$export$2e2bcd8739ae039 = $d8376de71c59ab12$var$ResCard;



var $5Wgfu = parcelRequire("5Wgfu");

var $5Wgfu = parcelRequire("5Wgfu");
const $6701ad0a17b9129c$var$ShimmerCard = ()=>{
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        className: "shimmer-card flex flex-col gap-5 w-64 h-80 p-2",
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "img bg-gray-200 w-full h-44 rounded-lg"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "text-1 bg-gray-200 w-2/3 h-3 rounded-lg"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "text-2 bg-gray-200 w-1/2 h-3 rounded-lg"
            })
        ]
    });
};
var $6701ad0a17b9129c$export$2e2bcd8739ae039 = $6701ad0a17b9129c$var$ShimmerCard;


const $d1fe336ba39d0b8d$var$Shimmer = ()=>{
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        className: "mx-16",
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "w-96 h-10 mt-10 mx-20 bg-gray-300 rounded-full"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                className: "shimmer-container flex flex-wrap justify-around  py-3 px-20",
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6701ad0a17b9129c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6701ad0a17b9129c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6701ad0a17b9129c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6701ad0a17b9129c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6701ad0a17b9129c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6701ad0a17b9129c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6701ad0a17b9129c$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $6701ad0a17b9129c$export$2e2bcd8739ae039), {})
                ]
            })
        ]
    });
};
var $d1fe336ba39d0b8d$export$2e2bcd8739ae039 = $d1fe336ba39d0b8d$var$Shimmer;



var $aOChP = parcelRequire("aOChP");



var $97ZOK = parcelRequire("97ZOK");

var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");
const $d4610e85d230f3f6$var$ScrollDetector = ()=>{
    // State to track scroll position
    const [scrollPosition, setScrollPosition] = (0, $aOChP.useState)(0);
    // Define the position you want to detect
    const positionToDetect = 500; // Adjust this value to the desired position
    // Function to handle scroll event
    const handleScroll = ()=>{
        const currentPosition = window.scrollY || window.pageYOffset;
        setScrollPosition(currentPosition);
    };
    // Effect to add scroll event listener when component mounts
    (0, $aOChP.useEffect)(()=>{
        window.addEventListener("scroll", handleScroll);
        // Cleanup: remove event listener when component unmounts
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    // Effect to perform action when scroll position reaches desired position
    (0, $aOChP.useEffect)(()=>{
        if (scrollPosition >= positionToDetect) // Scroll has reached the desired position
        console.log("Scroll has reached the desired position.");
    }, [
        scrollPosition,
        positionToDetect
    ]);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
        style: {
            height: "2000px"
        },
        children: " "
    });
};
var $d4610e85d230f3f6$export$2e2bcd8739ae039 = $d4610e85d230f3f6$var$ScrollDetector;


const $dcc39249737b0d10$var$Main = ()=>{
    const [listOfRes, setListOfRes] = (0, $aOChP.useState)([]);
    // another state variable
    const [beforeList, setBeforeList] = (0, $aOChP.useState)([]);
    const [searchText, setSearchText] = (0, $aOChP.useState)("");
    const { loggedInUser: loggedInUser, setUserName: setUserName } = (0, $aOChP.useContext)((0, $97ZOK.default));
    (0, $aOChP.useEffect)(()=>{
        fetchData();
    }, []);
    // const handleShowMore = async () => {
    //   const payload ={
    //     "lat": 12.9328638,
    //     "lng": 77.6139346,
    //     "nextOffset": "COVCELQ4KIDo+J+28sP6NzCnEzgE",
    //     "widgetOffset": {
    //         "NewListingView_category_bar_chicletranking_TwoRows": "",
    //         "NewListingView_category_bar_chicletranking_TwoRows_Rendition": "",
    //         "Restaurant_Group_WebView_PB_Theme": "",
    //         "Restaurant_Group_WebView_SEO_PB_Theme": "",
    //         "collectionV5RestaurantListWidget_SimRestoRelevance_food_seo": "10",
    //         "inlineFacetFilter": "",
    //         "restaurantCountWidget": ""
    //     },
    //     "filters": {},
    //     "seoParams": {
    //         "seoUrl": "https://www.swiggy.com/",
    //         "pageType": "FOOD_HOMEPAGE",
    //         "apiName": "FoodHomePage"
    //     },
    //     "page_type": "DESKTOP_WEB_LISTING",
    //     "_csrf": "dWtQ4mDE4eqE-I7bUVuw-IIkO7t-sbzJH_2KI45U"
    // }
    // fetch(UPDATE_LIST, {
    //     method: 'POST',
    //     headers: {
    //         'Content-Type': 'application/json',
    //     },
    //     body: JSON.stringify(payload),
    // })
    // .then(response => {
    //     if (!response.ok) {
    //         throw new Error('Network response was not ok');
    //     }
    //     return response.json();
    // })
    // .then(data => {
    //     console.log(data); // Handle response data here
    // })
    // .catch(error => {
    //     console.error('There was a problem with the fetch operation:', error);
    // });
    // }
    const fetchData = async ()=>{
        // console.log(HOME_API)
        const data = await fetch((0, $ded4f04298f3b61e$export$1f59aa9c7691335c));
        // console.log(data);
        // Check if the response status is OK
        const json = await data.json();
        //  console.log(json)
        // Optional Chaining
        const apiData = json?.data?.cards[4]?.card?.card?.gridElements?.infoWithStyle?.restaurants;
        // console.log(apiData)
        setListOfRes(apiData);
    // console.log(listOfRes)
    };
    const OfferedResCard = (0, $d8376de71c59ab12$export$70ba389ae48934f4)((0, $d8376de71c59ab12$export$2e2bcd8739ae039));
    // Conditional Rendering
    // if(listOfRes.length === 0){
    //   return <Shimmer />
    // }
    // Ternary Operator
    return listOfRes.length === 0 ? /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $d1fe336ba39d0b8d$export$2e2bcd8739ae039), {}) : /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        className: "main mx-24",
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                className: "filter p-5 mx-16 flex items-center justify-between",
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                        className: "search flex justify-around",
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("input", {
                                className: "w-96 px-2 border-solid border-2 border-gray-300 rounded-full shadow-lg",
                                type: "text",
                                "data-testid": "searchInput",
                                placeholder: "Search for Restaurants...",
                                value: searchText,
                                onChange: (e)=>{
                                    setSearchText(e.target.value);
                                },
                                onFocus: ()=>{
                                    if (beforeList.length !== 0) setListOfRes(beforeList);
                                }
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("button", {
                                id: "search-btn",
                                className: "p-2",
                                "data-testid": "searchBtn",
                                onClick: ()=>{
                                    // copying listOfRes to beforeList
                                    setBeforeList(listOfRes);
                                    // filtering, this is modifying the main list
                                    const searchList = listOfRes.filter((res)=>{
                                        return res.info.name.toLowerCase().includes(searchText.toLowerCase());
                                    });
                                    //modifying the main list listOfRes
                                    setListOfRes(searchList);
                                },
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                    width: "30",
                                    height: "30",
                                    src: "https://img.icons8.com/ios/50/search--v1.png",
                                    alt: "search--v1"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("button", {
                        className: "filter-btn w-60 py-2 border-solid border-2 border-black-700 rounded-full text-center shadow-lg hover:bg-green-200 transition ease-in duration-500",
                        onClick: ()=>{
                            //updating the UI
                            const filterList = listOfRes.filter((res)=>res.info.avgRating > 4.2);
                            setListOfRes(filterList);
                        },
                        children: "Top Rated Restaurants"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "res-container gap-10 mx-16 m-5 flex flex-wrap justify-start",
                children: listOfRes.map((res, index)=>/*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5016641478f75324$export$a6c7ac8248d6e38a), {
                        className: "",
                        to: "/restaurant/" + res.info.id,
                        children: // If any of these objects are undefined, attempting to access properties deeper in the hierarchy will result in a TypeError. To prevent the error, you should ensure that all the nested properties are defined before trying to access discountTag.
                        res && res.info && res.info.aggregatedDiscountInfoV3 && res.info.aggregatedDiscountInfoV3.discountTag === undefined ? /*#__PURE__*/ (0, $5Wgfu.jsx)(OfferedResCard, {
                            resData: res
                        }) : /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $d8376de71c59ab12$export$2e2bcd8739ae039), {
                            resData: res
                        })
                    }, res.info.id))
            })
        ]
    });
};
var $dcc39249737b0d10$export$2e2bcd8739ae039 = $dcc39249737b0d10$var$Main;




var $5Wgfu = parcelRequire("5Wgfu");
const $b2c572d619f7ebd8$var$Contact = ()=>{
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        className: "contact m-12",
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("h1", {
                className: "text-5xl font-lg",
                children: "Contact Us"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("h3", {
                children: "Email contact@feastfleet.com"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsxs)("form", {
                action: "/contact",
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("input", {
                        type: "text",
                        placeholder: "name",
                        className: "border border-gray-300 rounded-lg p-2 m-2"
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("input", {
                        type: "text",
                        placeholder: "email",
                        className: "border border-gray-300 rounded-lg p-2 m-2"
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("button", {
                        className: "border border-gray-300 rounded-lg p-2 m-2 bg-green-200",
                        children: "Submit"
                    })
                ]
            })
        ]
    });
};
var $b2c572d619f7ebd8$export$2e2bcd8739ae039 = $b2c572d619f7ebd8$var$Contact;



var $5Wgfu = parcelRequire("5Wgfu");

const $45f29b8d937d424e$var$Error = ()=>{
    const err = (0, $7d4ddebaad7c3ba2$export$ed527bf60f6e05f2)();
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        className: "m-16",
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("h1", {
                className: "text-3xl",
                children: "Oops!!!"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("h3", {
                children: "The page you requested was not found..."
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsxs)("h5", {
                children: [
                    err.status,
                    ": ",
                    err.statusText
                ]
            })
        ]
    });
};
var $45f29b8d937d424e$export$2e2bcd8739ae039 = $45f29b8d937d424e$var$Error;



var $5Wgfu = parcelRequire("5Wgfu");

var $5Wgfu = parcelRequire("5Wgfu");
const $7965e1ddc87bb2ae$var$ShimmerMenu = ()=>{
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        className: "mx-56",
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                className: " flex mt-10 gap-2 mx-auto justify-center ",
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                        className: "w-2/3",
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("h1", {
                                className: "m-2 w-9/12 h-6 bg-gray-200 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                className: "m-2 w-6/12 h-6 bg-gray-200 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                className: "m-2 w-7/12 h-6 bg-gray-200 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                className: "m-2 w-6/12 h-6 bg-gray-200 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                className: "m-2 w-5/12 h-6 bg-gray-200 rounded-lg"
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                className: "m-2 w-5/12 h-6 bg-gray-200 rounded-lg"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                        className: "rounded-lg h-36 w-36 bg-gray-200"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                className: "w-8/12 h-12 my-6 py-1 mx-auto px-2 rounded-lg bg-gray-200"
            })
        ]
    });
};
var $7965e1ddc87bb2ae$export$2e2bcd8739ae039 = $7965e1ddc87bb2ae$var$ShimmerMenu;




var $aOChP = parcelRequire("aOChP");

var $aOChP = parcelRequire("aOChP");

const $5f701d92aba1d046$var$useResMenu = (resId)=>{
    const [resInfo, setResInfo] = (0, $aOChP.useState)(null);
    (0, $aOChP.useEffect)(()=>{
        fetchMenuData();
    }, []);
    const fetchMenuData = async ()=>{
        const apiData = await fetch((0, $ded4f04298f3b61e$export$b77c1aa4fb57bd1c) + resId);
        const json = await apiData.json();
        setResInfo(json.data);
    };
    return resInfo;
};
var $5f701d92aba1d046$export$2e2bcd8739ae039 = $5f701d92aba1d046$var$useResMenu;



var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");

var $5Wgfu = parcelRequire("5Wgfu");
var $2214047ad0b1efd1$exports = {};
$2214047ad0b1efd1$exports = new URL("icons8-veg-32.1b7d3419.png", import.meta.url).toString();


var $89b55b17b0b09e89$exports = {};
$89b55b17b0b09e89$exports = new URL("icons8-non-veg-32.14536350.png", import.meta.url).toString();




// src/index.ts
// src/utils/formatProdErrorMessage.ts
function $bbc75262727a27e1$var$formatProdErrorMessage(code) {
    return `Minified Redux error #${code}; visit https://redux.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}
// src/utils/symbol-observable.ts
var $bbc75262727a27e1$var$$$observable = /* @__PURE__ */ (()=>typeof Symbol === "function" && Symbol.observable || "@@observable")();
var $bbc75262727a27e1$var$symbol_observable_default = $bbc75262727a27e1$var$$$observable;
// src/utils/actionTypes.ts
var $bbc75262727a27e1$var$randomString = ()=>Math.random().toString(36).substring(7).split("").join(".");
var $bbc75262727a27e1$var$ActionTypes = {
    INIT: `@@redux/INIT${$bbc75262727a27e1$var$randomString()}`,
    REPLACE: `@@redux/REPLACE${$bbc75262727a27e1$var$randomString()}`,
    PROBE_UNKNOWN_ACTION: ()=>`@@redux/PROBE_UNKNOWN_ACTION${$bbc75262727a27e1$var$randomString()}`
};
var $bbc75262727a27e1$export$4219e499db7ca678 = $bbc75262727a27e1$var$ActionTypes;
// src/utils/isPlainObject.ts
function $bbc75262727a27e1$export$53b83ca8eaab0383(obj) {
    if (typeof obj !== "object" || obj === null) return false;
    let proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
// src/utils/kindOf.ts
function $bbc75262727a27e1$var$miniKindOf(val) {
    if (val === void 0) return "undefined";
    if (val === null) return "null";
    const type = typeof val;
    switch(type){
        case "boolean":
        case "string":
        case "number":
        case "symbol":
        case "function":
            return type;
    }
    if (Array.isArray(val)) return "array";
    if ($bbc75262727a27e1$var$isDate(val)) return "date";
    if ($bbc75262727a27e1$var$isError(val)) return "error";
    const constructorName = $bbc75262727a27e1$var$ctorName(val);
    switch(constructorName){
        case "Symbol":
        case "Promise":
        case "WeakMap":
        case "WeakSet":
        case "Map":
        case "Set":
            return constructorName;
    }
    return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function $bbc75262727a27e1$var$ctorName(val) {
    return typeof val.constructor === "function" ? val.constructor.name : null;
}
function $bbc75262727a27e1$var$isError(val) {
    return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function $bbc75262727a27e1$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function $bbc75262727a27e1$var$kindOf(val) {
    let typeOfVal = typeof val;
    return typeOfVal;
}
// src/createStore.ts
function $bbc75262727a27e1$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    if (typeof reducer !== "function") throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(2));
    if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(0));
    if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
        enhancer = preloadedState;
        preloadedState = void 0;
    }
    if (typeof enhancer !== "undefined") {
        if (typeof enhancer !== "function") throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(1));
        return enhancer($bbc75262727a27e1$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    let currentReducer = reducer;
    let currentState = preloadedState;
    let currentListeners = /* @__PURE__ */ new Map();
    let nextListeners = currentListeners;
    let listenerIdCounter = 0;
    let isDispatching = false;
    function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) {
            nextListeners = /* @__PURE__ */ new Map();
            currentListeners.forEach((listener, key)=>{
                nextListeners.set(key, listener);
            });
        }
    }
    function getState() {
        if (isDispatching) throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(3));
        return currentState;
    }
    function subscribe(listener) {
        if (typeof listener !== "function") throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(5));
        let isSubscribed = true;
        ensureCanMutateNextListeners();
        const listenerId = listenerIdCounter++;
        nextListeners.set(listenerId, listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            nextListeners.delete(listenerId);
            currentListeners = null;
        };
    }
    function dispatch(action) {
        if (!$bbc75262727a27e1$export$53b83ca8eaab0383(action)) throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(7));
        if (typeof action.type === "undefined") throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(8));
        if (typeof action.type !== "string") throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(17));
        if (isDispatching) throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        const listeners = currentListeners = nextListeners;
        listeners.forEach((listener)=>{
            listener();
        });
        return action;
    }
    function replaceReducer(nextReducer) {
        if (typeof nextReducer !== "function") throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(10));
        currentReducer = nextReducer;
        dispatch({
            type: $bbc75262727a27e1$export$4219e499db7ca678.REPLACE
        });
    }
    function observable() {
        const outerSubscribe = subscribe;
        return {
            /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe (observer) {
                if (typeof observer !== "object" || observer === null) throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(11));
                function observeState() {
                    const observerAsObserver = observer;
                    if (observerAsObserver.next) observerAsObserver.next(getState());
                }
                observeState();
                const unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            },
            [$bbc75262727a27e1$var$symbol_observable_default] () {
                return this;
            }
        };
    }
    dispatch({
        type: $bbc75262727a27e1$export$4219e499db7ca678.INIT
    });
    const store = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer,
        [$bbc75262727a27e1$var$symbol_observable_default]: observable
    };
    return store;
}
function $bbc75262727a27e1$export$8928921ea2d3b126(reducer, preloadedState, enhancer) {
    return $bbc75262727a27e1$export$f51a9068ac82ea43(reducer, preloadedState, enhancer);
}
// src/utils/warning.ts
function $bbc75262727a27e1$var$warning(message) {
    if (typeof console !== "undefined" && typeof console.error === "function") console.error(message);
    try {
        throw new Error(message);
    } catch (e) {}
}
// src/combineReducers.ts
function $bbc75262727a27e1$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    const reducerKeys = Object.keys(reducers);
    const argumentName = action && action.type === $bbc75262727a27e1$export$4219e499db7ca678.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$bbc75262727a27e1$export$53b83ca8eaab0383(inputState)) return `The ${argumentName} has unexpected type of "${$bbc75262727a27e1$var$kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
    const unexpectedKeys = Object.keys(inputState).filter((key)=>!reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
    unexpectedKeys.forEach((key)=>{
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $bbc75262727a27e1$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
}
function $bbc75262727a27e1$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach((key)=>{
        const reducer = reducers[key];
        const initialState = reducer(void 0, {
            type: $bbc75262727a27e1$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === "undefined") throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(12));
        if (typeof reducer(void 0, {
            type: $bbc75262727a27e1$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === "undefined") throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(13));
    });
}
function $bbc75262727a27e1$export$66e4520cdb265d18(reducers) {
    const reducerKeys = Object.keys(reducers);
    const finalReducers = {};
    for(let i = 0; i < reducerKeys.length; i++){
        const key = reducerKeys[i];
        if (typeof reducers[key] === "function") finalReducers[key] = reducers[key];
    }
    const finalReducerKeys = Object.keys(finalReducers);
    let unexpectedKeyCache;
    let shapeAssertionError;
    try {
        $bbc75262727a27e1$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state = {}, action) {
        if (shapeAssertionError) throw shapeAssertionError;
        let hasChanged = false;
        const nextState = {};
        for(let i = 0; i < finalReducerKeys.length; i++){
            const key = finalReducerKeys[i];
            const reducer = finalReducers[key];
            const previousStateForKey = state[key];
            const nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === "undefined") {
                const actionType = action && action.type;
                throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(14));
            }
            nextState[key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
// src/bindActionCreators.ts
function $bbc75262727a27e1$var$bindActionCreator(actionCreator, dispatch) {
    return function(...args) {
        return dispatch(actionCreator.apply(this, args));
    };
}
function $bbc75262727a27e1$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === "function") return $bbc75262727a27e1$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== "object" || actionCreators === null) throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(16));
    const boundActionCreators = {};
    for(const key in actionCreators){
        const actionCreator = actionCreators[key];
        if (typeof actionCreator === "function") boundActionCreators[key] = $bbc75262727a27e1$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
// src/compose.ts
function $bbc75262727a27e1$export$f672e0b6f7222cd7(...funcs) {
    if (funcs.length === 0) return (arg)=>arg;
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce((a, b)=>(...args)=>a(b(...args)));
}
// src/applyMiddleware.ts
function $bbc75262727a27e1$export$9ff26e0402cc7b7(...middlewares) {
    return (createStore2)=>(reducer, preloadedState)=>{
            const store = createStore2(reducer, preloadedState);
            let dispatch = ()=>{
                throw new Error($bbc75262727a27e1$var$formatProdErrorMessage(15));
            };
            const middlewareAPI = {
                getState: store.getState,
                dispatch: (action, ...args)=>dispatch(action, ...args)
            };
            const chain = middlewares.map((middleware)=>middleware(middlewareAPI));
            dispatch = $bbc75262727a27e1$export$f672e0b6f7222cd7(...chain)(store.dispatch);
            return {
                ...store,
                dispatch: dispatch
            };
        };
}
// src/utils/isAction.ts
function $bbc75262727a27e1$export$b956e38827fca970(action) {
    return $bbc75262727a27e1$export$53b83ca8eaab0383(action) && "type" in action && typeof action.type === "string";
}


var $af646dc9ee6cb2b8$var$__defProp = Object.defineProperty;
var $af646dc9ee6cb2b8$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $af646dc9ee6cb2b8$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $af646dc9ee6cb2b8$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $af646dc9ee6cb2b8$var$__defNormalProp = (obj, key, value)=>key in obj ? $af646dc9ee6cb2b8$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $af646dc9ee6cb2b8$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($af646dc9ee6cb2b8$var$__hasOwnProp.call(b, prop)) $af646dc9ee6cb2b8$var$__defNormalProp(a, prop, b[prop]);
    if ($af646dc9ee6cb2b8$var$__getOwnPropSymbols) {
        for (var prop of $af646dc9ee6cb2b8$var$__getOwnPropSymbols(b))if ($af646dc9ee6cb2b8$var$__propIsEnum.call(b, prop)) $af646dc9ee6cb2b8$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
// src/utils/env.ts
var $af646dc9ee6cb2b8$export$45b790e32b2810ee = Symbol.for("immer-nothing");
var $af646dc9ee6cb2b8$export$6ee2082928bcb0ee = Symbol.for("immer-draftable");
var $af646dc9ee6cb2b8$var$DRAFT_STATE = Symbol.for("immer-state");
// src/utils/errors.ts
var $af646dc9ee6cb2b8$var$errors = [];
function $af646dc9ee6cb2b8$var$die(error, ...args) {
    throw new Error(`[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`);
}
// src/utils/common.ts
var $af646dc9ee6cb2b8$var$getPrototypeOf = Object.getPrototypeOf;
function $af646dc9ee6cb2b8$export$541ac630993a4c84(value) {
    return !!value && !!value[$af646dc9ee6cb2b8$var$DRAFT_STATE];
}
function $af646dc9ee6cb2b8$export$16e3aed3edb85946(value) {
    var _a;
    if (!value) return false;
    return $af646dc9ee6cb2b8$var$isPlainObject(value) || Array.isArray(value) || !!value[$af646dc9ee6cb2b8$export$6ee2082928bcb0ee] || !!((_a = value.constructor) == null ? void 0 : _a[$af646dc9ee6cb2b8$export$6ee2082928bcb0ee]) || $af646dc9ee6cb2b8$var$isMap(value) || $af646dc9ee6cb2b8$var$isSet(value);
}
var $af646dc9ee6cb2b8$var$objectCtorString = Object.prototype.constructor.toString();
function $af646dc9ee6cb2b8$var$isPlainObject(value) {
    if (!value || typeof value !== "object") return false;
    const proto = $af646dc9ee6cb2b8$var$getPrototypeOf(value);
    if (proto === null) return true;
    const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
    if (Ctor === Object) return true;
    return typeof Ctor == "function" && Function.toString.call(Ctor) === $af646dc9ee6cb2b8$var$objectCtorString;
}
function $af646dc9ee6cb2b8$export$22e8af3f75a010e3(value) {
    if (!$af646dc9ee6cb2b8$export$541ac630993a4c84(value)) $af646dc9ee6cb2b8$var$die(15, value);
    return value[$af646dc9ee6cb2b8$var$DRAFT_STATE].base_;
}
function $af646dc9ee6cb2b8$var$each(obj, iter) {
    if ($af646dc9ee6cb2b8$var$getArchtype(obj) === 0 /* Object */ ) Object.entries(obj).forEach(([key, value])=>{
        iter(key, value, obj);
    });
    else obj.forEach((entry, index)=>iter(index, entry, obj));
}
function $af646dc9ee6cb2b8$var$getArchtype(thing) {
    const state = thing[$af646dc9ee6cb2b8$var$DRAFT_STATE];
    return state ? state.type_ : Array.isArray(thing) ? 1 /* Array */  : $af646dc9ee6cb2b8$var$isMap(thing) ? 2 /* Map */  : $af646dc9ee6cb2b8$var$isSet(thing) ? 3 /* Set */  : 0 /* Object */ ;
}
function $af646dc9ee6cb2b8$var$has(thing, prop) {
    return $af646dc9ee6cb2b8$var$getArchtype(thing) === 2 /* Map */  ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function $af646dc9ee6cb2b8$var$get(thing, prop) {
    return $af646dc9ee6cb2b8$var$getArchtype(thing) === 2 /* Map */  ? thing.get(prop) : thing[prop];
}
function $af646dc9ee6cb2b8$var$set(thing, propOrOldValue, value) {
    const t = $af646dc9ee6cb2b8$var$getArchtype(thing);
    if (t === 2 /* Map */ ) thing.set(propOrOldValue, value);
    else if (t === 3 /* Set */ ) thing.add(value);
    else thing[propOrOldValue] = value;
}
function $af646dc9ee6cb2b8$var$is(x, y) {
    if (x === y) return x !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $af646dc9ee6cb2b8$var$isMap(target) {
    return target instanceof Map;
}
function $af646dc9ee6cb2b8$var$isSet(target) {
    return target instanceof Set;
}
function $af646dc9ee6cb2b8$var$latest(state) {
    return state.copy_ || state.base_;
}
function $af646dc9ee6cb2b8$var$shallowCopy(base, strict) {
    if ($af646dc9ee6cb2b8$var$isMap(base)) return new Map(base);
    if ($af646dc9ee6cb2b8$var$isSet(base)) return new Set(base);
    if (Array.isArray(base)) return Array.prototype.slice.call(base);
    if (!strict && $af646dc9ee6cb2b8$var$isPlainObject(base)) {
        if (!$af646dc9ee6cb2b8$var$getPrototypeOf(base)) {
            const obj = /* @__PURE__ */ Object.create(null);
            return Object.assign(obj, base);
        }
        return $af646dc9ee6cb2b8$var$__spreadValues({}, base);
    }
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[$af646dc9ee6cb2b8$var$DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const desc = descriptors[key];
        if (desc.writable === false) {
            desc.writable = true;
            desc.configurable = true;
        }
        if (desc.get || desc.set) descriptors[key] = {
            configurable: true,
            writable: true,
            // could live with !!desc.set as well here...
            enumerable: desc.enumerable,
            value: base[key]
        };
    }
    return Object.create($af646dc9ee6cb2b8$var$getPrototypeOf(base), descriptors);
}
function $af646dc9ee6cb2b8$export$792f3d81ea979f55(obj, deep = false) {
    if ($af646dc9ee6cb2b8$var$isFrozen(obj) || $af646dc9ee6cb2b8$export$541ac630993a4c84(obj) || !$af646dc9ee6cb2b8$export$16e3aed3edb85946(obj)) return obj;
    if ($af646dc9ee6cb2b8$var$getArchtype(obj) > 1) obj.set = obj.add = obj.clear = obj.delete = $af646dc9ee6cb2b8$var$dontMutateFrozenCollections;
    Object.freeze(obj);
    if (deep) $af646dc9ee6cb2b8$var$each(obj, (_key, value)=>$af646dc9ee6cb2b8$export$792f3d81ea979f55(value, true), true);
    return obj;
}
function $af646dc9ee6cb2b8$var$dontMutateFrozenCollections() {
    $af646dc9ee6cb2b8$var$die(2);
}
function $af646dc9ee6cb2b8$var$isFrozen(obj) {
    return Object.isFrozen(obj);
}
// src/utils/plugins.ts
var $af646dc9ee6cb2b8$var$plugins = {};
function $af646dc9ee6cb2b8$var$getPlugin(pluginKey) {
    const plugin = $af646dc9ee6cb2b8$var$plugins[pluginKey];
    if (!plugin) $af646dc9ee6cb2b8$var$die(0, pluginKey);
    return plugin;
}
function $af646dc9ee6cb2b8$var$loadPlugin(pluginKey, implementation) {
    if (!$af646dc9ee6cb2b8$var$plugins[pluginKey]) $af646dc9ee6cb2b8$var$plugins[pluginKey] = implementation;
}
// src/core/scope.ts
var $af646dc9ee6cb2b8$var$currentScope;
function $af646dc9ee6cb2b8$var$getCurrentScope() {
    return $af646dc9ee6cb2b8$var$currentScope;
}
function $af646dc9ee6cb2b8$var$createScope(parent_, immer_) {
    return {
        drafts_: [],
        parent_: parent_,
        immer_: immer_,
        // Whenever the modified draft contains a draft from another scope, we
        // need to prevent auto-freezing so the unowned draft can be finalized.
        canAutoFreeze_: true,
        unfinalizedDrafts_: 0
    };
}
function $af646dc9ee6cb2b8$var$usePatchesInScope(scope, patchListener) {
    if (patchListener) {
        $af646dc9ee6cb2b8$var$getPlugin("Patches");
        scope.patches_ = [];
        scope.inversePatches_ = [];
        scope.patchListener_ = patchListener;
    }
}
function $af646dc9ee6cb2b8$var$revokeScope(scope) {
    $af646dc9ee6cb2b8$var$leaveScope(scope);
    scope.drafts_.forEach($af646dc9ee6cb2b8$var$revokeDraft);
    scope.drafts_ = null;
}
function $af646dc9ee6cb2b8$var$leaveScope(scope) {
    if (scope === $af646dc9ee6cb2b8$var$currentScope) $af646dc9ee6cb2b8$var$currentScope = scope.parent_;
}
function $af646dc9ee6cb2b8$var$enterScope(immer2) {
    return $af646dc9ee6cb2b8$var$currentScope = $af646dc9ee6cb2b8$var$createScope($af646dc9ee6cb2b8$var$currentScope, immer2);
}
function $af646dc9ee6cb2b8$var$revokeDraft(draft) {
    const state = draft[$af646dc9ee6cb2b8$var$DRAFT_STATE];
    if (state.type_ === 0 /* Object */  || state.type_ === 1 /* Array */ ) state.revoke_();
    else state.revoked_ = true;
}
// src/core/finalize.ts
function $af646dc9ee6cb2b8$var$processResult(result, scope) {
    scope.unfinalizedDrafts_ = scope.drafts_.length;
    const baseDraft = scope.drafts_[0];
    const isReplaced = result !== void 0 && result !== baseDraft;
    if (isReplaced) {
        if (baseDraft[$af646dc9ee6cb2b8$var$DRAFT_STATE].modified_) {
            $af646dc9ee6cb2b8$var$revokeScope(scope);
            $af646dc9ee6cb2b8$var$die(4);
        }
        if ($af646dc9ee6cb2b8$export$16e3aed3edb85946(result)) {
            result = $af646dc9ee6cb2b8$var$finalize(scope, result);
            if (!scope.parent_) $af646dc9ee6cb2b8$var$maybeFreeze(scope, result);
        }
        if (scope.patches_) $af646dc9ee6cb2b8$var$getPlugin("Patches").generateReplacementPatches_(baseDraft[$af646dc9ee6cb2b8$var$DRAFT_STATE].base_, result, scope.patches_, scope.inversePatches_);
    } else result = $af646dc9ee6cb2b8$var$finalize(scope, baseDraft, []);
    $af646dc9ee6cb2b8$var$revokeScope(scope);
    if (scope.patches_) scope.patchListener_(scope.patches_, scope.inversePatches_);
    return result !== $af646dc9ee6cb2b8$export$45b790e32b2810ee ? result : void 0;
}
function $af646dc9ee6cb2b8$var$finalize(rootScope, value, path) {
    if ($af646dc9ee6cb2b8$var$isFrozen(value)) return value;
    const state = value[$af646dc9ee6cb2b8$var$DRAFT_STATE];
    if (!state) {
        $af646dc9ee6cb2b8$var$each(value, (key, childValue)=>$af646dc9ee6cb2b8$var$finalizeProperty(rootScope, state, value, key, childValue, path), true);
        return value;
    }
    if (state.scope_ !== rootScope) return value;
    if (!state.modified_) {
        $af646dc9ee6cb2b8$var$maybeFreeze(rootScope, state.base_, true);
        return state.base_;
    }
    if (!state.finalized_) {
        state.finalized_ = true;
        state.scope_.unfinalizedDrafts_--;
        const result = state.copy_;
        let resultEach = result;
        let isSet2 = false;
        if (state.type_ === 3 /* Set */ ) {
            resultEach = new Set(result);
            result.clear();
            isSet2 = true;
        }
        $af646dc9ee6cb2b8$var$each(resultEach, (key, childValue)=>$af646dc9ee6cb2b8$var$finalizeProperty(rootScope, state, result, key, childValue, path, isSet2));
        $af646dc9ee6cb2b8$var$maybeFreeze(rootScope, result, false);
        if (path && rootScope.patches_) $af646dc9ee6cb2b8$var$getPlugin("Patches").generatePatches_(state, path, rootScope.patches_, rootScope.inversePatches_);
    }
    return state.copy_;
}
function $af646dc9ee6cb2b8$var$finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
    if ($af646dc9ee6cb2b8$export$541ac630993a4c84(childValue)) {
        const path = rootPath && parentState && parentState.type_ !== 3 /* Set */  && // Set objects are atomic since they have no keys.
        !$af646dc9ee6cb2b8$var$has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
        const res = $af646dc9ee6cb2b8$var$finalize(rootScope, childValue, path);
        $af646dc9ee6cb2b8$var$set(targetObject, prop, res);
        if ($af646dc9ee6cb2b8$export$541ac630993a4c84(res)) rootScope.canAutoFreeze_ = false;
        else return;
    } else if (targetIsSet) targetObject.add(childValue);
    if ($af646dc9ee6cb2b8$export$16e3aed3edb85946(childValue) && !$af646dc9ee6cb2b8$var$isFrozen(childValue)) {
        if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) return;
        $af646dc9ee6cb2b8$var$finalize(rootScope, childValue);
        if (!parentState || !parentState.scope_.parent_) $af646dc9ee6cb2b8$var$maybeFreeze(rootScope, childValue);
    }
}
function $af646dc9ee6cb2b8$var$maybeFreeze(scope, value, deep = false) {
    if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) $af646dc9ee6cb2b8$export$792f3d81ea979f55(value, deep);
}
// src/core/proxy.ts
function $af646dc9ee6cb2b8$var$createProxyProxy(base, parent) {
    const isArray = Array.isArray(base);
    const state = {
        type_: isArray ? 1 /* Array */  : 0 /* Object */ ,
        // Track which produce call this is associated with.
        scope_: parent ? parent.scope_ : $af646dc9ee6cb2b8$var$getCurrentScope(),
        // True for both shallow and deep changes.
        modified_: false,
        // Used during finalization.
        finalized_: false,
        // Track which properties have been assigned (true) or deleted (false).
        assigned_: {},
        // The parent draft state.
        parent_: parent,
        // The base state.
        base_: base,
        // The base proxy.
        draft_: null,
        // set below
        // The base copy with any updated values.
        copy_: null,
        // Called by the `produce` function.
        revoke_: null,
        isManual_: false
    };
    let target = state;
    let traps = $af646dc9ee6cb2b8$var$objectTraps;
    if (isArray) {
        target = [
            state
        ];
        traps = $af646dc9ee6cb2b8$var$arrayTraps;
    }
    const { revoke: revoke, proxy: proxy } = Proxy.revocable(target, traps);
    state.draft_ = proxy;
    state.revoke_ = revoke;
    return proxy;
}
var $af646dc9ee6cb2b8$var$objectTraps = {
    get (state, prop) {
        if (prop === $af646dc9ee6cb2b8$var$DRAFT_STATE) return state;
        const source = $af646dc9ee6cb2b8$var$latest(state);
        if (!$af646dc9ee6cb2b8$var$has(source, prop)) return $af646dc9ee6cb2b8$var$readPropFromProto(state, source, prop);
        const value = source[prop];
        if (state.finalized_ || !$af646dc9ee6cb2b8$export$16e3aed3edb85946(value)) return value;
        if (value === $af646dc9ee6cb2b8$var$peek(state.base_, prop)) {
            $af646dc9ee6cb2b8$var$prepareCopy(state);
            return state.copy_[prop] = $af646dc9ee6cb2b8$var$createProxy(value, state);
        }
        return value;
    },
    has (state, prop) {
        return prop in $af646dc9ee6cb2b8$var$latest(state);
    },
    ownKeys (state) {
        return Reflect.ownKeys($af646dc9ee6cb2b8$var$latest(state));
    },
    set (state, prop, value) {
        const desc = $af646dc9ee6cb2b8$var$getDescriptorFromProto($af646dc9ee6cb2b8$var$latest(state), prop);
        if (desc == null ? void 0 : desc.set) {
            desc.set.call(state.draft_, value);
            return true;
        }
        if (!state.modified_) {
            const current2 = $af646dc9ee6cb2b8$var$peek($af646dc9ee6cb2b8$var$latest(state), prop);
            const currentState = current2 == null ? void 0 : current2[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            if (currentState && currentState.base_ === value) {
                state.copy_[prop] = value;
                state.assigned_[prop] = false;
                return true;
            }
            if ($af646dc9ee6cb2b8$var$is(value, current2) && (value !== void 0 || $af646dc9ee6cb2b8$var$has(state.base_, prop))) return true;
            $af646dc9ee6cb2b8$var$prepareCopy(state);
            $af646dc9ee6cb2b8$var$markChanged(state);
        }
        if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
        (value !== void 0 || prop in state.copy_) || // special case: NaN
        Number.isNaN(value) && Number.isNaN(state.copy_[prop])) return true;
        state.copy_[prop] = value;
        state.assigned_[prop] = true;
        return true;
    },
    deleteProperty (state, prop) {
        if ($af646dc9ee6cb2b8$var$peek(state.base_, prop) !== void 0 || prop in state.base_) {
            state.assigned_[prop] = false;
            $af646dc9ee6cb2b8$var$prepareCopy(state);
            $af646dc9ee6cb2b8$var$markChanged(state);
        } else delete state.assigned_[prop];
        if (state.copy_) delete state.copy_[prop];
        return true;
    },
    // Note: We never coerce `desc.value` into an Immer draft, because we can't make
    // the same guarantee in ES5 mode.
    getOwnPropertyDescriptor (state, prop) {
        const owner = $af646dc9ee6cb2b8$var$latest(state);
        const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
        if (!desc) return desc;
        return {
            writable: true,
            configurable: state.type_ !== 1 /* Array */  || prop !== "length",
            enumerable: desc.enumerable,
            value: owner[prop]
        };
    },
    defineProperty () {
        $af646dc9ee6cb2b8$var$die(11);
    },
    getPrototypeOf (state) {
        return $af646dc9ee6cb2b8$var$getPrototypeOf(state.base_);
    },
    setPrototypeOf () {
        $af646dc9ee6cb2b8$var$die(12);
    }
};
var $af646dc9ee6cb2b8$var$arrayTraps = {};
$af646dc9ee6cb2b8$var$each($af646dc9ee6cb2b8$var$objectTraps, (key, fn)=>{
    $af646dc9ee6cb2b8$var$arrayTraps[key] = function() {
        arguments[0] = arguments[0][0];
        return fn.apply(this, arguments);
    };
});
$af646dc9ee6cb2b8$var$arrayTraps.deleteProperty = function(state, prop) {
    return $af646dc9ee6cb2b8$var$arrayTraps.set.call(this, state, prop, void 0);
};
$af646dc9ee6cb2b8$var$arrayTraps.set = function(state, prop, value) {
    return $af646dc9ee6cb2b8$var$objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function $af646dc9ee6cb2b8$var$peek(draft, prop) {
    const state = draft[$af646dc9ee6cb2b8$var$DRAFT_STATE];
    const source = state ? $af646dc9ee6cb2b8$var$latest(state) : draft;
    return source[prop];
}
function $af646dc9ee6cb2b8$var$readPropFromProto(state, source, prop) {
    var _a;
    const desc = $af646dc9ee6cb2b8$var$getDescriptorFromProto(source, prop);
    return desc ? `value` in desc ? desc.value : // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    (_a = desc.get) == null ? void 0 : _a.call(state.draft_) : void 0;
}
function $af646dc9ee6cb2b8$var$getDescriptorFromProto(source, prop) {
    if (!(prop in source)) return void 0;
    let proto = $af646dc9ee6cb2b8$var$getPrototypeOf(source);
    while(proto){
        const desc = Object.getOwnPropertyDescriptor(proto, prop);
        if (desc) return desc;
        proto = $af646dc9ee6cb2b8$var$getPrototypeOf(proto);
    }
    return void 0;
}
function $af646dc9ee6cb2b8$var$markChanged(state) {
    if (!state.modified_) {
        state.modified_ = true;
        if (state.parent_) $af646dc9ee6cb2b8$var$markChanged(state.parent_);
    }
}
function $af646dc9ee6cb2b8$var$prepareCopy(state) {
    if (!state.copy_) state.copy_ = $af646dc9ee6cb2b8$var$shallowCopy(state.base_, state.scope_.immer_.useStrictShallowCopy_);
}
// src/core/immerClass.ts
var $af646dc9ee6cb2b8$export$aaadc6ff0f822719 = class {
    constructor(config){
        this.autoFreeze_ = true;
        this.useStrictShallowCopy_ = false;
        /**
     * The `produce` function takes a value and a "recipe function" (whose
     * return value often depends on the base state). The recipe function is
     * free to mutate its first argument however it wants. All mutations are
     * only ever applied to a __copy__ of the base state.
     *
     * Pass only a function to create a "curried producer" which relieves you
     * from passing the recipe function every time.
     *
     * Only plain objects and arrays are made mutable. All other objects are
     * considered uncopyable.
     *
     * Note: This function is __bound__ to its `Immer` instance.
     *
     * @param {any} base - the initial state
     * @param {Function} recipe - function that receives a proxy of the base state as first argument and which can be freely modified
     * @param {Function} patchListener - optional function that will be called with all the patches produced here
     * @returns {any} a new state, or the initial state if nothing was modified
     */ this.produce = (base, recipe, patchListener)=>{
            if (typeof base === "function" && typeof recipe !== "function") {
                const defaultBase = recipe;
                recipe = base;
                const self = this;
                return function curriedProduce(base2 = defaultBase, ...args) {
                    return self.produce(base2, (draft)=>recipe.call(this, draft, ...args));
                };
            }
            if (typeof recipe !== "function") $af646dc9ee6cb2b8$var$die(6);
            if (patchListener !== void 0 && typeof patchListener !== "function") $af646dc9ee6cb2b8$var$die(7);
            let result;
            if ($af646dc9ee6cb2b8$export$16e3aed3edb85946(base)) {
                const scope = $af646dc9ee6cb2b8$var$enterScope(this);
                const proxy = $af646dc9ee6cb2b8$var$createProxy(base, void 0);
                let hasError = true;
                try {
                    result = recipe(proxy);
                    hasError = false;
                } finally{
                    if (hasError) $af646dc9ee6cb2b8$var$revokeScope(scope);
                    else $af646dc9ee6cb2b8$var$leaveScope(scope);
                }
                $af646dc9ee6cb2b8$var$usePatchesInScope(scope, patchListener);
                return $af646dc9ee6cb2b8$var$processResult(result, scope);
            } else if (!base || typeof base !== "object") {
                result = recipe(base);
                if (result === void 0) result = base;
                if (result === $af646dc9ee6cb2b8$export$45b790e32b2810ee) result = void 0;
                if (this.autoFreeze_) $af646dc9ee6cb2b8$export$792f3d81ea979f55(result, true);
                if (patchListener) {
                    const p = [];
                    const ip = [];
                    $af646dc9ee6cb2b8$var$getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
                    patchListener(p, ip);
                }
                return result;
            } else $af646dc9ee6cb2b8$var$die(1, base);
        };
        this.produceWithPatches = (base, recipe)=>{
            if (typeof base === "function") return (state, ...args)=>this.produceWithPatches(state, (draft)=>base(draft, ...args));
            let patches, inversePatches;
            const result = this.produce(base, recipe, (p, ip)=>{
                patches = p;
                inversePatches = ip;
            });
            return [
                result,
                patches,
                inversePatches
            ];
        };
        if (typeof (config == null ? void 0 : config.autoFreeze) === "boolean") this.setAutoFreeze(config.autoFreeze);
        if (typeof (config == null ? void 0 : config.useStrictShallowCopy) === "boolean") this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    }
    createDraft(base) {
        if (!$af646dc9ee6cb2b8$export$16e3aed3edb85946(base)) $af646dc9ee6cb2b8$var$die(8);
        if ($af646dc9ee6cb2b8$export$541ac630993a4c84(base)) base = $af646dc9ee6cb2b8$export$97aac956da55dae9(base);
        const scope = $af646dc9ee6cb2b8$var$enterScope(this);
        const proxy = $af646dc9ee6cb2b8$var$createProxy(base, void 0);
        proxy[$af646dc9ee6cb2b8$var$DRAFT_STATE].isManual_ = true;
        $af646dc9ee6cb2b8$var$leaveScope(scope);
        return proxy;
    }
    finishDraft(draft, patchListener) {
        const state = draft && draft[$af646dc9ee6cb2b8$var$DRAFT_STATE];
        if (!state || !state.isManual_) $af646dc9ee6cb2b8$var$die(9);
        const { scope_: scope } = state;
        $af646dc9ee6cb2b8$var$usePatchesInScope(scope, patchListener);
        return $af646dc9ee6cb2b8$var$processResult(void 0, scope);
    }
    /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */ setAutoFreeze(value) {
        this.autoFreeze_ = value;
    }
    /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */ setUseStrictShallowCopy(value) {
        this.useStrictShallowCopy_ = value;
    }
    applyPatches(base, patches) {
        let i;
        for(i = patches.length - 1; i >= 0; i--){
            const patch = patches[i];
            if (patch.path.length === 0 && patch.op === "replace") {
                base = patch.value;
                break;
            }
        }
        if (i > -1) patches = patches.slice(i + 1);
        const applyPatchesImpl = $af646dc9ee6cb2b8$var$getPlugin("Patches").applyPatches_;
        if ($af646dc9ee6cb2b8$export$541ac630993a4c84(base)) return applyPatchesImpl(base, patches);
        return this.produce(base, (draft)=>applyPatchesImpl(draft, patches));
    }
};
function $af646dc9ee6cb2b8$var$createProxy(value, parent) {
    const draft = $af646dc9ee6cb2b8$var$isMap(value) ? $af646dc9ee6cb2b8$var$getPlugin("MapSet").proxyMap_(value, parent) : $af646dc9ee6cb2b8$var$isSet(value) ? $af646dc9ee6cb2b8$var$getPlugin("MapSet").proxySet_(value, parent) : $af646dc9ee6cb2b8$var$createProxyProxy(value, parent);
    const scope = parent ? parent.scope_ : $af646dc9ee6cb2b8$var$getCurrentScope();
    scope.drafts_.push(draft);
    return draft;
}
// src/core/current.ts
function $af646dc9ee6cb2b8$export$97aac956da55dae9(value) {
    if (!$af646dc9ee6cb2b8$export$541ac630993a4c84(value)) $af646dc9ee6cb2b8$var$die(10, value);
    return $af646dc9ee6cb2b8$var$currentImpl(value);
}
function $af646dc9ee6cb2b8$var$currentImpl(value) {
    if (!$af646dc9ee6cb2b8$export$16e3aed3edb85946(value) || $af646dc9ee6cb2b8$var$isFrozen(value)) return value;
    const state = value[$af646dc9ee6cb2b8$var$DRAFT_STATE];
    let copy;
    if (state) {
        if (!state.modified_) return state.base_;
        state.finalized_ = true;
        copy = $af646dc9ee6cb2b8$var$shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    } else copy = $af646dc9ee6cb2b8$var$shallowCopy(value, true);
    $af646dc9ee6cb2b8$var$each(copy, (key, childValue)=>{
        $af646dc9ee6cb2b8$var$set(copy, key, $af646dc9ee6cb2b8$var$currentImpl(childValue));
    });
    if (state) state.finalized_ = false;
    return copy;
}
// src/plugins/patches.ts
function $af646dc9ee6cb2b8$export$d3a6659991a0696c() {
    const errorOffset = 16;
    const REPLACE = "replace";
    const ADD = "add";
    const REMOVE = "remove";
    function generatePatches_(state, basePath, patches, inversePatches) {
        switch(state.type_){
            case 0 /* Object */ :
            case 2 /* Map */ :
                return generatePatchesFromAssigned(state, basePath, patches, inversePatches);
            case 1 /* Array */ :
                return generateArrayPatches(state, basePath, patches, inversePatches);
            case 3 /* Set */ :
                return generateSetPatches(state, basePath, patches, inversePatches);
        }
    }
    function generateArrayPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, assigned_: assigned_ } = state;
        let copy_ = state.copy_;
        if (copy_.length < base_.length) {
            [base_, copy_] = [
                copy_,
                base_
            ];
            [patches, inversePatches] = [
                inversePatches,
                patches
            ];
        }
        for(let i = 0; i < base_.length; i++)if (assigned_[i] && copy_[i] !== base_[i]) {
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: REPLACE,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
            inversePatches.push({
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(base_[i])
            });
        }
        for(let i = base_.length; i < copy_.length; i++){
            const path = basePath.concat([
                i
            ]);
            patches.push({
                op: ADD,
                path: path,
                // Need to maybe clone it, as it can in fact be the original value
                // due to the base/copy inversion at the start of this function
                value: clonePatchValueIfNeeded(copy_[i])
            });
        }
        for(let i = copy_.length - 1; base_.length <= i; --i){
            const path = basePath.concat([
                i
            ]);
            inversePatches.push({
                op: REMOVE,
                path: path
            });
        }
    }
    function generatePatchesFromAssigned(state, basePath, patches, inversePatches) {
        const { base_: base_, copy_: copy_ } = state;
        $af646dc9ee6cb2b8$var$each(state.assigned_, (key, assignedValue)=>{
            const origValue = $af646dc9ee6cb2b8$var$get(base_, key);
            const value = $af646dc9ee6cb2b8$var$get(copy_, key);
            const op = !assignedValue ? REMOVE : $af646dc9ee6cb2b8$var$has(base_, key) ? REPLACE : ADD;
            if (origValue === value && op === REPLACE) return;
            const path = basePath.concat(key);
            patches.push(op === REMOVE ? {
                op: op,
                path: path
            } : {
                op: op,
                path: path,
                value: value
            });
            inversePatches.push(op === ADD ? {
                op: REMOVE,
                path: path
            } : op === REMOVE ? {
                op: ADD,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            } : {
                op: REPLACE,
                path: path,
                value: clonePatchValueIfNeeded(origValue)
            });
        });
    }
    function generateSetPatches(state, basePath, patches, inversePatches) {
        let { base_: base_, copy_: copy_ } = state;
        let i = 0;
        base_.forEach((value)=>{
            if (!copy_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: REMOVE,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: ADD,
                    path: path,
                    value: value
                });
            }
            i++;
        });
        i = 0;
        copy_.forEach((value)=>{
            if (!base_.has(value)) {
                const path = basePath.concat([
                    i
                ]);
                patches.push({
                    op: ADD,
                    path: path,
                    value: value
                });
                inversePatches.unshift({
                    op: REMOVE,
                    path: path,
                    value: value
                });
            }
            i++;
        });
    }
    function generateReplacementPatches_(baseValue, replacement, patches, inversePatches) {
        patches.push({
            op: REPLACE,
            path: [],
            value: replacement === $af646dc9ee6cb2b8$export$45b790e32b2810ee ? void 0 : replacement
        });
        inversePatches.push({
            op: REPLACE,
            path: [],
            value: baseValue
        });
    }
    function applyPatches_(draft, patches) {
        patches.forEach((patch)=>{
            const { path: path, op: op } = patch;
            let base = draft;
            for(let i = 0; i < path.length - 1; i++){
                const parentType = $af646dc9ee6cb2b8$var$getArchtype(base);
                let p = path[i];
                if (typeof p !== "string" && typeof p !== "number") p = "" + p;
                if ((parentType === 0 /* Object */  || parentType === 1 /* Array */ ) && (p === "__proto__" || p === "constructor")) $af646dc9ee6cb2b8$var$die(errorOffset + 3);
                if (typeof base === "function" && p === "prototype") $af646dc9ee6cb2b8$var$die(errorOffset + 3);
                base = $af646dc9ee6cb2b8$var$get(base, p);
                if (typeof base !== "object") $af646dc9ee6cb2b8$var$die(errorOffset + 2, path.join("/"));
            }
            const type = $af646dc9ee6cb2b8$var$getArchtype(base);
            const value = deepClonePatchValue(patch.value);
            const key = path[path.length - 1];
            switch(op){
                case REPLACE:
                    switch(type){
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            $af646dc9ee6cb2b8$var$die(errorOffset);
                        default:
                            return base[key] = value;
                    }
                case ADD:
                    switch(type){
                        case 1 /* Array */ :
                            return key === "-" ? base.push(value) : base.splice(key, 0, value);
                        case 2 /* Map */ :
                            return base.set(key, value);
                        case 3 /* Set */ :
                            return base.add(value);
                        default:
                            return base[key] = value;
                    }
                case REMOVE:
                    switch(type){
                        case 1 /* Array */ :
                            return base.splice(key, 1);
                        case 2 /* Map */ :
                            return base.delete(key);
                        case 3 /* Set */ :
                            return base.delete(patch.value);
                        default:
                            return delete base[key];
                    }
                default:
                    $af646dc9ee6cb2b8$var$die(errorOffset + 1, op);
            }
        });
        return draft;
    }
    function deepClonePatchValue(obj) {
        if (!$af646dc9ee6cb2b8$export$16e3aed3edb85946(obj)) return obj;
        if (Array.isArray(obj)) return obj.map(deepClonePatchValue);
        if ($af646dc9ee6cb2b8$var$isMap(obj)) return new Map(Array.from(obj.entries()).map(([k, v])=>[
                k,
                deepClonePatchValue(v)
            ]));
        if ($af646dc9ee6cb2b8$var$isSet(obj)) return new Set(Array.from(obj).map(deepClonePatchValue));
        const cloned = Object.create($af646dc9ee6cb2b8$var$getPrototypeOf(obj));
        for(const key in obj)cloned[key] = deepClonePatchValue(obj[key]);
        if ($af646dc9ee6cb2b8$var$has(obj, $af646dc9ee6cb2b8$export$6ee2082928bcb0ee)) cloned[$af646dc9ee6cb2b8$export$6ee2082928bcb0ee] = obj[$af646dc9ee6cb2b8$export$6ee2082928bcb0ee];
        return cloned;
    }
    function clonePatchValueIfNeeded(obj) {
        if ($af646dc9ee6cb2b8$export$541ac630993a4c84(obj)) return deepClonePatchValue(obj);
        else return obj;
    }
    $af646dc9ee6cb2b8$var$loadPlugin("Patches", {
        applyPatches_: applyPatches_,
        generatePatches_: generatePatches_,
        generateReplacementPatches_: generateReplacementPatches_
    });
}
// src/plugins/mapset.ts
function $af646dc9ee6cb2b8$export$7d9f65390203b435() {
    class DraftMap extends Map {
        constructor(target, parent){
            super();
            this[$af646dc9ee6cb2b8$var$DRAFT_STATE] = {
                type_: 2 /* Map */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $af646dc9ee6cb2b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                assigned_: void 0,
                base_: target,
                draft_: this,
                isManual_: false,
                revoked_: false
            };
        }
        get size() {
            return $af646dc9ee6cb2b8$var$latest(this[$af646dc9ee6cb2b8$var$DRAFT_STATE]).size;
        }
        has(key) {
            return $af646dc9ee6cb2b8$var$latest(this[$af646dc9ee6cb2b8$var$DRAFT_STATE]).has(key);
        }
        set(key, value) {
            const state = this[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!$af646dc9ee6cb2b8$var$latest(state).has(key) || $af646dc9ee6cb2b8$var$latest(state).get(key) !== value) {
                prepareMapCopy(state);
                $af646dc9ee6cb2b8$var$markChanged(state);
                state.assigned_.set(key, true);
                state.copy_.set(key, value);
                state.assigned_.set(key, true);
            }
            return this;
        }
        delete(key) {
            if (!this.has(key)) return false;
            const state = this[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareMapCopy(state);
            $af646dc9ee6cb2b8$var$markChanged(state);
            if (state.base_.has(key)) state.assigned_.set(key, false);
            else state.assigned_.delete(key);
            state.copy_.delete(key);
            return true;
        }
        clear() {
            const state = this[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($af646dc9ee6cb2b8$var$latest(state).size) {
                prepareMapCopy(state);
                $af646dc9ee6cb2b8$var$markChanged(state);
                state.assigned_ = /* @__PURE__ */ new Map();
                $af646dc9ee6cb2b8$var$each(state.base_, (key)=>{
                    state.assigned_.set(key, false);
                });
                state.copy_.clear();
            }
        }
        forEach(cb, thisArg) {
            const state = this[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            $af646dc9ee6cb2b8$var$latest(state).forEach((_value, key, _map)=>{
                cb.call(thisArg, this.get(key), key, this);
            });
        }
        get(key) {
            const state = this[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            const value = $af646dc9ee6cb2b8$var$latest(state).get(key);
            if (state.finalized_ || !$af646dc9ee6cb2b8$export$16e3aed3edb85946(value)) return value;
            if (value !== state.base_.get(key)) return value;
            const draft = $af646dc9ee6cb2b8$var$createProxy(value, state);
            prepareMapCopy(state);
            state.copy_.set(key, draft);
            return draft;
        }
        keys() {
            return $af646dc9ee6cb2b8$var$latest(this[$af646dc9ee6cb2b8$var$DRAFT_STATE]).keys();
        }
        values() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.values(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: value
                    };
                }
            };
        }
        entries() {
            const iterator = this.keys();
            return {
                [Symbol.iterator]: ()=>this.entries(),
                next: ()=>{
                    const r = iterator.next();
                    if (r.done) return r;
                    const value = this.get(r.value);
                    return {
                        done: false,
                        value: [
                            r.value,
                            value
                        ]
                    };
                }
            };
        }
        [($af646dc9ee6cb2b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.entries();
        }
    }
    function proxyMap_(target, parent) {
        return new DraftMap(target, parent);
    }
    function prepareMapCopy(state) {
        if (!state.copy_) {
            state.assigned_ = /* @__PURE__ */ new Map();
            state.copy_ = new Map(state.base_);
        }
    }
    class DraftSet extends Set {
        constructor(target, parent){
            super();
            this[$af646dc9ee6cb2b8$var$DRAFT_STATE] = {
                type_: 3 /* Set */ ,
                parent_: parent,
                scope_: parent ? parent.scope_ : $af646dc9ee6cb2b8$var$getCurrentScope(),
                modified_: false,
                finalized_: false,
                copy_: void 0,
                base_: target,
                draft_: this,
                drafts_: /* @__PURE__ */ new Map(),
                revoked_: false,
                isManual_: false
            };
        }
        get size() {
            return $af646dc9ee6cb2b8$var$latest(this[$af646dc9ee6cb2b8$var$DRAFT_STATE]).size;
        }
        has(value) {
            const state = this[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!state.copy_) return state.base_.has(value);
            if (state.copy_.has(value)) return true;
            if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value))) return true;
            return false;
        }
        add(value) {
            const state = this[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if (!this.has(value)) {
                prepareSetCopy(state);
                $af646dc9ee6cb2b8$var$markChanged(state);
                state.copy_.add(value);
            }
            return this;
        }
        delete(value) {
            if (!this.has(value)) return false;
            const state = this[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            $af646dc9ee6cb2b8$var$markChanged(state);
            return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : /* istanbul ignore next */ false);
        }
        clear() {
            const state = this[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            if ($af646dc9ee6cb2b8$var$latest(state).size) {
                prepareSetCopy(state);
                $af646dc9ee6cb2b8$var$markChanged(state);
                state.copy_.clear();
            }
        }
        values() {
            const state = this[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.values();
        }
        entries() {
            const state = this[$af646dc9ee6cb2b8$var$DRAFT_STATE];
            assertUnrevoked(state);
            prepareSetCopy(state);
            return state.copy_.entries();
        }
        keys() {
            return this.values();
        }
        [($af646dc9ee6cb2b8$var$DRAFT_STATE, Symbol.iterator)]() {
            return this.values();
        }
        forEach(cb, thisArg) {
            const iterator = this.values();
            let result = iterator.next();
            while(!result.done){
                cb.call(thisArg, result.value, result.value, this);
                result = iterator.next();
            }
        }
    }
    function proxySet_(target, parent) {
        return new DraftSet(target, parent);
    }
    function prepareSetCopy(state) {
        if (!state.copy_) {
            state.copy_ = /* @__PURE__ */ new Set();
            state.base_.forEach((value)=>{
                if ($af646dc9ee6cb2b8$export$16e3aed3edb85946(value)) {
                    const draft = $af646dc9ee6cb2b8$var$createProxy(value, state);
                    state.drafts_.set(value, draft);
                    state.copy_.add(draft);
                } else state.copy_.add(value);
            });
        }
    }
    function assertUnrevoked(state) {
        if (state.revoked_) $af646dc9ee6cb2b8$var$die(3, JSON.stringify($af646dc9ee6cb2b8$var$latest(state)));
    }
    $af646dc9ee6cb2b8$var$loadPlugin("MapSet", {
        proxyMap_: proxyMap_,
        proxySet_: proxySet_
    });
}
// src/immer.ts
var $af646dc9ee6cb2b8$var$immer = new $af646dc9ee6cb2b8$export$aaadc6ff0f822719();
var $af646dc9ee6cb2b8$export$b46cabe22e78bc00 = $af646dc9ee6cb2b8$var$immer.produce;
var $af646dc9ee6cb2b8$export$4da66d41c9492c78 = $af646dc9ee6cb2b8$var$immer.produceWithPatches.bind($af646dc9ee6cb2b8$var$immer);
var $af646dc9ee6cb2b8$export$573f26f60825c493 = $af646dc9ee6cb2b8$var$immer.setAutoFreeze.bind($af646dc9ee6cb2b8$var$immer);
var $af646dc9ee6cb2b8$export$333ce65961cbe047 = $af646dc9ee6cb2b8$var$immer.setUseStrictShallowCopy.bind($af646dc9ee6cb2b8$var$immer);
var $af646dc9ee6cb2b8$export$a8b8e03e6bbe5473 = $af646dc9ee6cb2b8$var$immer.applyPatches.bind($af646dc9ee6cb2b8$var$immer);
var $af646dc9ee6cb2b8$export$3c3214997190395f = $af646dc9ee6cb2b8$var$immer.createDraft.bind($af646dc9ee6cb2b8$var$immer);
var $af646dc9ee6cb2b8$export$c60f5e69c521b528 = $af646dc9ee6cb2b8$var$immer.finishDraft.bind($af646dc9ee6cb2b8$var$immer);
function $af646dc9ee6cb2b8$export$c05b21e3257751e5(value) {
    return value;
}
function $af646dc9ee6cb2b8$export$20f911b3f8cf0b74(value) {
    return value;
}


var $c1c3982e33455b3d$var$__defProp = Object.defineProperty;
var $c1c3982e33455b3d$var$__getOwnPropSymbols = Object.getOwnPropertySymbols;
var $c1c3982e33455b3d$var$__hasOwnProp = Object.prototype.hasOwnProperty;
var $c1c3982e33455b3d$var$__propIsEnum = Object.prototype.propertyIsEnumerable;
var $c1c3982e33455b3d$var$__defNormalProp = (obj, key, value)=>key in obj ? $c1c3982e33455b3d$var$__defProp(obj, key, {
        enumerable: true,
        configurable: true,
        writable: true,
        value: value
    }) : obj[key] = value;
var $c1c3982e33455b3d$var$__spreadValues = (a, b)=>{
    for(var prop in b || (b = {}))if ($c1c3982e33455b3d$var$__hasOwnProp.call(b, prop)) $c1c3982e33455b3d$var$__defNormalProp(a, prop, b[prop]);
    if ($c1c3982e33455b3d$var$__getOwnPropSymbols) {
        for (var prop of $c1c3982e33455b3d$var$__getOwnPropSymbols(b))if ($c1c3982e33455b3d$var$__propIsEnum.call(b, prop)) $c1c3982e33455b3d$var$__defNormalProp(a, prop, b[prop]);
    }
    return a;
};
var $c1c3982e33455b3d$var$__publicField = (obj, key, value)=>{
    $c1c3982e33455b3d$var$__defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
    return value;
};
// src/devModeChecks/identityFunctionCheck.ts
var $c1c3982e33455b3d$var$runIdentityFunctionCheck = (resultFunc, inputSelectorsResults, outputSelectorResult)=>{
    if (inputSelectorsResults.length === 1 && inputSelectorsResults[0] === outputSelectorResult) {
        let isInputSameAsOutput = false;
        try {
            const emptyObject = {};
            if (resultFunc(emptyObject) === emptyObject) isInputSameAsOutput = true;
        } catch (e) {}
        if (isInputSameAsOutput) {
            let stack = void 0;
            try {
                throw new Error();
            } catch (e) {
                ({ stack: stack } = e);
            }
            console.warn("The result function returned its own inputs without modification. e.g\n`createSelector([state => state.todos], todos => todos)`\nThis could lead to inefficient memoization and unnecessary re-renders.\nEnsure transformation logic is in the result function, and extraction logic is in the input selectors.", {
                stack: stack
            });
        }
    }
};
// src/devModeChecks/inputStabilityCheck.ts
var $c1c3982e33455b3d$var$runInputStabilityCheck = (inputSelectorResultsObject, options, inputSelectorArgs)=>{
    const { memoize: memoize, memoizeOptions: memoizeOptions } = options;
    const { inputSelectorResults: inputSelectorResults, inputSelectorResultsCopy: inputSelectorResultsCopy } = inputSelectorResultsObject;
    const createAnEmptyObject = memoize(()=>({}), ...memoizeOptions);
    const areInputSelectorResultsEqual = createAnEmptyObject.apply(null, inputSelectorResults) === createAnEmptyObject.apply(null, inputSelectorResultsCopy);
    if (!areInputSelectorResultsEqual) {
        let stack = void 0;
        try {
            throw new Error();
        } catch (e) {
            ({ stack: stack } = e);
        }
        console.warn("An input selector returned a different result when passed same arguments.\nThis means your output selector will likely run more frequently than intended.\nAvoid returning a new reference inside your input selector, e.g.\n`createSelector([state => state.todos.map(todo => todo.id)], todoIds => todoIds.length)`", {
            arguments: inputSelectorArgs,
            firstInputs: inputSelectorResults,
            secondInputs: inputSelectorResultsCopy,
            stack: stack
        });
    }
};
// src/devModeChecks/setGlobalDevModeChecks.ts
var $c1c3982e33455b3d$var$globalDevModeChecks = {
    inputStabilityCheck: "once",
    identityFunctionCheck: "once"
};
var $c1c3982e33455b3d$export$1e290349de99e28c = (devModeChecks)=>{
    Object.assign($c1c3982e33455b3d$var$globalDevModeChecks, devModeChecks);
};
// src/utils.ts
var $c1c3982e33455b3d$var$NOT_FOUND = "NOT_FOUND";
function $c1c3982e33455b3d$var$assertIsFunction(func, errorMessage = `expected a function, instead received ${typeof func}`) {
    if (typeof func !== "function") throw new TypeError(errorMessage);
}
function $c1c3982e33455b3d$var$assertIsObject(object, errorMessage = `expected an object, instead received ${typeof object}`) {
    if (typeof object !== "object") throw new TypeError(errorMessage);
}
function $c1c3982e33455b3d$var$assertIsArrayOfFunctions(array, errorMessage = `expected all items to be functions, instead received the following types: `) {
    if (!array.every((item)=>typeof item === "function")) {
        const itemTypes = array.map((item)=>typeof item === "function" ? `function ${item.name || "unnamed"}()` : typeof item).join(", ");
        throw new TypeError(`${errorMessage}[${itemTypes}]`);
    }
}
var $c1c3982e33455b3d$var$ensureIsArray = (item)=>{
    return Array.isArray(item) ? item : [
        item
    ];
};
function $c1c3982e33455b3d$var$getDependencies(createSelectorArgs) {
    const dependencies = Array.isArray(createSelectorArgs[0]) ? createSelectorArgs[0] : createSelectorArgs;
    $c1c3982e33455b3d$var$assertIsArrayOfFunctions(dependencies, `createSelector expects all input-selectors to be functions, but received the following types: `);
    return dependencies;
}
function $c1c3982e33455b3d$var$collectInputSelectorResults(dependencies, inputSelectorArgs) {
    const inputSelectorResults = [];
    const { length: length } = dependencies;
    for(let i = 0; i < length; i++)inputSelectorResults.push(dependencies[i].apply(null, inputSelectorArgs));
    return inputSelectorResults;
}
var $c1c3982e33455b3d$var$getDevModeChecksExecutionInfo = (firstRun, devModeChecks)=>{
    const { identityFunctionCheck: identityFunctionCheck, inputStabilityCheck: inputStabilityCheck } = $c1c3982e33455b3d$var$__spreadValues($c1c3982e33455b3d$var$__spreadValues({}, $c1c3982e33455b3d$var$globalDevModeChecks), devModeChecks);
    return {
        identityFunctionCheck: {
            shouldRun: identityFunctionCheck === "always" || identityFunctionCheck === "once" && firstRun,
            run: $c1c3982e33455b3d$var$runIdentityFunctionCheck
        },
        inputStabilityCheck: {
            shouldRun: inputStabilityCheck === "always" || inputStabilityCheck === "once" && firstRun,
            run: $c1c3982e33455b3d$var$runInputStabilityCheck
        }
    };
};
// src/autotrackMemoize/autotracking.ts
var $c1c3982e33455b3d$var$$REVISION = 0;
var $c1c3982e33455b3d$var$CURRENT_TRACKER = null;
var $c1c3982e33455b3d$var$Cell = class {
    constructor(initialValue, isEqual = $c1c3982e33455b3d$var$tripleEq){
        $c1c3982e33455b3d$var$__publicField(this, "revision", $c1c3982e33455b3d$var$$REVISION);
        $c1c3982e33455b3d$var$__publicField(this, "_value");
        $c1c3982e33455b3d$var$__publicField(this, "_lastValue");
        $c1c3982e33455b3d$var$__publicField(this, "_isEqual", $c1c3982e33455b3d$var$tripleEq);
        this._value = this._lastValue = initialValue;
        this._isEqual = isEqual;
    }
    // Whenever a storage value is read, it'll add itself to the current tracker if
    // one exists, entangling its state with that cache.
    get value() {
        $c1c3982e33455b3d$var$CURRENT_TRACKER == null || $c1c3982e33455b3d$var$CURRENT_TRACKER.add(this);
        return this._value;
    }
    // Whenever a storage value is updated, we bump the global revision clock,
    // assign the revision for this storage to the new value, _and_ we schedule a
    // rerender. This is important, and it's what makes autotracking  _pull_
    // based. We don't actively tell the caches which depend on the storage that
    // anything has happened. Instead, we recompute the caches when needed.
    set value(newValue) {
        if (this.value === newValue) return;
        this._value = newValue;
        this.revision = ++$c1c3982e33455b3d$var$$REVISION;
    }
};
function $c1c3982e33455b3d$var$tripleEq(a, b) {
    return a === b;
}
var $c1c3982e33455b3d$var$TrackingCache = class {
    constructor(fn){
        $c1c3982e33455b3d$var$__publicField(this, "_cachedValue");
        $c1c3982e33455b3d$var$__publicField(this, "_cachedRevision", -1);
        $c1c3982e33455b3d$var$__publicField(this, "_deps", []);
        $c1c3982e33455b3d$var$__publicField(this, "hits", 0);
        $c1c3982e33455b3d$var$__publicField(this, "fn");
        this.fn = fn;
    }
    clear() {
        this._cachedValue = void 0;
        this._cachedRevision = -1;
        this._deps = [];
        this.hits = 0;
    }
    get value() {
        if (this.revision > this._cachedRevision) {
            const { fn: fn } = this;
            const currentTracker = /* @__PURE__ */ new Set();
            const prevTracker = $c1c3982e33455b3d$var$CURRENT_TRACKER;
            $c1c3982e33455b3d$var$CURRENT_TRACKER = currentTracker;
            this._cachedValue = fn();
            $c1c3982e33455b3d$var$CURRENT_TRACKER = prevTracker;
            this.hits++;
            this._deps = Array.from(currentTracker);
            this._cachedRevision = this.revision;
        }
        $c1c3982e33455b3d$var$CURRENT_TRACKER == null || $c1c3982e33455b3d$var$CURRENT_TRACKER.add(this);
        return this._cachedValue;
    }
    get revision() {
        return Math.max(...this._deps.map((d)=>d.revision), 0);
    }
};
function $c1c3982e33455b3d$var$getValue(cell) {
    if (!(cell instanceof $c1c3982e33455b3d$var$Cell)) console.warn("Not a valid cell! ", cell);
    return cell.value;
}
function $c1c3982e33455b3d$var$setValue(storage, value) {
    if (!(storage instanceof $c1c3982e33455b3d$var$Cell)) throw new TypeError("setValue must be passed a tracked store created with `createStorage`.");
    storage.value = storage._lastValue = value;
}
function $c1c3982e33455b3d$var$createCell(initialValue, isEqual = $c1c3982e33455b3d$var$tripleEq) {
    return new $c1c3982e33455b3d$var$Cell(initialValue, isEqual);
}
function $c1c3982e33455b3d$var$createCache(fn) {
    $c1c3982e33455b3d$var$assertIsFunction(fn, "the first parameter to `createCache` must be a function");
    return new $c1c3982e33455b3d$var$TrackingCache(fn);
}
// src/autotrackMemoize/tracking.ts
var $c1c3982e33455b3d$var$neverEq = (a, b)=>false;
function $c1c3982e33455b3d$var$createTag() {
    return $c1c3982e33455b3d$var$createCell(null, $c1c3982e33455b3d$var$neverEq);
}
function $c1c3982e33455b3d$var$dirtyTag(tag, value) {
    $c1c3982e33455b3d$var$setValue(tag, value);
}
var $c1c3982e33455b3d$var$consumeCollection = (node)=>{
    let tag = node.collectionTag;
    if (tag === null) tag = node.collectionTag = $c1c3982e33455b3d$var$createTag();
    $c1c3982e33455b3d$var$getValue(tag);
};
var $c1c3982e33455b3d$var$dirtyCollection = (node)=>{
    const tag = node.collectionTag;
    if (tag !== null) $c1c3982e33455b3d$var$dirtyTag(tag, null);
};
// src/autotrackMemoize/proxy.ts
var $c1c3982e33455b3d$var$REDUX_PROXY_LABEL = Symbol();
var $c1c3982e33455b3d$var$nextId = 0;
var $c1c3982e33455b3d$var$proto = Object.getPrototypeOf({});
var $c1c3982e33455b3d$var$ObjectTreeNode = class {
    constructor(value){
        this.value = value;
        $c1c3982e33455b3d$var$__publicField(this, "proxy", new Proxy(this, $c1c3982e33455b3d$var$objectProxyHandler));
        $c1c3982e33455b3d$var$__publicField(this, "tag", $c1c3982e33455b3d$var$createTag());
        $c1c3982e33455b3d$var$__publicField(this, "tags", {});
        $c1c3982e33455b3d$var$__publicField(this, "children", {});
        $c1c3982e33455b3d$var$__publicField(this, "collectionTag", null);
        $c1c3982e33455b3d$var$__publicField(this, "id", $c1c3982e33455b3d$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $c1c3982e33455b3d$var$objectProxyHandler = {
    get (node, key) {
        function calculateResult() {
            const { value: value } = node;
            const childValue = Reflect.get(value, key);
            if (typeof key === "symbol") return childValue;
            if (key in $c1c3982e33455b3d$var$proto) return childValue;
            if (typeof childValue === "object" && childValue !== null) {
                let childNode = node.children[key];
                if (childNode === void 0) childNode = node.children[key] = $c1c3982e33455b3d$var$createNode(childValue);
                if (childNode.tag) $c1c3982e33455b3d$var$getValue(childNode.tag);
                return childNode.proxy;
            } else {
                let tag = node.tags[key];
                if (tag === void 0) {
                    tag = node.tags[key] = $c1c3982e33455b3d$var$createTag();
                    tag.value = childValue;
                }
                $c1c3982e33455b3d$var$getValue(tag);
                return childValue;
            }
        }
        const res = calculateResult();
        return res;
    },
    ownKeys (node) {
        $c1c3982e33455b3d$var$consumeCollection(node);
        return Reflect.ownKeys(node.value);
    },
    getOwnPropertyDescriptor (node, prop) {
        return Reflect.getOwnPropertyDescriptor(node.value, prop);
    },
    has (node, prop) {
        return Reflect.has(node.value, prop);
    }
};
var $c1c3982e33455b3d$var$ArrayTreeNode = class {
    constructor(value){
        this.value = value;
        $c1c3982e33455b3d$var$__publicField(this, "proxy", new Proxy([
            this
        ], $c1c3982e33455b3d$var$arrayProxyHandler));
        $c1c3982e33455b3d$var$__publicField(this, "tag", $c1c3982e33455b3d$var$createTag());
        $c1c3982e33455b3d$var$__publicField(this, "tags", {});
        $c1c3982e33455b3d$var$__publicField(this, "children", {});
        $c1c3982e33455b3d$var$__publicField(this, "collectionTag", null);
        $c1c3982e33455b3d$var$__publicField(this, "id", $c1c3982e33455b3d$var$nextId++);
        this.value = value;
        this.tag.value = value;
    }
};
var $c1c3982e33455b3d$var$arrayProxyHandler = {
    get ([node], key) {
        if (key === "length") $c1c3982e33455b3d$var$consumeCollection(node);
        return $c1c3982e33455b3d$var$objectProxyHandler.get(node, key);
    },
    ownKeys ([node]) {
        return $c1c3982e33455b3d$var$objectProxyHandler.ownKeys(node);
    },
    getOwnPropertyDescriptor ([node], prop) {
        return $c1c3982e33455b3d$var$objectProxyHandler.getOwnPropertyDescriptor(node, prop);
    },
    has ([node], prop) {
        return $c1c3982e33455b3d$var$objectProxyHandler.has(node, prop);
    }
};
function $c1c3982e33455b3d$var$createNode(value) {
    if (Array.isArray(value)) return new $c1c3982e33455b3d$var$ArrayTreeNode(value);
    return new $c1c3982e33455b3d$var$ObjectTreeNode(value);
}
function $c1c3982e33455b3d$var$updateNode(node, newValue) {
    const { value: value, tags: tags, children: children } = node;
    node.value = newValue;
    if (Array.isArray(value) && Array.isArray(newValue) && value.length !== newValue.length) $c1c3982e33455b3d$var$dirtyCollection(node);
    else if (value !== newValue) {
        let oldKeysSize = 0;
        let newKeysSize = 0;
        let anyKeysAdded = false;
        for(const _key in value)oldKeysSize++;
        for(const key in newValue){
            newKeysSize++;
            if (!(key in value)) {
                anyKeysAdded = true;
                break;
            }
        }
        const isDifferent = anyKeysAdded || oldKeysSize !== newKeysSize;
        if (isDifferent) $c1c3982e33455b3d$var$dirtyCollection(node);
    }
    for(const key in tags){
        const childValue = value[key];
        const newChildValue = newValue[key];
        if (childValue !== newChildValue) {
            $c1c3982e33455b3d$var$dirtyCollection(node);
            $c1c3982e33455b3d$var$dirtyTag(tags[key], newChildValue);
        }
        if (typeof newChildValue === "object" && newChildValue !== null) delete tags[key];
    }
    for(const key in children){
        const childNode = children[key];
        const newChildValue = newValue[key];
        const childValue = childNode.value;
        if (childValue === newChildValue) continue;
        else if (typeof newChildValue === "object" && newChildValue !== null) $c1c3982e33455b3d$var$updateNode(childNode, newChildValue);
        else {
            $c1c3982e33455b3d$var$deleteNode(childNode);
            delete children[key];
        }
    }
}
function $c1c3982e33455b3d$var$deleteNode(node) {
    if (node.tag) $c1c3982e33455b3d$var$dirtyTag(node.tag, null);
    $c1c3982e33455b3d$var$dirtyCollection(node);
    for(const key in node.tags)$c1c3982e33455b3d$var$dirtyTag(node.tags[key], null);
    for(const key in node.children)$c1c3982e33455b3d$var$deleteNode(node.children[key]);
}
// src/lruMemoize.ts
function $c1c3982e33455b3d$var$createSingletonCache(equals) {
    let entry;
    return {
        get (key) {
            if (entry && equals(entry.key, key)) return entry.value;
            return $c1c3982e33455b3d$var$NOT_FOUND;
        },
        put (key, value) {
            entry = {
                key: key,
                value: value
            };
        },
        getEntries () {
            return entry ? [
                entry
            ] : [];
        },
        clear () {
            entry = void 0;
        }
    };
}
function $c1c3982e33455b3d$var$createLruCache(maxSize, equals) {
    let entries = [];
    function get(key) {
        const cacheIndex = entries.findIndex((entry)=>equals(key, entry.key));
        if (cacheIndex > -1) {
            const entry = entries[cacheIndex];
            if (cacheIndex > 0) {
                entries.splice(cacheIndex, 1);
                entries.unshift(entry);
            }
            return entry.value;
        }
        return $c1c3982e33455b3d$var$NOT_FOUND;
    }
    function put(key, value) {
        if (get(key) === $c1c3982e33455b3d$var$NOT_FOUND) {
            entries.unshift({
                key: key,
                value: value
            });
            if (entries.length > maxSize) entries.pop();
        }
    }
    function getEntries() {
        return entries;
    }
    function clear() {
        entries = [];
    }
    return {
        get: get,
        put: put,
        getEntries: getEntries,
        clear: clear
    };
}
var $c1c3982e33455b3d$export$3f025202a230c6dd = (a, b)=>a === b;
function $c1c3982e33455b3d$var$createCacheKeyComparator(equalityCheck) {
    return function areArgumentsShallowlyEqual(prev, next) {
        if (prev === null || next === null || prev.length !== next.length) return false;
        const { length: length } = prev;
        for(let i = 0; i < length; i++){
            if (!equalityCheck(prev[i], next[i])) return false;
        }
        return true;
    };
}
function $c1c3982e33455b3d$export$d8ead1d92249919b(func, equalityCheckOrOptions) {
    const providedOptions = typeof equalityCheckOrOptions === "object" ? equalityCheckOrOptions : {
        equalityCheck: equalityCheckOrOptions
    };
    const { equalityCheck: equalityCheck = $c1c3982e33455b3d$export$3f025202a230c6dd, maxSize: maxSize = 1, resultEqualityCheck: resultEqualityCheck } = providedOptions;
    const comparator = $c1c3982e33455b3d$var$createCacheKeyComparator(equalityCheck);
    let resultsCount = 0;
    const cache = maxSize === 1 ? $c1c3982e33455b3d$var$createSingletonCache(comparator) : $c1c3982e33455b3d$var$createLruCache(maxSize, comparator);
    function memoized() {
        let value = cache.get(arguments);
        if (value === $c1c3982e33455b3d$var$NOT_FOUND) {
            value = func.apply(null, arguments);
            resultsCount++;
            if (resultEqualityCheck) {
                const entries = cache.getEntries();
                const matchingEntry = entries.find((entry)=>resultEqualityCheck(entry.value, value));
                if (matchingEntry) {
                    value = matchingEntry.value;
                    resultsCount !== 0 && resultsCount--;
                }
            }
            cache.put(arguments, value);
        }
        return value;
    }
    memoized.clearCache = ()=>{
        cache.clear();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/autotrackMemoize/autotrackMemoize.ts
function $c1c3982e33455b3d$export$c8f9cf88d9fdee55(func) {
    const node = $c1c3982e33455b3d$var$createNode([]);
    let lastArgs = null;
    const shallowEqual = $c1c3982e33455b3d$var$createCacheKeyComparator($c1c3982e33455b3d$export$3f025202a230c6dd);
    const cache = $c1c3982e33455b3d$var$createCache(()=>{
        const res = func.apply(null, node.proxy);
        return res;
    });
    function memoized() {
        if (!shallowEqual(lastArgs, arguments)) {
            $c1c3982e33455b3d$var$updateNode(node, arguments);
            lastArgs = arguments;
        }
        return cache.value;
    }
    memoized.clearCache = ()=>{
        return cache.clear();
    };
    return memoized;
}
// src/weakMapMemoize.ts
var $c1c3982e33455b3d$var$StrongRef = class {
    constructor(value){
        this.value = value;
    }
    deref() {
        return this.value;
    }
};
var $c1c3982e33455b3d$var$Ref = typeof WeakRef !== "undefined" ? WeakRef : $c1c3982e33455b3d$var$StrongRef;
var $c1c3982e33455b3d$var$UNTERMINATED = 0;
var $c1c3982e33455b3d$var$TERMINATED = 1;
function $c1c3982e33455b3d$var$createCacheNode() {
    return {
        s: $c1c3982e33455b3d$var$UNTERMINATED,
        v: void 0,
        o: null,
        p: null
    };
}
function $c1c3982e33455b3d$export$8402dc26d96f6902(func, options = {}) {
    let fnNode = $c1c3982e33455b3d$var$createCacheNode();
    const { resultEqualityCheck: resultEqualityCheck } = options;
    let lastResult;
    let resultsCount = 0;
    function memoized() {
        var _a, _b;
        let cacheNode = fnNode;
        const { length: length } = arguments;
        for(let i = 0, l = length; i < l; i++){
            const arg = arguments[i];
            if (typeof arg === "function" || typeof arg === "object" && arg !== null) {
                let objectCache = cacheNode.o;
                if (objectCache === null) cacheNode.o = objectCache = /* @__PURE__ */ new WeakMap();
                const objectNode = objectCache.get(arg);
                if (objectNode === void 0) {
                    cacheNode = $c1c3982e33455b3d$var$createCacheNode();
                    objectCache.set(arg, cacheNode);
                } else cacheNode = objectNode;
            } else {
                let primitiveCache = cacheNode.p;
                if (primitiveCache === null) cacheNode.p = primitiveCache = /* @__PURE__ */ new Map();
                const primitiveNode = primitiveCache.get(arg);
                if (primitiveNode === void 0) {
                    cacheNode = $c1c3982e33455b3d$var$createCacheNode();
                    primitiveCache.set(arg, cacheNode);
                } else cacheNode = primitiveNode;
            }
        }
        const terminatedNode = cacheNode;
        let result;
        if (cacheNode.s === $c1c3982e33455b3d$var$TERMINATED) result = cacheNode.v;
        else {
            result = func.apply(null, arguments);
            resultsCount++;
        }
        terminatedNode.s = $c1c3982e33455b3d$var$TERMINATED;
        if (resultEqualityCheck) {
            const lastResultValue = (_b = (_a = lastResult == null ? void 0 : lastResult.deref) == null ? void 0 : _a.call(lastResult)) != null ? _b : lastResult;
            if (lastResultValue != null && resultEqualityCheck(lastResultValue, result)) {
                result = lastResultValue;
                resultsCount !== 0 && resultsCount--;
            }
            const needsWeakRef = typeof result === "object" && result !== null || typeof result === "function";
            lastResult = needsWeakRef ? new $c1c3982e33455b3d$var$Ref(result) : result;
        }
        terminatedNode.v = result;
        return result;
    }
    memoized.clearCache = ()=>{
        fnNode = $c1c3982e33455b3d$var$createCacheNode();
        memoized.resetResultsCount();
    };
    memoized.resultsCount = ()=>resultsCount;
    memoized.resetResultsCount = ()=>{
        resultsCount = 0;
    };
    return memoized;
}
// src/createSelectorCreator.ts
function $c1c3982e33455b3d$export$5943f4447f6ef248(memoizeOrOptions, ...memoizeOptionsFromArgs) {
    const createSelectorCreatorOptions = typeof memoizeOrOptions === "function" ? {
        memoize: memoizeOrOptions,
        memoizeOptions: memoizeOptionsFromArgs
    } : memoizeOrOptions;
    const createSelector2 = (...createSelectorArgs)=>{
        let recomputations = 0;
        let dependencyRecomputations = 0;
        let lastResult;
        let directlyPassedOptions = {};
        let resultFunc = createSelectorArgs.pop();
        if (typeof resultFunc === "object") {
            directlyPassedOptions = resultFunc;
            resultFunc = createSelectorArgs.pop();
        }
        $c1c3982e33455b3d$var$assertIsFunction(resultFunc, `createSelector expects an output function after the inputs, but received: [${typeof resultFunc}]`);
        const combinedOptions = $c1c3982e33455b3d$var$__spreadValues($c1c3982e33455b3d$var$__spreadValues({}, createSelectorCreatorOptions), directlyPassedOptions);
        const { memoize: memoize, memoizeOptions: memoizeOptions = [], argsMemoize: argsMemoize = $c1c3982e33455b3d$export$8402dc26d96f6902, argsMemoizeOptions: argsMemoizeOptions = [], devModeChecks: devModeChecks = {} } = combinedOptions;
        const finalMemoizeOptions = $c1c3982e33455b3d$var$ensureIsArray(memoizeOptions);
        const finalArgsMemoizeOptions = $c1c3982e33455b3d$var$ensureIsArray(argsMemoizeOptions);
        const dependencies = $c1c3982e33455b3d$var$getDependencies(createSelectorArgs);
        const memoizedResultFunc = memoize(function recomputationWrapper() {
            recomputations++;
            return resultFunc.apply(null, arguments);
        }, ...finalMemoizeOptions);
        let firstRun = true;
        const selector = argsMemoize(function dependenciesChecker() {
            dependencyRecomputations++;
            const inputSelectorResults = $c1c3982e33455b3d$var$collectInputSelectorResults(dependencies, arguments);
            lastResult = memoizedResultFunc.apply(null, inputSelectorResults);
            return lastResult;
        }, ...finalArgsMemoizeOptions);
        return Object.assign(selector, {
            resultFunc: resultFunc,
            memoizedResultFunc: memoizedResultFunc,
            dependencies: dependencies,
            dependencyRecomputations: ()=>dependencyRecomputations,
            resetDependencyRecomputations: ()=>{
                dependencyRecomputations = 0;
            },
            lastResult: ()=>lastResult,
            recomputations: ()=>recomputations,
            resetRecomputations: ()=>{
                recomputations = 0;
            },
            memoize: memoize,
            argsMemoize: argsMemoize
        });
    };
    Object.assign(createSelector2, {
        withTypes: ()=>createSelector2
    });
    return createSelector2;
}
var $c1c3982e33455b3d$export$595d22ed68ca2841 = /* @__PURE__ */ $c1c3982e33455b3d$export$5943f4447f6ef248($c1c3982e33455b3d$export$8402dc26d96f6902);
// src/createStructuredSelector.ts
var $c1c3982e33455b3d$export$75979cfcd91bf38f = Object.assign((inputSelectorsObject, selectorCreator = $c1c3982e33455b3d$export$595d22ed68ca2841)=>{
    $c1c3982e33455b3d$var$assertIsObject(inputSelectorsObject, `createStructuredSelector expects first argument to be an object where each property is a selector, instead received a ${typeof inputSelectorsObject}`);
    const inputSelectorKeys = Object.keys(inputSelectorsObject);
    const dependencies = inputSelectorKeys.map((key)=>inputSelectorsObject[key]);
    const structuredSelector = selectorCreator(dependencies, (...inputSelectorResults)=>{
        return inputSelectorResults.reduce((composition, value, index)=>{
            composition[inputSelectorKeys[index]] = value;
            return composition;
        }, {});
    });
    return structuredSelector;
}, {
    withTypes: ()=>$c1c3982e33455b3d$export$75979cfcd91bf38f
});


// src/index.ts
function $b7cde1b059870743$var$createThunkMiddleware(extraArgument) {
    const middleware = ({ dispatch: dispatch, getState: getState })=>(next)=>(action)=>{
                if (typeof action === "function") return action(dispatch, getState, extraArgument);
                return next(action);
            };
    return middleware;
}
var $b7cde1b059870743$export$dd164f5517779f15 = $b7cde1b059870743$var$createThunkMiddleware();
var $b7cde1b059870743$export$16d06542a1949d9e = $b7cde1b059870743$var$createThunkMiddleware;


var $879b2beb6cc9bacc$exports = {};
// shim for using process in browser
var $879b2beb6cc9bacc$var$process = $879b2beb6cc9bacc$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $879b2beb6cc9bacc$var$cachedSetTimeout;
var $879b2beb6cc9bacc$var$cachedClearTimeout;
function $879b2beb6cc9bacc$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $879b2beb6cc9bacc$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $879b2beb6cc9bacc$var$cachedSetTimeout = setTimeout;
        else $879b2beb6cc9bacc$var$cachedSetTimeout = $879b2beb6cc9bacc$var$defaultSetTimout;
    } catch (e) {
        $879b2beb6cc9bacc$var$cachedSetTimeout = $879b2beb6cc9bacc$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $879b2beb6cc9bacc$var$cachedClearTimeout = clearTimeout;
        else $879b2beb6cc9bacc$var$cachedClearTimeout = $879b2beb6cc9bacc$var$defaultClearTimeout;
    } catch (e) {
        $879b2beb6cc9bacc$var$cachedClearTimeout = $879b2beb6cc9bacc$var$defaultClearTimeout;
    }
})();
function $879b2beb6cc9bacc$var$runTimeout(fun) {
    if ($879b2beb6cc9bacc$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($879b2beb6cc9bacc$var$cachedSetTimeout === $879b2beb6cc9bacc$var$defaultSetTimout || !$879b2beb6cc9bacc$var$cachedSetTimeout) && setTimeout) {
        $879b2beb6cc9bacc$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $879b2beb6cc9bacc$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $879b2beb6cc9bacc$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $879b2beb6cc9bacc$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $879b2beb6cc9bacc$var$runClearTimeout(marker) {
    if ($879b2beb6cc9bacc$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($879b2beb6cc9bacc$var$cachedClearTimeout === $879b2beb6cc9bacc$var$defaultClearTimeout || !$879b2beb6cc9bacc$var$cachedClearTimeout) && clearTimeout) {
        $879b2beb6cc9bacc$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $879b2beb6cc9bacc$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $879b2beb6cc9bacc$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $879b2beb6cc9bacc$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $879b2beb6cc9bacc$var$queue = [];
var $879b2beb6cc9bacc$var$draining = false;
var $879b2beb6cc9bacc$var$currentQueue;
var $879b2beb6cc9bacc$var$queueIndex = -1;
function $879b2beb6cc9bacc$var$cleanUpNextTick() {
    if (!$879b2beb6cc9bacc$var$draining || !$879b2beb6cc9bacc$var$currentQueue) return;
    $879b2beb6cc9bacc$var$draining = false;
    if ($879b2beb6cc9bacc$var$currentQueue.length) $879b2beb6cc9bacc$var$queue = $879b2beb6cc9bacc$var$currentQueue.concat($879b2beb6cc9bacc$var$queue);
    else $879b2beb6cc9bacc$var$queueIndex = -1;
    if ($879b2beb6cc9bacc$var$queue.length) $879b2beb6cc9bacc$var$drainQueue();
}
function $879b2beb6cc9bacc$var$drainQueue() {
    if ($879b2beb6cc9bacc$var$draining) return;
    var timeout = $879b2beb6cc9bacc$var$runTimeout($879b2beb6cc9bacc$var$cleanUpNextTick);
    $879b2beb6cc9bacc$var$draining = true;
    var len = $879b2beb6cc9bacc$var$queue.length;
    while(len){
        $879b2beb6cc9bacc$var$currentQueue = $879b2beb6cc9bacc$var$queue;
        $879b2beb6cc9bacc$var$queue = [];
        while(++$879b2beb6cc9bacc$var$queueIndex < len)if ($879b2beb6cc9bacc$var$currentQueue) $879b2beb6cc9bacc$var$currentQueue[$879b2beb6cc9bacc$var$queueIndex].run();
        $879b2beb6cc9bacc$var$queueIndex = -1;
        len = $879b2beb6cc9bacc$var$queue.length;
    }
    $879b2beb6cc9bacc$var$currentQueue = null;
    $879b2beb6cc9bacc$var$draining = false;
    $879b2beb6cc9bacc$var$runClearTimeout(timeout);
}
$879b2beb6cc9bacc$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $879b2beb6cc9bacc$var$queue.push(new $879b2beb6cc9bacc$var$Item(fun, args));
    if ($879b2beb6cc9bacc$var$queue.length === 1 && !$879b2beb6cc9bacc$var$draining) $879b2beb6cc9bacc$var$runTimeout($879b2beb6cc9bacc$var$drainQueue);
};
// v8 likes predictible objects
function $879b2beb6cc9bacc$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$879b2beb6cc9bacc$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$879b2beb6cc9bacc$var$process.title = "browser";
$879b2beb6cc9bacc$var$process.browser = true;
$879b2beb6cc9bacc$var$process.env = {};
$879b2beb6cc9bacc$var$process.argv = [];
$879b2beb6cc9bacc$var$process.version = ""; // empty string to avoid regexp issues
$879b2beb6cc9bacc$var$process.versions = {};
function $879b2beb6cc9bacc$var$noop() {}
$879b2beb6cc9bacc$var$process.on = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.addListener = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.once = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.off = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.removeListener = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.removeAllListeners = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.emit = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.prependListener = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.prependOnceListener = $879b2beb6cc9bacc$var$noop;
$879b2beb6cc9bacc$var$process.listeners = function(name) {
    return [];
};
$879b2beb6cc9bacc$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$879b2beb6cc9bacc$var$process.cwd = function() {
    return "/";
};
$879b2beb6cc9bacc$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$879b2beb6cc9bacc$var$process.umask = function() {
    return 0;
};


var $34ed020f7f2c9609$export$aab6de9e3dbb1473 = (...args)=>{
    const createSelector2 = (0, $c1c3982e33455b3d$export$5943f4447f6ef248)(...args);
    const createDraftSafeSelector2 = Object.assign((...args2)=>{
        const selector = createSelector2(...args2);
        const wrappedSelector = (value, ...rest)=>selector((0, $af646dc9ee6cb2b8$export$541ac630993a4c84)(value) ? (0, $af646dc9ee6cb2b8$export$97aac956da55dae9)(value) : value, ...rest);
        Object.assign(wrappedSelector, selector);
        return wrappedSelector;
    }, {
        withTypes: ()=>createDraftSafeSelector2
    });
    return createDraftSafeSelector2;
};
var $34ed020f7f2c9609$export$a5d3c27355e35910 = $34ed020f7f2c9609$export$aab6de9e3dbb1473((0, $c1c3982e33455b3d$export$8402dc26d96f6902));
var $34ed020f7f2c9609$var$composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
    if (arguments.length === 0) return void 0;
    if (typeof arguments[0] === "object") return 0, $bbc75262727a27e1$export$f672e0b6f7222cd7;
    return (0, $bbc75262727a27e1$export$f672e0b6f7222cd7).apply(null, arguments);
};
var $34ed020f7f2c9609$var$devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function() {
    return function(noop3) {
        return noop3;
    };
};
// src/tsHelpers.ts
var $34ed020f7f2c9609$var$hasMatchFunction = (v)=>{
    return v && typeof v.match === "function";
};
// src/createAction.ts
function $34ed020f7f2c9609$export$309c7a02b0b0bc62(type, prepareAction) {
    function actionCreator(...args) {
        if (prepareAction) {
            let prepared = prepareAction(...args);
            if (!prepared) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(0));
            return {
                type: type,
                payload: prepared.payload,
                ..."meta" in prepared && {
                    meta: prepared.meta
                },
                ..."error" in prepared && {
                    error: prepared.error
                }
            };
        }
        return {
            type: type,
            payload: args[0]
        };
    }
    actionCreator.toString = ()=>`${type}`;
    actionCreator.type = type;
    actionCreator.match = (action)=>(0, $bbc75262727a27e1$export$b956e38827fca970)(action) && action.type === type;
    return actionCreator;
}
function $34ed020f7f2c9609$export$4e5cad2c7f795b8f(action) {
    return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
    $34ed020f7f2c9609$var$hasMatchFunction(action);
}
function $34ed020f7f2c9609$export$ebd532f9034651f3(action) {
    return (0, $bbc75262727a27e1$export$b956e38827fca970)(action) && Object.keys(action).every($34ed020f7f2c9609$var$isValidKey);
}
function $34ed020f7f2c9609$var$isValidKey(key) {
    return [
        "type",
        "payload",
        "error",
        "meta"
    ].indexOf(key) > -1;
}
// src/actionCreatorInvariantMiddleware.ts
function $34ed020f7f2c9609$var$getMessage(type) {
    const splitType = type ? `${type}`.split("/") : [];
    const actionName = splitType[splitType.length - 1] || "actionCreator";
    return `Detected an action creator with type "${type || "unknown"}" being dispatched. 
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function $34ed020f7f2c9609$export$6a1fcb4ceef578f(options = {}) {
    var next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $34ed020f7f2c9609$var$getTimeMeasureUtils(maxDelay, fnName) {
    let elapsed = 0;
    return {
        measureTime (fn) {
            const started = Date.now();
            try {
                return fn();
            } finally{
                const finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded () {
            if (elapsed > maxDelay) console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
        }
    };
}
function $34ed020f7f2c9609$var$find(iterable, comparator) {
    for (const entry of iterable){
        if (comparator(entry)) return entry;
    }
    return void 0;
}
var $34ed020f7f2c9609$export$1908877435b1d5e9 = class _Tuple extends Array {
    constructor(...items){
        super(...items);
        Object.setPrototypeOf(this, _Tuple.prototype);
    }
    static get [Symbol.species]() {
        return _Tuple;
    }
    concat(...arr) {
        return super.concat.apply(this, arr);
    }
    prepend(...arr) {
        if (arr.length === 1 && Array.isArray(arr[0])) return new _Tuple(...arr[0].concat(this));
        return new _Tuple(...arr.concat(this));
    }
};
function $34ed020f7f2c9609$var$freezeDraftable(val) {
    return (0, $af646dc9ee6cb2b8$export$16e3aed3edb85946)(val) ? (0, $af646dc9ee6cb2b8$export$b46cabe22e78bc00)(val, ()=>{}) : val;
}
function $34ed020f7f2c9609$var$emplace(map, key, handler) {
    if (map.has(key)) {
        let value = map.get(key);
        if (handler.update) {
            value = handler.update(value, key, map);
            map.set(key, value);
        }
        return value;
    }
    if (!handler.insert) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(10));
    const inserted = handler.insert(key, map);
    map.set(key, inserted);
    return inserted;
}
// src/immutableStateInvariantMiddleware.ts
function $34ed020f7f2c9609$export$9021b2733a0028a3(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function $34ed020f7f2c9609$var$trackForMutations(isImmutable, ignorePaths, obj) {
    const trackedProperties = $34ed020f7f2c9609$var$trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations () {
            return $34ed020f7f2c9609$var$detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function $34ed020f7f2c9609$var$trackProperties(isImmutable, ignorePaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
    const tracked = {
        value: obj
    };
    if (!isImmutable(obj) && !checkedObjects.has(obj)) {
        checkedObjects.add(obj);
        tracked.children = {};
        for(const key in obj){
            const childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) continue;
            tracked.children[key] = $34ed020f7f2c9609$var$trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function $34ed020f7f2c9609$var$detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
    const prevObj = trackedProperty ? trackedProperty.value : void 0;
    const sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) return {
        wasMutated: true,
        path: path
    };
    if (isImmutable(prevObj) || isImmutable(obj)) return {
        wasMutated: false
    };
    const keysToDetect = {};
    for(let key in trackedProperty.children)keysToDetect[key] = true;
    for(let key in obj)keysToDetect[key] = true;
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for(let key in keysToDetect){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        const result = $34ed020f7f2c9609$var$detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
        if (result.wasMutated) return result;
    }
    return {
        wasMutated: false
    };
}
function $34ed020f7f2c9609$export$9181bb1a5474289(options = {}) {
    var stringify, getSerialize, getState, next, action;
    return ()=>(next)=>(action)=>next(action);
}
function $34ed020f7f2c9609$export$77670485918dab4e(val) {
    const type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || (0, $bbc75262727a27e1$export$53b83ca8eaab0383)(val);
}
function $34ed020f7f2c9609$export$ada5dca0b571bc7(value, path = "", isSerializable = $34ed020f7f2c9609$export$77670485918dab4e, getEntries, ignoredPaths = [], cache) {
    let foundNestedSerializable;
    if (!isSerializable(value)) return {
        keyPath: path || "<root>",
        value: value
    };
    if (typeof value !== "object" || value === null) return false;
    if (cache?.has(value)) return false;
    const entries = getEntries != null ? getEntries(value) : Object.entries(value);
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const [key, nestedValue] of entries){
        const nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths) {
            const hasMatches = ignoredPaths.some((ignored)=>{
                if (ignored instanceof RegExp) return ignored.test(nestedPath);
                return nestedPath === ignored;
            });
            if (hasMatches) continue;
        }
        if (!isSerializable(nestedValue)) return {
            keyPath: nestedPath,
            value: nestedValue
        };
        if (typeof nestedValue === "object") {
            foundNestedSerializable = $34ed020f7f2c9609$export$ada5dca0b571bc7(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
            if (foundNestedSerializable) return foundNestedSerializable;
        }
    }
    if (cache && $34ed020f7f2c9609$var$isNestedFrozen(value)) cache.add(value);
    return false;
}
function $34ed020f7f2c9609$var$isNestedFrozen(value) {
    if (!Object.isFrozen(value)) return false;
    for (const nestedValue of Object.values(value)){
        if (typeof nestedValue !== "object" || nestedValue === null) continue;
        if (!$34ed020f7f2c9609$var$isNestedFrozen(nestedValue)) return false;
    }
    return true;
}
function $34ed020f7f2c9609$export$6dea1aad6dac5ac2(options = {}) {
    var storeAPI, next, action;
    return ()=>(next)=>(action)=>next(action);
}
// src/getDefaultMiddleware.ts
function $34ed020f7f2c9609$var$isBoolean(x) {
    return typeof x === "boolean";
}
var $34ed020f7f2c9609$var$buildGetDefaultMiddleware = ()=>function getDefaultMiddleware(options) {
        const { thunk: thunk = true, immutableCheck: immutableCheck = true, serializableCheck: serializableCheck = true, actionCreatorCheck: actionCreatorCheck = true } = options ?? {};
        let middlewareArray = new $34ed020f7f2c9609$export$1908877435b1d5e9();
        if (thunk) {
            if ($34ed020f7f2c9609$var$isBoolean(thunk)) middlewareArray.push((0, $b7cde1b059870743$export$dd164f5517779f15));
            else middlewareArray.push((0, $b7cde1b059870743$export$16d06542a1949d9e)(thunk.extraArgument));
        }
        return middlewareArray;
    };
// src/autoBatchEnhancer.ts
var $34ed020f7f2c9609$export$8fb31c0f05df007b = "RTK_autoBatch";
var $34ed020f7f2c9609$export$39fcd5145ec5e4e2 = ()=>(payload)=>({
            payload: payload,
            meta: {
                [$34ed020f7f2c9609$export$8fb31c0f05df007b]: true
            }
        });
var $34ed020f7f2c9609$var$createQueueWithTimer = (timeout)=>{
    return (notify)=>{
        setTimeout(notify, timeout);
    };
};
var $34ed020f7f2c9609$var$rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : $34ed020f7f2c9609$var$createQueueWithTimer(10);
var $34ed020f7f2c9609$export$676277d7dca0f396 = (options = {
    type: "raf"
})=>(next)=>(...args)=>{
            const store = next(...args);
            let notifying = true;
            let shouldNotifyAtEndOfTick = false;
            let notificationQueued = false;
            const listeners = /* @__PURE__ */ new Set();
            const queueCallback = options.type === "tick" ? queueMicrotask : options.type === "raf" ? $34ed020f7f2c9609$var$rAF : options.type === "callback" ? options.queueNotification : $34ed020f7f2c9609$var$createQueueWithTimer(options.timeout);
            const notifyListeners = ()=>{
                notificationQueued = false;
                if (shouldNotifyAtEndOfTick) {
                    shouldNotifyAtEndOfTick = false;
                    listeners.forEach((l)=>l());
                }
            };
            return Object.assign({}, store, {
                // Override the base `store.subscribe` method to keep original listeners
                // from running if we're delaying notifications
                subscribe (listener2) {
                    const wrappedListener = ()=>notifying && listener2();
                    const unsubscribe = store.subscribe(wrappedListener);
                    listeners.add(listener2);
                    return ()=>{
                        unsubscribe();
                        listeners.delete(listener2);
                    };
                },
                // Override the base `store.dispatch` method so that we can check actions
                // for the `shouldAutoBatch` flag and determine if batching is active
                dispatch (action) {
                    try {
                        notifying = !action?.meta?.[$34ed020f7f2c9609$export$8fb31c0f05df007b];
                        shouldNotifyAtEndOfTick = !notifying;
                        if (shouldNotifyAtEndOfTick) {
                            if (!notificationQueued) {
                                notificationQueued = true;
                                queueCallback(notifyListeners);
                            }
                        }
                        return store.dispatch(action);
                    } finally{
                        notifying = true;
                    }
                }
            });
        };
// src/getDefaultEnhancers.ts
var $34ed020f7f2c9609$var$buildGetDefaultEnhancers = (middlewareEnhancer)=>function getDefaultEnhancers(options) {
        const { autoBatch: autoBatch = true } = options ?? {};
        let enhancerArray = new $34ed020f7f2c9609$export$1908877435b1d5e9(middlewareEnhancer);
        if (autoBatch) enhancerArray.push($34ed020f7f2c9609$export$676277d7dca0f396(typeof autoBatch === "object" ? autoBatch : void 0));
        return enhancerArray;
    };
// src/configureStore.ts
var $34ed020f7f2c9609$var$IS_PRODUCTION = true;
function $34ed020f7f2c9609$export$7d8a5b498da695ac(options) {
    const getDefaultMiddleware = $34ed020f7f2c9609$var$buildGetDefaultMiddleware();
    const { reducer: reducer, middleware: middleware, devTools: devTools = true, preloadedState: preloadedState, enhancers: enhancers } = options || {};
    let rootReducer;
    if (typeof reducer === "function") rootReducer = reducer;
    else if ((0, $bbc75262727a27e1$export$53b83ca8eaab0383)(reducer)) rootReducer = (0, $bbc75262727a27e1$export$66e4520cdb265d18)(reducer);
    else throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(1));
    if (!$34ed020f7f2c9609$var$IS_PRODUCTION && middleware && typeof middleware !== "function") throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(2));
    let finalMiddleware;
    if (typeof middleware === "function") {
        finalMiddleware = middleware(getDefaultMiddleware);
        if (!$34ed020f7f2c9609$var$IS_PRODUCTION && !Array.isArray(finalMiddleware)) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(3));
    } else finalMiddleware = getDefaultMiddleware();
    if (!$34ed020f7f2c9609$var$IS_PRODUCTION && finalMiddleware.some((item)=>typeof item !== "function")) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(4));
    let finalCompose = (0, $bbc75262727a27e1$export$f672e0b6f7222cd7);
    if (devTools) finalCompose = $34ed020f7f2c9609$var$composeWithDevTools({
        // Enable capture of stack traces for dispatched Redux actions
        trace: !$34ed020f7f2c9609$var$IS_PRODUCTION,
        ...typeof devTools === "object" && devTools
    });
    const middlewareEnhancer = (0, $bbc75262727a27e1$export$9ff26e0402cc7b7)(...finalMiddleware);
    const getDefaultEnhancers = $34ed020f7f2c9609$var$buildGetDefaultEnhancers(middlewareEnhancer);
    if (!$34ed020f7f2c9609$var$IS_PRODUCTION && enhancers && typeof enhancers !== "function") throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(5));
    let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
    if (!$34ed020f7f2c9609$var$IS_PRODUCTION && !Array.isArray(storeEnhancers)) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(6));
    if (!$34ed020f7f2c9609$var$IS_PRODUCTION && storeEnhancers.some((item)=>typeof item !== "function")) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(7));
    if (!$34ed020f7f2c9609$var$IS_PRODUCTION && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
    const composedEnhancer = finalCompose(...storeEnhancers);
    return (0, $bbc75262727a27e1$export$f51a9068ac82ea43)(rootReducer, preloadedState, composedEnhancer);
}
// src/mapBuilders.ts
function $34ed020f7f2c9609$var$executeReducerBuilderCallback(builderCallback) {
    const actionsMap = {};
    const actionMatchers = [];
    let defaultCaseReducer;
    const builder = {
        addCase (typeOrActionCreator, reducer) {
            const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (!type) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(28));
            if (type in actionsMap) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(29));
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher (matcher, reducer) {
            actionMatchers.push({
                matcher: matcher,
                reducer: reducer
            });
            return builder;
        },
        addDefaultCase (reducer) {
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [
        actionsMap,
        actionMatchers,
        defaultCaseReducer
    ];
}
// src/createReducer.ts
function $34ed020f7f2c9609$var$isStateFunction(x) {
    return typeof x === "function";
}
function $34ed020f7f2c9609$export$473eb76d322d0290(initialState, mapOrBuilderCallback) {
    let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = $34ed020f7f2c9609$var$executeReducerBuilderCallback(mapOrBuilderCallback);
    let getInitialState;
    if ($34ed020f7f2c9609$var$isStateFunction(initialState)) getInitialState = ()=>$34ed020f7f2c9609$var$freezeDraftable(initialState());
    else {
        const frozenInitialState = $34ed020f7f2c9609$var$freezeDraftable(initialState);
        getInitialState = ()=>frozenInitialState;
    }
    function reducer(state = getInitialState(), action) {
        let caseReducers = [
            actionsMap[action.type],
            ...finalActionMatchers.filter(({ matcher: matcher })=>matcher(action)).map(({ reducer: reducer2 })=>reducer2)
        ];
        if (caseReducers.filter((cr)=>!!cr).length === 0) caseReducers = [
            finalDefaultCaseReducer
        ];
        return caseReducers.reduce((previousState, caseReducer)=>{
            if (caseReducer) {
                if ((0, $af646dc9ee6cb2b8$export$541ac630993a4c84)(previousState)) {
                    const draft = previousState;
                    const result = caseReducer(draft, action);
                    if (result === void 0) return previousState;
                    return result;
                } else if (!(0, $af646dc9ee6cb2b8$export$16e3aed3edb85946)(previousState)) {
                    const result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) return previousState;
                        throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(9));
                    }
                    return result;
                } else return (0, $af646dc9ee6cb2b8$export$b46cabe22e78bc00)(previousState, (draft)=>{
                    return caseReducer(draft, action);
                });
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/nanoid.ts
var $34ed020f7f2c9609$var$urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var $34ed020f7f2c9609$export$ac4959f4f1338dfc = (size = 21)=>{
    let id = "";
    let i = size;
    while(i--)id += $34ed020f7f2c9609$var$urlAlphabet[Math.random() * 64 | 0];
    return id;
};
// src/matchers.ts
var $34ed020f7f2c9609$var$matches = (matcher, action)=>{
    if ($34ed020f7f2c9609$var$hasMatchFunction(matcher)) return matcher.match(action);
    else return matcher(action);
};
function $34ed020f7f2c9609$export$2c3435c7647f7b0d(...matchers) {
    return (action)=>{
        return matchers.some((matcher)=>$34ed020f7f2c9609$var$matches(matcher, action));
    };
}
function $34ed020f7f2c9609$export$9dd1fb32974da385(...matchers) {
    return (action)=>{
        return matchers.every((matcher)=>$34ed020f7f2c9609$var$matches(matcher, action));
    };
}
function $34ed020f7f2c9609$var$hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta) return false;
    const hasValidRequestId = typeof action.meta.requestId === "string";
    const hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function $34ed020f7f2c9609$var$isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function $34ed020f7f2c9609$export$872dec21e9a69476(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$34ed020f7f2c9609$var$hasExpectedRequestMetadata(action, [
            "pending"
        ]);
    if (!$34ed020f7f2c9609$var$isAsyncThunkArray(asyncThunks)) return $34ed020f7f2c9609$export$872dec21e9a69476()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.pending);
        const combinedMatcher = $34ed020f7f2c9609$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $34ed020f7f2c9609$export$a5c5d27e3994c5be(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$34ed020f7f2c9609$var$hasExpectedRequestMetadata(action, [
            "rejected"
        ]);
    if (!$34ed020f7f2c9609$var$isAsyncThunkArray(asyncThunks)) return $34ed020f7f2c9609$export$a5c5d27e3994c5be()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.rejected);
        const combinedMatcher = $34ed020f7f2c9609$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $34ed020f7f2c9609$export$fcc3388fb56de601(...asyncThunks) {
    const hasFlag = (action)=>{
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) return (action)=>{
        const combinedMatcher = $34ed020f7f2c9609$export$9dd1fb32974da385($34ed020f7f2c9609$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
    if (!$34ed020f7f2c9609$var$isAsyncThunkArray(asyncThunks)) return $34ed020f7f2c9609$export$fcc3388fb56de601()(asyncThunks[0]);
    return (action)=>{
        const combinedMatcher = $34ed020f7f2c9609$export$9dd1fb32974da385($34ed020f7f2c9609$export$a5c5d27e3994c5be(...asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function $34ed020f7f2c9609$export$1da80a6ef1307441(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$34ed020f7f2c9609$var$hasExpectedRequestMetadata(action, [
            "fulfilled"
        ]);
    if (!$34ed020f7f2c9609$var$isAsyncThunkArray(asyncThunks)) return $34ed020f7f2c9609$export$1da80a6ef1307441()(asyncThunks[0]);
    return (action)=>{
        const matchers = asyncThunks.map((asyncThunk)=>asyncThunk.fulfilled);
        const combinedMatcher = $34ed020f7f2c9609$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
function $34ed020f7f2c9609$export$6aa4142d99c1abce(...asyncThunks) {
    if (asyncThunks.length === 0) return (action)=>$34ed020f7f2c9609$var$hasExpectedRequestMetadata(action, [
            "pending",
            "fulfilled",
            "rejected"
        ]);
    if (!$34ed020f7f2c9609$var$isAsyncThunkArray(asyncThunks)) return $34ed020f7f2c9609$export$6aa4142d99c1abce()(asyncThunks[0]);
    return (action)=>{
        const matchers = [];
        for (const asyncThunk of asyncThunks)matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        const combinedMatcher = $34ed020f7f2c9609$export$2c3435c7647f7b0d(...matchers);
        return combinedMatcher(action);
    };
}
// src/createAsyncThunk.ts
var $34ed020f7f2c9609$var$commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var $34ed020f7f2c9609$var$RejectWithValue = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $34ed020f7f2c9609$var$FulfillWithMeta = class {
    constructor(payload, meta){
        this.payload = payload;
        this.meta = meta;
    }
    /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */ _type;
};
var $34ed020f7f2c9609$export$c97c53d0b2d5d81e = (value)=>{
    if (typeof value === "object" && value !== null) {
        const simpleError = {};
        for (const property of $34ed020f7f2c9609$var$commonProperties)if (typeof value[property] === "string") simpleError[property] = value[property];
        return simpleError;
    }
    return {
        message: String(value)
    };
};
var $34ed020f7f2c9609$export$6abd22dc03e5063f = /* @__PURE__ */ (()=>{
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        const fulfilled = $34ed020f7f2c9609$export$309c7a02b0b0bc62(typePrefix + "/fulfilled", (payload, requestId, arg, meta)=>({
                payload: payload,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "fulfilled"
                }
            }));
        const pending = $34ed020f7f2c9609$export$309c7a02b0b0bc62(typePrefix + "/pending", (requestId, arg, meta)=>({
                payload: void 0,
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    requestStatus: "pending"
                }
            }));
        const rejected = $34ed020f7f2c9609$export$309c7a02b0b0bc62(typePrefix + "/rejected", (error, requestId, arg, payload, meta)=>({
                payload: payload,
                error: (options && options.serializeError || $34ed020f7f2c9609$export$c97c53d0b2d5d81e)(error || "Rejected"),
                meta: {
                    ...meta || {},
                    arg: arg,
                    requestId: requestId,
                    rejectedWithValue: !!payload,
                    requestStatus: "rejected",
                    aborted: error?.name === "AbortError",
                    condition: error?.name === "ConditionError"
                }
            }));
        function actionCreator(arg) {
            return (dispatch, getState, extra)=>{
                const requestId = options?.idGenerator ? options.idGenerator(arg) : $34ed020f7f2c9609$export$ac4959f4f1338dfc();
                const abortController = new AbortController();
                let abortHandler;
                let abortReason;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                const promise = async function() {
                    let finalAction;
                    try {
                        let conditionResult = options?.condition?.(arg, {
                            getState: getState,
                            extra: extra
                        });
                        if ($34ed020f7f2c9609$var$isThenable(conditionResult)) conditionResult = await conditionResult;
                        if (conditionResult === false || abortController.signal.aborted) throw {
                            name: "ConditionError",
                            message: "Aborted due to condition callback returning false."
                        };
                        const abortedPromise = new Promise((_, reject)=>{
                            abortHandler = ()=>{
                                reject({
                                    name: "AbortError",
                                    message: abortReason || "Aborted"
                                });
                            };
                            abortController.signal.addEventListener("abort", abortHandler);
                        });
                        dispatch(pending(requestId, arg, options?.getPendingMeta?.({
                            requestId: requestId,
                            arg: arg
                        }, {
                            getState: getState,
                            extra: extra
                        })));
                        finalAction = await Promise.race([
                            abortedPromise,
                            Promise.resolve(payloadCreator(arg, {
                                dispatch: dispatch,
                                getState: getState,
                                extra: extra,
                                requestId: requestId,
                                signal: abortController.signal,
                                abort: abort,
                                rejectWithValue: (value, meta)=>{
                                    return new $34ed020f7f2c9609$var$RejectWithValue(value, meta);
                                },
                                fulfillWithValue: (value, meta)=>{
                                    return new $34ed020f7f2c9609$var$FulfillWithMeta(value, meta);
                                }
                            })).then((result)=>{
                                if (result instanceof $34ed020f7f2c9609$var$RejectWithValue) throw result;
                                if (result instanceof $34ed020f7f2c9609$var$FulfillWithMeta) return fulfilled(result.payload, requestId, arg, result.meta);
                                return fulfilled(result, requestId, arg);
                            })
                        ]);
                    } catch (err) {
                        finalAction = err instanceof $34ed020f7f2c9609$var$RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
                    } finally{
                        if (abortHandler) abortController.signal.removeEventListener("abort", abortHandler);
                    }
                    const skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                    if (!skipDispatch) dispatch(finalAction);
                    return finalAction;
                }();
                return Object.assign(promise, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap () {
                        return promise.then($34ed020f7f2c9609$export$5b28227b4c5dc983);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            settled: $34ed020f7f2c9609$export$2c3435c7647f7b0d(rejected, fulfilled),
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = ()=>createAsyncThunk2;
    return createAsyncThunk2;
})();
function $34ed020f7f2c9609$export$5b28227b4c5dc983(action) {
    if (action.meta && action.meta.rejectedWithValue) throw action.payload;
    if (action.error) throw action.error;
    return action.payload;
}
function $34ed020f7f2c9609$var$isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/createSlice.ts
var $34ed020f7f2c9609$var$asyncThunkSymbol = Symbol.for("rtk-slice-createasyncthunk");
var $34ed020f7f2c9609$export$343355ed40c51c46 = {
    [$34ed020f7f2c9609$var$asyncThunkSymbol]: $34ed020f7f2c9609$export$6abd22dc03e5063f
};
var $34ed020f7f2c9609$export$23a094319a4b586 = /* @__PURE__ */ ((ReducerType2)=>{
    ReducerType2["reducer"] = "reducer";
    ReducerType2["reducerWithPrepare"] = "reducerWithPrepare";
    ReducerType2["asyncThunk"] = "asyncThunk";
    return ReducerType2;
})($34ed020f7f2c9609$export$23a094319a4b586 || {});
function $34ed020f7f2c9609$var$getType(slice, actionKey) {
    return `${slice}/${actionKey}`;
}
function $34ed020f7f2c9609$export$affdea4146de9cf5({ creators: creators } = {}) {
    const cAT = creators?.asyncThunk?.[$34ed020f7f2c9609$var$asyncThunkSymbol];
    return function createSlice2(options) {
        const { name: name, reducerPath: reducerPath = name } = options;
        if (!name) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(11));
        typeof $879b2beb6cc9bacc$exports;
        const reducers = (typeof options.reducers === "function" ? options.reducers($34ed020f7f2c9609$var$buildReducerCreators()) : options.reducers) || {};
        const reducerNames = Object.keys(reducers);
        const context = {
            sliceCaseReducersByName: {},
            sliceCaseReducersByType: {},
            actionCreators: {},
            sliceMatchers: []
        };
        const contextMethods = {
            addCase (typeOrActionCreator, reducer2) {
                const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
                if (!type) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(12));
                if (type in context.sliceCaseReducersByType) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(13));
                context.sliceCaseReducersByType[type] = reducer2;
                return contextMethods;
            },
            addMatcher (matcher, reducer2) {
                context.sliceMatchers.push({
                    matcher: matcher,
                    reducer: reducer2
                });
                return contextMethods;
            },
            exposeAction (name2, actionCreator) {
                context.actionCreators[name2] = actionCreator;
                return contextMethods;
            },
            exposeCaseReducer (name2, reducer2) {
                context.sliceCaseReducersByName[name2] = reducer2;
                return contextMethods;
            }
        };
        reducerNames.forEach((reducerName)=>{
            const reducerDefinition = reducers[reducerName];
            const reducerDetails = {
                reducerName: reducerName,
                type: $34ed020f7f2c9609$var$getType(name, reducerName),
                createNotation: typeof options.reducers === "function"
            };
            if ($34ed020f7f2c9609$var$isAsyncThunkSliceReducerDefinition(reducerDefinition)) $34ed020f7f2c9609$var$handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
            else $34ed020f7f2c9609$var$handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
        });
        function buildReducer() {
            const [extraReducers = {}, actionMatchers = [], defaultCaseReducer] = typeof options.extraReducers === "function" ? $34ed020f7f2c9609$var$executeReducerBuilderCallback(options.extraReducers) : [
                options.extraReducers
            ];
            const finalCaseReducers = {
                ...extraReducers,
                ...context.sliceCaseReducersByType
            };
            return $34ed020f7f2c9609$export$473eb76d322d0290(options.initialState, (builder)=>{
                for(let key in finalCaseReducers)builder.addCase(key, finalCaseReducers[key]);
                for (let sM of context.sliceMatchers)builder.addMatcher(sM.matcher, sM.reducer);
                for (let m of actionMatchers)builder.addMatcher(m.matcher, m.reducer);
                if (defaultCaseReducer) builder.addDefaultCase(defaultCaseReducer);
            });
        }
        const selectSelf = (state)=>state;
        const injectedSelectorCache = /* @__PURE__ */ new Map();
        let _reducer;
        function reducer(state, action) {
            if (!_reducer) _reducer = buildReducer();
            return _reducer(state, action);
        }
        function getInitialState() {
            if (!_reducer) _reducer = buildReducer();
            return _reducer.getInitialState();
        }
        function makeSelectorProps(reducerPath2, injected = false) {
            function selectSlice(state) {
                let sliceState = state[reducerPath2];
                if (typeof sliceState === "undefined") {
                    if (injected) sliceState = getInitialState();
                }
                return sliceState;
            }
            function getSelectors(selectState = selectSelf) {
                const selectorCache = $34ed020f7f2c9609$var$emplace(injectedSelectorCache, injected, {
                    insert: ()=>/* @__PURE__ */ new WeakMap()
                });
                return $34ed020f7f2c9609$var$emplace(selectorCache, selectState, {
                    insert: ()=>{
                        const map = {};
                        for (const [name2, selector] of Object.entries(options.selectors ?? {}))map[name2] = $34ed020f7f2c9609$var$wrapSelector(selector, selectState, getInitialState, injected);
                        return map;
                    }
                });
            }
            return {
                reducerPath: reducerPath2,
                getSelectors: getSelectors,
                get selectors () {
                    return getSelectors(selectSlice);
                },
                selectSlice: selectSlice
            };
        }
        const slice = {
            name: name,
            reducer: reducer,
            actions: context.actionCreators,
            caseReducers: context.sliceCaseReducersByName,
            getInitialState: getInitialState,
            ...makeSelectorProps(reducerPath),
            injectInto (injectable, { reducerPath: pathOpt, ...config } = {}) {
                const newReducerPath = pathOpt ?? reducerPath;
                injectable.inject({
                    reducerPath: newReducerPath,
                    reducer: reducer
                }, config);
                return {
                    ...slice,
                    ...makeSelectorProps(newReducerPath, true)
                };
            }
        };
        return slice;
    };
}
function $34ed020f7f2c9609$var$wrapSelector(selector, selectState, getInitialState, injected) {
    function wrapper(rootState, ...args) {
        let sliceState = selectState(rootState);
        if (typeof sliceState === "undefined") {
            if (injected) sliceState = getInitialState();
        }
        return selector(sliceState, ...args);
    }
    wrapper.unwrapped = selector;
    return wrapper;
}
var $34ed020f7f2c9609$export$4d8d9bd83c24ae8b = $34ed020f7f2c9609$export$affdea4146de9cf5();
function $34ed020f7f2c9609$var$buildReducerCreators() {
    function asyncThunk(payloadCreator, config) {
        return {
            _reducerDefinitionType: "asyncThunk" /* asyncThunk */ ,
            payloadCreator: payloadCreator,
            ...config
        };
    }
    asyncThunk.withTypes = ()=>asyncThunk;
    return {
        reducer (caseReducer) {
            return Object.assign({
                // hack so the wrapping function has the same name as the original
                // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
                [caseReducer.name] (...args) {
                    return caseReducer(...args);
                }
            }[caseReducer.name], {
                _reducerDefinitionType: "reducer" /* reducer */ 
            });
        },
        preparedReducer (prepare, reducer) {
            return {
                _reducerDefinitionType: "reducerWithPrepare" /* reducerWithPrepare */ ,
                prepare: prepare,
                reducer: reducer
            };
        },
        asyncThunk: asyncThunk
    };
}
function $34ed020f7f2c9609$var$handleNormalReducerDefinition({ type: type, reducerName: reducerName, createNotation: createNotation }, maybeReducerWithPrepare, context) {
    let caseReducer;
    let prepareCallback;
    if ("reducer" in maybeReducerWithPrepare) {
        if (createNotation && !$34ed020f7f2c9609$var$isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(17));
        caseReducer = maybeReducerWithPrepare.reducer;
        prepareCallback = maybeReducerWithPrepare.prepare;
    } else caseReducer = maybeReducerWithPrepare;
    context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? $34ed020f7f2c9609$export$309c7a02b0b0bc62(type, prepareCallback) : $34ed020f7f2c9609$export$309c7a02b0b0bc62(type));
}
function $34ed020f7f2c9609$var$isAsyncThunkSliceReducerDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "asyncThunk" /* asyncThunk */ ;
}
function $34ed020f7f2c9609$var$isCaseReducerWithPrepareDefinition(reducerDefinition) {
    return reducerDefinition._reducerDefinitionType === "reducerWithPrepare" /* reducerWithPrepare */ ;
}
function $34ed020f7f2c9609$var$handleThunkCaseReducerDefinition({ type: type, reducerName: reducerName }, reducerDefinition, context, cAT) {
    if (!cAT) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(18));
    const { payloadCreator: payloadCreator, fulfilled: fulfilled, pending: pending, rejected: rejected, settled: settled, options: options } = reducerDefinition;
    const thunk = cAT(type, payloadCreator, options);
    context.exposeAction(reducerName, thunk);
    if (fulfilled) context.addCase(thunk.fulfilled, fulfilled);
    if (pending) context.addCase(thunk.pending, pending);
    if (rejected) context.addCase(thunk.rejected, rejected);
    if (settled) context.addMatcher(thunk.settled, settled);
    context.exposeCaseReducer(reducerName, {
        fulfilled: fulfilled || $34ed020f7f2c9609$var$noop,
        pending: pending || $34ed020f7f2c9609$var$noop,
        rejected: rejected || $34ed020f7f2c9609$var$noop,
        settled: settled || $34ed020f7f2c9609$var$noop
    });
}
function $34ed020f7f2c9609$var$noop() {}
// src/entities/entity_state.ts
function $34ed020f7f2c9609$var$getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function $34ed020f7f2c9609$var$createInitialStateFactory() {
    function getInitialState(additionalState = {}) {
        return Object.assign($34ed020f7f2c9609$var$getInitialEntityState(), additionalState);
    }
    return {
        getInitialState: getInitialState
    };
}
// src/entities/state_selectors.ts
function $34ed020f7f2c9609$var$createSelectorsFactory() {
    function getSelectors(selectState, options = {}) {
        const { createSelector: createSelector2 = $34ed020f7f2c9609$export$a5d3c27355e35910 } = options;
        const selectIds = (state)=>state.ids;
        const selectEntities = (state)=>state.entities;
        const selectAll = createSelector2(selectIds, selectEntities, (ids, entities)=>ids.map((id)=>entities[id]));
        const selectId = (_, id)=>id;
        const selectById = (entities, id)=>entities[id];
        const selectTotal = createSelector2(selectIds, (ids)=>ids.length);
        if (!selectState) return {
            selectIds: selectIds,
            selectEntities: selectEntities,
            selectAll: selectAll,
            selectTotal: selectTotal,
            selectById: createSelector2(selectEntities, selectId, selectById)
        };
        const selectGlobalizedEntities = createSelector2(selectState, selectEntities);
        return {
            selectIds: createSelector2(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createSelector2(selectState, selectAll),
            selectTotal: createSelector2(selectState, selectTotal),
            selectById: createSelector2(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return {
        getSelectors: getSelectors
    };
}
var $34ed020f7f2c9609$var$isDraftTyped = (0, $af646dc9ee6cb2b8$export$541ac630993a4c84);
function $34ed020f7f2c9609$var$createSingleArgumentStateOperator(mutator) {
    const operator = $34ed020f7f2c9609$var$createStateOperator((_, state)=>mutator(state));
    return function operation(state) {
        return operator(state, void 0);
    };
}
function $34ed020f7f2c9609$var$createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return $34ed020f7f2c9609$export$ebd532f9034651f3(arg2);
        }
        const runMutator = (draft)=>{
            if (isPayloadActionArgument(arg)) mutator(arg.payload, draft);
            else mutator(arg, draft);
        };
        if ($34ed020f7f2c9609$var$isDraftTyped(state)) {
            runMutator(state);
            return state;
        }
        return (0, $af646dc9ee6cb2b8$export$b46cabe22e78bc00)(state, runMutator);
    };
}
// src/entities/utils.ts
function $34ed020f7f2c9609$var$selectIdValue(entity, selectId) {
    const key = selectId(entity);
    return key;
}
function $34ed020f7f2c9609$var$ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) entities = Object.values(entities);
    return entities;
}
function $34ed020f7f2c9609$var$splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = $34ed020f7f2c9609$var$ensureEntitiesArray(newEntities);
    const added = [];
    const updated = [];
    for (const entity of newEntities){
        const id = $34ed020f7f2c9609$var$selectIdValue(entity, selectId);
        if (id in state.entities) updated.push({
            id: id,
            changes: entity
        });
        else added.push(entity);
    }
    return [
        added,
        updated
    ];
}
// src/entities/unsorted_state_adapter.ts
function $34ed020f7f2c9609$var$createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        const key = $34ed020f7f2c9609$var$selectIdValue(entity, selectId);
        if (key in state.entities) return;
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = $34ed020f7f2c9609$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)addOneMutably(entity, state);
    }
    function setOneMutably(entity, state) {
        const key = $34ed020f7f2c9609$var$selectIdValue(entity, selectId);
        if (!(key in state.entities)) state.ids.push(key);
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = $34ed020f7f2c9609$var$ensureEntitiesArray(newEntities);
        for (const entity of newEntities)setOneMutably(entity, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $34ed020f7f2c9609$var$ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([
            key
        ], state);
    }
    function removeManyMutably(keys, state) {
        let didMutate = false;
        keys.forEach((key)=>{
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) state.ids = state.ids.filter((id)=>id in state.entities);
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        const original3 = state.entities[update.id];
        if (original3 === void 0) return false;
        const updated = Object.assign({}, original3, update.changes);
        const newKey = $34ed020f7f2c9609$var$selectIdValue(updated, selectId);
        const hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        const newKeys = {};
        const updatesPerEntity = {};
        updates.forEach((update)=>{
            if (update.id in state.entities) updatesPerEntity[update.id] = {
                id: update.id,
                // Spreads ignore falsy values, so this works even if there isn't
                // an existing update already at this key
                changes: {
                    ...updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null,
                    ...update.changes
                }
            };
        });
        updates = Object.values(updatesPerEntity);
        const didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            const didMutateIds = updates.filter((update)=>takeNewKey(newKeys, update, state)).length > 0;
            if (didMutateIds) state.ids = Object.values(state.entities).map((e)=>$34ed020f7f2c9609$var$selectIdValue(e, selectId));
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $34ed020f7f2c9609$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: $34ed020f7f2c9609$var$createSingleArgumentStateOperator(removeAllMutably),
        addOne: $34ed020f7f2c9609$var$createStateOperator(addOneMutably),
        addMany: $34ed020f7f2c9609$var$createStateOperator(addManyMutably),
        setOne: $34ed020f7f2c9609$var$createStateOperator(setOneMutably),
        setMany: $34ed020f7f2c9609$var$createStateOperator(setManyMutably),
        setAll: $34ed020f7f2c9609$var$createStateOperator(setAllMutably),
        updateOne: $34ed020f7f2c9609$var$createStateOperator(updateOneMutably),
        updateMany: $34ed020f7f2c9609$var$createStateOperator(updateManyMutably),
        upsertOne: $34ed020f7f2c9609$var$createStateOperator(upsertOneMutably),
        upsertMany: $34ed020f7f2c9609$var$createStateOperator(upsertManyMutably),
        removeOne: $34ed020f7f2c9609$var$createStateOperator(removeOneMutably),
        removeMany: $34ed020f7f2c9609$var$createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function $34ed020f7f2c9609$var$createSortedStateAdapter(selectId, sort) {
    const { removeOne: removeOne, removeMany: removeMany, removeAll: removeAll } = $34ed020f7f2c9609$var$createUnsortedStateAdapter(selectId);
    function addOneMutably(entity, state) {
        return addManyMutably([
            entity
        ], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = $34ed020f7f2c9609$var$ensureEntitiesArray(newEntities);
        const models = newEntities.filter((model)=>!($34ed020f7f2c9609$var$selectIdValue(model, selectId) in state.entities));
        if (models.length !== 0) merge(models, state);
    }
    function setOneMutably(entity, state) {
        return setManyMutably([
            entity
        ], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = $34ed020f7f2c9609$var$ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) merge(newEntities, state);
    }
    function setAllMutably(newEntities, state) {
        newEntities = $34ed020f7f2c9609$var$ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([
            update
        ], state);
    }
    function updateManyMutably(updates, state) {
        let appliedUpdates = false;
        for (let update of updates){
            const entity = state.entities[update.id];
            if (!entity) continue;
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            const newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) resortEntities(state);
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([
            entity
        ], state);
    }
    function upsertManyMutably(newEntities, state) {
        const [added, updated] = $34ed020f7f2c9609$var$splitAddedUpdatedEntities(newEntities, selectId, state);
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) return false;
        for(let i = 0; i < a.length && i < b.length; i++){
            if (a[i] === b[i]) continue;
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach((model)=>{
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        const allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        const newSortedIds = allEntities.map(selectId);
        const { ids: ids } = state;
        if (!areArraysEqual(ids, newSortedIds)) state.ids = newSortedIds;
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: $34ed020f7f2c9609$var$createStateOperator(addOneMutably),
        updateOne: $34ed020f7f2c9609$var$createStateOperator(updateOneMutably),
        upsertOne: $34ed020f7f2c9609$var$createStateOperator(upsertOneMutably),
        setOne: $34ed020f7f2c9609$var$createStateOperator(setOneMutably),
        setMany: $34ed020f7f2c9609$var$createStateOperator(setManyMutably),
        setAll: $34ed020f7f2c9609$var$createStateOperator(setAllMutably),
        addMany: $34ed020f7f2c9609$var$createStateOperator(addManyMutably),
        updateMany: $34ed020f7f2c9609$var$createStateOperator(updateManyMutably),
        upsertMany: $34ed020f7f2c9609$var$createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function $34ed020f7f2c9609$export$abcf4037b41e0df(options = {}) {
    const { selectId: selectId, sortComparer: sortComparer } = {
        sortComparer: false,
        selectId: (instance)=>instance.id,
        ...options
    };
    const stateFactory = $34ed020f7f2c9609$var$createInitialStateFactory();
    const selectorsFactory = $34ed020f7f2c9609$var$createSelectorsFactory();
    const stateAdapter = sortComparer ? $34ed020f7f2c9609$var$createSortedStateAdapter(selectId, sortComparer) : $34ed020f7f2c9609$var$createUnsortedStateAdapter(selectId);
    return {
        selectId: selectId,
        sortComparer: sortComparer,
        ...stateFactory,
        ...selectorsFactory,
        ...stateAdapter
    };
}
// src/listenerMiddleware/exceptions.ts
var $34ed020f7f2c9609$var$task = "task";
var $34ed020f7f2c9609$var$listener = "listener";
var $34ed020f7f2c9609$var$completed = "completed";
var $34ed020f7f2c9609$var$cancelled = "cancelled";
var $34ed020f7f2c9609$var$taskCancelled = `task-${$34ed020f7f2c9609$var$cancelled}`;
var $34ed020f7f2c9609$var$taskCompleted = `task-${$34ed020f7f2c9609$var$completed}`;
var $34ed020f7f2c9609$var$listenerCancelled = `${$34ed020f7f2c9609$var$listener}-${$34ed020f7f2c9609$var$cancelled}`;
var $34ed020f7f2c9609$var$listenerCompleted = `${$34ed020f7f2c9609$var$listener}-${$34ed020f7f2c9609$var$completed}`;
var $34ed020f7f2c9609$export$cb1bdac908fed7f = class {
    constructor(code){
        this.code = code;
        this.message = `${$34ed020f7f2c9609$var$task} ${$34ed020f7f2c9609$var$cancelled} (reason: ${code})`;
    }
    name = "TaskAbortError";
    message;
};
// src/listenerMiddleware/utils.ts
var $34ed020f7f2c9609$var$assertFunction = (func, expected)=>{
    if (typeof func !== "function") throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(32));
};
var $34ed020f7f2c9609$var$noop2 = ()=>{};
var $34ed020f7f2c9609$var$catchRejection = (promise, onError = $34ed020f7f2c9609$var$noop2)=>{
    promise.catch(onError);
    return promise;
};
var $34ed020f7f2c9609$var$addAbortSignalListener = (abortSignal, callback)=>{
    abortSignal.addEventListener("abort", callback, {
        once: true
    });
    return ()=>abortSignal.removeEventListener("abort", callback);
};
var $34ed020f7f2c9609$var$abortControllerWithReason = (abortController, reason)=>{
    const signal = abortController.signal;
    if (signal.aborted) return;
    if (!("reason" in signal)) Object.defineProperty(signal, "reason", {
        enumerable: true,
        value: reason,
        configurable: true,
        writable: true
    });
    abortController.abort(reason);
};
// src/listenerMiddleware/task.ts
var $34ed020f7f2c9609$var$validateActive = (signal)=>{
    if (signal.aborted) {
        const { reason: reason } = signal;
        throw new $34ed020f7f2c9609$export$cb1bdac908fed7f(reason);
    }
};
function $34ed020f7f2c9609$var$raceWithSignal(signal, promise) {
    let cleanup = $34ed020f7f2c9609$var$noop2;
    return new Promise((resolve, reject)=>{
        const notifyRejection = ()=>reject(new $34ed020f7f2c9609$export$cb1bdac908fed7f(signal.reason));
        if (signal.aborted) {
            notifyRejection();
            return;
        }
        cleanup = $34ed020f7f2c9609$var$addAbortSignalListener(signal, notifyRejection);
        promise.finally(()=>cleanup()).then(resolve, reject);
    }).finally(()=>{
        cleanup = $34ed020f7f2c9609$var$noop2;
    });
}
var $34ed020f7f2c9609$var$runTask = async (task2, cleanUp)=>{
    try {
        await Promise.resolve();
        const value = await task2();
        return {
            status: "ok",
            value: value
        };
    } catch (error) {
        return {
            status: error instanceof $34ed020f7f2c9609$export$cb1bdac908fed7f ? "cancelled" : "rejected",
            error: error
        };
    } finally{
        cleanUp?.();
    }
};
var $34ed020f7f2c9609$var$createPause = (signal)=>{
    return (promise)=>{
        return $34ed020f7f2c9609$var$catchRejection($34ed020f7f2c9609$var$raceWithSignal(signal, promise).then((output)=>{
            $34ed020f7f2c9609$var$validateActive(signal);
            return output;
        }));
    };
};
var $34ed020f7f2c9609$var$createDelay = (signal)=>{
    const pause = $34ed020f7f2c9609$var$createPause(signal);
    return (timeoutMs)=>{
        return pause(new Promise((resolve)=>setTimeout(resolve, timeoutMs)));
    };
};
// src/listenerMiddleware/index.ts
var { assign: $34ed020f7f2c9609$var$assign } = Object;
var $34ed020f7f2c9609$var$INTERNAL_NIL_TOKEN = {};
var $34ed020f7f2c9609$var$alm = "listenerMiddleware";
var $34ed020f7f2c9609$var$createFork = (parentAbortSignal, parentBlockingPromises)=>{
    const linkControllers = (controller)=>$34ed020f7f2c9609$var$addAbortSignalListener(parentAbortSignal, ()=>$34ed020f7f2c9609$var$abortControllerWithReason(controller, parentAbortSignal.reason));
    return (taskExecutor, opts)=>{
        $34ed020f7f2c9609$var$assertFunction(taskExecutor, "taskExecutor");
        const childAbortController = new AbortController();
        linkControllers(childAbortController);
        const result = $34ed020f7f2c9609$var$runTask(async ()=>{
            $34ed020f7f2c9609$var$validateActive(parentAbortSignal);
            $34ed020f7f2c9609$var$validateActive(childAbortController.signal);
            const result2 = await taskExecutor({
                pause: $34ed020f7f2c9609$var$createPause(childAbortController.signal),
                delay: $34ed020f7f2c9609$var$createDelay(childAbortController.signal),
                signal: childAbortController.signal
            });
            $34ed020f7f2c9609$var$validateActive(childAbortController.signal);
            return result2;
        }, ()=>$34ed020f7f2c9609$var$abortControllerWithReason(childAbortController, $34ed020f7f2c9609$var$taskCompleted));
        if (opts?.autoJoin) parentBlockingPromises.push(result.catch($34ed020f7f2c9609$var$noop2));
        return {
            result: $34ed020f7f2c9609$var$createPause(parentAbortSignal)(result),
            cancel () {
                $34ed020f7f2c9609$var$abortControllerWithReason(childAbortController, $34ed020f7f2c9609$var$taskCancelled);
            }
        };
    };
};
var $34ed020f7f2c9609$var$createTakePattern = (startListening, signal)=>{
    const take = async (predicate, timeout)=>{
        $34ed020f7f2c9609$var$validateActive(signal);
        let unsubscribe = ()=>{};
        const tuplePromise = new Promise((resolve, reject)=>{
            let stopListening = startListening({
                predicate: predicate,
                effect: (action, listenerApi)=>{
                    listenerApi.unsubscribe();
                    resolve([
                        action,
                        listenerApi.getState(),
                        listenerApi.getOriginalState()
                    ]);
                }
            });
            unsubscribe = ()=>{
                stopListening();
                reject();
            };
        });
        const promises = [
            tuplePromise
        ];
        if (timeout != null) promises.push(new Promise((resolve)=>setTimeout(resolve, timeout, null)));
        try {
            const output = await $34ed020f7f2c9609$var$raceWithSignal(signal, Promise.race(promises));
            $34ed020f7f2c9609$var$validateActive(signal);
            return output;
        } finally{
            unsubscribe();
        }
    };
    return (predicate, timeout)=>$34ed020f7f2c9609$var$catchRejection(take(predicate, timeout));
};
var $34ed020f7f2c9609$var$getListenerEntryPropsFrom = (options)=>{
    let { type: type, actionCreator: actionCreator, matcher: matcher, predicate: predicate, effect: effect } = options;
    if (type) predicate = $34ed020f7f2c9609$export$309c7a02b0b0bc62(type).match;
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    } else if (matcher) predicate = matcher;
    else if (predicate) ;
    else throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(21));
    $34ed020f7f2c9609$var$assertFunction(effect, "options.listener");
    return {
        predicate: predicate,
        type: type,
        effect: effect
    };
};
var $34ed020f7f2c9609$var$createListenerEntry = Object.assign((options)=>{
    const { type: type, predicate: predicate, effect: effect } = $34ed020f7f2c9609$var$getListenerEntryPropsFrom(options);
    const id = $34ed020f7f2c9609$export$ac4959f4f1338dfc();
    const entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: /* @__PURE__ */ new Set(),
        unsubscribe: ()=>{
            throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(22));
        }
    };
    return entry;
}, {
    withTypes: ()=>$34ed020f7f2c9609$var$createListenerEntry
});
var $34ed020f7f2c9609$var$cancelActiveListeners = (entry)=>{
    entry.pending.forEach((controller)=>{
        $34ed020f7f2c9609$var$abortControllerWithReason(controller, $34ed020f7f2c9609$var$listenerCancelled);
    });
};
var $34ed020f7f2c9609$var$createClearListenerMiddleware = (listenerMap)=>{
    return ()=>{
        listenerMap.forEach($34ed020f7f2c9609$var$cancelActiveListeners);
        listenerMap.clear();
    };
};
var $34ed020f7f2c9609$var$safelyNotifyError = (errorHandler, errorToNotify, errorInfo)=>{
    try {
        errorHandler(errorToNotify, errorInfo);
    } catch (errorHandlerError) {
        setTimeout(()=>{
            throw errorHandlerError;
        }, 0);
    }
};
var $34ed020f7f2c9609$export$f03a6b845d3fb58b = Object.assign($34ed020f7f2c9609$export$309c7a02b0b0bc62(`${$34ed020f7f2c9609$var$alm}/add`), {
    withTypes: ()=>$34ed020f7f2c9609$export$f03a6b845d3fb58b
});
var $34ed020f7f2c9609$export$b1b8022855fb2b71 = $34ed020f7f2c9609$export$309c7a02b0b0bc62(`${$34ed020f7f2c9609$var$alm}/removeAll`);
var $34ed020f7f2c9609$export$b03e9483f936dccb = Object.assign($34ed020f7f2c9609$export$309c7a02b0b0bc62(`${$34ed020f7f2c9609$var$alm}/remove`), {
    withTypes: ()=>$34ed020f7f2c9609$export$b03e9483f936dccb
});
var $34ed020f7f2c9609$var$defaultErrorHandler = (...args)=>{
    console.error(`${$34ed020f7f2c9609$var$alm}/error`, ...args);
};
var $34ed020f7f2c9609$export$1228acebbbcb485b = (middlewareOptions = {})=>{
    const listenerMap = /* @__PURE__ */ new Map();
    const { extra: extra, onError: onError = $34ed020f7f2c9609$var$defaultErrorHandler } = middlewareOptions;
    $34ed020f7f2c9609$var$assertFunction(onError, "onError");
    const insertEntry = (entry)=>{
        entry.unsubscribe = ()=>listenerMap.delete(entry.id);
        listenerMap.set(entry.id, entry);
        return (cancelOptions)=>{
            entry.unsubscribe();
            if (cancelOptions?.cancelActive) $34ed020f7f2c9609$var$cancelActiveListeners(entry);
        };
    };
    const startListening = (options)=>{
        let entry = $34ed020f7f2c9609$var$find(Array.from(listenerMap.values()), (existingEntry)=>existingEntry.effect === options.effect);
        if (!entry) entry = $34ed020f7f2c9609$var$createListenerEntry(options);
        return insertEntry(entry);
    };
    Object.assign(startListening, {
        withTypes: ()=>startListening
    });
    const stopListening = (options)=>{
        const { type: type, effect: effect, predicate: predicate } = $34ed020f7f2c9609$var$getListenerEntryPropsFrom(options);
        const entry = $34ed020f7f2c9609$var$find(Array.from(listenerMap.values()), (entry2)=>{
            const matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) $34ed020f7f2c9609$var$cancelActiveListeners(entry);
        }
        return !!entry;
    };
    Object.assign(stopListening, {
        withTypes: ()=>stopListening
    });
    const notifyListener = async (entry, action, api, getOriginalState)=>{
        const internalTaskController = new AbortController();
        const take = $34ed020f7f2c9609$var$createTakePattern(startListening, internalTaskController.signal);
        const autoJoinPromises = [];
        try {
            entry.pending.add(internalTaskController);
            await Promise.resolve(entry.effect(action, // Use assign() rather than ... to avoid extra helper functions added to bundle
            $34ed020f7f2c9609$var$assign({}, api, {
                getOriginalState: getOriginalState,
                condition: (predicate, timeout)=>take(predicate, timeout).then(Boolean),
                take: take,
                delay: $34ed020f7f2c9609$var$createDelay(internalTaskController.signal),
                pause: $34ed020f7f2c9609$var$createPause(internalTaskController.signal),
                extra: extra,
                signal: internalTaskController.signal,
                fork: $34ed020f7f2c9609$var$createFork(internalTaskController.signal, autoJoinPromises),
                unsubscribe: entry.unsubscribe,
                subscribe: ()=>{
                    listenerMap.set(entry.id, entry);
                },
                cancelActiveListeners: ()=>{
                    entry.pending.forEach((controller, _, set)=>{
                        if (controller !== internalTaskController) {
                            $34ed020f7f2c9609$var$abortControllerWithReason(controller, $34ed020f7f2c9609$var$listenerCancelled);
                            set.delete(controller);
                        }
                    });
                },
                cancel: ()=>{
                    $34ed020f7f2c9609$var$abortControllerWithReason(internalTaskController, $34ed020f7f2c9609$var$listenerCancelled);
                    entry.pending.delete(internalTaskController);
                },
                throwIfCancelled: ()=>{
                    $34ed020f7f2c9609$var$validateActive(internalTaskController.signal);
                }
            })));
        } catch (listenerError) {
            if (!(listenerError instanceof $34ed020f7f2c9609$export$cb1bdac908fed7f)) $34ed020f7f2c9609$var$safelyNotifyError(onError, listenerError, {
                raisedBy: "effect"
            });
        } finally{
            await Promise.all(autoJoinPromises);
            $34ed020f7f2c9609$var$abortControllerWithReason(internalTaskController, $34ed020f7f2c9609$var$listenerCompleted);
            entry.pending.delete(internalTaskController);
        }
    };
    const clearListenerMiddleware = $34ed020f7f2c9609$var$createClearListenerMiddleware(listenerMap);
    const middleware = (api)=>(next)=>(action)=>{
                if (!(0, $bbc75262727a27e1$export$b956e38827fca970)(action)) return next(action);
                if ($34ed020f7f2c9609$export$f03a6b845d3fb58b.match(action)) return startListening(action.payload);
                if ($34ed020f7f2c9609$export$b1b8022855fb2b71.match(action)) {
                    clearListenerMiddleware();
                    return;
                }
                if ($34ed020f7f2c9609$export$b03e9483f936dccb.match(action)) return stopListening(action.payload);
                let originalState = api.getState();
                const getOriginalState = ()=>{
                    if (originalState === $34ed020f7f2c9609$var$INTERNAL_NIL_TOKEN) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(23));
                    return originalState;
                };
                let result;
                try {
                    result = next(action);
                    if (listenerMap.size > 0) {
                        const currentState = api.getState();
                        const listenerEntries = Array.from(listenerMap.values());
                        for (const entry of listenerEntries){
                            let runListener = false;
                            try {
                                runListener = entry.predicate(action, currentState, originalState);
                            } catch (predicateError) {
                                runListener = false;
                                $34ed020f7f2c9609$var$safelyNotifyError(onError, predicateError, {
                                    raisedBy: "predicate"
                                });
                            }
                            if (!runListener) continue;
                            notifyListener(entry, action, api, getOriginalState);
                        }
                    }
                } finally{
                    originalState = $34ed020f7f2c9609$var$INTERNAL_NIL_TOKEN;
                }
                return result;
            };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
};
var $34ed020f7f2c9609$var$createMiddlewareEntry = (middleware)=>({
        id: $34ed020f7f2c9609$export$ac4959f4f1338dfc(),
        middleware: middleware,
        applied: /* @__PURE__ */ new Map()
    });
var $34ed020f7f2c9609$var$matchInstance = (instanceId)=>(action)=>action?.meta?.instanceId === instanceId;
var $34ed020f7f2c9609$export$4bb1606a79445586 = ()=>{
    const instanceId = $34ed020f7f2c9609$export$ac4959f4f1338dfc();
    const middlewareMap = /* @__PURE__ */ new Map();
    const withMiddleware = Object.assign($34ed020f7f2c9609$export$309c7a02b0b0bc62("dynamicMiddleware/add", (...middlewares)=>({
            payload: middlewares,
            meta: {
                instanceId: instanceId
            }
        })), {
        withTypes: ()=>withMiddleware
    });
    const addMiddleware = Object.assign(function addMiddleware2(...middlewares) {
        middlewares.forEach((middleware2)=>{
            let entry = $34ed020f7f2c9609$var$find(Array.from(middlewareMap.values()), (entry2)=>entry2.middleware === middleware2);
            if (!entry) entry = $34ed020f7f2c9609$var$createMiddlewareEntry(middleware2);
            middlewareMap.set(entry.id, entry);
        });
    }, {
        withTypes: ()=>addMiddleware
    });
    const getFinalMiddleware = (api)=>{
        const appliedMiddleware = Array.from(middlewareMap.values()).map((entry)=>$34ed020f7f2c9609$var$emplace(entry.applied, api, {
                insert: ()=>entry.middleware(api)
            }));
        return (0, $bbc75262727a27e1$export$f672e0b6f7222cd7)(...appliedMiddleware);
    };
    const isWithMiddleware = $34ed020f7f2c9609$export$9dd1fb32974da385(withMiddleware, $34ed020f7f2c9609$var$matchInstance(instanceId));
    const middleware = (api)=>(next)=>(action)=>{
                if (isWithMiddleware(action)) {
                    addMiddleware(...action.payload);
                    return api.dispatch;
                }
                return getFinalMiddleware(api)(next)(action);
            };
    return {
        middleware: middleware,
        addMiddleware: addMiddleware,
        withMiddleware: withMiddleware,
        instanceId: instanceId
    };
};
var $34ed020f7f2c9609$var$isSliceLike = (maybeSliceLike)=>"reducerPath" in maybeSliceLike && typeof maybeSliceLike.reducerPath === "string";
var $34ed020f7f2c9609$var$getReducers = (slices)=>slices.flatMap((sliceOrMap)=>$34ed020f7f2c9609$var$isSliceLike(sliceOrMap) ? [
            [
                sliceOrMap.reducerPath,
                sliceOrMap.reducer
            ]
        ] : Object.entries(sliceOrMap));
var $34ed020f7f2c9609$var$ORIGINAL_STATE = Symbol.for("rtk-state-proxy-original");
var $34ed020f7f2c9609$var$isStateProxy = (value)=>!!value && !!value[$34ed020f7f2c9609$var$ORIGINAL_STATE];
var $34ed020f7f2c9609$var$stateProxyMap = /* @__PURE__ */ new WeakMap();
var $34ed020f7f2c9609$var$createStateProxy = (state, reducerMap)=>$34ed020f7f2c9609$var$emplace($34ed020f7f2c9609$var$stateProxyMap, state, {
        insert: ()=>new Proxy(state, {
                get: (target, prop, receiver)=>{
                    if (prop === $34ed020f7f2c9609$var$ORIGINAL_STATE) return target;
                    const result = Reflect.get(target, prop, receiver);
                    if (typeof result === "undefined") {
                        const reducer = reducerMap[prop.toString()];
                        if (reducer) {
                            const reducerResult = reducer(void 0, {
                                type: $34ed020f7f2c9609$export$ac4959f4f1338dfc()
                            });
                            if (typeof reducerResult === "undefined") throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(24));
                            return reducerResult;
                        }
                    }
                    return result;
                }
            })
    });
var $34ed020f7f2c9609$var$original = (state)=>{
    if (!$34ed020f7f2c9609$var$isStateProxy(state)) throw new Error($34ed020f7f2c9609$export$378fa86b259c0280(25));
    return state[$34ed020f7f2c9609$var$ORIGINAL_STATE];
};
function $34ed020f7f2c9609$export$a3734c7614660b9(...slices) {
    const reducerMap = Object.fromEntries($34ed020f7f2c9609$var$getReducers(slices));
    const getReducer = ()=>(0, $bbc75262727a27e1$export$66e4520cdb265d18)(reducerMap);
    let reducer = getReducer();
    function combinedReducer(state, action) {
        return reducer(state, action);
    }
    combinedReducer.withLazyLoadedSlices = ()=>combinedReducer;
    const inject = (slice, config = {})=>{
        const { reducerPath: reducerPath, reducer: reducerToInject } = slice;
        const currentReducer = reducerMap[reducerPath];
        if (!config.overrideExisting && currentReducer && currentReducer !== reducerToInject) {
            typeof $879b2beb6cc9bacc$exports;
            return combinedReducer;
        }
        reducerMap[reducerPath] = reducerToInject;
        reducer = getReducer();
        return combinedReducer;
    };
    const selector = Object.assign(function makeSelector(selectorFn, selectState) {
        return function selector2(state, ...args) {
            return selectorFn($34ed020f7f2c9609$var$createStateProxy(selectState ? selectState(state, ...args) : state, reducerMap), ...args);
        };
    }, {
        original: $34ed020f7f2c9609$var$original
    });
    return Object.assign(combinedReducer, {
        inject: inject,
        selector: selector
    });
}
// src/formatProdErrorMessage.ts
function $34ed020f7f2c9609$export$378fa86b259c0280(code) {
    return `Minified Redux Toolkit error #${code}; visit https://redux-toolkit.js.org/Errors?code=${code} for the full message or use the non-minified dev environment for full errors. `;
}


const $6e3f649c67c08cff$var$cartSlice = (0, $34ed020f7f2c9609$export$4d8d9bd83c24ae8b)({
    name: "cart",
    initialState: {
        items: []
    },
    reducers: {
        addItem: (state, action)=>{
            state.items.push(action.payload);
        },
        removeItem: (state, action)=>{
            const removedArray = state.items.filter((item)=>item.card.info.id !== action.payload.card.info.id);
            return {
                items: removedArray
            };
        },
        clearCart: (state, action)=>{
            state.items.length = 0;
        }
    }
});
const { addItem: $6e3f649c67c08cff$export$fb9705de59d96855, removeItem: $6e3f649c67c08cff$export$fe2d9b4e03920b4c, clearCart: $6e3f649c67c08cff$export$810121176e3e3671 } = $6e3f649c67c08cff$var$cartSlice.actions;
var $6e3f649c67c08cff$export$2e2bcd8739ae039 = $6e3f649c67c08cff$var$cartSlice.reducer;



var $aOChP = parcelRequire("aOChP");
function $9dd0e7fad28ce0e4$export$2e2bcd8739ae039() {
    $9dd0e7fad28ce0e4$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $9dd0e7fad28ce0e4$export$2e2bcd8739ae039.apply(this, arguments);
}



var $aOChP = parcelRequire("aOChP");

function $10b7648fa971952e$export$b9ecd428b558ff10(originalEventHandler, ourEventHandler, { checkForDefaultPrevented: checkForDefaultPrevented = true } = {}) {
    return function handleEvent(event) {
        originalEventHandler === null || originalEventHandler === void 0 || originalEventHandler(event);
        if (checkForDefaultPrevented === false || !event.defaultPrevented) return ourEventHandler === null || ourEventHandler === void 0 ? void 0 : ourEventHandler(event);
    };
}



var $aOChP = parcelRequire("aOChP");
/**
 * Set a given ref to a given value
 * This utility takes care of different types of refs: callback refs and RefObject(s)
 */ function $a1ec28269954e36e$var$$6ed0406888f73fc4$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== undefined) ref.current = value;
}
/**
 * A utility to compose multiple refs together
 * Accepts callback refs and RefObject(s)
 */ function $a1ec28269954e36e$export$43e446d32b3d21af(...refs) {
    return (node)=>refs.forEach((ref)=>$a1ec28269954e36e$var$$6ed0406888f73fc4$var$setRef(ref, node));
}
/**
 * A custom hook that composes multiple refs
 * Accepts callback refs and RefObject(s)
 */ function $a1ec28269954e36e$export$c7b2cbe3552a0d05(...refs) {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return (0, $aOChP.useCallback)($a1ec28269954e36e$export$43e446d32b3d21af(...refs), refs);
}



var $aOChP = parcelRequire("aOChP");

var $aOChP = parcelRequire("aOChP");
function $2faebf39acec7f19$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
    const Context = /*#__PURE__*/ (0, $aOChP.createContext)(defaultContext);
    function Provider(props) {
        const { children: children, ...context } = props; // Only re-memoize when prop values change
        // eslint-disable-next-line react-hooks/exhaustive-deps
        const value = (0, $aOChP.useMemo)(()=>context, Object.values(context));
        return /*#__PURE__*/ (0, $aOChP.createElement)(Context.Provider, {
            value: value
        }, children);
    }
    function useContext(consumerName) {
        const context = (0, $aOChP.useContext)(Context);
        if (context) return context;
        if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
        throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
    }
    Provider.displayName = rootComponentName + "Provider";
    return [
        Provider,
        useContext
    ];
}
/* -------------------------------------------------------------------------------------------------
 * createContextScope
 * -----------------------------------------------------------------------------------------------*/ function $2faebf39acec7f19$export$50c7b4e9d9f19c1(scopeName, createContextScopeDeps = []) {
    let defaultContexts = [];
    /* -----------------------------------------------------------------------------------------------
   * createContext
   * ---------------------------------------------------------------------------------------------*/ function $c512c27ab02ef895$export$fd42f52fd3ae1109(rootComponentName, defaultContext) {
        const BaseContext = /*#__PURE__*/ (0, $aOChP.createContext)(defaultContext);
        const index = defaultContexts.length;
        defaultContexts = [
            ...defaultContexts,
            defaultContext
        ];
        function Provider(props) {
            const { scope: scope, children: children, ...context } = props;
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext; // Only re-memoize when prop values change
            // eslint-disable-next-line react-hooks/exhaustive-deps
            const value = (0, $aOChP.useMemo)(()=>context, Object.values(context));
            return /*#__PURE__*/ (0, $aOChP.createElement)(Context.Provider, {
                value: value
            }, children);
        }
        function useContext(consumerName, scope) {
            const Context = (scope === null || scope === void 0 ? void 0 : scope[scopeName][index]) || BaseContext;
            const context = (0, $aOChP.useContext)(Context);
            if (context) return context;
            if (defaultContext !== undefined) return defaultContext; // if a defaultContext wasn't specified, it's a required context.
            throw new Error(`\`${consumerName}\` must be used within \`${rootComponentName}\``);
        }
        Provider.displayName = rootComponentName + "Provider";
        return [
            Provider,
            useContext
        ];
    }
    /* -----------------------------------------------------------------------------------------------
   * createScope
   * ---------------------------------------------------------------------------------------------*/ const createScope = ()=>{
        const scopeContexts = defaultContexts.map((defaultContext)=>{
            return /*#__PURE__*/ (0, $aOChP.createContext)(defaultContext);
        });
        return function useScope(scope) {
            const contexts = (scope === null || scope === void 0 ? void 0 : scope[scopeName]) || scopeContexts;
            return (0, $aOChP.useMemo)(()=>({
                    [`__scope${scopeName}`]: {
                        ...scope,
                        [scopeName]: contexts
                    }
                }), [
                scope,
                contexts
            ]);
        };
    };
    createScope.scopeName = scopeName;
    return [
        $c512c27ab02ef895$export$fd42f52fd3ae1109,
        $2faebf39acec7f19$var$$c512c27ab02ef895$var$composeContextScopes(createScope, ...createContextScopeDeps)
    ];
}
/* -------------------------------------------------------------------------------------------------
 * composeContextScopes
 * -----------------------------------------------------------------------------------------------*/ function $2faebf39acec7f19$var$$c512c27ab02ef895$var$composeContextScopes(...scopes) {
    const baseScope = scopes[0];
    if (scopes.length === 1) return baseScope;
    const createScope1 = ()=>{
        const scopeHooks = scopes.map((createScope)=>({
                useScope: createScope(),
                scopeName: createScope.scopeName
            }));
        return function useComposedScopes(overrideScopes) {
            const nextScopes1 = scopeHooks.reduce((nextScopes, { useScope: useScope, scopeName: scopeName })=>{
                // We are calling a hook inside a callback which React warns against to avoid inconsistent
                // renders, however, scoping doesn't have render side effects so we ignore the rule.
                // eslint-disable-next-line react-hooks/rules-of-hooks
                const scopeProps = useScope(overrideScopes);
                const currentScope = scopeProps[`__scope${scopeName}`];
                return {
                    ...nextScopes,
                    ...currentScope
                };
            }, {});
            return (0, $aOChP.useMemo)(()=>({
                    [`__scope${baseScope.scopeName}`]: nextScopes1
                }), [
                nextScopes1
            ]);
        };
    };
    createScope1.scopeName = baseScope.scopeName;
    return createScope1;
}





var $aOChP = parcelRequire("aOChP");

/* -------------------------------------------------------------------------------------------------
 * Slot
 * -----------------------------------------------------------------------------------------------*/ const $1c228d3abb2a6ccd$export$8c6ed5c666ac1360 = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    const childrenArray = (0, $aOChP.Children).toArray(children);
    const slottable = childrenArray.find($1c228d3abb2a6ccd$var$$5e63c961fc1ce211$var$isSlottable);
    if (slottable) {
        // the new element to render is the one passed as a child of `Slottable`
        const newElement = slottable.props.children;
        const newChildren = childrenArray.map((child)=>{
            if (child === slottable) {
                // because the new element will be the one rendered, we are only interested
                // in grabbing its children (`newElement.props.children`)
                if ((0, $aOChP.Children).count(newElement) > 1) return (0, $aOChP.Children).only(null);
                return /*#__PURE__*/ (0, $aOChP.isValidElement)(newElement) ? newElement.props.children : null;
            } else return child;
        });
        return /*#__PURE__*/ (0, $aOChP.createElement)($1c228d3abb2a6ccd$var$$5e63c961fc1ce211$var$SlotClone, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({}, slotProps, {
            ref: forwardedRef
        }), /*#__PURE__*/ (0, $aOChP.isValidElement)(newElement) ? /*#__PURE__*/ (0, $aOChP.cloneElement)(newElement, undefined, newChildren) : null);
    }
    return /*#__PURE__*/ (0, $aOChP.createElement)($1c228d3abb2a6ccd$var$$5e63c961fc1ce211$var$SlotClone, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({}, slotProps, {
        ref: forwardedRef
    }), children);
});
$1c228d3abb2a6ccd$export$8c6ed5c666ac1360.displayName = "Slot";
/* -------------------------------------------------------------------------------------------------
 * SlotClone
 * -----------------------------------------------------------------------------------------------*/ const $1c228d3abb2a6ccd$var$$5e63c961fc1ce211$var$SlotClone = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const { children: children, ...slotProps } = props;
    if (/*#__PURE__*/ (0, $aOChP.isValidElement)(children)) return /*#__PURE__*/ (0, $aOChP.cloneElement)(children, {
        ...$1c228d3abb2a6ccd$var$$5e63c961fc1ce211$var$mergeProps(slotProps, children.props),
        ref: forwardedRef ? (0, $a1ec28269954e36e$export$43e446d32b3d21af)(forwardedRef, children.ref) : children.ref
    });
    return (0, $aOChP.Children).count(children) > 1 ? (0, $aOChP.Children).only(null) : null;
});
$1c228d3abb2a6ccd$var$$5e63c961fc1ce211$var$SlotClone.displayName = "SlotClone";
/* -------------------------------------------------------------------------------------------------
 * Slottable
 * -----------------------------------------------------------------------------------------------*/ const $1c228d3abb2a6ccd$export$d9f1ccf0bdb05d45 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $aOChP.createElement)((0, $aOChP.Fragment), null, children);
};
/* ---------------------------------------------------------------------------------------------- */ function $1c228d3abb2a6ccd$var$$5e63c961fc1ce211$var$isSlottable(child) {
    return /*#__PURE__*/ (0, $aOChP.isValidElement)(child) && child.type === $1c228d3abb2a6ccd$export$d9f1ccf0bdb05d45;
}
function $1c228d3abb2a6ccd$var$$5e63c961fc1ce211$var$mergeProps(slotProps, childProps) {
    // all child props should override
    const overrideProps = {
        ...childProps
    };
    for(const propName in childProps){
        const slotPropValue = slotProps[propName];
        const childPropValue = childProps[propName];
        const isHandler = /^on[A-Z]/.test(propName);
        if (isHandler) {
            // if the handler exists on both, we compose them
            if (slotPropValue && childPropValue) overrideProps[propName] = (...args)=>{
                childPropValue(...args);
                slotPropValue(...args);
            };
            else if (slotPropValue) overrideProps[propName] = slotPropValue;
        } else if (propName === "style") overrideProps[propName] = {
            ...slotPropValue,
            ...childPropValue
        };
        else if (propName === "className") overrideProps[propName] = [
            slotPropValue,
            childPropValue
        ].filter(Boolean).join(" ");
    }
    return {
        ...slotProps,
        ...overrideProps
    };
}
const $1c228d3abb2a6ccd$export$be92b6f5f03c0fe9 = $1c228d3abb2a6ccd$export$8c6ed5c666ac1360;


// We have resorted to returning slots directly rather than exposing primitives that can then
// be slotted like `<CollectionItem as={Slot}>…</CollectionItem>`.
// This is because we encountered issues with generic types that cannot be statically analysed
// due to creating them dynamically via createCollection.
function $98fc231b3b687e12$export$c74125a8e3af6bb2(name) {
    /* -----------------------------------------------------------------------------------------------
   * CollectionProvider
   * ---------------------------------------------------------------------------------------------*/ const PROVIDER_NAME = name + "CollectionProvider";
    const [createCollectionContext, createCollectionScope] = (0, $2faebf39acec7f19$export$50c7b4e9d9f19c1)(PROVIDER_NAME);
    const [CollectionProviderImpl, useCollectionContext] = createCollectionContext(PROVIDER_NAME, {
        collectionRef: {
            current: null
        },
        itemMap: new Map()
    });
    const CollectionProvider = (props)=>{
        const { scope: scope, children: children } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).useRef(null);
        const itemMap = (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).useRef(new Map()).current;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement(CollectionProviderImpl, {
            scope: scope,
            itemMap: itemMap,
            collectionRef: ref
        }, children);
    };
    /*#__PURE__*/ Object.assign(CollectionProvider, {
        displayName: PROVIDER_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionSlot
   * ---------------------------------------------------------------------------------------------*/ const COLLECTION_SLOT_NAME = name + "CollectionSlot";
    const CollectionSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children } = props;
        const context = useCollectionContext(COLLECTION_SLOT_NAME, scope);
        const composedRefs = (0, $a1ec28269954e36e$export$c7b2cbe3552a0d05)(forwardedRef, context.collectionRef);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement((0, $1c228d3abb2a6ccd$export$8c6ed5c666ac1360), {
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionSlot, {
        displayName: COLLECTION_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * CollectionItem
   * ---------------------------------------------------------------------------------------------*/ const ITEM_SLOT_NAME = name + "CollectionItemSlot";
    const ITEM_DATA_ATTR = "data-radix-collection-item";
    const CollectionItemSlot = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).forwardRef((props, forwardedRef)=>{
        const { scope: scope, children: children, ...itemData } = props;
        const ref = (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).useRef(null);
        const composedRefs = (0, $a1ec28269954e36e$export$c7b2cbe3552a0d05)(forwardedRef, ref);
        const context = useCollectionContext(ITEM_SLOT_NAME, scope);
        (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).useEffect(()=>{
            context.itemMap.set(ref, {
                ref: ref,
                ...itemData
            });
            return ()=>void context.itemMap.delete(ref);
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).createElement((0, $1c228d3abb2a6ccd$export$8c6ed5c666ac1360), {
            [ITEM_DATA_ATTR]: "",
            ref: composedRefs
        }, children);
    });
    /*#__PURE__*/ Object.assign(CollectionItemSlot, {
        displayName: ITEM_SLOT_NAME
    });
    /* -----------------------------------------------------------------------------------------------
   * useCollection
   * ---------------------------------------------------------------------------------------------*/ function useCollection(scope) {
        const context = useCollectionContext(name + "CollectionConsumer", scope);
        const getItems = (0, (/*@__PURE__*/$parcel$interopDefault($aOChP))).useCallback(()=>{
            const collectionNode = context.collectionRef.current;
            if (!collectionNode) return [];
            const orderedNodes = Array.from(collectionNode.querySelectorAll(`[${ITEM_DATA_ATTR}]`));
            const items = Array.from(context.itemMap.values());
            const orderedItems = items.sort((a, b)=>orderedNodes.indexOf(a.ref.current) - orderedNodes.indexOf(b.ref.current));
            return orderedItems;
        }, [
            context.collectionRef,
            context.itemMap
        ]);
        return getItems;
    }
    return [
        {
            Provider: CollectionProvider,
            Slot: CollectionSlot,
            ItemSlot: CollectionItemSlot
        },
        useCollection,
        createCollectionScope
    ];
}





var $aOChP = parcelRequire("aOChP");



var $aOChP = parcelRequire("aOChP");


const $6a0e2eba41459a28$var$$8927f6f2acc4f386$var$NODES = [
    "a",
    "button",
    "div",
    "form",
    "h2",
    "h3",
    "img",
    "input",
    "label",
    "li",
    "nav",
    "ol",
    "p",
    "span",
    "svg",
    "ul"
]; // Temporary while we await merge of this fix:
// https://github.com/DefinitelyTyped/DefinitelyTyped/pull/55396
// prettier-ignore
/* -------------------------------------------------------------------------------------------------
 * Primitive
 * -----------------------------------------------------------------------------------------------*/ const $6a0e2eba41459a28$export$250ffa63cdc0d034 = $6a0e2eba41459a28$var$$8927f6f2acc4f386$var$NODES.reduce((primitive, node)=>{
    const Node = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
        const { asChild: asChild, ...primitiveProps } = props;
        const Comp = asChild ? (0, $1c228d3abb2a6ccd$export$8c6ed5c666ac1360) : node;
        (0, $aOChP.useEffect)(()=>{
            window[Symbol.for("radix-ui")] = true;
        }, []);
        return /*#__PURE__*/ (0, $aOChP.createElement)(Comp, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({}, primitiveProps, {
            ref: forwardedRef
        }));
    });
    Node.displayName = `Primitive.${node}`;
    return {
        ...primitive,
        [node]: Node
    };
}, {});
/* -------------------------------------------------------------------------------------------------
 * Utils
 * -----------------------------------------------------------------------------------------------*/ /**
 * Flush custom event dispatch
 * https://github.com/radix-ui/primitives/pull/1378
 *
 * React batches *all* event handlers since version 18, this introduces certain considerations when using custom event types.
 *
 * Internally, React prioritises events in the following order:
 *  - discrete
 *  - continuous
 *  - default
 *
 * https://github.com/facebook/react/blob/a8a4742f1c54493df00da648a3f9d26e3db9c8b5/packages/react-dom/src/events/ReactDOMEventListener.js#L294-L350
 *
 * `discrete` is an  important distinction as updates within these events are applied immediately.
 * React however, is not able to infer the priority of custom event types due to how they are detected internally.
 * Because of this, it's possible for updates from custom events to be unexpectedly batched when
 * dispatched by another `discrete` event.
 *
 * In order to ensure that updates from custom events are applied predictably, we need to manually flush the batch.
 * This utility should be used when dispatching a custom event from within another `discrete` event, this utility
 * is not nessesary when dispatching known event types, or if dispatching a custom type inside a non-discrete event.
 * For example:
 *
 * dispatching a known click 👎
 * target.dispatchEvent(new Event(‘click’))
 *
 * dispatching a custom type within a non-discrete event 👎
 * onScroll={(event) => event.target.dispatchEvent(new CustomEvent(‘customType’))}
 *
 * dispatching a custom type within a `discrete` event 👍
 * onPointerDown={(event) => dispatchDiscreteCustomEvent(event.target, new CustomEvent(‘customType’))}
 *
 * Note: though React classifies `focus`, `focusin` and `focusout` events as `discrete`, it's  not recommended to use
 * this utility with them. This is because it's possible for those handlers to be called implicitly during render
 * e.g. when focus is within a component as it is unmounted, or when managing focus on mount.
 */ function $6a0e2eba41459a28$export$6d1a0317bde7de7f(target, event) {
    if (target) (0, $a4960af4154d3849$exports.flushSync)(()=>target.dispatchEvent(event));
}
/* -----------------------------------------------------------------------------------------------*/ const $6a0e2eba41459a28$export$be92b6f5f03c0fe9 = $6a0e2eba41459a28$export$250ffa63cdc0d034;




var $aOChP = parcelRequire("aOChP");
/**
 * A custom hook that converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency
 */ function $60b6529be484f710$export$25bec8c6f54ee79a(callback) {
    const callbackRef = (0, $aOChP.useRef)(callback);
    (0, $aOChP.useEffect)(()=>{
        callbackRef.current = callback;
    }); // https://github.com/facebook/react/issues/19240
    return (0, $aOChP.useMemo)(()=>(...args)=>{
            var _callbackRef$current;
            return (_callbackRef$current = callbackRef.current) === null || _callbackRef$current === void 0 ? void 0 : _callbackRef$current.call(callbackRef, ...args);
        }, []);
}



var $aOChP = parcelRequire("aOChP");

/**
 * Listens for when the escape key is down
 */ function $b7305d7e6a9bb1d7$export$3a72a57244d6e765(onEscapeKeyDownProp, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const onEscapeKeyDown = (0, $60b6529be484f710$export$25bec8c6f54ee79a)(onEscapeKeyDownProp);
    (0, $aOChP.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            if (event.key === "Escape") onEscapeKeyDown(event);
        };
        ownerDocument.addEventListener("keydown", handleKeyDown);
        return ()=>ownerDocument.removeEventListener("keydown", handleKeyDown);
    }, [
        onEscapeKeyDown,
        ownerDocument
    ]);
}


/* -------------------------------------------------------------------------------------------------
 * DismissableLayer
 * -----------------------------------------------------------------------------------------------*/ const $b8305c8aec918214$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME = "DismissableLayer";
const $b8305c8aec918214$var$$5cb92bef7577960e$var$CONTEXT_UPDATE = "dismissableLayer.update";
const $b8305c8aec918214$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE = "dismissableLayer.pointerDownOutside";
const $b8305c8aec918214$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE = "dismissableLayer.focusOutside";
let $b8305c8aec918214$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
const $b8305c8aec918214$var$$5cb92bef7577960e$var$DismissableLayerContext = /*#__PURE__*/ (0, $aOChP.createContext)({
    layers: new Set(),
    layersWithOutsidePointerEventsDisabled: new Set(),
    branches: new Set()
});
const $b8305c8aec918214$export$177fb62ff3ec1f22 = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    var _node$ownerDocument;
    const { disableOutsidePointerEvents: disableOutsidePointerEvents = false, onEscapeKeyDown: onEscapeKeyDown, onPointerDownOutside: onPointerDownOutside, onFocusOutside: onFocusOutside, onInteractOutside: onInteractOutside, onDismiss: onDismiss, ...layerProps } = props;
    const context = (0, $aOChP.useContext)($b8305c8aec918214$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const [node1, setNode] = (0, $aOChP.useState)(null);
    const ownerDocument = (_node$ownerDocument = node1 === null || node1 === void 0 ? void 0 : node1.ownerDocument) !== null && _node$ownerDocument !== void 0 ? _node$ownerDocument : globalThis === null || globalThis === void 0 ? void 0 : globalThis.document;
    const [, force] = (0, $aOChP.useState)({});
    const composedRefs = (0, $a1ec28269954e36e$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const layers = Array.from(context.layers);
    const [highestLayerWithOutsidePointerEventsDisabled] = [
        ...context.layersWithOutsidePointerEventsDisabled
    ].slice(-1); // prettier-ignore
    const highestLayerWithOutsidePointerEventsDisabledIndex = layers.indexOf(highestLayerWithOutsidePointerEventsDisabled); // prettier-ignore
    const index = node1 ? layers.indexOf(node1) : -1;
    const isBodyPointerEventsDisabled = context.layersWithOutsidePointerEventsDisabled.size > 0;
    const isPointerEventsEnabled = index >= highestLayerWithOutsidePointerEventsDisabledIndex;
    const pointerDownOutside = $b8305c8aec918214$var$$5cb92bef7577960e$var$usePointerDownOutside((event)=>{
        const target = event.target;
        const isPointerDownOnBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (!isPointerEventsEnabled || isPointerDownOnBranch) return;
        onPointerDownOutside === null || onPointerDownOutside === void 0 || onPointerDownOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    const focusOutside = $b8305c8aec918214$var$$5cb92bef7577960e$var$useFocusOutside((event)=>{
        const target = event.target;
        const isFocusInBranch = [
            ...context.branches
        ].some((branch)=>branch.contains(target));
        if (isFocusInBranch) return;
        onFocusOutside === null || onFocusOutside === void 0 || onFocusOutside(event);
        onInteractOutside === null || onInteractOutside === void 0 || onInteractOutside(event);
        if (!event.defaultPrevented) onDismiss === null || onDismiss === void 0 || onDismiss();
    }, ownerDocument);
    (0, $b7305d7e6a9bb1d7$export$3a72a57244d6e765)((event)=>{
        const isHighestLayer = index === context.layers.size - 1;
        if (!isHighestLayer) return;
        onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event);
        if (!event.defaultPrevented && onDismiss) {
            event.preventDefault();
            onDismiss();
        }
    }, ownerDocument);
    (0, $aOChP.useEffect)(()=>{
        if (!node1) return;
        if (disableOutsidePointerEvents) {
            if (context.layersWithOutsidePointerEventsDisabled.size === 0) {
                $b8305c8aec918214$var$$5cb92bef7577960e$var$originalBodyPointerEvents = ownerDocument.body.style.pointerEvents;
                ownerDocument.body.style.pointerEvents = "none";
            }
            context.layersWithOutsidePointerEventsDisabled.add(node1);
        }
        context.layers.add(node1);
        $b8305c8aec918214$var$$5cb92bef7577960e$var$dispatchUpdate();
        return ()=>{
            if (disableOutsidePointerEvents && context.layersWithOutsidePointerEventsDisabled.size === 1) ownerDocument.body.style.pointerEvents = $b8305c8aec918214$var$$5cb92bef7577960e$var$originalBodyPointerEvents;
        };
    }, [
        node1,
        ownerDocument,
        disableOutsidePointerEvents,
        context
    ]);
    /**
   * We purposefully prevent combining this effect with the `disableOutsidePointerEvents` effect
   * because a change to `disableOutsidePointerEvents` would remove this layer from the stack
   * and add it to the end again so the layering order wouldn't be _creation order_.
   * We only want them to be removed from context stacks when unmounted.
   */ (0, $aOChP.useEffect)(()=>{
        return ()=>{
            if (!node1) return;
            context.layers.delete(node1);
            context.layersWithOutsidePointerEventsDisabled.delete(node1);
            $b8305c8aec918214$var$$5cb92bef7577960e$var$dispatchUpdate();
        };
    }, [
        node1,
        context
    ]);
    (0, $aOChP.useEffect)(()=>{
        const handleUpdate = ()=>force({});
        document.addEventListener($b8305c8aec918214$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
        return ()=>document.removeEventListener($b8305c8aec918214$var$$5cb92bef7577960e$var$CONTEXT_UPDATE, handleUpdate);
    }, []);
    return /*#__PURE__*/ (0, $aOChP.createElement)((0, $6a0e2eba41459a28$export$250ffa63cdc0d034).div, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({}, layerProps, {
        ref: composedRefs,
        style: {
            pointerEvents: isBodyPointerEventsDisabled ? isPointerEventsEnabled ? "auto" : "none" : undefined,
            ...props.style
        },
        onFocusCapture: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onFocusCapture, focusOutside.onFocusCapture),
        onBlurCapture: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onBlurCapture, focusOutside.onBlurCapture),
        onPointerDownCapture: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onPointerDownCapture, pointerDownOutside.onPointerDownCapture)
    }));
});
/*#__PURE__*/ Object.assign($b8305c8aec918214$export$177fb62ff3ec1f22, {
    displayName: $b8305c8aec918214$var$$5cb92bef7577960e$var$DISMISSABLE_LAYER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * DismissableLayerBranch
 * -----------------------------------------------------------------------------------------------*/ const $b8305c8aec918214$var$$5cb92bef7577960e$var$BRANCH_NAME = "DismissableLayerBranch";
const $b8305c8aec918214$export$4d5eb2109db14228 = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const context = (0, $aOChP.useContext)($b8305c8aec918214$var$$5cb92bef7577960e$var$DismissableLayerContext);
    const ref = (0, $aOChP.useRef)(null);
    const composedRefs = (0, $a1ec28269954e36e$export$c7b2cbe3552a0d05)(forwardedRef, ref);
    (0, $aOChP.useEffect)(()=>{
        const node = ref.current;
        if (node) {
            context.branches.add(node);
            return ()=>{
                context.branches.delete(node);
            };
        }
    }, [
        context.branches
    ]);
    return /*#__PURE__*/ (0, $aOChP.createElement)((0, $6a0e2eba41459a28$export$250ffa63cdc0d034).div, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({}, props, {
        ref: composedRefs
    }));
});
/*#__PURE__*/ Object.assign($b8305c8aec918214$export$4d5eb2109db14228, {
    displayName: $b8305c8aec918214$var$$5cb92bef7577960e$var$BRANCH_NAME
});
/* -----------------------------------------------------------------------------------------------*/ /**
 * Listens for `pointerdown` outside a react subtree. We use `pointerdown` rather than `pointerup`
 * to mimic layer dismissing behaviour present in OS.
 * Returns props to pass to the node we want to check for outside events.
 */ function $b8305c8aec918214$var$$5cb92bef7577960e$var$usePointerDownOutside(onPointerDownOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handlePointerDownOutside = (0, $60b6529be484f710$export$25bec8c6f54ee79a)(onPointerDownOutside);
    const isPointerInsideReactTreeRef = (0, $aOChP.useRef)(false);
    const handleClickRef = (0, $aOChP.useRef)(()=>{});
    (0, $aOChP.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (event.target && !isPointerInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                function handleAndDispatchPointerDownOutsideEvent() {
                    $b8305c8aec918214$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($b8305c8aec918214$var$$5cb92bef7577960e$var$POINTER_DOWN_OUTSIDE, handlePointerDownOutside, eventDetail, {
                        discrete: true
                    });
                }
                /**
         * On touch devices, we need to wait for a click event because browsers implement
         * a ~350ms delay between the time the user stops touching the display and when the
         * browser executres events. We need to ensure we don't reactivate pointer-events within
         * this timeframe otherwise the browser may execute events that should have been prevented.
         *
         * Additionally, this also lets us deal automatically with cancellations when a click event
         * isn't raised because the page was considered scrolled/drag-scrolled, long-pressed, etc.
         *
         * This is why we also continuously remove the previous listener, because we cannot be
         * certain that it was raised, and therefore cleaned-up.
         */ if (event.pointerType === "touch") {
                    ownerDocument.removeEventListener("click", handleClickRef.current);
                    handleClickRef.current = handleAndDispatchPointerDownOutsideEvent;
                    ownerDocument.addEventListener("click", handleClickRef.current, {
                        once: true
                    });
                } else handleAndDispatchPointerDownOutsideEvent();
            } else // See: https://github.com/radix-ui/primitives/issues/2171
            ownerDocument.removeEventListener("click", handleClickRef.current);
            isPointerInsideReactTreeRef.current = false;
        };
        /**
     * if this hook executes in a component that mounts via a `pointerdown` event, the event
     * would bubble up to the document and trigger a `pointerDownOutside` event. We avoid
     * this by delaying the event listener registration on the document.
     * This is not React specific, but rather how the DOM works, ie:
     * ```
     * button.addEventListener('pointerdown', () => {
     *   console.log('I will log');
     *   document.addEventListener('pointerdown', () => {
     *     console.log('I will also log');
     *   })
     * });
     */ const timerId = window.setTimeout(()=>{
            ownerDocument.addEventListener("pointerdown", handlePointerDown);
        }, 0);
        return ()=>{
            window.clearTimeout(timerId);
            ownerDocument.removeEventListener("pointerdown", handlePointerDown);
            ownerDocument.removeEventListener("click", handleClickRef.current);
        };
    }, [
        ownerDocument,
        handlePointerDownOutside
    ]);
    return {
        // ensures we check React component tree (not just DOM tree)
        onPointerDownCapture: ()=>isPointerInsideReactTreeRef.current = true
    };
}
/**
 * Listens for when focus happens outside a react subtree.
 * Returns props to pass to the root (node) of the subtree we want to check.
 */ function $b8305c8aec918214$var$$5cb92bef7577960e$var$useFocusOutside(onFocusOutside, ownerDocument = globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) {
    const handleFocusOutside = (0, $60b6529be484f710$export$25bec8c6f54ee79a)(onFocusOutside);
    const isFocusInsideReactTreeRef = (0, $aOChP.useRef)(false);
    (0, $aOChP.useEffect)(()=>{
        const handleFocus = (event)=>{
            if (event.target && !isFocusInsideReactTreeRef.current) {
                const eventDetail = {
                    originalEvent: event
                };
                $b8305c8aec918214$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent($b8305c8aec918214$var$$5cb92bef7577960e$var$FOCUS_OUTSIDE, handleFocusOutside, eventDetail, {
                    discrete: false
                });
            }
        };
        ownerDocument.addEventListener("focusin", handleFocus);
        return ()=>ownerDocument.removeEventListener("focusin", handleFocus);
    }, [
        ownerDocument,
        handleFocusOutside
    ]);
    return {
        onFocusCapture: ()=>isFocusInsideReactTreeRef.current = true,
        onBlurCapture: ()=>isFocusInsideReactTreeRef.current = false
    };
}
function $b8305c8aec918214$var$$5cb92bef7577960e$var$dispatchUpdate() {
    const event = new CustomEvent($b8305c8aec918214$var$$5cb92bef7577960e$var$CONTEXT_UPDATE);
    document.dispatchEvent(event);
}
function $b8305c8aec918214$var$$5cb92bef7577960e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const target = detail.originalEvent.target;
    const event = new CustomEvent(name, {
        bubbles: false,
        cancelable: true,
        detail: detail
    });
    if (handler) target.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $6a0e2eba41459a28$export$6d1a0317bde7de7f)(target, event);
    else target.dispatchEvent(event);
}
const $b8305c8aec918214$export$be92b6f5f03c0fe9 = $b8305c8aec918214$export$177fb62ff3ec1f22;
const $b8305c8aec918214$export$aecb2ddcb55c95be = $b8305c8aec918214$export$4d5eb2109db14228;




var $aOChP = parcelRequire("aOChP");


/* -------------------------------------------------------------------------------------------------
 * Portal
 * -----------------------------------------------------------------------------------------------*/ const $4f50d46168c445e7$var$$f1701beae083dbae$var$PORTAL_NAME = "Portal";
const $4f50d46168c445e7$export$602eac185826482c = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    var _globalThis$document;
    const { container: container = globalThis === null || globalThis === void 0 ? void 0 : (_globalThis$document = globalThis.document) === null || _globalThis$document === void 0 ? void 0 : _globalThis$document.body, ...portalProps } = props;
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($a4960af4154d3849$exports))).createPortal(/*#__PURE__*/ (0, $aOChP.createElement)((0, $6a0e2eba41459a28$export$250ffa63cdc0d034).div, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({}, portalProps, {
        ref: forwardedRef
    })), container) : null;
});
/*#__PURE__*/ Object.assign($4f50d46168c445e7$export$602eac185826482c, {
    displayName: $4f50d46168c445e7$var$$f1701beae083dbae$var$PORTAL_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $4f50d46168c445e7$export$be92b6f5f03c0fe9 = $4f50d46168c445e7$export$602eac185826482c;



var $aOChP = parcelRequire("aOChP");



var $aOChP = parcelRequire("aOChP");
/**
 * On the server, React emits a warning when calling `useLayoutEffect`.
 * This is because neither `useLayoutEffect` nor `useEffect` run on the server.
 * We use this safe version which suppresses the warning by replacing it with a noop on the server.
 *
 * See: https://reactjs.org/docs/hooks-reference.html#uselayouteffect
 */ const $f73d68885bc96af3$export$e5c5a5f917a5871c = Boolean(globalThis === null || globalThis === void 0 ? void 0 : globalThis.document) ? (0, $aOChP.useLayoutEffect) : ()=>{};


function $7a26f1d18e4f411d$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, machine) {
    return (0, $aOChP.useReducer)((state, event)=>{
        const nextState = machine[state][event];
        return nextState !== null && nextState !== void 0 ? nextState : state;
    }, initialState);
}
const $7a26f1d18e4f411d$export$99c2b779aa4e8b8b = (props)=>{
    const { present: present, children: children } = props;
    const presence = $7a26f1d18e4f411d$var$$921a889cee6df7e8$var$usePresence(present);
    const child = typeof children === "function" ? children({
        present: presence.isPresent
    }) : (0, $aOChP.Children).only(children);
    const ref = (0, $a1ec28269954e36e$export$c7b2cbe3552a0d05)(presence.ref, child.ref);
    const forceMount = typeof children === "function";
    return forceMount || presence.isPresent ? /*#__PURE__*/ (0, $aOChP.cloneElement)(child, {
        ref: ref
    }) : null;
};
$7a26f1d18e4f411d$export$99c2b779aa4e8b8b.displayName = "Presence";
/* -------------------------------------------------------------------------------------------------
 * usePresence
 * -----------------------------------------------------------------------------------------------*/ function $7a26f1d18e4f411d$var$$921a889cee6df7e8$var$usePresence(present) {
    const [node1, setNode] = (0, $aOChP.useState)();
    const stylesRef = (0, $aOChP.useRef)({});
    const prevPresentRef = (0, $aOChP.useRef)(present);
    const prevAnimationNameRef = (0, $aOChP.useRef)("none");
    const initialState = present ? "mounted" : "unmounted";
    const [state, send] = $7a26f1d18e4f411d$var$$fe963b355347cc68$export$3e6543de14f8614f(initialState, {
        mounted: {
            UNMOUNT: "unmounted",
            ANIMATION_OUT: "unmountSuspended"
        },
        unmountSuspended: {
            MOUNT: "mounted",
            ANIMATION_END: "unmounted"
        },
        unmounted: {
            MOUNT: "mounted"
        }
    });
    (0, $aOChP.useEffect)(()=>{
        const currentAnimationName = $7a26f1d18e4f411d$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
        prevAnimationNameRef.current = state === "mounted" ? currentAnimationName : "none";
    }, [
        state
    ]);
    (0, $f73d68885bc96af3$export$e5c5a5f917a5871c)(()=>{
        const styles = stylesRef.current;
        const wasPresent = prevPresentRef.current;
        const hasPresentChanged = wasPresent !== present;
        if (hasPresentChanged) {
            const prevAnimationName = prevAnimationNameRef.current;
            const currentAnimationName = $7a26f1d18e4f411d$var$$921a889cee6df7e8$var$getAnimationName(styles);
            if (present) send("MOUNT");
            else if (currentAnimationName === "none" || (styles === null || styles === void 0 ? void 0 : styles.display) === "none") // so we unmount instantly
            send("UNMOUNT");
            else {
                /**
         * When `present` changes to `false`, we check changes to animation-name to
         * determine whether an animation has started. We chose this approach (reading
         * computed styles) because there is no `animationrun` event and `animationstart`
         * fires after `animation-delay` has expired which would be too late.
         */ const isAnimating = prevAnimationName !== currentAnimationName;
                if (wasPresent && isAnimating) send("ANIMATION_OUT");
                else send("UNMOUNT");
            }
            prevPresentRef.current = present;
        }
    }, [
        present,
        send
    ]);
    (0, $f73d68885bc96af3$export$e5c5a5f917a5871c)(()=>{
        if (node1) {
            /**
       * Triggering an ANIMATION_OUT during an ANIMATION_IN will fire an `animationcancel`
       * event for ANIMATION_IN after we have entered `unmountSuspended` state. So, we
       * make sure we only trigger ANIMATION_END for the currently active animation.
       */ const handleAnimationEnd = (event)=>{
                const currentAnimationName = $7a26f1d18e4f411d$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
                const isCurrentAnimation = currentAnimationName.includes(event.animationName);
                if (event.target === node1 && isCurrentAnimation) // a frame after the animation ends, creating a flash of visible content.
                // By manually flushing we ensure they sync within a frame, removing the flash.
                (0, $a4960af4154d3849$exports.flushSync)(()=>send("ANIMATION_END"));
            };
            const handleAnimationStart = (event)=>{
                if (event.target === node1) prevAnimationNameRef.current = $7a26f1d18e4f411d$var$$921a889cee6df7e8$var$getAnimationName(stylesRef.current);
            };
            node1.addEventListener("animationstart", handleAnimationStart);
            node1.addEventListener("animationcancel", handleAnimationEnd);
            node1.addEventListener("animationend", handleAnimationEnd);
            return ()=>{
                node1.removeEventListener("animationstart", handleAnimationStart);
                node1.removeEventListener("animationcancel", handleAnimationEnd);
                node1.removeEventListener("animationend", handleAnimationEnd);
            };
        } else // We avoid doing so during cleanup as the node may change but still exist.
        send("ANIMATION_END");
    }, [
        node1,
        send
    ]);
    return {
        isPresent: [
            "mounted",
            "unmountSuspended"
        ].includes(state),
        ref: (0, $aOChP.useCallback)((node)=>{
            if (node) stylesRef.current = getComputedStyle(node);
            setNode(node);
        }, [])
    };
}
/* -----------------------------------------------------------------------------------------------*/ function $7a26f1d18e4f411d$var$$921a889cee6df7e8$var$getAnimationName(styles) {
    return (styles === null || styles === void 0 ? void 0 : styles.animationName) || "none";
}





var $aOChP = parcelRequire("aOChP");

function $e77733c3f5606b79$export$6f32135080cb4c3({ prop: prop, defaultProp: defaultProp, onChange: onChange = ()=>{} }) {
    const [uncontrolledProp, setUncontrolledProp] = $e77733c3f5606b79$var$$71cd76cc60e0454e$var$useUncontrolledState({
        defaultProp: defaultProp,
        onChange: onChange
    });
    const isControlled = prop !== undefined;
    const value1 = isControlled ? prop : uncontrolledProp;
    const handleChange = (0, $60b6529be484f710$export$25bec8c6f54ee79a)(onChange);
    const setValue = (0, $aOChP.useCallback)((nextValue)=>{
        if (isControlled) {
            const setter = nextValue;
            const value = typeof nextValue === "function" ? setter(prop) : nextValue;
            if (value !== prop) handleChange(value);
        } else setUncontrolledProp(nextValue);
    }, [
        isControlled,
        prop,
        setUncontrolledProp,
        handleChange
    ]);
    return [
        value1,
        setValue
    ];
}
function $e77733c3f5606b79$var$$71cd76cc60e0454e$var$useUncontrolledState({ defaultProp: defaultProp, onChange: onChange }) {
    const uncontrolledState = (0, $aOChP.useState)(defaultProp);
    const [value] = uncontrolledState;
    const prevValueRef = (0, $aOChP.useRef)(value);
    const handleChange = (0, $60b6529be484f710$export$25bec8c6f54ee79a)(onChange);
    (0, $aOChP.useEffect)(()=>{
        if (prevValueRef.current !== value) {
            handleChange(value);
            prevValueRef.current = value;
        }
    }, [
        value,
        prevValueRef,
        handleChange
    ]);
    return uncontrolledState;
}





var $aOChP = parcelRequire("aOChP");

/* -------------------------------------------------------------------------------------------------
 * VisuallyHidden
 * -----------------------------------------------------------------------------------------------*/ const $2f984305b4e3ded8$var$$ea1ef594cf570d83$var$NAME = "VisuallyHidden";
const $2f984305b4e3ded8$export$439d29a4e110a164 = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    return /*#__PURE__*/ (0, $aOChP.createElement)((0, $6a0e2eba41459a28$export$250ffa63cdc0d034).span, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({}, props, {
        ref: forwardedRef,
        style: {
            // See: https://github.com/twbs/bootstrap/blob/master/scss/mixins/_screen-reader.scss
            position: "absolute",
            border: 0,
            width: 1,
            height: 1,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            wordWrap: "normal",
            ...props.style
        }
    }));
});
/*#__PURE__*/ Object.assign($2f984305b4e3ded8$export$439d29a4e110a164, {
    displayName: $2f984305b4e3ded8$var$$ea1ef594cf570d83$var$NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $2f984305b4e3ded8$export$be92b6f5f03c0fe9 = $2f984305b4e3ded8$export$439d29a4e110a164;


/* -------------------------------------------------------------------------------------------------
 * ToastProvider
 * -----------------------------------------------------------------------------------------------*/ const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$PROVIDER_NAME = "ToastProvider";
const [$a6c5e10b762813a4$var$$054eb8030ebde76e$var$Collection, $a6c5e10b762813a4$var$$054eb8030ebde76e$var$useCollection, $a6c5e10b762813a4$var$$054eb8030ebde76e$var$createCollectionScope] = (0, $98fc231b3b687e12$export$c74125a8e3af6bb2)("Toast");
const [$a6c5e10b762813a4$var$$054eb8030ebde76e$var$createToastContext, $a6c5e10b762813a4$export$8a359da18fbc9073] = (0, $2faebf39acec7f19$export$50c7b4e9d9f19c1)("Toast", [
    $a6c5e10b762813a4$var$$054eb8030ebde76e$var$createCollectionScope
]);
const [$a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastProviderProvider, $a6c5e10b762813a4$var$$054eb8030ebde76e$var$useToastProviderContext] = $a6c5e10b762813a4$var$$054eb8030ebde76e$var$createToastContext($a6c5e10b762813a4$var$$054eb8030ebde76e$var$PROVIDER_NAME);
const $a6c5e10b762813a4$export$f5d03d415824e0e = (props)=>{
    const { __scopeToast: __scopeToast, label: label = "Notification", duration: duration = 5000, swipeDirection: swipeDirection = "right", swipeThreshold: swipeThreshold = 50, children: children } = props;
    const [viewport, setViewport] = (0, $aOChP.useState)(null);
    const [toastCount, setToastCount] = (0, $aOChP.useState)(0);
    const isFocusedToastEscapeKeyDownRef = (0, $aOChP.useRef)(false);
    const isClosePausedRef = (0, $aOChP.useRef)(false);
    return /*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$var$$054eb8030ebde76e$var$Collection.Provider, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastProviderProvider, {
        scope: __scopeToast,
        label: label,
        duration: duration,
        swipeDirection: swipeDirection,
        swipeThreshold: swipeThreshold,
        toastCount: toastCount,
        viewport: viewport,
        onViewportChange: setViewport,
        onToastAdd: (0, $aOChP.useCallback)(()=>setToastCount((prevCount)=>prevCount + 1), []),
        onToastRemove: (0, $aOChP.useCallback)(()=>setToastCount((prevCount)=>prevCount - 1), []),
        isFocusedToastEscapeKeyDownRef: isFocusedToastEscapeKeyDownRef,
        isClosePausedRef: isClosePausedRef
    }, children));
};
$a6c5e10b762813a4$export$f5d03d415824e0e.propTypes = {
    label (props) {
        if (props.label && typeof props.label === "string" && !props.label.trim()) {
            const error = `Invalid prop \`label\` supplied to \`${$a6c5e10b762813a4$var$$054eb8030ebde76e$var$PROVIDER_NAME}\`. Expected non-empty \`string\`.`;
            return new Error(error);
        }
        return null;
    }
};
/*#__PURE__*/ Object.assign($a6c5e10b762813a4$export$f5d03d415824e0e, {
    displayName: $a6c5e10b762813a4$var$$054eb8030ebde76e$var$PROVIDER_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastViewport
 * -----------------------------------------------------------------------------------------------*/ const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_NAME = "ToastViewport";
const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY = [
    "F8"
];
const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE = "toast.viewportPause";
const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_RESUME = "toast.viewportResume";
const $a6c5e10b762813a4$export$6192c2425ecfd989 = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, hotkey: hotkey = $a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_DEFAULT_HOTKEY, label: label = "Notifications ({hotkey})", ...viewportProps } = props;
    const context = $a6c5e10b762813a4$var$$054eb8030ebde76e$var$useToastProviderContext($a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_NAME, __scopeToast);
    const getItems = $a6c5e10b762813a4$var$$054eb8030ebde76e$var$useCollection(__scopeToast);
    const wrapperRef = (0, $aOChP.useRef)(null);
    const headFocusProxyRef = (0, $aOChP.useRef)(null);
    const tailFocusProxyRef = (0, $aOChP.useRef)(null);
    const ref = (0, $aOChP.useRef)(null);
    const composedRefs = (0, $a1ec28269954e36e$export$c7b2cbe3552a0d05)(forwardedRef, ref, context.onViewportChange);
    const hotkeyLabel = hotkey.join("+").replace(/Key/g, "").replace(/Digit/g, "");
    const hasToasts = context.toastCount > 0;
    (0, $aOChP.useEffect)(()=>{
        const handleKeyDown = (event)=>{
            var _ref$current;
            // we use `event.code` as it is consistent regardless of meta keys that were pressed.
            // for example, `event.key` for `Control+Alt+t` is `†` and `t !== †`
            const isHotkeyPressed = hotkey.every((key)=>event[key] || event.code === key);
            if (isHotkeyPressed) (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.focus();
        };
        document.addEventListener("keydown", handleKeyDown);
        return ()=>document.removeEventListener("keydown", handleKeyDown);
    }, [
        hotkey
    ]);
    (0, $aOChP.useEffect)(()=>{
        const wrapper = wrapperRef.current;
        const viewport = ref.current;
        if (hasToasts && wrapper && viewport) {
            const handlePause = ()=>{
                if (!context.isClosePausedRef.current) {
                    const pauseEvent = new CustomEvent($a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE);
                    viewport.dispatchEvent(pauseEvent);
                    context.isClosePausedRef.current = true;
                }
            };
            const handleResume = ()=>{
                if (context.isClosePausedRef.current) {
                    const resumeEvent = new CustomEvent($a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_RESUME);
                    viewport.dispatchEvent(resumeEvent);
                    context.isClosePausedRef.current = false;
                }
            };
            const handleFocusOutResume = (event)=>{
                const isFocusMovingOutside = !wrapper.contains(event.relatedTarget);
                if (isFocusMovingOutside) handleResume();
            };
            const handlePointerLeaveResume = ()=>{
                const isFocusInside = wrapper.contains(document.activeElement);
                if (!isFocusInside) handleResume();
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            wrapper.addEventListener("focusin", handlePause);
            wrapper.addEventListener("focusout", handleFocusOutResume);
            wrapper.addEventListener("pointermove", handlePause);
            wrapper.addEventListener("pointerleave", handlePointerLeaveResume);
            window.addEventListener("blur", handlePause);
            window.addEventListener("focus", handleResume);
            return ()=>{
                wrapper.removeEventListener("focusin", handlePause);
                wrapper.removeEventListener("focusout", handleFocusOutResume);
                wrapper.removeEventListener("pointermove", handlePause);
                wrapper.removeEventListener("pointerleave", handlePointerLeaveResume);
                window.removeEventListener("blur", handlePause);
                window.removeEventListener("focus", handleResume);
            };
        }
    }, [
        hasToasts,
        context.isClosePausedRef
    ]);
    const getSortedTabbableCandidates = (0, $aOChP.useCallback)(({ tabbingDirection: tabbingDirection })=>{
        const toastItems = getItems();
        const tabbableCandidates = toastItems.map((toastItem)=>{
            const toastNode = toastItem.ref.current;
            const toastTabbableCandidates = [
                toastNode,
                ...$a6c5e10b762813a4$var$$054eb8030ebde76e$var$getTabbableCandidates(toastNode)
            ];
            return tabbingDirection === "forwards" ? toastTabbableCandidates : toastTabbableCandidates.reverse();
        });
        return (tabbingDirection === "forwards" ? tabbableCandidates.reverse() : tabbableCandidates).flat();
    }, [
        getItems
    ]);
    (0, $aOChP.useEffect)(()=>{
        const viewport = ref.current; // We programmatically manage tabbing as we are unable to influence
        // the source order with portals, this allows us to reverse the
        // tab order so that it runs from most recent toast to least
        if (viewport) {
            const handleKeyDown = (event)=>{
                const isMetaKey = event.altKey || event.ctrlKey || event.metaKey;
                const isTabKey = event.key === "Tab" && !isMetaKey;
                if (isTabKey) {
                    const focusedElement = document.activeElement;
                    const isTabbingBackwards = event.shiftKey;
                    const targetIsViewport = event.target === viewport; // If we're back tabbing after jumping to the viewport then we simply
                    // proxy focus out to the preceding document
                    if (targetIsViewport && isTabbingBackwards) {
                        var _headFocusProxyRef$cu;
                        (_headFocusProxyRef$cu = headFocusProxyRef.current) === null || _headFocusProxyRef$cu === void 0 || _headFocusProxyRef$cu.focus();
                        return;
                    }
                    const tabbingDirection = isTabbingBackwards ? "backwards" : "forwards";
                    const sortedCandidates = getSortedTabbableCandidates({
                        tabbingDirection: tabbingDirection
                    });
                    const index = sortedCandidates.findIndex((candidate)=>candidate === focusedElement);
                    if ($a6c5e10b762813a4$var$$054eb8030ebde76e$var$focusFirst(sortedCandidates.slice(index + 1))) event.preventDefault();
                    else {
                        var _headFocusProxyRef$cu2, _tailFocusProxyRef$cu;
                        // If we can't focus that means we're at the edges so we
                        // proxy to the corresponding exit point and let the browser handle
                        // tab/shift+tab keypress and implicitly pass focus to the next valid element in the document
                        isTabbingBackwards ? (_headFocusProxyRef$cu2 = headFocusProxyRef.current) === null || _headFocusProxyRef$cu2 === void 0 || _headFocusProxyRef$cu2.focus() : (_tailFocusProxyRef$cu = tailFocusProxyRef.current) === null || _tailFocusProxyRef$cu === void 0 || _tailFocusProxyRef$cu.focus();
                    }
                }
            }; // Toasts are not in the viewport React tree so we need to bind DOM events
            viewport.addEventListener("keydown", handleKeyDown);
            return ()=>viewport.removeEventListener("keydown", handleKeyDown);
        }
    }, [
        getItems,
        getSortedTabbableCandidates
    ]);
    return /*#__PURE__*/ (0, $aOChP.createElement)((0, $b8305c8aec918214$export$aecb2ddcb55c95be), {
        ref: wrapperRef,
        role: "region",
        "aria-label": label.replace("{hotkey}", hotkeyLabel) // Ensure virtual cursor from landmarks menus triggers focus/blur for pause/resume
        ,
        tabIndex: -1 // incase list has size when empty (e.g. padding), we remove pointer events so
        ,
        style: {
            pointerEvents: hasToasts ? undefined : "none"
        }
    }, hasToasts && /*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: headFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "forwards"
            });
            $a6c5e10b762813a4$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }), /*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$var$$054eb8030ebde76e$var$Collection.Slot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $aOChP.createElement)((0, $6a0e2eba41459a28$export$250ffa63cdc0d034).ol, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({
        tabIndex: -1
    }, viewportProps, {
        ref: composedRefs
    }))), hasToasts && /*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$var$$054eb8030ebde76e$var$FocusProxy, {
        ref: tailFocusProxyRef,
        onFocusFromOutsideViewport: ()=>{
            const tabbableCandidates = getSortedTabbableCandidates({
                tabbingDirection: "backwards"
            });
            $a6c5e10b762813a4$var$$054eb8030ebde76e$var$focusFirst(tabbableCandidates);
        }
    }));
});
/*#__PURE__*/ Object.assign($a6c5e10b762813a4$export$6192c2425ecfd989, {
    displayName: $a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME = "ToastFocusProxy";
const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$FocusProxy = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, onFocusFromOutsideViewport: onFocusFromOutsideViewport, ...proxyProps } = props;
    const context = $a6c5e10b762813a4$var$$054eb8030ebde76e$var$useToastProviderContext($a6c5e10b762813a4$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $aOChP.createElement)((0, $2f984305b4e3ded8$export$439d29a4e110a164), (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({
        "aria-hidden": true,
        tabIndex: 0
    }, proxyProps, {
        ref: forwardedRef // Avoid page scrolling when focus is on the focus proxy
        ,
        style: {
            position: "fixed"
        },
        onFocus: (event)=>{
            var _context$viewport;
            const prevFocusedElement = event.relatedTarget;
            const isFocusFromOutsideViewport = !((_context$viewport = context.viewport) !== null && _context$viewport !== void 0 && _context$viewport.contains(prevFocusedElement));
            if (isFocusFromOutsideViewport) onFocusFromOutsideViewport();
        }
    }));
});
/*#__PURE__*/ Object.assign($a6c5e10b762813a4$var$$054eb8030ebde76e$var$FocusProxy, {
    displayName: $a6c5e10b762813a4$var$$054eb8030ebde76e$var$FOCUS_PROXY_NAME
});
/* -------------------------------------------------------------------------------------------------
 * Toast
 * -----------------------------------------------------------------------------------------------*/ const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_NAME = "Toast";
const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_SWIPE_START = "toast.swipeStart";
const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE = "toast.swipeMove";
const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL = "toast.swipeCancel";
const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_SWIPE_END = "toast.swipeEnd";
const $a6c5e10b762813a4$export$8d8dc7d5f743331b = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const { forceMount: forceMount, open: openProp, defaultOpen: defaultOpen, onOpenChange: onOpenChange, ...toastProps } = props;
    const [open = true, setOpen] = (0, $e77733c3f5606b79$export$6f32135080cb4c3)({
        prop: openProp,
        defaultProp: defaultOpen,
        onChange: onOpenChange
    });
    return /*#__PURE__*/ (0, $aOChP.createElement)((0, $7a26f1d18e4f411d$export$99c2b779aa4e8b8b), {
        present: forceMount || open
    }, /*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastImpl, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({
        open: open
    }, toastProps, {
        ref: forwardedRef,
        onClose: ()=>setOpen(false),
        onPause: (0, $60b6529be484f710$export$25bec8c6f54ee79a)(props.onPause),
        onResume: (0, $60b6529be484f710$export$25bec8c6f54ee79a)(props.onResume),
        onSwipeStart: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onSwipeStart, (event)=>{
            event.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onSwipeMove, (event)=>{
            const { x: x, y: y } = event.detail.delta;
            event.currentTarget.setAttribute("data-swipe", "move");
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${x}px`);
            event.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${y}px`);
        }),
        onSwipeCancel: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onSwipeCancel, (event)=>{
            event.currentTarget.setAttribute("data-swipe", "cancel");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onSwipeEnd, (event)=>{
            const { x: x, y: y } = event.detail.delta;
            event.currentTarget.setAttribute("data-swipe", "end");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-x");
            event.currentTarget.style.removeProperty("--radix-toast-swipe-move-y");
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${x}px`);
            event.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${y}px`);
            setOpen(false);
        })
    })));
});
/*#__PURE__*/ Object.assign($a6c5e10b762813a4$export$8d8dc7d5f743331b, {
    displayName: $a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_NAME
});
/* -----------------------------------------------------------------------------------------------*/ const [$a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastInteractiveProvider, $a6c5e10b762813a4$var$$054eb8030ebde76e$var$useToastInteractiveContext] = $a6c5e10b762813a4$var$$054eb8030ebde76e$var$createToastContext($a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_NAME, {
    onClose () {}
});
const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastImpl = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, type: type = "foreground", duration: durationProp, open: open, onClose: onClose, onEscapeKeyDown: onEscapeKeyDown, onPause: onPause, onResume: onResume, onSwipeStart: onSwipeStart, onSwipeMove: onSwipeMove, onSwipeCancel: onSwipeCancel, onSwipeEnd: onSwipeEnd, ...toastProps } = props;
    const context = $a6c5e10b762813a4$var$$054eb8030ebde76e$var$useToastProviderContext($a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [node1, setNode] = (0, $aOChP.useState)(null);
    const composedRefs = (0, $a1ec28269954e36e$export$c7b2cbe3552a0d05)(forwardedRef, (node)=>setNode(node));
    const pointerStartRef = (0, $aOChP.useRef)(null);
    const swipeDeltaRef = (0, $aOChP.useRef)(null);
    const duration1 = durationProp || context.duration;
    const closeTimerStartTimeRef = (0, $aOChP.useRef)(0);
    const closeTimerRemainingTimeRef = (0, $aOChP.useRef)(duration1);
    const closeTimerRef = (0, $aOChP.useRef)(0);
    const { onToastAdd: onToastAdd, onToastRemove: onToastRemove } = context;
    const handleClose = (0, $60b6529be484f710$export$25bec8c6f54ee79a)(()=>{
        var _context$viewport2;
        // focus viewport if focus is within toast to read the remaining toast
        // count to SR users and ensure focus isn't lost
        const isFocusInToast = node1 === null || node1 === void 0 ? void 0 : node1.contains(document.activeElement);
        if (isFocusInToast) (_context$viewport2 = context.viewport) === null || _context$viewport2 === void 0 || _context$viewport2.focus();
        onClose();
    });
    const startTimer = (0, $aOChP.useCallback)((duration)=>{
        if (!duration || duration === Infinity) return;
        window.clearTimeout(closeTimerRef.current);
        closeTimerStartTimeRef.current = new Date().getTime();
        closeTimerRef.current = window.setTimeout(handleClose, duration);
    }, [
        handleClose
    ]);
    (0, $aOChP.useEffect)(()=>{
        const viewport = context.viewport;
        if (viewport) {
            const handleResume = ()=>{
                startTimer(closeTimerRemainingTimeRef.current);
                onResume === null || onResume === void 0 || onResume();
            };
            const handlePause = ()=>{
                const elapsedTime = new Date().getTime() - closeTimerStartTimeRef.current;
                closeTimerRemainingTimeRef.current = closeTimerRemainingTimeRef.current - elapsedTime;
                window.clearTimeout(closeTimerRef.current);
                onPause === null || onPause === void 0 || onPause();
            };
            viewport.addEventListener($a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
            viewport.addEventListener($a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            return ()=>{
                viewport.removeEventListener($a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_PAUSE, handlePause);
                viewport.removeEventListener($a6c5e10b762813a4$var$$054eb8030ebde76e$var$VIEWPORT_RESUME, handleResume);
            };
        }
    }, [
        context.viewport,
        duration1,
        onPause,
        onResume,
        startTimer
    ]); // start timer when toast opens or duration changes.
    // we include `open` in deps because closed !== unmounted when animating
    // so it could reopen before being completely unmounted
    (0, $aOChP.useEffect)(()=>{
        if (open && !context.isClosePausedRef.current) startTimer(duration1);
    }, [
        open,
        duration1,
        context.isClosePausedRef,
        startTimer
    ]);
    (0, $aOChP.useEffect)(()=>{
        onToastAdd();
        return ()=>onToastRemove();
    }, [
        onToastAdd,
        onToastRemove
    ]);
    const announceTextContent = (0, $aOChP.useMemo)(()=>{
        return node1 ? $a6c5e10b762813a4$var$$054eb8030ebde76e$var$getAnnounceTextContent(node1) : null;
    }, [
        node1
    ]);
    if (!context.viewport) return null;
    return /*#__PURE__*/ (0, $aOChP.createElement)((0, $aOChP.Fragment), null, announceTextContent && /*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastAnnounce, {
        __scopeToast: __scopeToast // Toasts are always role=status to avoid stuttering issues with role=alert in SRs.
        ,
        role: "status",
        "aria-live": type === "foreground" ? "assertive" : "polite",
        "aria-atomic": true
    }, announceTextContent), /*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastInteractiveProvider, {
        scope: __scopeToast,
        onClose: handleClose
    }, /*#__PURE__*/ (0, $a4960af4154d3849$exports.createPortal)(/*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$var$$054eb8030ebde76e$var$Collection.ItemSlot, {
        scope: __scopeToast
    }, /*#__PURE__*/ (0, $aOChP.createElement)((0, $b8305c8aec918214$export$be92b6f5f03c0fe9), {
        asChild: true,
        onEscapeKeyDown: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(onEscapeKeyDown, ()=>{
            if (!context.isFocusedToastEscapeKeyDownRef.current) handleClose();
            context.isFocusedToastEscapeKeyDownRef.current = false;
        })
    }, /*#__PURE__*/ (0, $aOChP.createElement)((0, $6a0e2eba41459a28$export$250ffa63cdc0d034).li, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({
        // Ensure toasts are announced as status list or status when focused
        role: "status",
        "aria-live": "off",
        "aria-atomic": true,
        tabIndex: 0,
        "data-state": open ? "open" : "closed",
        "data-swipe-direction": context.swipeDirection
    }, toastProps, {
        ref: composedRefs,
        style: {
            userSelect: "none",
            touchAction: "none",
            ...props.style
        },
        onKeyDown: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onKeyDown, (event)=>{
            if (event.key !== "Escape") return;
            onEscapeKeyDown === null || onEscapeKeyDown === void 0 || onEscapeKeyDown(event.nativeEvent);
            if (!event.nativeEvent.defaultPrevented) {
                context.isFocusedToastEscapeKeyDownRef.current = true;
                handleClose();
            }
        }),
        onPointerDown: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onPointerDown, (event)=>{
            if (event.button !== 0) return;
            pointerStartRef.current = {
                x: event.clientX,
                y: event.clientY
            };
        }),
        onPointerMove: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onPointerMove, (event)=>{
            if (!pointerStartRef.current) return;
            const x = event.clientX - pointerStartRef.current.x;
            const y = event.clientY - pointerStartRef.current.y;
            const hasSwipeMoveStarted = Boolean(swipeDeltaRef.current);
            const isHorizontalSwipe = [
                "left",
                "right"
            ].includes(context.swipeDirection);
            const clamp = [
                "left",
                "up"
            ].includes(context.swipeDirection) ? Math.min : Math.max;
            const clampedX = isHorizontalSwipe ? clamp(0, x) : 0;
            const clampedY = !isHorizontalSwipe ? clamp(0, y) : 0;
            const moveStartBuffer = event.pointerType === "touch" ? 10 : 2;
            const delta = {
                x: clampedX,
                y: clampedY
            };
            const eventDetail = {
                originalEvent: event,
                delta: delta
            };
            if (hasSwipeMoveStarted) {
                swipeDeltaRef.current = delta;
                $a6c5e10b762813a4$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_SWIPE_MOVE, onSwipeMove, eventDetail, {
                    discrete: false
                });
            } else if ($a6c5e10b762813a4$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, moveStartBuffer)) {
                swipeDeltaRef.current = delta;
                $a6c5e10b762813a4$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_SWIPE_START, onSwipeStart, eventDetail, {
                    discrete: false
                });
                event.target.setPointerCapture(event.pointerId);
            } else if (Math.abs(x) > moveStartBuffer || Math.abs(y) > moveStartBuffer) // for the current pointer down interaction
            pointerStartRef.current = null;
        }),
        onPointerUp: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onPointerUp, (event1)=>{
            const delta = swipeDeltaRef.current;
            const target = event1.target;
            if (target.hasPointerCapture(event1.pointerId)) target.releasePointerCapture(event1.pointerId);
            swipeDeltaRef.current = null;
            pointerStartRef.current = null;
            if (delta) {
                const toast = event1.currentTarget;
                const eventDetail = {
                    originalEvent: event1,
                    delta: delta
                };
                if ($a6c5e10b762813a4$var$$054eb8030ebde76e$var$isDeltaInDirection(delta, context.swipeDirection, context.swipeThreshold)) $a6c5e10b762813a4$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_SWIPE_END, onSwipeEnd, eventDetail, {
                    discrete: true
                });
                else $a6c5e10b762813a4$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent($a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_SWIPE_CANCEL, onSwipeCancel, eventDetail, {
                    discrete: true
                });
                // Prevent click event from triggering on items within the toast when
                // pointer up is part of a swipe gesture
                toast.addEventListener("click", (event)=>event.preventDefault(), {
                    once: true
                });
            }
        })
    })))), context.viewport)));
});
$a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastImpl.propTypes = {
    type (props) {
        if (props.type && ![
            "foreground",
            "background"
        ].includes(props.type)) {
            const error = `Invalid prop \`type\` supplied to \`${$a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_NAME}\`. Expected \`foreground | background\`.`;
            return new Error(error);
        }
        return null;
    }
};
/* -----------------------------------------------------------------------------------------------*/ const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastAnnounce = (props)=>{
    const { __scopeToast: __scopeToast, children: children, ...announceProps } = props;
    const context = $a6c5e10b762813a4$var$$054eb8030ebde76e$var$useToastProviderContext($a6c5e10b762813a4$var$$054eb8030ebde76e$var$TOAST_NAME, __scopeToast);
    const [renderAnnounceText, setRenderAnnounceText] = (0, $aOChP.useState)(false);
    const [isAnnounced, setIsAnnounced] = (0, $aOChP.useState)(false); // render text content in the next frame to ensure toast is announced in NVDA
    $a6c5e10b762813a4$var$$054eb8030ebde76e$var$useNextFrame(()=>setRenderAnnounceText(true)); // cleanup after announcing
    (0, $aOChP.useEffect)(()=>{
        const timer = window.setTimeout(()=>setIsAnnounced(true), 1000);
        return ()=>window.clearTimeout(timer);
    }, []);
    return isAnnounced ? null : /*#__PURE__*/ (0, $aOChP.createElement)((0, $4f50d46168c445e7$export$602eac185826482c), {
        asChild: true
    }, /*#__PURE__*/ (0, $aOChP.createElement)((0, $2f984305b4e3ded8$export$439d29a4e110a164), announceProps, renderAnnounceText && /*#__PURE__*/ (0, $aOChP.createElement)((0, $aOChP.Fragment), null, context.label, " ", children)));
};
/* -------------------------------------------------------------------------------------------------
 * ToastTitle
 * -----------------------------------------------------------------------------------------------*/ const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$TITLE_NAME = "ToastTitle";
const $a6c5e10b762813a4$export$16d42d7c29b95a4 = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...titleProps } = props;
    return /*#__PURE__*/ (0, $aOChP.createElement)((0, $6a0e2eba41459a28$export$250ffa63cdc0d034).div, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({}, titleProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a6c5e10b762813a4$export$16d42d7c29b95a4, {
    displayName: $a6c5e10b762813a4$var$$054eb8030ebde76e$var$TITLE_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastDescription
 * -----------------------------------------------------------------------------------------------*/ const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$DESCRIPTION_NAME = "ToastDescription";
const $a6c5e10b762813a4$export$ecddd96c53621d9a = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...descriptionProps } = props;
    return /*#__PURE__*/ (0, $aOChP.createElement)((0, $6a0e2eba41459a28$export$250ffa63cdc0d034).div, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({}, descriptionProps, {
        ref: forwardedRef
    }));
});
/*#__PURE__*/ Object.assign($a6c5e10b762813a4$export$ecddd96c53621d9a, {
    displayName: $a6c5e10b762813a4$var$$054eb8030ebde76e$var$DESCRIPTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastAction
 * -----------------------------------------------------------------------------------------------*/ const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$ACTION_NAME = "ToastAction";
const $a6c5e10b762813a4$export$3019feecfda683d2 = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const { altText: altText, ...actionProps } = props;
    if (!altText) return null;
    return /*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        altText: altText,
        asChild: true
    }, /*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$export$811e70f61c205839, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({}, actionProps, {
        ref: forwardedRef
    })));
});
$a6c5e10b762813a4$export$3019feecfda683d2.propTypes = {
    altText (props) {
        if (!props.altText) return new Error(`Missing prop \`altText\` expected on \`${$a6c5e10b762813a4$var$$054eb8030ebde76e$var$ACTION_NAME}\``);
        return null;
    }
};
/*#__PURE__*/ Object.assign($a6c5e10b762813a4$export$3019feecfda683d2, {
    displayName: $a6c5e10b762813a4$var$$054eb8030ebde76e$var$ACTION_NAME
});
/* -------------------------------------------------------------------------------------------------
 * ToastClose
 * -----------------------------------------------------------------------------------------------*/ const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$CLOSE_NAME = "ToastClose";
const $a6c5e10b762813a4$export$811e70f61c205839 = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, ...closeProps } = props;
    const interactiveContext = $a6c5e10b762813a4$var$$054eb8030ebde76e$var$useToastInteractiveContext($a6c5e10b762813a4$var$$054eb8030ebde76e$var$CLOSE_NAME, __scopeToast);
    return /*#__PURE__*/ (0, $aOChP.createElement)($a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastAnnounceExclude, {
        asChild: true
    }, /*#__PURE__*/ (0, $aOChP.createElement)((0, $6a0e2eba41459a28$export$250ffa63cdc0d034).button, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({
        type: "button"
    }, closeProps, {
        ref: forwardedRef,
        onClick: (0, $10b7648fa971952e$export$b9ecd428b558ff10)(props.onClick, interactiveContext.onClose)
    })));
});
/*#__PURE__*/ Object.assign($a6c5e10b762813a4$export$811e70f61c205839, {
    displayName: $a6c5e10b762813a4$var$$054eb8030ebde76e$var$CLOSE_NAME
});
/* ---------------------------------------------------------------------------------------------- */ const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$ToastAnnounceExclude = /*#__PURE__*/ (0, $aOChP.forwardRef)((props, forwardedRef)=>{
    const { __scopeToast: __scopeToast, altText: altText, ...announceExcludeProps } = props;
    return /*#__PURE__*/ (0, $aOChP.createElement)((0, $6a0e2eba41459a28$export$250ffa63cdc0d034).div, (0, $9dd0e7fad28ce0e4$export$2e2bcd8739ae039)({
        "data-radix-toast-announce-exclude": "",
        "data-radix-toast-announce-alt": altText || undefined
    }, announceExcludeProps, {
        ref: forwardedRef
    }));
});
function $a6c5e10b762813a4$var$$054eb8030ebde76e$var$getAnnounceTextContent(container) {
    const textContent = [];
    const childNodes = Array.from(container.childNodes);
    childNodes.forEach((node)=>{
        if (node.nodeType === node.TEXT_NODE && node.textContent) textContent.push(node.textContent);
        if ($a6c5e10b762813a4$var$$054eb8030ebde76e$var$isHTMLElement(node)) {
            const isHidden = node.ariaHidden || node.hidden || node.style.display === "none";
            const isExcluded = node.dataset.radixToastAnnounceExclude === "";
            if (!isHidden) {
                if (isExcluded) {
                    const altText = node.dataset.radixToastAnnounceAlt;
                    if (altText) textContent.push(altText);
                } else textContent.push(...$a6c5e10b762813a4$var$$054eb8030ebde76e$var$getAnnounceTextContent(node));
            }
        }
    }); // We return a collection of text rather than a single concatenated string.
    // This allows SR VO to naturally pause break between nodes while announcing.
    return textContent;
}
/* ---------------------------------------------------------------------------------------------- */ function $a6c5e10b762813a4$var$$054eb8030ebde76e$var$handleAndDispatchCustomEvent(name, handler, detail, { discrete: discrete }) {
    const currentTarget = detail.originalEvent.currentTarget;
    const event = new CustomEvent(name, {
        bubbles: true,
        cancelable: true,
        detail: detail
    });
    if (handler) currentTarget.addEventListener(name, handler, {
        once: true
    });
    if (discrete) (0, $6a0e2eba41459a28$export$6d1a0317bde7de7f)(currentTarget, event);
    else currentTarget.dispatchEvent(event);
}
const $a6c5e10b762813a4$var$$054eb8030ebde76e$var$isDeltaInDirection = (delta, direction, threshold = 0)=>{
    const deltaX = Math.abs(delta.x);
    const deltaY = Math.abs(delta.y);
    const isDeltaX = deltaX > deltaY;
    if (direction === "left" || direction === "right") return isDeltaX && deltaX > threshold;
    else return !isDeltaX && deltaY > threshold;
};
function $a6c5e10b762813a4$var$$054eb8030ebde76e$var$useNextFrame(callback = ()=>{}) {
    const fn = (0, $60b6529be484f710$export$25bec8c6f54ee79a)(callback);
    (0, $f73d68885bc96af3$export$e5c5a5f917a5871c)(()=>{
        let raf1 = 0;
        let raf2 = 0;
        raf1 = window.requestAnimationFrame(()=>raf2 = window.requestAnimationFrame(fn));
        return ()=>{
            window.cancelAnimationFrame(raf1);
            window.cancelAnimationFrame(raf2);
        };
    }, [
        fn
    ]);
}
function $a6c5e10b762813a4$var$$054eb8030ebde76e$var$isHTMLElement(node) {
    return node.nodeType === node.ELEMENT_NODE;
}
/**
 * Returns a list of potential tabbable candidates.
 *
 * NOTE: This is only a close approximation. For example it doesn't take into account cases like when
 * elements are not visible. This cannot be worked out easily by just reading a property, but rather
 * necessitate runtime knowledge (computed styles, etc). We deal with these cases separately.
 *
 * See: https://developer.mozilla.org/en-US/docs/Web/API/TreeWalker
 * Credit: https://github.com/discord/focus-layers/blob/master/src/util/wrapFocus.tsx#L1
 */ function $a6c5e10b762813a4$var$$054eb8030ebde76e$var$getTabbableCandidates(container) {
    const nodes = [];
    const walker = document.createTreeWalker(container, NodeFilter.SHOW_ELEMENT, {
        acceptNode: (node)=>{
            const isHiddenInput = node.tagName === "INPUT" && node.type === "hidden";
            if (node.disabled || node.hidden || isHiddenInput) return NodeFilter.FILTER_SKIP; // `.tabIndex` is not the same as the `tabindex` attribute. It works on the
            // runtime's understanding of tabbability, so this automatically accounts
            // for any kind of element that could be tabbed to.
            return node.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
        }
    });
    while(walker.nextNode())nodes.push(walker.currentNode); // we do not take into account the order of nodes with positive `tabIndex` as it
    // hinders accessibility to have tab order different from visual order.
    return nodes;
}
function $a6c5e10b762813a4$var$$054eb8030ebde76e$var$focusFirst(candidates) {
    const previouslyFocusedElement = document.activeElement;
    return candidates.some((candidate)=>{
        // if focus is already where we want to go, we don't want to keep going through the candidates
        if (candidate === previouslyFocusedElement) return true;
        candidate.focus();
        return document.activeElement !== previouslyFocusedElement;
    });
}
const $a6c5e10b762813a4$export$2881499e37b75b9a = $a6c5e10b762813a4$export$f5d03d415824e0e;
const $a6c5e10b762813a4$export$d5c6c08dc2d3ca7 = $a6c5e10b762813a4$export$6192c2425ecfd989;
const $a6c5e10b762813a4$export$be92b6f5f03c0fe9 = $a6c5e10b762813a4$export$8d8dc7d5f743331b;
const $a6c5e10b762813a4$export$f99233281efd08a0 = $a6c5e10b762813a4$export$16d42d7c29b95a4;
const $a6c5e10b762813a4$export$393edc798c47379d = $a6c5e10b762813a4$export$ecddd96c53621d9a;
const $a6c5e10b762813a4$export$e19cd5f9376f8cee = $a6c5e10b762813a4$export$3019feecfda683d2;
const $a6c5e10b762813a4$export$f39c2d165cd861fe = $a6c5e10b762813a4$export$811e70f61c205839;


const $e0523f05564edcbe$var$ItemList = ({ items: items })=>{
    // console.log(items);
    const styles = {
        rootStyle: "  p-[15px] grid [grid-template-areas:_'title_action'_'description_action'] grid-cols-[auto_max-content] gap-x-[15px] items-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=end]:animate-swipeOut fixed top-[90px] right-0 z-50 rounded-lg m-2 bg-white shadow-sm ",
        closeButtonStyle: "rounded-lg font-medium text-xs px-[10px] leading-[25px] h-[25px] bg-green2 text-green11 shadow-[inset_0_0_0_1px] shadow-green7 hover:shadow-[inset_0_0_0_1px] hover:shadow-green8 focus:shadow-[0_0_0_2px] focus:shadow-green8",
        viewPortStyle: "[--viewport-padding:_25px] fixed bottom-0 right-0 flex flex-col p-[var(--viewport-padding)] gap-[10px] w-[390px] max-w-[100vw] m-0 list-none z-[2147483647] outline-none"
    };
    const [open, setOpen] = (0, $aOChP.useState)(false);
    const timerRef = (0, $aOChP.useRef)(0);
    const [toastTitle, setToastTitle] = (0, $aOChP.useState)("Default Title");
    (0, $aOChP.useEffect)(()=>{
        return ()=>clearTimeout(timerRef.current);
    }, []);
    //dispatch is an action
    const dispatch = (0, $1c7032cc59fc9fd2$export$8ad76b76a4c905f8)();
    // onClick of Add Button
    const handleAddItem = (item)=>{
        // Dispatch an action
        dispatch((0, $6e3f649c67c08cff$export$fb9705de59d96855)(item));
        setOpen(false);
        setToastTitle("Added " + item.card.info.name);
        window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(()=>{
            setOpen(true);
        }, 100);
    };
    return /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
        children: items.map((item)=>/*#__PURE__*/ (0, $5Wgfu.jsxs)($a6c5e10b762813a4$export$2881499e37b75b9a, {
                swipeDirection: "right",
                duration: 1000,
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                        className: "border-b-2 border-gray-200 my-4 pb-5 flex",
                        "data-testid": "foodItem",
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                                className: "w-1/4 pl-6",
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                                        className: "absolute",
                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)("button", {
                                            className: " bg-white text-green-600 px-5 py-1 border-gray-300 border-2 rounded-md ml-6 mt-20 hover:bg-green-200 hover:text-black",
                                            onClick: ()=>handleAddItem(item),
                                            children: "Add +"
                                        })
                                    }),
                                    item.card.info.imageId ? /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                        className: "w-36 h-28 rounded-lg",
                                        src: (0, $ded4f04298f3b61e$export$31adfacaf07ffe63) + item.card.info.imageId,
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                        className: "text-center w-36 h-28",
                                        children: "No Image"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                                className: "w-3/4",
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
                                        className: "font-medium",
                                        children: item.card.info.name
                                    }),
                                    item.card.info.itemAttribute.vegClassifier === "VEG" ? /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2214047ad0b1efd1$exports))),
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($89b55b17b0b09e89$exports))),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("p", {
                                        children: [
                                            "\u20B9",
                                            (item.card.info.price ? item.card.info.price : item.card.info.defaultPrice) / 100
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                        className: "text-xs text-gray-500",
                                        children: item.card.info.description
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($a6c5e10b762813a4$export$be92b6f5f03c0fe9, {
                        className: styles.rootStyle,
                        open: open,
                        onOpenChange: setOpen,
                        type: "background",
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)($a6c5e10b762813a4$export$f99233281efd08a0, {
                                className: "[grid-area:_title] mb-[5px] font-medium text-slate12 text-[15px] truncate w-52",
                                children: toastTitle
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)($a6c5e10b762813a4$export$f39c2d165cd861fe, {
                                className: styles.closeButtonStyle,
                                children: "OK"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)($a6c5e10b762813a4$export$d5c6c08dc2d3ca7, {
                        className: styles.viewPortStyle
                    })
                ]
            }, item.card.info.id))
    });
};
var $e0523f05564edcbe$export$2e2bcd8739ae039 = $e0523f05564edcbe$var$ItemList;


const $1f6adac45b55707b$var$ResCategory = ({ data: data, showItems: showItems, indexCbFun: indexCbFun, index: index })=>{
    const { title: title, itemCards: itemCards } = data?.card?.card;
    console.log(data);
    //This state var is tracking click of category
    // false- by default all are collapsed
    const [click, setClick] = (0, $aOChP.useState)(false);
    const handleClick = ()=>{
        // toggling clicks
        //1st click set to true shows items, second click set to false hides items
        setClick(!click);
        indexCbFun();
    };
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        className: "w-8/12 my-6 py-1 shadow-xl mx-auto px-2 rounded-lg bg-slate-50",
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                className: "flex justify-between items-center cursor-pointer ",
                onClick: handleClick,
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("span", {
                        className: "font-bold text-2xl p-2",
                        children: [
                            title,
                            " (",
                            itemCards.length,
                            ")"
                        ]
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
                        className: "mr-6",
                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                            // src={ARROW_DOWN}
                            //During Testing
                            src: "https://img.icons8.com/ios/30/expand-arrow--v1.png",
                            alt: "arrow-down"
                        })
                    })
                ]
            }),
            click && showItems && /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $e0523f05564edcbe$export$2e2bcd8739ae039), {
                items: itemCards
            })
        ]
    });
};
var $1f6adac45b55707b$export$2e2bcd8739ae039 = $1f6adac45b55707b$var$ResCategory;


parcelRequire("97ZOK");
const $308c3e9cdb2e0b29$var$ResMenu = ()=>{
    // const [resInfo, setResInfo] = useState(null);
    const { resId: resId } = (0, $7d4ddebaad7c3ba2$export$99eaa27ddbbb95ef)();
    // const params = useParams();
    //using custom Hook which gives data using resId
    const resInfo = (0, $5f701d92aba1d046$export$2e2bcd8739ae039)(resId);
    const [showIndex, setShowIndex] = (0, $aOChP.useState)(0);
    // const {loggedInUser} = useContext(UserContext)
    if (resInfo === null) return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7965e1ddc87bb2ae$export$2e2bcd8739ae039), {});
    console.log(resInfo);
    //As per the API 0th element of array contains the restaurant name
    const { name: name, avgRating: avgRating, cuisines: cuisines, areaName: areaName, costForTwoMessage: costForTwoMessage } = resInfo?.cards[2]?.card?.card?.info;
    console.log(name, avgRating, cuisines, areaName, costForTwoMessage);
    //As per the API 2nd element of array contains the category and dishes
    // Getting Categories like Recommended from the array. This string signifes category "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory"
    const categories = resInfo?.cards[4]?.groupedCard?.cardGroupMap?.REGULAR?.cards.filter((c)=>c?.card?.card?.["@type"] === "type.googleapis.com/swiggy.presentation.food.v2.ItemCategory");
    console.log(categories[0]);
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        className: "mx-24",
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                className: "resDetails flex gap-24 mt-10 mx-auto justify-center ",
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("h1", {
                                className: "font-bold text-3xl",
                                children: name
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                children: areaName
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                children: cuisines.join(", ")
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("p", {
                                children: [
                                    avgRating,
                                    "  \u2B50"
                                ]
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                children: costForTwoMessage
                            })
                        ]
                    })
                ]
            }),
            categories.map((c, index)=>/*#__PURE__*/ (0, $5Wgfu.jsx)((0, $1f6adac45b55707b$export$2e2bcd8739ae039), {
                    data: c,
                    showItems: index === showIndex ? true : false,
                    indexCbFun: ()=>setShowIndex(index),
                    index: index
                }, c.card.card.title))
        ]
    });
};
var $308c3e9cdb2e0b29$export$2e2bcd8739ae039 = $308c3e9cdb2e0b29$var$ResMenu;




var $5Wgfu = parcelRequire("5Wgfu");




var $5Wgfu = parcelRequire("5Wgfu");






var $aOChP = parcelRequire("aOChP");

const $9fa240dfe663188d$var$CartItemList = ({ items: items })=>{
    const styles = {
        rootStyle: "  p-[15px] grid [grid-template-areas:_'title_action'_'description_action'] grid-cols-[auto_max-content] gap-x-[15px] items-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=end]:animate-swipeOut fixed top-[90px] right-0 z-50 rounded-lg m-2 bg-slate-50 shadow-sm ",
        closeButtonStyle: "rounded-lg font-medium text-xs px-[10px] leading-[25px] h-[25px] bg-green2 text-green11 shadow-[inset_0_0_0_1px] shadow-green7 hover:shadow-[inset_0_0_0_1px] hover:shadow-green8 focus:shadow-[0_0_0_2px] focus:shadow-green8",
        viewPortStyle: "[--viewport-padding:_25px] fixed bottom-0 right-0 flex flex-col p-[var(--viewport-padding)] gap-[10px] w-[390px] max-w-[100vw] m-0 list-none z-[2147483647] outline-none"
    };
    //RadixUI
    const [open, setOpen] = (0, $aOChP.useState)(false);
    const timerRef = (0, $aOChP.useRef)(0);
    const [toastTitle, setToastTitle] = (0, $aOChP.useState)("Default Title");
    (0, $aOChP.useEffect)(()=>{
        return ()=>clearTimeout(timerRef.current);
    }, []);
    const dispatch = (0, $1c7032cc59fc9fd2$export$8ad76b76a4c905f8)();
    const handleRemoveItem = (item)=>{
        dispatch((0, $6e3f649c67c08cff$export$fe2d9b4e03920b4c)(item));
        //RadixUI
        setOpen(false);
        setToastTitle("Removed " + item.card.info.name);
        window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(()=>{
            setOpen(true);
        }, 100);
    };
    return /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
        children: items.map((item)=>/*#__PURE__*/ (0, $5Wgfu.jsxs)($a6c5e10b762813a4$export$2881499e37b75b9a, {
                swipeDirection: "right",
                duration: 1000,
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                        className: "border-b-2 border-gray-200 my-4 pb-5 flex",
                        "data-testid": "cartItem",
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                                className: " px-6",
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                                        className: "absolute",
                                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)("button", {
                                            className: " bg-white text-red-500 px-3 py-1 border-gray-300 border-2 rounded-md mx-3 mt-20 hover:bg-green-200",
                                            onClick: ()=>handleRemoveItem(item),
                                            "data-testid": "removeButton",
                                            children: "Remove"
                                        })
                                    }),
                                    item.card.info.imageId ? /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                        className: "w-36 h-28 rounded-lg",
                                        src: (0, $ded4f04298f3b61e$export$31adfacaf07ffe63) + item.card.info.imageId,
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                        className: "text-center w-36 h-28",
                                        children: "No Image"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                                className: "",
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
                                        className: "font-medium",
                                        children: item.card.info.name
                                    }),
                                    item.card.info.itemAttribute.vegClassifier === "VEG" ? /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($2214047ad0b1efd1$exports))),
                                        alt: ""
                                    }) : /*#__PURE__*/ (0, $5Wgfu.jsx)("img", {
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($89b55b17b0b09e89$exports))),
                                        alt: ""
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("p", {
                                        children: [
                                            "\u20B9",
                                            (item.card.info.price ? item.card.info.price : item.card.info.defaultPrice) / 100
                                        ]
                                    })
                                ]
                            })
                        ]
                    }, item.card.info.id),
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($a6c5e10b762813a4$export$be92b6f5f03c0fe9, {
                        className: styles.rootStyle,
                        open: open,
                        onOpenChange: setOpen,
                        type: "background",
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)($a6c5e10b762813a4$export$f99233281efd08a0, {
                                className: "[grid-area:_title] mb-[5px] font-medium text-slate12 text-[15px] truncate w-52",
                                children: toastTitle
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)($a6c5e10b762813a4$export$f39c2d165cd861fe, {
                                className: styles.closeButtonStyle,
                                children: "OK"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)($a6c5e10b762813a4$export$d5c6c08dc2d3ca7, {
                        className: styles.viewPortStyle
                    })
                ]
            }, item.card.info.id))
    });
};
var $9fa240dfe663188d$export$2e2bcd8739ae039 = $9fa240dfe663188d$var$CartItemList;



var $aOChP = parcelRequire("aOChP");

const $67febe582704f5f3$var$Cart = ()=>{
    const cartItems = (0, $1c7032cc59fc9fd2$export$2105062e25df4afe)((store)=>store.cart.items);
    const styles = {
        rootStyle: "  p-[15px] grid [grid-template-areas:_'title_action'_'description_action'] grid-cols-[auto_max-content] gap-x-[15px] items-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=end]:animate-swipeOut fixed top-[90px] right-0 z-50 rounded-lg m-2 bg-slate-50 shadow-sm ",
        closeButtonStyle: "rounded-lg font-medium text-xs px-[10px] leading-[25px] h-[25px] bg-green2 text-green11 shadow-[inset_0_0_0_1px] shadow-green7 hover:shadow-[inset_0_0_0_1px] hover:shadow-green8 focus:shadow-[0_0_0_2px] focus:shadow-green8",
        viewPortStyle: "[--viewport-padding:_25px] fixed bottom-0 right-0 flex flex-col p-[var(--viewport-padding)] gap-[10px] w-[390px] max-w-[100vw] m-0 list-none z-[2147483647] outline-none"
    };
    //RadixUI
    const [open, setOpen] = (0, $aOChP.useState)(false);
    const timerRef = (0, $aOChP.useRef)(0);
    const [toastTitle, setToastTitle] = (0, $aOChP.useState)("Default Title");
    (0, $aOChP.useEffect)(()=>{
        return ()=>clearTimeout(timerRef.current);
    }, []);
    const dispatch = (0, $1c7032cc59fc9fd2$export$8ad76b76a4c905f8)();
    const handleClearCart = ()=>{
        dispatch((0, $6e3f649c67c08cff$export$810121176e3e3671)());
        //RadixUI
        setOpen(false);
        cartItems.length !== 0 ? setToastTitle("Cart Cleared") : setToastTitle("Nothing to clear");
        window.clearTimeout(timerRef.current);
        timerRef.current = window.setTimeout(()=>{
            setOpen(true);
        }, 100);
    };
    const itemTotal = cartItems.reduce((acc, curr)=>{
        return acc + (curr.card.info.price ? curr.card.info.price : curr.card.info.defaultPrice);
    }, 0);
    const gst = parseFloat((itemTotal / 100 * 0.12).toFixed(2));
    const totalPrice = itemTotal / 100 + gst + 40 + 3;
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($a6c5e10b762813a4$export$2881499e37b75b9a, {
        swipeDirection: "right",
        duration: 1000,
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                className: "my-4 mx-24 px-48",
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                        className: "my-8 flex justify-between",
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("h2", {
                                className: "text-3xl font-semibold ",
                                children: [
                                    "Your Cart (",
                                    cartItems.length,
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("button", {
                                className: "w-32 py-2 border-solid border-2 border-black-700 rounded-full text-center  hover:font-medium shadow-lg hover:bg-red-100",
                                onClick: handleClearCart,
                                children: "Clear Cart"
                            })
                        ]
                    }),
                    cartItems.length === 0 ? /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                        className: "p-2 flex flex-col gap-2",
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("h2", {
                                className: "text-2xl",
                                children: "Oops! Your Cart is as Empty as a Cookie Jar at Midnight \uD83C\uDF6A"
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                className: "text-xl",
                                children: "Looks like you haven't sprinkled any goodies into your cart yet! How about picking some delicious treats from our menu?"
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                                className: "text-center",
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5016641478f75324$export$a6c7ac8248d6e38a), {
                                    to: "/",
                                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)("button", {
                                        className: "w-36 m-4 p-2 text-xl border-solid border-2 border-black-700 rounded-full text-center  hover:font-medium shadow-lg hover:bg-green-100",
                                        children: "Let's Fill It Up! \uD83D\uDE0B"
                                    })
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                        className: "gap-4 flex",
                        children: [
                            /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                                className: "",
                                children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $9fa240dfe663188d$export$2e2bcd8739ae039), {
                                    items: cartItems
                                })
                            }),
                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                                className: " border-l-2 p-4 w-1/3 ",
                                children: [
                                    /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                        className: "font-semibold  text-2xl",
                                        children: "Bill Details"
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                                        className: "flex justify-between p-2",
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                                children: "Item Total"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                                children: itemTotal / 100
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                                        className: "flex justify-between p-2",
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                                children: "Delivery Fee"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                                children: "40"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                                        className: "flex justify-between p-2",
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                                children: "Platform fee"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                                children: "3"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                                        className: "flex justify-between border-b-2 p-2",
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                                children: "GST(12%)"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                                children: gst
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                                        className: "flex justify-between border-b-2 p-2",
                                        children: [
                                            /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                                                children: "To Pay"
                                            }),
                                            /*#__PURE__*/ (0, $5Wgfu.jsxs)("p", {
                                                children: [
                                                    "\u20B9 ",
                                                    totalPrice
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsxs)($a6c5e10b762813a4$export$be92b6f5f03c0fe9, {
                className: styles.rootStyle,
                open: open,
                onOpenChange: setOpen,
                type: "background",
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsx)($a6c5e10b762813a4$export$f99233281efd08a0, {
                        className: "[grid-area:_title] mb-[5px] font-medium text-slate12 text-[15px]",
                        children: toastTitle
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)($a6c5e10b762813a4$export$f39c2d165cd861fe, {
                        className: styles.closeButtonStyle,
                        children: "OK"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)($a6c5e10b762813a4$export$d5c6c08dc2d3ca7, {
                className: styles.viewPortStyle
            })
        ]
    });
};
var $67febe582704f5f3$export$2e2bcd8739ae039 = $67febe582704f5f3$var$Cart;



var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");
function $7e16598e6849b806$var$Panel({ title: title, children: children, isActive: isActive, onShow: onShow }) {
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("section", {
        className: "panel border-2 border-black",
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("h3", {
                children: title
            }),
            isActive ? /*#__PURE__*/ (0, $5Wgfu.jsx)("p", {
                children: children
            }) : /*#__PURE__*/ (0, $5Wgfu.jsx)("button", {
                className: "p-2 border-2 border-black rounded-lg",
                onClick: onShow,
                children: "Show"
            })
        ]
    });
}
function $7e16598e6849b806$export$2e2bcd8739ae039() {
    const [activeIndex, setActiveIndex] = (0, $aOChP.useState)(0);
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("h2", {
                children: "Almaty, Kazakhstan"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)($7e16598e6849b806$var$Panel, {
                title: "About",
                isActive: activeIndex === 0,
                onShow: ()=>setActiveIndex(0),
                children: "With a population of about 2 million, Almaty is Kazakhstan's largest city. From 1929 to 1997, it was its capital city."
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsxs)($7e16598e6849b806$var$Panel, {
                title: "Etymology",
                isActive: activeIndex === 1,
                onShow: ()=>setActiveIndex(1),
                children: [
                    "The name comes from ",
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("span", {
                        lang: "kk-KZ",
                        children: "\u0430\u043B\u043C\u0430"
                    }),
                    ', the Kazakh word for "apple" and is often translated as "full of apples". In fact, the region surrounding Almaty is thought to be the ancestral home of the apple, and the wild ',
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("i", {
                        lang: "la",
                        children: "Malus sieversii"
                    }),
                    " is considered a likely candidate for the ancestor of the modern domestic apple."
                ]
            })
        ]
    });
}



var $97ZOK = parcelRequire("97ZOK");

var $5Wgfu = parcelRequire("5Wgfu");

var $aOChP = parcelRequire("aOChP");

const $0a71d2d0c849d986$var$Testing = ()=>{
    const [open, setOpen] = (0, $aOChP.useState)(false);
    const timerRef = (0, $aOChP.useRef)(0);
    const [toastTitle, setToastTitle] = (0, $aOChP.useState)("Default Title");
    (0, $aOChP.useEffect)(()=>{
        return ()=>clearTimeout(timerRef.current);
    }, []);
    const myBtn = "w-36 m-4 p-2 text-xl border-solid border-2 border-black-700 rounded-full text-center  hover:font-medium shadow-lg hover:bg-green-100";
    return /*#__PURE__*/ (0, $5Wgfu.jsxs)($a6c5e10b762813a4$export$2881499e37b75b9a, {
        swipeDirection: "right",
        duration: 2000,
        children: [
            /*#__PURE__*/ (0, $5Wgfu.jsx)("button", {
                className: myBtn,
                onClick: ()=>{
                    setOpen(false);
                    setToastTitle("hiiiii");
                    window.clearTimeout(timerRef.current);
                    timerRef.current = window.setTimeout(()=>{
                        setOpen(true);
                    }, 100);
                },
                children: "Add +"
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsxs)($a6c5e10b762813a4$export$be92b6f5f03c0fe9, {
                className: "bg-white rounded-md shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] p-[15px] grid [grid-template-areas:_'title_action'_'description_action'] grid-cols-[auto_max-content] gap-x-[15px] items-center data-[state=open]:animate-slideIn data-[state=closed]:animate-hide data-[swipe=move]:translate-x-[var(--radix-toast-swipe-move-x)] data-[swipe=cancel]:translate-x-0 data-[swipe=cancel]:transition-[transform_200ms_ease-out] data-[swipe=end]:animate-swipeOut",
                open: open,
                v: true,
                onOpenChange: setOpen,
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsxs)($a6c5e10b762813a4$export$f99233281efd08a0, {
                        className: "[grid-area:_title] mb-[5px] font-medium text-slate12 text-[15px]",
                        children: [
                            toastTitle,
                            "        "
                        ]
                    }),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)($a6c5e10b762813a4$export$e19cd5f9376f8cee, {
                        className: "[grid-area:_action]",
                        asChild: true,
                        altText: "Goto schedule to undo",
                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)("button", {
                            className: "rounded-lg font-medium text-xs px-[10px] leading-[25px] h-[25px] bg-green2 text-green11 shadow-[inset_0_0_0_1px] shadow-green7 hover:shadow-[inset_0_0_0_1px] hover:shadow-green8 focus:shadow-[0_0_0_2px] focus:shadow-green8",
                            children: "OK"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $5Wgfu.jsx)($a6c5e10b762813a4$export$d5c6c08dc2d3ca7, {
                className: "[--viewport-padding:_25px] fixed bottom-0 right-0 flex flex-col p-[var(--viewport-padding)] gap-[10px] w-[390px] max-w-[100vw] m-0 list-none z-[2147483647] outline-none"
            })
        ]
    });
};
var $0a71d2d0c849d986$export$2e2bcd8739ae039 = $0a71d2d0c849d986$var$Testing;





const $195d8a50b883f585$var$appStore = (0, $34ed020f7f2c9609$export$7d8a5b498da695ac)({
    reducer: {
        cart: (0, $6e3f649c67c08cff$export$2e2bcd8739ae039)
    }
});
var $195d8a50b883f585$export$2e2bcd8739ae039 = $195d8a50b883f585$var$appStore;



const $b33bb22541d9cb53$var$Grocery = /*#__PURE__*/ (0, $aOChP.lazy)(()=>(parcelRequire("179KA")));

const $b33bb22541d9cb53$var$About = /*#__PURE__*/ (0, $aOChP.lazy)(()=>(parcelRequire("jJdUP")));
const $b33bb22541d9cb53$var$AppLayout = ()=>{
    const [userName, setUserName] = (0, $aOChP.useState)();
    //auhthentication
    (0, $aOChP.useEffect)(()=>{
        //API call and send Username and Password get result data
        const data = {
            name: "Default User"
        };
        setUserName(data.name);
    }, []);
    // console.log(userName);
    return /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $1c7032cc59fc9fd2$export$2881499e37b75b9a), {
        store: (0, $195d8a50b883f585$export$2e2bcd8739ae039),
        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $97ZOK.default).Provider, {
            value: {
                loggedInUser: userName,
                setUserName: setUserName
            },
            children: /*#__PURE__*/ (0, $5Wgfu.jsxs)("div", {
                className: "font-poppins ",
                children: [
                    /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7d1003a005902228$export$2e2bcd8739ae039), {}),
                    /*#__PURE__*/ (0, $5Wgfu.jsx)("div", {
                        children: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7d4ddebaad7c3ba2$export$910ae8079b2c2852), {})
                    })
                ]
            })
        })
    });
};
const $b33bb22541d9cb53$var$appRouter = (0, $5016641478f75324$export$1f3f55432a00e06d)([
    {
        path: "/",
        element: /*#__PURE__*/ (0, $5Wgfu.jsx)($b33bb22541d9cb53$var$AppLayout, {}),
        children: [
            {
                path: "/",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $dcc39249737b0d10$export$2e2bcd8739ae039), {})
            },
            {
                path: "/about",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $aOChP.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $d1fe336ba39d0b8d$export$2e2bcd8739ae039), {}),
                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)($b33bb22541d9cb53$var$About, {})
                })
            },
            {
                path: "/contact",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $b2c572d619f7ebd8$export$2e2bcd8739ae039), {})
            },
            {
                path: "/grocery",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $aOChP.Suspense), {
                    fallback: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $d1fe336ba39d0b8d$export$2e2bcd8739ae039), {}),
                    children: /*#__PURE__*/ (0, $5Wgfu.jsx)($b33bb22541d9cb53$var$Grocery, {})
                })
            },
            {
                //colon represents resId is Dynamic
                path: "/restaurant/:resId",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $308c3e9cdb2e0b29$export$2e2bcd8739ae039), {})
            },
            {
                path: "/accordion",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $7e16598e6849b806$export$2e2bcd8739ae039), {})
            },
            {
                path: "/cart",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $67febe582704f5f3$export$2e2bcd8739ae039), {})
            },
            {
                path: "/test",
                element: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $0a71d2d0c849d986$export$2e2bcd8739ae039), {})
            }
        ],
        errorElement: /*#__PURE__*/ (0, $5Wgfu.jsx)((0, $45f29b8d937d424e$export$2e2bcd8739ae039), {})
    }
]);
const $b33bb22541d9cb53$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($3ffba8a88cb861dc$exports))).createRoot(document.getElementById("root"));
// root.render(<AppLayout />);
$b33bb22541d9cb53$var$root.render(/*#__PURE__*/ (0, $5Wgfu.jsx)((0, $5016641478f75324$export$323e4fc2fa4753fb), {
    router: $b33bb22541d9cb53$var$appRouter
}));


//# sourceMappingURL=index.3c4d8f8e.js.map
